(() => {
  const html = document.documentElement;
  const body = document.body;
  const header = document.querySelector(".section-header");
  const isHome = body?.classList.contains("template-index");
  const isCollection = body?.classList.contains("template-collection");
  html.classList.add("hcx-launch-unlocked");
  html.classList.remove("hcx-launch-locked");
  try {
    window.localStorage.setItem("hcx:launch-gate:v1", "1");
  } catch (error) {
    window.HCXLaunchGateStorageError = false;
  }
  let lastSyncedScrollY = window.scrollY;
  const hcxTransparentImage =
    "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%201%201%22%2F%3E";
  const hcxReturnLookupLocalFallbackOrigin = "http://127.0.0.1:8787";
  const hcxOrderLookupBackendMessage =
    "If you need further assistance, email us at enquiries@hercxles.co.uk.";
  const getHcxHugeTeeDisplayTitle = (value = "", fallbackTitle = "") => {
    const handle = String(value || "").trim().toLowerCase();
    let title = "";

    if (handle.includes("bodybuilding-giant-t-shirt")) title = "Bodybuilding HUGE T-Shirt";
    else if (handle.includes("vintage-athlete-giant-t-shirt") || handle.includes("athlete-giant-t-shirt")) {
      title = "Vintage Athlete HUGE T-Shirt";
    } else if (handle.includes("hercstudios-giant-t-shirt")) title = "HERCSTUDIOS HUGE T-Shirt";
    else if (handle === "hrcxls-giant-t-shirt") title = "HRCXLS HUGE T-Shirt";
    else if (handle.includes("bicep-giant-t-shirt") || handle === "herc-oversized-t-shirt") {
      title = "Bicep HUGE T-Shirt";
    } else if (handle.includes("viper-giant-t-shirt")) title = "Viper HUGE T-Shirt";
    else if (handle.includes("oni-giant-t-shirt")) title = "Oni HUGE T-Shirt";
    else if (handle.includes("venom-giant-t-shirt")) title = "Venom HUGE T-Shirt";
    else if (handle.includes("icarus-giant-t-shirt")) title = "Icarus HUGE T-Shirt";
    else if (
      handle.includes("sport-giant-t-shirt") ||
      handle.includes("sport-giant-oversized-t-shirt") ||
      handle.includes("sport-oversized-drop-shoulder-t-shirt") ||
      handle === "sport-oversized-t-shirt-grey"
    ) {
      title = "Sport HUGE T-Shirt";
    } else if (
      handle.includes("logo-giant-t-shirt") ||
      handle.includes("logo-giant-oversized-t-shirt") ||
      handle.includes("giant-logo-oversized-t-shirt")
    ) {
      title = "Logo HUGE T-Shirt";
    }

    if (!title && handle.includes("-giant-t-shirt") && fallbackTitle) {
      title = String(fallbackTitle).replace(/\bGiant\b/gi, "HUGE").replace(/\s+/g, " ").trim();
    }

    return title;
  };
  const hcxHandleFromUrl = (url) => {
    const match = String(url || "").match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]).toLowerCase() : "";
  };
  const hcxTitleLooksStale = (text, title) => {
    const value = String(text || "").trim();
    if (!value || value === title || value === title.toUpperCase()) return false;
    const lowerValue = value.toLowerCase();
    return (
      lowerValue.includes("giant t-shirt") ||
      lowerValue.includes("oversized t-shirt") ||
      (lowerValue.includes("t-shirt") && !lowerValue.includes("huge t-shirt"))
    );
  };
  const hcxApplyGiantTeeDisplayTitles = () => {
    const productHandle = document.body?.classList.contains("template-product")
      ? hcxHandleFromUrl(window.location.pathname)
      : "";
    const productTitle = getHcxHugeTeeDisplayTitle(productHandle);

    if (productTitle) {
      document
        .querySelectorAll(".product__title h1, .product__title .h1")
        .forEach((titleNode) => {
          if (hcxTitleLooksStale(titleNode.textContent, productTitle)) titleNode.textContent = productTitle;
        });

      document.querySelectorAll("[data-product-title]").forEach((node) => {
        if (hcxTitleLooksStale(node.getAttribute("data-product-title"), productTitle)) {
          node.setAttribute("data-product-title", productTitle);
        }
      });

      document
        .querySelectorAll('meta[property="og:title"], meta[name="twitter:title"]')
        .forEach((meta) => {
          const content = meta.getAttribute("content") || "";
          if (!hcxTitleLooksStale(content, productTitle)) return;
          const suffix = content.includes(" - ") ? content.slice(content.indexOf(" - ")) : "";
          meta.setAttribute("content", `${productTitle}${suffix}`);
        });

      document
        .querySelectorAll(".product__title [data-hcx-feature-label], .product__title .hcx-product-feature-line")
        .forEach((labelNode) => {
          labelNode.textContent = "VERY OVERSIZED";
          labelNode.setAttribute("data-hcx-feature-label", "VERY OVERSIZED");
        });
    }

    document.querySelectorAll('a[href*="/products/"]').forEach((link) => {
      const handle = hcxHandleFromUrl(link.getAttribute("href"));
      const title = getHcxHugeTeeDisplayTitle(handle);
      if (!title) return;

      const card = link.closest(".product-card-wrapper, .card-wrapper, .predictive-search__item, .hcx-search-card, .hcx-cart-rec");
      if (!card) return;
      card.querySelectorAll("[data-hcx-feature-label]").forEach((labelNode) => {
        labelNode.textContent = "VERY OVERSIZED";
        labelNode.setAttribute("data-hcx-feature-label", "VERY OVERSIZED");
      });

      card
        .querySelectorAll(".card__heading a, .card__heading, .hcx-card-title, .predictive-search__item-heading, .hcx-cart-rec__title")
        .forEach((titleNode) => {
          if (hcxTitleLooksStale(titleNode.textContent, title)) titleNode.textContent = title.toUpperCase();
        });
    });
  };
  hcxApplyGiantTeeDisplayTitles();
  document.addEventListener("DOMContentLoaded", hcxApplyGiantTeeDisplayTitles);
  window.setTimeout(hcxApplyGiantTeeDisplayTitles, 250);
  window.setTimeout(hcxApplyGiantTeeDisplayTitles, 1200);
  const injectHcxCollectionCardOutlineFix = () => {
    if (!body?.classList.contains("template-collection")) return;
    if (document.getElementById("hcx-collection-card-outline-fix-20260619")) return;

    const style = document.createElement("style");
    style.id = "hcx-collection-card-outline-fix-20260619";
    style.textContent = `
      body:not(.hcx-legacy-page).template-collection #MainContent .product-grid .product-card-wrapper .card,
      body:not(.hcx-legacy-page).template-collection #MainContent .product-grid .product-card-wrapper .card__inner,
      body:not(.hcx-legacy-page).template-collection #MainContent .product-grid .product-card-wrapper .card__media,
      body:not(.hcx-legacy-page).template-collection #MainContent .product-grid .product-card-wrapper .media {
        border-top: 0 !important;
        border-bottom: 0 !important;
        border-color: transparent !important;
        box-shadow: none !important;
        outline: 0 !important;
      }

      body:not(.hcx-legacy-page).template-collection #MainContent .product-grid .product-card-wrapper .card::before,
      body:not(.hcx-legacy-page).template-collection #MainContent .product-grid .product-card-wrapper .card::after,
      body:not(.hcx-legacy-page).template-collection #MainContent .product-grid .product-card-wrapper .card__inner::before,
      body:not(.hcx-legacy-page).template-collection #MainContent .product-grid .product-card-wrapper .card__inner::after,
      body:not(.hcx-legacy-page).template-collection #MainContent .product-grid .product-card-wrapper .card__media::before,
      body:not(.hcx-legacy-page).template-collection #MainContent .product-grid .product-card-wrapper .card__media::after,
      body:not(.hcx-legacy-page).template-collection #MainContent .product-grid .product-card-wrapper .media::before,
      body:not(.hcx-legacy-page).template-collection #MainContent .product-grid .product-card-wrapper .media::after {
        border-top: 0 !important;
        border-bottom: 0 !important;
        border-color: transparent !important;
        box-shadow: none !important;
        outline: 0 !important;
      }

      body:not(.hcx-legacy-page).template-collection #MainContent .product-grid .product-card-wrapper .card__inner {
        overflow: hidden !important;
      }
    `;
    document.head.appendChild(style);
  };
  injectHcxCollectionCardOutlineFix();
  const hcxNewInReviewBlockedHandles = new Set([
    "swoosh-boxy-hoodie",
    "hercstudios-boxy-hoodie",
    "swoosh-snow-wash-hoodie-light-grey",
    "tiger-x-studios-hoodie",
    "running-zip-hoodie",
    "hercxles-swoosh-hoodie-red",
    "vintage-wash-t-shirt-coffee",
    "vintage-wash-t-shirt-light-grey",
    "vintage-wash-t-shirt-cobalt-blue",
    "bodybuilding-oversized-t-shirt-5",
    "sport-tee-white",
    "sport-tee-black",
    "sport-fitted-t-shirt-white",
    "sport-fitted-t-shirt-grey",
    "unisex-classic-crew-neck-cotton-t-shirt-6",
    "unisex-classic-crew-neck-cotton-t-shirt-7",
    "unisex-classic-crew-neck-cotton-t-shirt-8",
    "unisex-classic-crew-neck-cotton-t-shirt-9",
    "sport-tank-top",
    "hercxles-tank-top-dark",
    "black-grunge-oversized-t-shirt",
    "sport-oversized-t-shirt-grey",
  ]);
  const guardHcxNewInCardReviews = () => {
    if (!body?.classList.contains("template-index") && !body?.classList.contains("template-collection")) return;
    document.querySelectorAll(".product-card-wrapper").forEach((card) => {
      const link = card.querySelector('a[href*="/products/"]');
      const href = link?.getAttribute("href") || "";
      const handle = href.match(/\/products\/([^/?#]+)/)?.[1] || "";
      if (!handle || handle === "swoosh-boxy-t-shirt-white" || handle.includes("giant-t-shirt")) return;
      if (!hcxNewInReviewBlockedHandles.has(handle)) return;
      card.querySelectorAll(".hcx-card-rating").forEach((rating) => rating.remove());
    });
  };
  guardHcxNewInCardReviews();
  document.addEventListener("DOMContentLoaded", guardHcxNewInCardReviews);
  window.setTimeout(guardHcxNewInCardReviews, 300);
  window.setTimeout(guardHcxNewInCardReviews, 1200);
  let hcxLazyImageObserver = null;
  let hcxStableMobileViewportWidth = 0;
  let hcxMobileMediaLockFrame = 0;
  let hcxMobileMediaMutationObserver = null;
  const hcxStableMobileViewportMedia = window.matchMedia("(max-width: 749px)");
  const hcxMobileMediaLockSelectors = {
    hero: [
      ".section-hcx-hero",
      ".hcx-hero",
      ".hcx-hero__media",
      ".hcx-hero__media img",
      ".hcx-hero__media video",
      ".hcx-hero__asset",
      ".hcx-product-slideshow",
      ".hcx-product-slideshow__track",
      ".hcx-product-slide",
      ".hcx-product-slide img",
      ".slideshow",
      ".slideshow__slide",
      ".slideshow__media",
      ".slideshow__media.banner__media",
      ".slideshow__media img",
    ],
    collection: [
      ".hcx-collection-hero--cinematic",
      ".hcx-collection-hero--cinematic .collection-hero__inner",
      ".hcx-collection-hero--cinematic .hcx-collection-hero__media",
      ".hcx-collection-hero--cinematic .hcx-collection-hero__image",
    ],
    banner: [
      "#MainContent [class*='banner']",
      "#MainContent [class*='banner'] picture",
      "#MainContent [class*='banner'] img",
      "#MainContent [class*='banner'] svg",
      "#MainContent [class*='image-banner']",
      "#MainContent [class*='hero-banner']",
      "#MainContent [class*='__banner']",
      ".banner",
      ".banner__content",
      ".banner__media",
      ".banner__media > img",
      ".banner__media > svg",
      ".email-signup-banner",
      ".email-signup-banner .banner__media",
      ".email-signup-banner .banner__media img",
      ".image-with-text__media",
      ".image-with-text__media img",
      ".hcx-editorial__media",
      ".hcx-editorial__media img",
      ".hcx-editorial__media svg",
      ".hcx-category__placeholder-slide",
      ".hcx-category__placeholder-slide img",
      ".hcx-category__placeholder-content",
      ".hcx-rep-drop__media",
      ".hcx-rep-drop__media picture",
      ".hcx-rep-drop__media img",
      ".hcx-rep-drop__media svg",
      ".hcx-rep-drop__content",
      ".hcx-conversion-story__hero",
      ".hcx-conversion-story__hero picture",
      ".hcx-conversion-story__hero img",
      ".hcx-conversion-story__hero svg",
      ".hcx-loyalty-program__hero",
      ".hcx-loyalty-profile--hero",
      ".video-section__media",
      ".video-section .media",
      ".deferred-media",
      ".deferred-media img",
    ],
    cardBanner: [
      ".hcx-category-card",
      ".hcx-category-card img",
      ".hcx-category-card svg",
      ".hcx-rep-tile",
      ".hcx-rep-tile img",
      ".hcx-rep-tile svg",
    ],
    product: [
      ".template-product .hcx-product-carousel",
      ".template-product .hcx-product-carousel .slider-mobile-gutter:not(.thumbnail-slider)",
      ".template-product .hcx-product-carousel .product__media-list",
      ".template-product .hcx-product-carousel .product__media-item",
      ".template-product .hcx-product-carousel .product-media-container",
      ".template-product .hcx-product-carousel .product-media-container.gradient",
      ".template-product .hcx-product-carousel .global-media-settings",
      ".template-product .hcx-product-carousel .product__modal-opener",
      ".template-product .hcx-product-carousel .product__media",
      ".template-product .hcx-product-carousel .media",
      ".template-product .hcx-product-carousel img",
    ],
  };

  const isHcxLocalPreviewHost = () => {
    try {
      return ["localhost", "127.0.0.1", "::1"].includes(window.location.hostname);
    } catch (_) {
      return false;
    }
  };

  const getHcxReturnLookupUrls = (lookupUrl = "") => {
    const primaryUrl = String(lookupUrl || "").trim();
    if (!primaryUrl) return [];

    const urls = [primaryUrl];
    if (isHcxLocalPreviewHost()) {
      try {
        const parsedUrl = new URL(primaryUrl, window.location.origin);
        if (
          parsedUrl.pathname === "/apps/hercxles-returns/lookup" ||
          parsedUrl.pathname === "/apps/hercxles-returns/request" ||
          parsedUrl.pathname === "/lookup" ||
          parsedUrl.pathname === "/request"
        ) {
          const localUrl = new URL(parsedUrl.pathname, hcxReturnLookupLocalFallbackOrigin);
          localUrl.search = parsedUrl.search;
          urls.push(localUrl.href);
        }
      } catch (_) {}
    }

    return [...new Set(urls)];
  };

  const isHcxSameOriginUrl = (url = "") => {
    try {
      return new URL(url, window.location.origin).origin === window.location.origin;
    } catch (_) {
      return false;
    }
  };

  const fetchHcxOrderLookup = async (lookupUrl, body) => {
    const urls = getHcxReturnLookupUrls(lookupUrl);
    let lastResult = null;
    let lastError = null;

    for (const url of urls) {
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
          },
          body: JSON.stringify(body)
        });
        const payload = await response.json().catch(() => ({}));
        lastResult = { payload, response, url };

        if (!(isHcxLocalPreviewHost() && response.status === 404 && isHcxSameOriginUrl(url))) {
          return lastResult;
        }
      } catch (error) {
        lastError = error;
      }
    }

    if (lastResult) return lastResult;
    throw lastError || new Error("Order lookup request failed");
  };

  const hcxOrderLookupErrorMessage = (payload = {}, status = 0, fallbackMessage = "") => {
    const error = String(payload?.error || "").trim();
    if (
      status === 404 ||
      status === 503 ||
      error === "shopify_admin_api_not_configured" ||
      error === "invalid_app_proxy_signature"
    ) {
      return hcxOrderLookupBackendMessage;
    }

    if (status === 429 || error === "too_many_lookup_attempts") {
      return "Too many lookup attempts. Please wait a few minutes and try again.";
    }

    return fallbackMessage || "Order lookup is unavailable right now. Please try again shortly.";
  };

  const syncHcxStableMobileViewport = ({ force = false } = {}) => {
    const isMobile = hcxStableMobileViewportMedia.matches;

    if (!isMobile) {
      hcxStableMobileViewportWidth = 0;
      html.style.removeProperty("--hcx-mobile-stable-vh");
      html.style.removeProperty("--hcx-mobile-hero-height");
      html.style.removeProperty("--hcx-mobile-product-media-height");
      html.style.removeProperty("--hcx-mobile-product-stage-height");
      html.style.removeProperty("--hcx-product-carousel-stage-height");
      html.style.removeProperty("--hcx-mobile-collection-hero-height");
      html.style.removeProperty("--hcx-mobile-banner-height");
      html.style.removeProperty("--hcx-mobile-launchpad-height");
      html.style.removeProperty("--hcx-mobile-card-banner-height");
      unlockHcxMobileMediaHeights();
      return;
    }

    const width = Math.round(window.innerWidth || document.documentElement.clientWidth || 0);
    const existingHeight = parseInt(html.style.getPropertyValue("--hcx-mobile-stable-vh"), 10);

    if (!force && existingHeight > 0 && hcxStableMobileViewportWidth > 0 && Math.abs(width - hcxStableMobileViewportWidth) < 24) {
      // Browser-bar height changes do not change the locked media dimensions.
      const viewportHeight = `${existingHeight}px`;
      if (html.style.getPropertyValue("--viewport-height") !== viewportHeight) {
        html.style.setProperty("--viewport-height", viewportHeight);
      }
      return;
    }

    const stableHeight = Math.round(Math.min(860, Math.max(680, width * 2.16 || 680)));
    const productMediaHeight = Math.round(Math.min(520, Math.max(420, width * 1.23 || 480)));
    const productStageHeight = getHcxMobileProductStageHeight(productMediaHeight);
    const collectionHeroHeight = Math.round(Math.min(350, Math.max(260, width * 0.88 || 320)));
    const bannerHeight = Math.round(Math.min(580, Math.max(420, width * 1.32 || 520)));
    const launchpadHeight = Math.round(Math.min(960, Math.max(880, width * 2.3 || 900)));
    const cardBannerHeight = Math.round(Math.min(480, Math.max(320, width * 1.05 || 400)));

    hcxStableMobileViewportWidth = width;
    html.style.setProperty("--hcx-mobile-stable-vh", `${stableHeight}px`);
    html.style.setProperty("--hcx-mobile-hero-height", `${stableHeight}px`);
    html.style.setProperty("--hcx-mobile-product-media-height", `${productMediaHeight}px`);
    html.style.setProperty("--hcx-mobile-product-stage-height", `${productStageHeight}px`);
    html.style.setProperty("--hcx-product-carousel-stage-height", `${productStageHeight}px`);
    html.style.setProperty("--hcx-mobile-collection-hero-height", `${collectionHeroHeight}px`);
    html.style.setProperty("--hcx-mobile-banner-height", `${bannerHeight}px`);
    html.style.setProperty("--hcx-mobile-launchpad-height", `${launchpadHeight}px`);
    html.style.setProperty("--hcx-mobile-card-banner-height", `${cardBannerHeight}px`);
    html.style.setProperty("--viewport-height", `${stableHeight}px`);
    requestHcxMobileMediaLock();
  };

  const initHeaderAccountPointsGuard = () => {
    const headerIcons = document.querySelector(".section-header .header__icons");
    if (!headerIcons || headerIcons.dataset.hcxAccountPointsGuard === "true") return;

    headerIcons.dataset.hcxAccountPointsGuard = "true";

    const injectedPointsSelector = [
      ".shopify-app-block",
      ".shopify-block",
      "[class*='avada' i]",
      "[id*='avada' i]",
      "[class*='joy' i]",
      "[id*='joy' i]",
      "[class*='loyalty' i]",
      "[id*='loyalty' i]",
      "[class*='points' i]",
      "[id*='points' i]",
      "[class*='balance' i]",
      "[id*='balance' i]",
      "[data-hcx-header-points]",
      "[data-hcx-account-points]",
    ].join(",");
    const protectedHeaderSelector = [
      ".hcx-header-utility-link",
      ".hcx-header-saves-link",
      ".header__search",
      ".desktop-localization-wrapper",
      ".header__icon--account",
      ".header__icon--cart",
      "#cart-icon-bubble",
    ].join(",");
    const lonePointsTextPattern = /^(?:0|[\d,]+\s*(?:pts?|points?)?)$/i;
    const accountPointsTextPattern = /\b(?:gold|pts?|points?)\b/i;

    const hideNode = (node) => {
      if (!node || node.nodeType !== Node.ELEMENT_NODE) return;
      if (node.matches(protectedHeaderSelector)) return;
      node.hidden = true;
      node.setAttribute("aria-hidden", "true");
      node.style.setProperty("display", "none", "important");
    };

    const hideInjectedDescendant = (node) => {
      if (!node || node.nodeType !== Node.ELEMENT_NODE) return;
      if (node.matches("svg, path, circle, rect, line, polyline, .svg-wrapper, account-icon, shop-user-avatar, .visually-hidden")) return;
      node.hidden = true;
      node.setAttribute("aria-hidden", "true");
      node.style.setProperty("display", "none", "important");
    };

    const scrubInlinePointText = (root) => {
      if (!root) return;
      root.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && accountPointsTextPattern.test(node.textContent || "")) {
          node.textContent = "";
        }
      });
    };

    const scrubHeaderChildren = () => {
      Array.from(headerIcons.children).forEach((child) => {
        if (child.matches(protectedHeaderSelector)) return;
        const text = child.textContent.trim();
        if (child.matches(injectedPointsSelector) || lonePointsTextPattern.test(text) || accountPointsTextPattern.test(text)) {
          hideNode(child);
        }
      });
    };

    const scrubHeaderZeroBadges = () => {
      headerIcons.querySelectorAll("*").forEach((node) => {
        if (node.matches("svg, path, circle, rect, line, polyline, .svg-wrapper, account-icon, shop-user-avatar, .visually-hidden")) return;
        if (node.textContent.trim() !== "0") return;

        const badge = node.closest(".cart-count-bubble, .hcx-header-saves-link__count") || node;
        if (badge.matches(".header__icon--cart, #cart-icon-bubble, .header__icon--account")) return;
        hideInjectedDescendant(badge);
      });

      const walker = document.createTreeWalker(headerIcons, NodeFilter.SHOW_TEXT);
      const textNodes = [];
      while (walker.nextNode()) textNodes.push(walker.currentNode);
      textNodes.forEach((node) => {
        if (node.textContent.trim() === "0") node.textContent = "";
      });
    };

    const scrubAccountDescendants = (account) => {
      scrubInlinePointText(account);
      account.querySelectorAll(injectedPointsSelector).forEach(hideInjectedDescendant);
      account.querySelectorAll("*").forEach((node) => {
        if (node.matches("svg, path, circle, rect, line, polyline, .visually-hidden")) return;
        if (node.matches(".svg-wrapper, account-icon, shop-user-avatar")) {
          scrubInlinePointText(node);
          return;
        }
        const text = node.textContent.trim();
        if (lonePointsTextPattern.test(text) || accountPointsTextPattern.test(text)) hideInjectedDescendant(node);
      });
    };

    const scrubSiblingRun = (startNode, direction) => {
      let sibling = startNode;
      while (sibling) {
        if (sibling.nodeType === Node.TEXT_NODE && (lonePointsTextPattern.test(sibling.textContent.trim()) || accountPointsTextPattern.test(sibling.textContent || ""))) {
          sibling.textContent = "";
        } else if (sibling.nodeType === Node.ELEMENT_NODE) {
          if (
            direction === "next" &&
            sibling.matches(".header__icon--cart, #cart-icon-bubble")
          ) {
            break;
          }
          if (
            direction === "previous" &&
            sibling.matches(".header__search, .desktop-localization-wrapper, .hcx-header-saves-link")
          ) {
            break;
          }

          const text = sibling.textContent.trim();
          if (sibling.matches(injectedPointsSelector) || lonePointsTextPattern.test(text) || accountPointsTextPattern.test(text)) {
            hideNode(sibling);
          }
        }
        sibling = direction === "next" ? sibling.nextSibling : sibling.previousSibling;
      }
    };

    const scrubAccount = () => {
      const account = headerIcons.querySelector(".header__icon--account");
      scrubHeaderChildren();
      scrubHeaderZeroBadges();
      if (!account) return;

      account.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && (lonePointsTextPattern.test(node.textContent.trim()) || accountPointsTextPattern.test(node.textContent || ""))) {
          node.textContent = "";
        }
      });

      scrubAccountDescendants(account);
      scrubSiblingRun(account.previousSibling, "previous");
      scrubSiblingRun(account.nextSibling, "next");
    };

    scrubAccount();

    const observer = new MutationObserver(scrubAccount);
    observer.observe(headerIcons, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  };

  function clearHcxMobileLockedHeight(element) {
    if (!element) return;
    element.removeAttribute("data-hcx-mobile-locked-height");
    element.style.removeProperty("height");
    element.style.removeProperty("min-height");
    element.style.removeProperty("max-height");
  }

  function getHcxMobileProductStageHeight(height) {
    const width = Math.round(window.innerWidth || document.documentElement.clientWidth || 390);
    const railHeight = Math.min(66, Math.max(56, width * 0.1595 || 62));
    return Math.round(Math.min(height, Math.max(320, height - railHeight - 24)));
  }

  function getHcxMobileLockedHeightForElement(element, height) {
    const carousel = element?.closest?.(".template-product .hcx-product-carousel");
    if (!carousel || element === carousel || element.matches?.(".hcx-product-carousel")) return height;
    if (carousel.closest?.(".hcx-product-media-wrapper--mobile-clean")) return height;
    return getHcxMobileProductStageHeight(height);
  }

  function setHcxMobileLockedHeight(element, height) {
    if (!element || height <= 0) return;
    if (element.matches?.(".thumbnail-slider") || element.closest?.(".thumbnail-slider")) return;
    if (isHcxSummerSaleSlideElement(element)) return;
    if (isHcxSs26SlideElement(element)) {
      releaseHcxSs26SlideElement(element);
      return;
    }
    if (isHcxLaunchpadArtwork(element)) return;
    if (isHcxHeroInteractiveContent(element)) return;

    if (element.closest(".hcx-info-page--returns")) {
      clearHcxMobileLockedHeight(element);
      return;
    }

    const style = element.style;
    const criticalValue = element.dataset.hcxCriticalMobileBannerFreeze;
    if (criticalValue && /^[0-9.]+px$/.test(criticalValue)) {
      element.dataset.hcxMobileLockedHeight = criticalValue;
      style.setProperty("height", criticalValue, "important");
      style.setProperty("min-height", criticalValue, "important");
      style.setProperty("max-height", criticalValue, "important");
      return;
    }

    const value = `${getHcxMobileLockedHeightForElement(element, height)}px`;
    const isAlreadyLocked =
      element.dataset.hcxMobileLockedHeight === value &&
      style.getPropertyValue("height") === value &&
      style.getPropertyPriority("height") === "important" &&
      style.getPropertyValue("min-height") === value &&
      style.getPropertyPriority("min-height") === "important" &&
      style.getPropertyValue("max-height") === value &&
      style.getPropertyPriority("max-height") === "important";

    if (isAlreadyLocked) return;

    element.dataset.hcxMobileLockedHeight = value;
    style.setProperty("height", value, "important");
    style.setProperty("min-height", value, "important");
    style.setProperty("max-height", value, "important");
  }

  function isHcxLaunchpadArtwork(element) {
    return element?.matches?.(
      "body.template-index [id$='__studios_slide'] .hcx-category__placeholder-slide img, body.template-index [id$='__lckd_in_slide'] .hcx-category__placeholder-slide img"
    );
  }

  function isHcxSummerSaleSlideElement(element) {
    return Boolean(document.body?.classList?.contains("template-index") && element?.closest?.("[id$='__summer_sale_slide']"));
  }

  function isHcxSs26SlideElement(element) {
    return Boolean(
      document.body?.classList?.contains("template-index") &&
        element?.closest?.(
          "[id$='__new_arrivals_slide'], [id*='__preseason_hoodies_slide'], [id$='__hercstudios_slide_20260903']"
        )
    );
  }

  function releaseHcxSs26SlideElement(element) {
    if (!element) return;
    element.removeAttribute("data-hcx-mobile-locked-height");
    if (element.matches?.(".hcx-category__placeholder-slide--image")) {
      element.style.setProperty("height", "auto", "important");
      element.style.setProperty("min-height", "0", "important");
      element.style.setProperty("max-height", "none", "important");
      return;
    }
    if (element.matches?.(".hcx-category__placeholder-slide img")) {
      element.style.setProperty("height", "100%", "important");
      element.style.setProperty("min-height", "0", "important");
      element.style.setProperty("max-height", "none", "important");
      return;
    }
    clearHcxMobileLockedHeight(element);
  }

  function isHcxHeroInteractiveContent(element) {
    return Boolean(
      element?.matches?.(
        ".hcx-hero__content, .hcx-hero__content-inner, .hcx-hero .hcx-actions, .hcx-hero .hcx-btn, .hcx-hero a, .hcx-hero button"
      ) || element?.closest?.(".hcx-hero .hcx-actions")
    );
  }

  function releaseHcxHomepageHeroCta() {
    document
      .querySelectorAll("body.template-index #MainContent > .shopify-section:first-child .hcx-hero__content, body.template-index #MainContent > .shopify-section:first-child .hcx-hero__content-inner")
      .forEach((element) => {
        element.removeAttribute("data-hcx-mobile-locked-height");
        element.style.removeProperty("height");
        element.style.removeProperty("min-height");
        element.style.removeProperty("max-height");
        element.style.setProperty("overflow", "visible", "important");
      });

    document
      .querySelectorAll("body.template-index #MainContent > .shopify-section:first-child .hcx-hero .hcx-actions")
      .forEach((actions) => {
        actions.removeAttribute("data-hcx-mobile-locked-height");
        actions.style.setProperty("display", "flex", "important");
        actions.style.setProperty("justify-content", "center", "important");
        actions.style.setProperty("align-items", "center", "important");
        actions.style.setProperty("align-self", "center", "important");
        actions.style.setProperty("justify-self", "center", "important");
        actions.style.setProperty("width", "auto", "important");
        actions.style.setProperty("height", "auto", "important");
        actions.style.setProperty("min-height", "0", "important");
        actions.style.setProperty("max-height", "none", "important");
        actions.style.setProperty("overflow", "visible", "important");
      });

    document
      .querySelectorAll("body.template-index #MainContent > .shopify-section:first-child .hcx-hero .hcx-actions .hcx-btn")
      .forEach((button) => {
        button.removeAttribute("data-hcx-mobile-locked-height");
        button.style.setProperty("display", "inline-flex", "important");
        button.style.setProperty("flex", "0 0 auto", "important");
        button.style.setProperty("align-self", "center", "important");
        button.style.setProperty("width", "auto", "important");
        button.style.setProperty("min-width", "11.8rem", "important");
        button.style.setProperty("max-width", "calc(100vw - 3.6rem)", "important");
        button.style.setProperty("height", "3.8rem", "important");
        button.style.setProperty("min-height", "3.8rem", "important");
        button.style.setProperty("max-height", "3.8rem", "important");
        button.style.setProperty("padding", "0 1.85rem", "important");
        button.style.setProperty("line-height", "1", "important");
        button.style.setProperty("-webkit-backdrop-filter", "none", "important");
        button.style.setProperty("backdrop-filter", "none", "important");
        button.style.setProperty("overflow", "hidden", "important");
      });
  }

  function unlockHcxMobileMediaHeights() {
    document.querySelectorAll("[data-hcx-mobile-locked-height]").forEach((element) => {
      clearHcxMobileLockedHeight(element);
    });
    clearHcxLaunchpadArtwork();
  }

  function clearHcxLaunchpadArtwork() {
    document
      .querySelectorAll(
        "body.template-index [id$='__studios_slide'], body.template-index [id$='__lckd_in_slide'], body.template-index [id$='__studios_slide'] .hcx-category__placeholder-slide, body.template-index [id$='__lckd_in_slide'] .hcx-category__placeholder-slide, body.template-index [id$='__studios_slide'] .hcx-category__placeholder-slide--image, body.template-index [id$='__lckd_in_slide'] .hcx-category__placeholder-slide--image, body.template-index [id$='__studios_slide'] .hcx-category__placeholder-content, body.template-index [id$='__lckd_in_slide'] .hcx-category__placeholder-content, body.template-index [id$='__studios_slide'] .hcx-category__placeholder-slide img, body.template-index [id$='__lckd_in_slide'] .hcx-category__placeholder-slide img"
      )
      .forEach((element) => {
        element.removeAttribute("data-hcx-mobile-locked-height");
        element.style.removeProperty("height");
        element.style.removeProperty("min-height");
        element.style.removeProperty("max-height");
        element.style.removeProperty("overflow");
      });

    document
      .querySelectorAll(
        "body.template-index [id$='__studios_slide'] .hcx-category__placeholder-slide img, body.template-index [id$='__lckd_in_slide'] .hcx-category__placeholder-slide img"
      )
      .forEach((image) => {
        image.style.removeProperty("position");
        image.style.removeProperty("top");
        image.style.removeProperty("right");
        image.style.removeProperty("bottom");
        image.style.removeProperty("left");
        image.style.removeProperty("width");
        image.style.removeProperty("object-fit");
        image.style.removeProperty("object-position");
        image.style.removeProperty("transform");
        image.style.removeProperty("scale");
      });
  }

  function lockHcxMobileMediaHeights() {
    if (!hcxStableMobileViewportMedia.matches) {
      unlockHcxMobileMediaHeights();
      return;
    }

    const rootStyles = getComputedStyle(html);
    const width = Math.round(window.innerWidth || document.documentElement.clientWidth || 0);
    const fallbackHeroHeight = Math.round(Math.min(860, Math.max(680, width * 2.16 || 680)));
    const fallbackCollectionHeight = Math.round(Math.min(350, Math.max(260, width * 0.88 || 320)));
    const fallbackProductHeight = Math.round(Math.min(520, Math.max(420, width * 1.23 || 480)));
    const fallbackBannerHeight = Math.round(Math.min(580, Math.max(420, width * 1.32 || 520)));
    const fallbackLaunchpadHeight = Math.round(Math.min(960, Math.max(880, width * 2.3 || 900)));
    const fallbackCardBannerHeight = Math.round(Math.min(480, Math.max(320, width * 1.05 || 400)));
    const readPixelProperty = (name, fallback) => {
      const value = rootStyles.getPropertyValue(name).trim();
      const pixels = value.endsWith("px") ? parseFloat(value) : NaN;
      return Math.round(Number.isFinite(pixels) ? pixels : fallback);
    };
    const heroHeight = readPixelProperty("--hcx-mobile-hero-height", fallbackHeroHeight);
    const collectionHeight = readPixelProperty("--hcx-mobile-collection-hero-height", fallbackCollectionHeight);
    const productHeight = readPixelProperty("--hcx-mobile-product-media-height", fallbackProductHeight);
    const bannerHeight = readPixelProperty("--hcx-mobile-banner-height", fallbackBannerHeight);
    const launchpadHeight = readPixelProperty("--hcx-mobile-launchpad-height", fallbackLaunchpadHeight);
    const cardBannerHeight = readPixelProperty("--hcx-mobile-card-banner-height", fallbackCardBannerHeight);

    hcxMobileMediaLockSelectors.hero.forEach((selector) => {
      document.querySelectorAll(selector).forEach((element) => setHcxMobileLockedHeight(element, heroHeight));
    });
    hcxMobileMediaLockSelectors.collection.forEach((selector) => {
      document.querySelectorAll(selector).forEach((element) => setHcxMobileLockedHeight(element, collectionHeight));
    });
    hcxMobileMediaLockSelectors.banner.forEach((selector) => {
      document.querySelectorAll(selector).forEach((element) => setHcxMobileLockedHeight(element, bannerHeight));
    });
    hcxMobileMediaLockSelectors.cardBanner.forEach((selector) => {
      document.querySelectorAll(selector).forEach((element) => setHcxMobileLockedHeight(element, cardBannerHeight));
    });
    hcxMobileMediaLockSelectors.product.forEach((selector) => {
      document.querySelectorAll(selector).forEach((element) => setHcxMobileLockedHeight(element, productHeight));
    });
    positionHcxLaunchpadArtwork(launchpadHeight);
    releaseHcxHomepageHeroCta();
  }

  function positionHcxLaunchpadArtwork(height) {
    if (height <= 0) return;

    const value = `${height}px`;
    const lockLaunchpadBox = (element) => {
      if (!element) return;
      element.dataset.hcxMobileLockedHeight = value;
      element.style.setProperty("height", value, "important");
      element.style.setProperty("min-height", value, "important");
      element.style.setProperty("max-height", value, "important");
      element.style.setProperty("overflow", "hidden", "important");
    };

    document
      .querySelectorAll(
        "body.template-index [id$='__studios_slide'], body.template-index [id$='__lckd_in_slide'], body.template-index [id$='__studios_slide'] .hcx-category__placeholder-slide, body.template-index [id$='__lckd_in_slide'] .hcx-category__placeholder-slide, body.template-index [id$='__studios_slide'] .hcx-category__placeholder-slide--image, body.template-index [id$='__lckd_in_slide'] .hcx-category__placeholder-slide--image, body.template-index [id$='__studios_slide'] .hcx-category__placeholder-content, body.template-index [id$='__lckd_in_slide'] .hcx-category__placeholder-content"
      )
      .forEach(lockLaunchpadBox);

    document
      .querySelectorAll(
        "body.template-index [id$='__studios_slide'] .hcx-category__placeholder-slide img, body.template-index [id$='__lckd_in_slide'] .hcx-category__placeholder-slide img"
      )
      .forEach((image) => {
        image.dataset.hcxMobileLockedHeight = value;
        image.style.setProperty("position", "absolute", "important");
        image.style.setProperty("top", "0", "important");
        image.style.setProperty("right", "0", "important");
        image.style.setProperty("bottom", "0", "important");
        image.style.setProperty("left", "0", "important");
        image.style.setProperty("width", "100%", "important");
        image.style.setProperty("height", value, "important");
        image.style.setProperty("min-height", value, "important");
        image.style.setProperty("max-height", value, "important");
        image.style.setProperty("object-fit", "cover", "important");
        image.style.setProperty("object-position", "center bottom", "important");
        image.style.setProperty("transform", "none", "important");
        image.style.setProperty("scale", "1", "important");
      });
  }

  function requestHcxMobileMediaLock() {
    if (hcxMobileMediaLockFrame) return;
    hcxMobileMediaLockFrame = window.requestAnimationFrame(() => {
      hcxMobileMediaLockFrame = 0;
      lockHcxMobileMediaHeights();
    });
  }

  function initHcxMobileMediaMutationLock() {
    if (hcxMobileMediaMutationObserver || !("MutationObserver" in window)) return;

    let mutationLockCount = 0;
    hcxMobileMediaMutationObserver = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.addedNodes.length || mutation.removedNodes.length)) {
        mutationLockCount += 1;
        requestHcxMobileMediaLock();
        if (mutationLockCount >= 2) hcxMobileMediaMutationObserver.disconnect();
      }
    });
    hcxMobileMediaMutationObserver.observe(document.getElementById("MainContent") || document.body, {
      childList: true,
      subtree: true,
    });
  }

  syncHcxStableMobileViewport({ force: true });
  initHcxMobileMediaMutationLock();
  window.addEventListener("resize", () => syncHcxStableMobileViewport(), { passive: true });
  window.visualViewport?.addEventListener("resize", () => syncHcxStableMobileViewport(), { passive: true });
  window.addEventListener("load", requestHcxMobileMediaLock, { once: true });
  document.addEventListener("shopify:section:load", requestHcxMobileMediaLock);
  hcxStableMobileViewportMedia.addEventListener?.("change", () => syncHcxStableMobileViewport({ force: true }));
  window.addEventListener("orientationchange", () => {
    hcxStableMobileViewportWidth = 0;
    html.style.removeProperty("--hcx-mobile-stable-vh");
    window.setTimeout(() => syncHcxStableMobileViewport({ force: true }), 250);
  });

  const markHcxDeferredImageLoaded = (image) => {
    image.classList.remove("is-hcx-lazy-loading");
    image.classList.add("is-hcx-lazy-loaded");

    if (image.dataset.hcxLazyHoverImage === "true") {
      image.closest(".media--hover-effect, .hcx-search-product-card__media")?.classList.add("hcx-hover-image-is-loaded");
    }
  };

  const loadHcxDeferredImage = (image) => {
    if (!(image instanceof HTMLImageElement) || image.dataset.hcxLazyLoaded === "true") return;

    const srcset = image.dataset.hcxLazySrcset;
    const src = image.dataset.hcxLazySrc;
    if (!src && !srcset) return;

    image.dataset.hcxLazyLoaded = "true";
    image.classList.add("is-hcx-lazy-loading");
    if (srcset) image.srcset = srcset;
    if (src) image.src = src;

    if (image.complete && image.naturalWidth > 0) {
      markHcxDeferredImageLoaded(image);
      return;
    }

    image.addEventListener(
      "load",
      () => markHcxDeferredImageLoaded(image),
      { once: true }
    );
  };

  const getHcxLazyImageObserver = () => {
    if (hcxLazyImageObserver || !("IntersectionObserver" in window)) return hcxLazyImageObserver;

    hcxLazyImageObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          hcxLazyImageObserver.unobserve(entry.target);
          loadHcxDeferredImage(entry.target);
        });
      },
      { rootMargin: "320px 0px" }
    );

    return hcxLazyImageObserver;
  };

  const bindHcxDeferredImages = (root = document) => {
    const images = [];
    if (root instanceof HTMLImageElement && root.dataset.hcxLazySrc) images.push(root);
    if (root?.querySelectorAll) images.push(...root.querySelectorAll("img[data-hcx-lazy-src]"));

    images.forEach((image) => {
      if (image.dataset.hcxLazyBound === "true") return;
      image.dataset.hcxLazyBound = "true";
      if (!image.getAttribute("src")) image.src = hcxTransparentImage;
      if (
        image.dataset.hcxLazyHoverImage === "true" &&
        image.complete &&
        image.naturalWidth > 0 &&
        image.currentSrc &&
        image.currentSrc !== hcxTransparentImage
      ) {
        markHcxDeferredImageLoaded(image);
      }

      const intentRoot =
        image.closest(".card-wrapper, .product-card-wrapper, .hcx-search-product-card, .hcx-search-product-card__media") ||
        image.parentElement;
      const load = () => loadHcxDeferredImage(image);
      if (!image.closest("[data-hcx-card-gallery]")) {
        intentRoot?.addEventListener("pointerenter", (event) => {
          if (event.pointerType !== "touch") load();
        }, { passive: true });
        intentRoot?.addEventListener("focusin", load, { once: true });
      }

      if (image.dataset.hcxLazyHoverImage === "true") return;

      const observer = getHcxLazyImageObserver();
      if (observer) {
        observer.observe(image);
      } else {
        window.setTimeout(load, 300);
      }
    });

    if (html.dataset.hcxDeferredImageObserverBound === "true" || !document.body || !("MutationObserver" in window)) return;
    html.dataset.hcxDeferredImageObserverBound = "true";
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) bindHcxDeferredImages(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  };

  const getHomeHero = () =>
    document.querySelector(
      ".section-hcx-hero, .section-hcx-product-slideshow, main .shopify-section:first-child"
    );

  const getCollectionHero = () => document.querySelector(".hcx-collection-hero--cinematic");

  const isHeaderOverPictureBanner = (selector) => {
    if (!header) return false;

    const headerRect = header.getBoundingClientRect();
    const headerTop = Math.max(headerRect.top, 0);
    const headerHeight = header.offsetHeight || headerRect.height || 0;
    const headerBottom = headerTop + headerHeight;
    const pictureBanners = document.querySelectorAll(selector);

    return Array.from(pictureBanners).some((banner) => {
      const bannerRect = banner.getBoundingClientRect();

      return bannerRect.bottom > headerTop + 2 && bannerRect.top < headerBottom - 2;
    });
  };

  const isHeaderOverHomePictureBanner = () =>
    isHome &&
    isHeaderOverPictureBanner(
      ".section-hcx-hero, .section-hcx-product-slideshow, .section-hcx-category-grid .hcx-category__placeholder-slide--image"
    );

  const getAnnouncementHeight = () => {
    const announcement =
      document.querySelector(".announcement-bar-section") ||
      document.querySelector(".announcement-bar")?.closest(".shopify-section") ||
      document.querySelector(".announcement-bar");
    const height = announcement?.offsetHeight || announcement?.getBoundingClientRect().height || 0;

    return Math.round(height);
  };

  const syncHomeHeader = () => {
    if (!isHome || !header) return;

    const hero = getHomeHero();
    const announcementHeight = getAnnouncementHeight();
    const headerHeight = header.offsetHeight || 0;
    const currentScrollY = Math.max(window.scrollY, 0);
    const isScrollingDown = currentScrollY > lastSyncedScrollY;
    const pinToViewport = window.scrollY > Math.max(announcementHeight - 1, 0);
    const triggerLine = pinToViewport ? headerHeight : announcementHeight + headerHeight;
    const pastHero = hero ? hero.getBoundingClientRect().bottom <= triggerLine + 2 : window.scrollY > 18;
    const solid = pastHero && !isScrollingDown && !isHeaderOverHomePictureBanner();

    html.style.setProperty("--hcx-home-header-top", `${announcementHeight}px`);
    html.classList.toggle("hcx-home-header-at-window-top", pinToViewport);
    html.classList.toggle("hcx-home-header-solid", solid);
    header.classList.toggle("hcx-home-header-solid", solid);
  };

  const syncCollectionHeader = () => {
    if (!isCollection || !header) return;

    const hero = getCollectionHero();
    if (!hero) {
      html.classList.remove("hcx-collection-header-solid");
      html.classList.remove("hcx-collection-header-past-hero");
      header.classList.remove("hcx-collection-header-solid");
      header.classList.remove("hcx-collection-header-past-hero");
      return;
    }

    const announcementHeight = getAnnouncementHeight();
    const headerHeight = header.offsetHeight || 0;
    const currentScrollY = Math.max(window.scrollY, 0);
    const isScrollingUp = currentScrollY < lastSyncedScrollY;
    const pinToViewport = window.scrollY > Math.max(announcementHeight - 1, 0);
    const triggerLine = pinToViewport ? headerHeight : announcementHeight + headerHeight;
    const pastHero = hero.getBoundingClientRect().bottom <= triggerLine + 2;
    const solid = pastHero && isScrollingUp;
    const hidden = pastHero && !solid;

    html.classList.toggle("hcx-collection-header-past-hero", hidden);
    header.classList.toggle("hcx-collection-header-past-hero", hidden);
    html.classList.toggle("hcx-collection-header-solid", solid);
    header.classList.toggle("hcx-collection-header-solid", solid);

    if (solid) {
      header.classList.add("shopify-section-header-sticky");
      header.classList.remove("shopify-section-header-hidden", "hcx-header-scroll-hidden");
    }
  };

  const syncHeader = () => {
    html.classList.toggle("hcx-scrolled", window.scrollY > 18);
    syncHomeHeader();
    syncCollectionHeader();
    lastSyncedScrollY = Math.max(window.scrollY, 0);
  };

  syncHeader();
  let hcxHeaderSyncFrame = 0;
  const requestHcxHeaderSync = () => {
    if (hcxHeaderSyncFrame) return;
    hcxHeaderSyncFrame = window.requestAnimationFrame(() => {
      hcxHeaderSyncFrame = 0;
      syncHeader();
    });
  };
  window.addEventListener("scroll", requestHcxHeaderSync, { passive: true });
  window.addEventListener("resize", requestHcxHeaderSync, { passive: true });

  const syncCollectionPurposeCopy = () => {
    document.querySelectorAll("[data-hcx-collection-purpose-copy]").forEach((description) => {
      const copy = description.dataset.hcxCollectionPurposeCopy || "";
      if (!copy) return;

      let paragraph = description.querySelector("p");
      if (!paragraph) {
        paragraph = document.createElement("p");
        description.replaceChildren(paragraph);
      }

      if (paragraph.textContent.trim() !== copy) paragraph.textContent = copy;
    });
  };

  syncCollectionPurposeCopy();
  window.addEventListener("load", syncCollectionPurposeCopy);
  window.setTimeout(syncCollectionPurposeCopy, 250);
  window.setTimeout(syncCollectionPurposeCopy, 1200);

  if (header) {
    const stickyType = header.querySelector("sticky-header")?.dataset.stickyType || "none";
    const shouldAutoHideHeader = stickyType !== "none";
    const mobileHeaderMedia = window.matchMedia("(max-width: 749px), (hover: none), (pointer: coarse)");
    const isMobileHeaderViewport = () => mobileHeaderMedia.matches;
    let lastHeaderScrollY = window.scrollY;
    let headerScrollFrame = null;
    const getHeaderScrollHidePoint = () => {
      const headerHeight = header.offsetHeight || 0;

      if (isHome || isCollection) {
        const hero = isHome ? getHomeHero() : getCollectionHero();

        if (hero) {
          const headerRect = header.getBoundingClientRect();
          const headerBottomLine = Math.max(headerRect.top, 0) + (headerHeight || headerRect.height || 0);
          const heroBottom = hero.getBoundingClientRect().bottom + window.scrollY;

          return Math.max(headerHeight, heroBottom - headerBottomLine);
        }
      }

      const documentHeight = Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.offsetHeight
      );
      const scrollableHeight = Math.max(documentHeight - window.innerHeight, 0);

      return Math.max(headerHeight, scrollableHeight * 0.05);
    };

    const shouldKeepHeaderOpen = () =>
      header.classList.contains("menu-open") ||
      document.body.classList.contains("hcx-menu-open") ||
      document.body.classList.contains("overflow-hidden") ||
      header.matches(":hover") ||
      header.matches(":focus-within") ||
      document.querySelector("cart-drawer.active, .cart-drawer.active, .drawer.active, details[open] .menu-drawer");

    const syncHeaderScrollDirection = () => {
      headerScrollFrame = null;

      const currentScrollY = Math.max(window.scrollY, 0);
      const scrollDelta = currentScrollY - lastHeaderScrollY;
      const canHideHeader = currentScrollY >= getHeaderScrollHidePoint();

      if (!shouldAutoHideHeader || !canHideHeader || shouldKeepHeaderOpen()) {
        header.classList.remove("hcx-header-scroll-hidden");
      } else if (scrollDelta > 0) {
        header.classList.add("hcx-header-scroll-hidden");
      } else if (scrollDelta < 0) {
        header.classList.remove("hcx-header-scroll-hidden");
      }

      lastHeaderScrollY = currentScrollY;
    };

    const requestHeaderScrollSync = () => {
      if (headerScrollFrame) return;
      headerScrollFrame = window.requestAnimationFrame(syncHeaderScrollDirection);
    };

    const resetMobileHeaderScrollState = () => {
      lastHeaderScrollY = Math.max(window.scrollY, 0);
      header.classList.remove("hcx-header-scroll-hidden");
      if (isMobileHeaderViewport()) header.classList.remove("shopify-section-header-hidden");
    };

    window.addEventListener("scroll", requestHeaderScrollSync, { passive: true });
    window.addEventListener("resize", () => {
      resetMobileHeaderScrollState();
    });
    mobileHeaderMedia.addEventListener("change", resetMobileHeaderScrollState);
    header.addEventListener("mouseenter", () => header.classList.remove("hcx-header-scroll-hidden"));
    header.addEventListener("focusin", () => header.classList.remove("hcx-header-scroll-hidden"));
  }

  if (header) {
    const observer = new MutationObserver(() => {
      document.body.classList.toggle("hcx-menu-open", header.classList.contains("menu-open"));
    });

    observer.observe(header, { attributes: true, attributeFilter: ["class"] });
  }

  const initClickableHeroes = () => {
    document.querySelectorAll("[data-hcx-clickable-hero]").forEach((hero) => {
      if (!(hero instanceof HTMLElement)) return;
      if (hero.dataset.hcxClickableHeroBound === "true") return;

      const getPrimaryAction = () => hero.querySelector(".hcx-actions .hcx-btn--light, [data-hcx-hero-primary-action]");
      const hasNestedInteractiveTarget = (target) => {
        if (!(target instanceof Element)) return false;

        const interactive = target.closest("a, button, input, select, textarea, summary, label, [role='button'], [role='link']");
        return Boolean(interactive && interactive !== hero);
      };
      const activateHero = () => {
        const primaryAction = getPrimaryAction();
        const targetHref = hero.dataset.hcxClickableHeroTarget || "";

        if (targetHref) {
          window.location.href = targetHref;
          return;
        }

        if (primaryAction instanceof HTMLAnchorElement && primaryAction.href) {
          window.location.href = primaryAction.href;
          return;
        }

        if (primaryAction instanceof HTMLElement) primaryAction.click();
      };

      if (!hero.dataset.hcxClickableHeroTarget && !getPrimaryAction()) return;

      hero.dataset.hcxClickableHeroBound = "true";
      hero.addEventListener("click", (event) => {
        if (hasNestedInteractiveTarget(event.target)) return;

        activateHero();
      });
      hero.addEventListener("keydown", (event) => {
        if (event.key !== "Enter" && event.key !== " ") return;
        if (hasNestedInteractiveTarget(event.target)) return;

        event.preventDefault();
        activateHero();
      });
    });
  };

  document.querySelectorAll("[data-hcx-shop-menu]").forEach((menu) => {
    const trigger = menu.querySelector("[data-hcx-shop-trigger]");
    const panel = menu.querySelector(".hcx-shop-mega");
    const header = menu.closest(".section-header");
    const closeDelay = 120;
    let closeTimer;
    let lastPointerEvent;

    const updatePanelTop = () => {
      const header = document.querySelector(".section-header");
      const headerRect = header?.getBoundingClientRect();
      const headerStyle = header ? window.getComputedStyle(header) : null;
      const panelTop =
        headerStyle?.position === "fixed" ? headerRect?.height || 0 : headerRect?.bottom || 0;

      menu.style.setProperty("--hcx-shop-panel-top", `${Math.max(0, panelTop)}px`);
    };

    const clearCloseTimer = () => {
      window.clearTimeout(closeTimer);
    };

    const setOpen = (isOpen) => {
      if (isOpen) {
        clearCloseTimer();
        updatePanelTop();
      }
      menu.classList.toggle("is-open", isOpen);
      html.classList.toggle("hcx-shop-open", isOpen);
      trigger?.setAttribute("aria-expanded", isOpen ? "true" : "false");
    };

    const scheduleClose = (event) => {
      if (event) lastPointerEvent = event;
      clearCloseTimer();
      closeTimer = window.setTimeout(() => {
        closeTimer = 0;
        if (menu.matches(":focus-within")) return;
        if (lastPointerEvent && isPointerInMenuZone(lastPointerEvent)) return;
        setOpen(false);
      }, closeDelay);
    };

    const isHoverPointer = () => window.matchMedia("(hover: hover) and (pointer: fine)").matches;

    const isPointInRect = (event, rect, padding = 0) =>
      rect &&
      event.clientX >= rect.left - padding &&
      event.clientX <= rect.right + padding &&
      event.clientY >= rect.top - padding &&
      event.clientY <= rect.bottom + padding;

    const isOtherHeaderControl = (target) => {
      if (!(target instanceof Element) || !header) return false;
      const control = target.closest("a, button, summary, [role='button']");
      return Boolean(control && header.contains(control) && !menu.contains(control));
    };

    const isPointerInMenuZone = (event) => {
      if (isOtherHeaderControl(event.target)) return false;
      const triggerRect = trigger?.getBoundingClientRect();
      const panelRect = panel?.getBoundingClientRect();
      const panelTop = panelRect?.top ?? triggerRect?.bottom ?? 0;
      const bridgeTop = triggerRect?.bottom ?? panelTop;

      return (
        isPointInRect(event, triggerRect, 12) ||
        (menu.classList.contains("is-open") && isPointInRect(event, panelRect, 10)) ||
        (menu.classList.contains("is-open") &&
          event.clientX >= 0 &&
          event.clientX <= window.innerWidth &&
          event.clientY >= bridgeTop &&
          event.clientY <= panelTop + 10)
      );
    };

    menu.addEventListener("mouseenter", () => setOpen(true));
    menu.addEventListener("mouseleave", scheduleClose);
    panel?.addEventListener("mouseenter", () => setOpen(true));
    panel?.addEventListener("mouseleave", scheduleClose);
    const closeForSiblingHeaderLink = () => {
      lastPointerEvent = null;
      clearCloseTimer();
      setOpen(false);
    };
    header?.querySelectorAll("a, button, summary, [role='button']").forEach((control) => {
      if (menu.contains(control)) return;
      control.addEventListener("pointerenter", closeForSiblingHeaderLink);
      control.addEventListener("focusin", closeForSiblingHeaderLink);
    });
    document.addEventListener(
      "pointermove",
      (event) => {
        if (!isHoverPointer()) return;
        if (isOtherHeaderControl(event.target)) {
          closeForSiblingHeaderLink();
          return;
        }
        lastPointerEvent = event;
        if (isPointerInMenuZone(event)) {
          setOpen(true);
        } else if (menu.classList.contains("is-open")) {
          scheduleClose(event);
        }
      },
      { passive: true }
    );
    trigger?.addEventListener("click", (event) => {
      const shouldNavigate =
        trigger instanceof HTMLAnchorElement &&
        trigger.href &&
        window.matchMedia("(hover: hover) and (pointer: fine)").matches &&
        !event.metaKey &&
        !event.ctrlKey &&
        !event.shiftKey &&
        !event.altKey &&
        event.button === 0;

      if (shouldNavigate) return;

      event.preventDefault();
      clearCloseTimer();
      setOpen(!menu.classList.contains("is-open"));
    });
    document.addEventListener("click", (event) => {
      if (!menu.contains(event.target)) {
        clearCloseTimer();
        setOpen(false);
      }
    });
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && menu.classList.contains("is-open")) {
        clearCloseTimer();
        setOpen(false);
      }
    });
    window.addEventListener("resize", () => {
      if (menu.classList.contains("is-open")) updatePanelTop();
    });
    window.addEventListener(
      "scroll",
      () => {
        if (menu.classList.contains("is-open")) updatePanelTop();
      },
      { passive: true }
    );
    menu.addEventListener("focusin", () => setOpen(true));
    menu.addEventListener("focusout", (event) => {
      if (!menu.contains(event.relatedTarget)) setOpen(false);
    });
    menu.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;
      clearCloseTimer();
      setOpen(false);
      trigger?.focus();
    });
  });

  document.querySelectorAll("[data-hcx-parallax]").forEach((media) => {
    if (window.matchMedia("(prefers-reduced-motion: reduce), (max-width: 749px), (hover: none), (pointer: coarse)").matches) {
      media.style.removeProperty("--hcx-parallax-y");
      return;
    }

    const move = () => {
      const rect = media.getBoundingClientRect();
      const progress = (rect.top + rect.height / 2 - window.innerHeight / 2) / window.innerHeight;
      media.style.setProperty("--hcx-parallax-y", `${Math.max(-16, Math.min(16, progress * -26))}px`);
    };

    move();
    window.addEventListener("scroll", move, { passive: true });
  });

  const initFastNavigationPrefetch = () => {
    if (["localhost", "127.0.0.1", "::1"].includes(window.location.hostname)) return;
    if (navigator.connection?.saveData) return;

    const prefetched = new Set();
    const maxPrefetches = 8;
    const skipPath = /\/(account|cart|checkout|customer_authentication|apps)\b/;

    const prefetch = (link) => {
      if (!(link instanceof HTMLAnchorElement)) return;
      if (!link.href || link.target && link.target !== "_self" || link.hasAttribute("download")) return;

      let url;
      try {
        url = new URL(link.href, window.location.href);
      } catch (_) {
        return;
      }

      if (url.origin !== window.location.origin) return;
      if (url.pathname === window.location.pathname && url.search === window.location.search) return;
      if (skipPath.test(url.pathname)) return;
      if (prefetched.has(url.href) || prefetched.size >= maxPrefetches) return;

      prefetched.add(url.href);
      const hint = document.createElement("link");
      hint.rel = "prefetch";
      hint.href = url.href;
      hint.as = "document";
      document.head.appendChild(hint);
    };

    const prefetchFromEvent = (event) => {
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      prefetch(target?.closest("a[href]"));
    };

    document.addEventListener("pointerover", prefetchFromEvent, { passive: true });
    document.addEventListener("focusin", prefetchFromEvent);
    document.addEventListener("touchstart", prefetchFromEvent, { passive: true });
  };

  initFastNavigationPrefetch();

  document.querySelectorAll("[data-hcx-slider]").forEach((slider) => {
    const slides = [...slider.querySelectorAll("[data-hcx-slide]")];
    const triggers = [...slider.querySelectorAll("[data-hcx-slide-trigger]")];
    if (slides.length < 2) return;

    let active = 0;
    let timer;
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const autoplay = !slider.hasAttribute("data-hcx-no-autoplay");

    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === active;
        slide.classList.toggle("is-active", isActive);
        slide.toggleAttribute("aria-hidden", !isActive);
      });
      triggers.forEach((trigger, triggerIndex) => {
        trigger.classList.toggle("is-active", triggerIndex === active);
      });
    };

    const start = () => {
      if (reduceMotion || !autoplay) return;
      window.clearInterval(timer);
      timer = window.setInterval(() => show(active + 1), 5200);
    };

    triggers.forEach((trigger, index) => {
      trigger.addEventListener("click", () => {
        show(index);
        start();
      });
    });

    slider.addEventListener("mouseenter", () => window.clearInterval(timer));
    slider.addEventListener("mouseleave", start);
    start();
  });

  const initProductMediaCarousels = (root = document) => {
    root.querySelectorAll("[data-hcx-product-carousel]").forEach((gallery) => {
      if (gallery.dataset.hcxProductCarouselBound === "true") return;
      gallery.dataset.hcxProductCarouselBound = "true";

      const previous = gallery.querySelector("[data-hcx-product-carousel-prev]");
      const next = gallery.querySelector("[data-hcx-product-carousel-next]");
      const currentCounter = gallery.querySelector("[data-hcx-product-carousel-current]");
      const totalCounter = gallery.querySelector("[data-hcx-product-carousel-total]");
      const list = gallery.querySelector(".product__media-list");
      let active = 0;
      let isApplying = false;
      let isAnimating = false;
      let hasInitialized = false;
      let touchStartX = 0;
      let touchStartY = 0;
      const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      const slideClasses = [
        "is-hcx-active",
        "is-hcx-enter-next",
        "is-hcx-enter-prev",
        "is-hcx-exit-next",
        "is-hcx-exit-prev",
      ];

      const getItems = () => [...gallery.querySelectorAll(".product__media-list > [data-media-id]")];
      const preloadImages = (index = active) => {
        const items = getItems();
        if (!items.length) return;

        const indexes = new Set([
          (index + items.length) % items.length,
          (index + 1) % items.length,
          (index - 1 + items.length) % items.length,
        ]);

        indexes.forEach((itemIndex) => {
          items[itemIndex]?.querySelectorAll("img[loading='lazy']").forEach((image) => {
            image.loading = "eager";
            image.decoding = "async";
            image.setAttribute("fetchpriority", itemIndex === index ? "high" : "low");
          });
        });
      };

      const setThumbnail = (mediaId) => {
        gallery.querySelectorAll("[id^='GalleryThumbnails'] [data-target] button").forEach((button) => {
          const target = button.closest("[data-target]")?.dataset.target;
          if (target === mediaId) {
            button.setAttribute("aria-current", "true");
          } else {
            button.removeAttribute("aria-current");
          }
        });
      };

      const clearMotionClasses = (item) => item?.classList.remove(...slideClasses);
      const updateCounter = (index, total) => {
        if (currentCounter) currentCounter.textContent = String(index + 1);
        if (totalCounter) totalCounter.textContent = String(total);
      };

      const show = (index, direction = 0, animate = hasInitialized) => {
        const items = getItems();
        if (!items.length || isAnimating) return;

        const nextIndex = (index + items.length) % items.length;
        preloadImages(nextIndex);
        const previousIndex = active;
        const current = items[nextIndex];
        const previousItem = items[previousIndex];
        const shouldAnimate = animate && !reduceMotion && hasInitialized && nextIndex !== previousIndex;
        const motionDirection = direction || (nextIndex > previousIndex ? 1 : -1);

        isApplying = true;

        if (!shouldAnimate) {
          active = nextIndex;
          items.forEach((item, itemIndex) => {
            const isActive = itemIndex === active;
            clearMotionClasses(item);
            item.classList.toggle("is-active", isActive);
            item.classList.toggle("is-hcx-active", isActive);
            item.toggleAttribute("aria-hidden", !isActive);
          });

          if (current?.dataset.mediaId) setThumbnail(current.dataset.mediaId);
          updateCounter(active, items.length);
          gallery.playActiveMedia?.(current);
          hasInitialized = true;

          window.requestAnimationFrame(() => {
            isApplying = false;
          });
          return;
        }

        isAnimating = true;
        const enterClass = motionDirection > 0 ? "is-hcx-enter-next" : "is-hcx-enter-prev";
        const exitClass = motionDirection > 0 ? "is-hcx-exit-next" : "is-hcx-exit-prev";

        items.forEach((item, itemIndex) => {
          if (itemIndex !== previousIndex && itemIndex !== nextIndex) {
            clearMotionClasses(item);
            item.classList.remove("is-active");
            item.setAttribute("aria-hidden", "true");
          }
        });

        clearMotionClasses(current);
        current.classList.add(enterClass);
        current.removeAttribute("aria-hidden");
        previousItem?.removeAttribute("aria-hidden");
        previousItem?.classList.add("is-hcx-active");

        current.offsetWidth;

        window.requestAnimationFrame(() => {
          active = nextIndex;
          previousItem?.classList.remove("is-active", "is-hcx-active");
          previousItem?.classList.add(exitClass);
          current.classList.remove(enterClass);
          current.classList.add("is-active", "is-hcx-active");

          if (current?.dataset.mediaId) setThumbnail(current.dataset.mediaId);
          updateCounter(active, items.length);
          gallery.playActiveMedia?.(current);

          window.setTimeout(() => {
            previousItem?.setAttribute("aria-hidden", "true");
            previousItem?.classList.remove(exitClass);
            isApplying = false;
            isAnimating = false;
          }, 470);
        });
      };

      const syncFromDawn = () => {
        const items = getItems();
        const activeIndex = items.findIndex((item) => item.classList.contains("is-active"));
        const preferredIndex =
          !hasInitialized && gallery.dataset.hcxPreferredMediaId
            ? items.findIndex((item) => item.dataset.mediaId === gallery.dataset.hcxPreferredMediaId)
            : -1;
        const nextIndex = preferredIndex >= 0 ? preferredIndex : activeIndex >= 0 ? activeIndex : active;
        show(nextIndex, nextIndex >= active ? 1 : -1);
      };

      previous?.addEventListener("click", () => show(active - 1, -1));
      next?.addEventListener("click", () => show(active + 1, 1));

      list?.addEventListener(
        "touchstart",
        (event) => {
          touchStartX = event.changedTouches[0]?.clientX || 0;
          touchStartY = event.changedTouches[0]?.clientY || 0;
        },
        { passive: true }
      );

      list?.addEventListener(
        "touchend",
        (event) => {
          const touch = event.changedTouches[0];
          if (!touch) return;

          const deltaX = touch.clientX - touchStartX;
          const deltaY = touch.clientY - touchStartY;
          if (Math.abs(deltaX) < 42 || Math.abs(deltaX) < Math.abs(deltaY) * 1.2) return;

          show(active + (deltaX < 0 ? 1 : -1), deltaX < 0 ? 1 : -1);
        },
        { passive: true }
      );

      gallery.addEventListener("click", (event) => {
        if (!event.target.closest("[data-target]")) return;
        window.requestAnimationFrame(syncFromDawn);
      });

      if (list) {
        const observer = new MutationObserver((mutations) => {
          if (isApplying) return;
          const shouldSync = mutations.some((mutation) => {
            if (mutation.type === "childList") return true;
            return mutation.target instanceof HTMLElement && mutation.target.matches("[data-media-id].is-active");
          });
          if (shouldSync) window.requestAnimationFrame(syncFromDawn);
        });

        observer.observe(list, {
          childList: true,
          attributes: true,
          attributeFilter: ["class"],
          subtree: true,
        });
      }

      syncFromDawn();
    });
  };

  initProductMediaCarousels();
  document.addEventListener("shopify:section:load", (event) => initProductMediaCarousels(event.target));

  const initCardImageGalleries = (root = document) => {
    root.querySelectorAll?.("[data-hcx-card-gallery]").forEach((gallery) => {
      if (gallery.dataset.hcxCardGalleryBound === "true") return;

      const wrapper = gallery.closest(".product-card-wrapper, .card-wrapper");
      const cardInner = gallery.closest(".card__inner");
      const images = Array.from(gallery.querySelectorAll("img[data-hcx-card-image]"));
      if (!wrapper || !cardInner || images.length < 2) return;

      gallery.dataset.hcxCardGalleryBound = "true";
      gallery.dataset.hcxCardGalleryVersion = "20260619-slide-wrap-v7";
      wrapper.dataset.hcxCardGalleryBound = "true";

      const previous = cardInner.querySelector("[data-hcx-card-gallery-prev]");
      const next = cardInner.querySelector("[data-hcx-card-gallery-next]");
      let active = Math.max(0, images.findIndex((image) => image.classList.contains("is-hcx-active")));
      let touchStartX = 0;
      let touchStartY = 0;
      let touchStartAt = 0;
      let touchScrollingVertically = false;
      let suppressClickUntil = 0;
      let pointerStartX = 0;
      let pointerStartY = 0;
      let pointerStartAt = 0;
      let pointerId = null;
      let swipeDeltaX = 0;
      let swipeDeltaY = 0;
      let swipeDirection = 0;
      let isSwipePreviewing = false;
      let isSlideAnimating = false;
      let queuedSlideDirection = 0;
      let swipeAnimationFrame = null;
      let swipeAnimationTimer = null;

      const isGalleryTarget = (target) =>
        target instanceof Element && Boolean(target.closest(".card__media, .hcx-card-media-link"));

      const loadImage = (index) => {
        const image = images[(index + images.length) % images.length];
        if (image instanceof HTMLImageElement) loadHcxDeferredImage(image);
      };

      const loadNextGalleryImage = () => loadImage(active + 1);
      const preloadOnMouseHover = (event) => {
        if (event.pointerType === "touch" || !window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
        loadNextGalleryImage();
        wrapper.removeEventListener("pointerenter", preloadOnMouseHover);
      };
      wrapper.addEventListener("pointerenter", preloadOnMouseHover, { passive: true });
      wrapper.addEventListener("focusin", loadNextGalleryImage, { once: true });

      const isMobileGallery = () =>
        !window.matchMedia || window.matchMedia("(max-width: 989px)").matches;

      const getGalleryWidth = () => gallery.getBoundingClientRect().width || 1;

      const getSwipeThreshold = () => Math.min(90, Math.max(56, getGalleryWidth() * 0.24));

      const getSwipeDirection = (deltaX) => (deltaX < 0 ? 1 : -1);

      const getImageDirection = (nextIndex, requestedDirection) => {
        if (requestedDirection) return requestedDirection > 0 ? 1 : -1;
        if (((active + 1) % images.length) === nextIndex) return 1;
        if (((active - 1 + images.length) % images.length) === nextIndex) return -1;
        return nextIndex > active ? 1 : -1;
      };

      const clampSwipeDelta = (deltaX) => {
        const width = getGalleryWidth();
        return Math.max(width * -1, Math.min(width, deltaX));
      };

      const clearSwipeAnimationTimer = () => {
        if (!swipeAnimationTimer) return;
        window.clearTimeout(swipeAnimationTimer);
        swipeAnimationTimer = null;
      };

      const clearSwipeAnimationFrame = () => {
        if (!swipeAnimationFrame) return;
        window.cancelAnimationFrame(swipeAnimationFrame);
        swipeAnimationFrame = null;
      };

      const setSwipeStyle = (image, { opacity, zIndex, transform, transition }) => {
        if (!image) return;
        image.style.setProperty("opacity", opacity, "important");
        image.style.setProperty("z-index", zIndex, "important");
        image.style.setProperty("visibility", opacity === "0" ? "hidden" : "visible", "important");
        image.style.setProperty("transform", transform, "important");
        image.style.setProperty("pointer-events", "none", "important");
        image.style.setProperty("transition", transition, "important");
      };

      const forceSwipeLayout = (...elements) => {
        elements.forEach((element) => {
          if (!element) return;
          void element.offsetWidth;
          window.getComputedStyle(element).transform;
        });
      };

      const easeSwipeProgress = (progress) => 1 - Math.pow(1 - progress, 3);

      const animateSwipePositions = ({
        swipe,
        duration,
        currentZIndex = "3",
        incomingZIndex = "4",
        getCurrentX,
        getIncomingX,
        onComplete,
      }) => {
        let startedAt = null;

        const animateFrame = () => {
          if (startedAt === null) startedAt = Date.now();
          const elapsed = Date.now() - startedAt;
          const progress = Math.min(1, Math.max(0, elapsed / duration));
          const eased = easeSwipeProgress(progress);

          setSwipeStyle(swipe.current, {
            opacity: "1",
            zIndex: currentZIndex,
            transform: `translate3d(${getCurrentX(eased)}px, 0, 0)`,
            transition: "none",
          });
          setSwipeStyle(swipe.incoming, {
            opacity: "1",
            zIndex: incomingZIndex,
            transform: `translate3d(${getIncomingX(eased)}px, 0, 0)`,
            transition: "none",
          });

          if (progress < 1) {
            swipeAnimationFrame = window.requestAnimationFrame(animateFrame);
            return;
          }

          swipeAnimationFrame = null;
          onComplete?.();
        };

        clearSwipeAnimationFrame();
        forceSwipeLayout(swipe.current, swipe.incoming);
        swipeAnimationFrame = window.requestAnimationFrame(animateFrame);
      };

      const setSwipePair = (deltaX, direction, transition = "none") => {
        const width = getGalleryWidth();
        const current = images[active];
        const incomingIndex = (active + direction + images.length) % images.length;
        const incoming = images[incomingIndex];
        const boundedDelta = clampSwipeDelta(deltaX);

        images.forEach((image, index) => {
          const isActive = index === active;
          image.classList.toggle("is-hcx-active", isActive);
          if (isActive) {
            image.removeAttribute("aria-hidden");
          } else {
            image.setAttribute("aria-hidden", "true");
          }
          setSwipeStyle(image, {
            opacity: "0",
            zIndex: "1",
            transform: "translate3d(0, 0, 0)",
            transition: "none",
          });
        });

        setSwipeStyle(current, {
          opacity: "1",
          zIndex: "3",
          transform: `translate3d(${boundedDelta}px, 0, 0)`,
          transition,
        });
        setSwipeStyle(incoming, {
          opacity: "1",
          zIndex: "2",
          transform: `translate3d(${boundedDelta + direction * width}px, 0, 0)`,
          transition,
        });
        loadImage(active + direction);

        return { boundedDelta, current, incoming, incomingIndex, width };
      };

      const syncImages = () => {
        clearSwipeAnimationTimer();
        clearSwipeAnimationFrame();
        isSwipePreviewing = false;
        isSlideAnimating = false;
        queuedSlideDirection = 0;
        gallery.removeAttribute("data-hcx-card-gallery-sliding");
        gallery.dataset.hcxCardGalleryIndex = String(active);
        images.forEach((image, index) => {
          const isActive = index === active;
          image.classList.toggle("is-hcx-active", isActive);
          image.style.setProperty("opacity", isActive ? "1" : "0", "important");
          image.style.setProperty("z-index", isActive ? "3" : "1", "important");
          image.style.setProperty("visibility", isActive ? "visible" : "hidden", "important");
          image.style.setProperty("transform", "none", "important");
          image.style.setProperty("pointer-events", "none", "important");
          image.style.setProperty("transition", "none", "important");
          if (isActive) {
            image.removeAttribute("aria-hidden");
          } else {
            image.setAttribute("aria-hidden", "true");
          }
        });
      };

      const showImage = (index, event, direction) => {
        event?.preventDefault?.();
        event?.stopPropagation?.();
        const nextIndex = (index + images.length) % images.length;
        const requestedDirection = getImageDirection(nextIndex, direction);
        if (isSlideAnimating) {
          queuedSlideDirection = requestedDirection;
          return;
        }
        if (nextIndex === active) return;
        animateSwipeComplete(0, requestedDirection);
      };

      const isDeliberateSwipe = (deltaX, deltaY) => {
        const absX = Math.abs(deltaX);
        const absY = Math.abs(deltaY);

        return (
          Date.now() - touchStartAt < 900 &&
          absX >= getSwipeThreshold() &&
          absX > absY * 1.45
        );
      };

      const previewSwipe = (deltaX, deltaY) => {
        if (isSlideAnimating) return false;
        if (!isMobileGallery()) return false;

        const absX = Math.abs(deltaX);
        const absY = Math.abs(deltaY);
        if (absX < 12 && absY < 12) return false;
        if (absX <= absY * 1.2) return false;

        swipeDirection = getSwipeDirection(deltaX);
        swipeDeltaX = deltaX;
        swipeDeltaY = deltaY;
        isSwipePreviewing = true;
        gallery.dataset.hcxCardGallerySliding = "true";
        setSwipePair(deltaX, swipeDirection);
        return true;
      };

      const animateSwipeCancel = (deltaX, direction) => {
        if (!isSwipePreviewing) return;

        isSlideAnimating = true;
        queuedSlideDirection = 0;
        const resolvedDeltaX = Number.isFinite(deltaX) ? deltaX : swipeDeltaX;
        const resolvedDirection = direction || swipeDirection || 1;
        const swipe = setSwipePair(resolvedDeltaX, resolvedDirection);
        const startX = swipe.boundedDelta;
        const incomingStartX = swipe.boundedDelta + resolvedDirection * swipe.width;
        const incomingEndX = swipe.width * resolvedDirection;

        clearSwipeAnimationTimer();
        animateSwipePositions({
          swipe,
          duration: 200,
          incomingZIndex: "2",
          getCurrentX: (progress) => startX * (1 - progress),
          getIncomingX: (progress) => incomingStartX + (incomingEndX - incomingStartX) * progress,
          onComplete: syncImages,
        });
      };

      const animateSwipeComplete = (deltaX, direction) => {
        const resolvedDirection = direction || swipeDirection || 1;
        if (isSlideAnimating) {
          queuedSlideDirection = resolvedDirection;
          return;
        }

        isSlideAnimating = true;
        gallery.dataset.hcxCardGallerySliding = "true";
        const swipe = setSwipePair(Number.isFinite(deltaX) ? deltaX : swipeDeltaX, resolvedDirection);
        const startX = swipe.boundedDelta;
        const currentEndX = -resolvedDirection * swipe.width;
        const incomingStartX = swipe.boundedDelta + resolvedDirection * swipe.width;

        clearSwipeAnimationTimer();
        animateSwipePositions({
          swipe,
          duration: 260,
          incomingZIndex: "4",
          getCurrentX: (progress) => startX + (currentEndX - startX) * progress,
          getIncomingX: (progress) => incomingStartX * (1 - progress),
          onComplete: () => {
            const queuedDirection = queuedSlideDirection;
            queuedSlideDirection = 0;
            active = swipe.incomingIndex;
            syncImages();
            if (queuedDirection) {
              window.requestAnimationFrame(() => {
                showImage(active + queuedDirection, null, queuedDirection);
              });
            }
          },
        });
      };

      const applySwipe = (deltaX, deltaY, event) => {
        const direction = getSwipeDirection(deltaX);
        if (!isDeliberateSwipe(deltaX, deltaY)) {
          animateSwipeCancel(deltaX, direction);
          return false;
        }

        suppressClickUntil = Date.now() + 650;
        event?.preventDefault?.();
        event?.stopPropagation?.();
        if (isMobileGallery()) {
          animateSwipeComplete(deltaX, direction);
        } else {
          showImage(active + direction, event, direction);
        }
        return true;
      };

      previous?.addEventListener("click", (event) => showImage(active - 1, event, -1));
      next?.addEventListener("click", (event) => showImage(active + 1, event, 1));

      cardInner.addEventListener(
        "click",
        (event) => {
          if (Date.now() > suppressClickUntil) return;
          event.preventDefault();
          event.stopPropagation();
        },
        true
      );

      cardInner.addEventListener(
        "touchstart",
        (event) => {
          if (!isGalleryTarget(event.target)) return;
          const touch = event.changedTouches[0];
          if (!touch) return;

          touchStartX = touch.clientX;
          touchStartY = touch.clientY;
          touchStartAt = Date.now();
          touchScrollingVertically = false;
          swipeDeltaX = 0;
          swipeDeltaY = 0;
          swipeDirection = 0;
          isSwipePreviewing = false;
          // Vertical scrolling must not fetch the hidden gallery images.
        },
        { passive: true }
      );

      cardInner.addEventListener(
        "touchmove",
        (event) => {
          if (!isGalleryTarget(event.target)) return;
          const touch = event.touches?.[0] || event.changedTouches[0];
          if (!touch) return;

          swipeDeltaX = touch.clientX - touchStartX;
          swipeDeltaY = touch.clientY - touchStartY;
          if (touchScrollingVertically) return;
          if (!isSwipePreviewing && Math.abs(swipeDeltaY) >= 12 && Math.abs(swipeDeltaY) >= Math.abs(swipeDeltaX)) {
            touchScrollingVertically = true;
            return;
          }
          previewSwipe(swipeDeltaX, swipeDeltaY);
        },
        { passive: true }
      );

      cardInner.addEventListener(
        "touchend",
        (event) => {
          if (!isGalleryTarget(event.target)) return;
          const touch = event.changedTouches[0];
          if (!touch) return;

          if (touchScrollingVertically) return;
          const deltaX = touch.clientX - touchStartX;
          const deltaY = touch.clientY - touchStartY;
          applySwipe(deltaX, deltaY, event);
        },
        { passive: false }
      );

      cardInner.addEventListener("touchcancel", () => {
        touchScrollingVertically = true;
        if (isSwipePreviewing || isSlideAnimating) syncImages();
      }, { passive: true });

      cardInner.addEventListener(
        "pointerdown",
        (event) => {
          if (event.pointerType === "touch" || !window.matchMedia("(max-width: 989px)").matches) return;
          if (!isGalleryTarget(event.target)) return;

          pointerId = event.pointerId;
          pointerStartX = event.clientX;
          pointerStartY = event.clientY;
          pointerStartAt = Date.now();
          touchStartAt = pointerStartAt;
          swipeDeltaX = 0;
          swipeDeltaY = 0;
          swipeDirection = 0;
          isSwipePreviewing = false;
          loadImage(active + 1);
          loadImage(active - 1);
        },
        { passive: true }
      );

      cardInner.addEventListener(
        "pointermove",
        (event) => {
          if (pointerId !== event.pointerId) return;
          if (event.pointerType === "touch" || !window.matchMedia("(max-width: 989px)").matches) return;
          if (!isGalleryTarget(event.target)) return;

          swipeDeltaX = event.clientX - pointerStartX;
          swipeDeltaY = event.clientY - pointerStartY;
          previewSwipe(swipeDeltaX, swipeDeltaY);
        },
        { passive: true }
      );

      cardInner.addEventListener(
        "pointerup",
        (event) => {
          if (pointerId !== event.pointerId) return;
          pointerId = null;
          if (event.pointerType === "touch" || !window.matchMedia("(max-width: 989px)").matches) return;
          if (!isGalleryTarget(event.target)) return;

          touchStartAt = pointerStartAt;
          applySwipe(event.clientX - pointerStartX, event.clientY - pointerStartY, event);
        },
        { passive: false }
      );

      cardInner.addEventListener("pointercancel", (event) => {
        if (pointerId !== event.pointerId) return;
        pointerId = null;
        animateSwipeCancel(swipeDeltaX, swipeDirection || 1);
      });

      syncImages();
    });
  };

  initCardImageGalleries();
  document.addEventListener("shopify:section:load", (event) => initCardImageGalleries(event.target));

  const clearCardSizeHoverState = (quickAdd) => {
    quickAdd
      ?.querySelectorAll(".hcx-card-size-button.is-size-hovered")
      .forEach((button) => button.classList.remove("is-size-hovered"));
  };

  const closeCardQuickAdd = (quickAdd) => {
    const toggle = quickAdd?.querySelector("[data-hcx-card-quick-toggle]");
    const input = quickAdd?.querySelector("[data-hcx-card-quick-input]");
    if (!quickAdd) return;

    quickAdd.classList.remove("is-open", "is-hover-open", "is-toggle-active");
    clearCardSizeHoverState(quickAdd);
    if (input) input.checked = false;
    if (document.activeElement instanceof HTMLElement && quickAdd.contains(document.activeElement)) {
      document.activeElement.blur();
    }
    toggle?.setAttribute("aria-expanded", "false");
    syncCardQuickAddLayout(quickAdd);
  };

  const closeOtherCardQuickAdds = (currentQuickAdd = null) => {
    document
      .querySelectorAll("[data-hcx-card-quick-add].is-open, [data-hcx-card-quick-add].is-hover-open, [data-hcx-card-quick-add].is-toggle-active")
      .forEach((quickAdd) => {
        if (quickAdd !== currentQuickAdd) closeCardQuickAdd(quickAdd);
      });
  };

  const setImportantStyle = (element, styles) => {
    if (!element) return;

    Object.entries(styles).forEach(([property, value]) => {
      element.style.setProperty(property, value, "important");
    });
  };

  const syncCardQuickAddLayout = (quickAdd) => {
    if (!quickAdd) return;

    const panel = quickAdd.querySelector("[data-hcx-card-size-panel]");
    const toggle = quickAdd.querySelector("[data-hcx-card-quick-toggle]");
    const icon = toggle?.querySelector("svg");
    const hasFullVintageSizes = panel?.classList.contains("hcx-card-sizes--vintage-full");
    const isTrayOpen =
      quickAdd.classList.contains("is-hover-open") ||
      quickAdd.classList.contains("is-open") ||
      quickAdd.contains(document.activeElement);

    setImportantStyle(quickAdd, {
      position: "absolute",
      inset: "auto 0 0 0",
      "z-index": "120",
      height: hasFullVintageSizes ? "9.8rem" : "7.2rem",
      "min-height": "0",
      overflow: "visible",
      transform: "none",
    });

    setImportantStyle(panel, {
      position: "absolute",
      inset: "auto 5.45rem .8rem .8rem",
      top: "auto",
      right: "5.45rem",
      bottom: ".8rem",
      left: ".8rem",
      "z-index": "121",
      display: hasFullVintageSizes ? "grid" : "flex",
      width: "auto",
      "min-width": "0",
      "max-width": "none",
      "grid-auto-flow": "row",
      "grid-auto-columns": "auto",
      "grid-template-columns": hasFullVintageSizes ? "repeat(4, minmax(0, 1fr))" : "none",
      overflow: "hidden",
      "justify-content": "stretch",
      "justify-self": "stretch",
      opacity: isTrayOpen ? "1" : "0",
      visibility: isTrayOpen ? "visible" : "hidden",
      "pointer-events": isTrayOpen ? "auto" : "none",
      transform: "none",
      transition: "opacity .12s ease, visibility 0s linear .12s",
    });

    if (hasFullVintageSizes) setImportantStyle(panel, { height: "auto" });

    setImportantStyle(toggle, {
      position: "absolute",
      top: "auto",
      right: ".8rem",
      bottom: ".8rem",
      left: "auto",
      "z-index": "122",
      display: "grid",
      width: "4.1rem",
      height: "4.1rem",
      "min-width": "0",
      "min-height": "0",
      transform: "none",
    });

    setImportantStyle(icon, {
      transform: isTrayOpen ? "rotate(135deg)" : "rotate(0deg)",
      "transform-origin": "center center",
      transition: "transform .18s ease",
    });
  };

  const getCardQuickAddUrl = () => {
    const cartAddUrl = window.routes?.cart_add_url || "/cart/add";
    return cartAddUrl.endsWith(".js") ? cartAddUrl : `${cartAddUrl}.js`;
  };

  const parseCardQuickAddResponse = async (response) => {
    const responseText = await response.text();
    let parsedState = {};

    if (responseText.trim()) {
      try {
        parsedState = JSON.parse(responseText);
      } catch (error) {
        parsedState = {
          status: response.status || 500,
          message: window.cartStrings?.error || "Unable to add this item to cart.",
          description: window.cartStrings?.error || "Unable to add this item to cart.",
        };
      }
    }

    if (!response.ok && !parsedState.status) {
      parsedState.status = response.status || 500;
      parsedState.message = response.statusText || window.cartStrings?.error || "Unable to add this item to cart.";
      parsedState.description = parsedState.message;
    }

    return parsedState;
  };

  const addCardQuickVariant = async (control) => {
    const quickAdd = control?.closest("[data-hcx-card-quick-add]");
    const form = control?.closest("form");
    const variantId = control?.dataset?.hcxCardVariantId || form?.querySelector("[name='id']")?.value;
    const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    const spinner = control?.querySelector(".loading__spinner");

    if (
      !variantId ||
      !quickAdd ||
      control.disabled ||
      control.getAttribute("aria-disabled") === "true" ||
      quickAdd.classList.contains("is-loading")
    )
      return;

    quickAdd.classList.remove("has-error");
    quickAdd.classList.add("is-loading");
    control.classList.add("loading");
    control.setAttribute("aria-busy", "true");
    control.setAttribute("aria-disabled", "true");
    spinner?.classList.remove("hidden");

    try {
      const formData = form ? new FormData(form) : new FormData();
      if (!formData.has("id")) formData.append("id", variantId);
      if (!formData.has("quantity")) formData.append("quantity", "1");

      if (cart?.getSectionsToRender) {
        formData.append(
          "sections",
          cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        cart.setActiveElement?.(document.activeElement);
      }

      const response = await fetch(getCardQuickAddUrl(), {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: formData,
      });
      const parsedState = await parseCardQuickAddResponse(response);

      if (!response.ok || parsedState.status) {
        throw new Error(parsedState.description || parsedState.message || "Unable to add this item.");
      }

      if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "hcx-card-quick-add",
          productVariantId: String(variantId),
          cartData: parsedState,
        });
      }

      closeCardQuickAdd(quickAdd);

      if (cart?.renderContents && parsedState.sections) {
        cart.renderContents(parsedState);
      } else if (cart?.open) {
        cart.open(control);
      } else if (!cart && window.routes?.cart_url) {
        window.location = window.routes.cart_url;
      }
    } catch (error) {
      quickAdd.classList.add("has-error");
      window.setTimeout(() => quickAdd.classList.remove("has-error"), 1600);
      console.error(error);
    } finally {
      quickAdd.classList.remove("is-loading");
      control.classList.remove("loading");
      control.removeAttribute("aria-busy");
      control.removeAttribute("aria-disabled");
      spinner?.classList.add("hidden");
    }
  };

  const hydrateCardQuickAdd = (quickAdd) => {
    const template = quickAdd?.querySelector('template[data-hcx-card-sizes-template]');
    if (!template) return;
    // Keep hundreds of hidden product forms inert until a shopper opens sizes.
    // Moving the original nodes preserves variant IDs, availability and form data.
    template.replaceWith(template.content);
    quickAdd.dispatchEvent(new Event('hcx:card-sizes-ready'));
  };

  const setCardQuickAddOpen = (quickAdd, isOpen) => {
    const toggle = quickAdd?.querySelector("[data-hcx-card-quick-toggle]");
    const input = quickAdd?.querySelector("[data-hcx-card-quick-input]");
    if (!quickAdd || !toggle) return;

    if (isOpen) {
      hydrateCardQuickAdd(quickAdd);
      closeOtherCardQuickAdds(quickAdd);
      quickAdd.classList.remove("is-hover-open");
    }
    quickAdd.classList.toggle("is-open", isOpen);
    if (!isOpen) {
      quickAdd.classList.remove("is-hover-open", "is-toggle-active");
      clearCardSizeHoverState(quickAdd);
      if (document.activeElement instanceof HTMLElement && quickAdd.contains(document.activeElement)) {
        document.activeElement.blur();
      }
    }
    if (input) input.checked = isOpen;
    toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    syncCardQuickAddLayout(quickAdd);
  };

  const setCardQuickAddHoverOpen = (quickAdd, isOpen) => {
    const toggle = quickAdd?.querySelector("[data-hcx-card-quick-toggle]");
    if (!quickAdd) return;

    if (isOpen) {
      hydrateCardQuickAdd(quickAdd);
      closeOtherCardQuickAdds(quickAdd);
    } else if (quickAdd.classList.contains("is-open")) {
      return;
    }

    quickAdd.classList.toggle("is-hover-open", isOpen);
    if (!isOpen) clearCardSizeHoverState(quickAdd);
    if (!quickAdd.classList.contains("is-open")) {
      toggle?.setAttribute("aria-expanded", isOpen ? "true" : "false");
    }
    syncCardQuickAddLayout(quickAdd);
  };

  const initCardQuickAdds = () => {
    document.querySelectorAll("[data-hcx-card-quick-add]").forEach((quickAdd) => {
      if (quickAdd.dataset.hcxCardQuickBound === "true") return;
      quickAdd.dataset.hcxCardQuickBound = "true";

      const toggle = quickAdd.querySelector("[data-hcx-card-quick-toggle]");
      const panel = quickAdd.querySelector("[data-hcx-card-size-panel]");
      let hoverCloseTimer = null;
      const canUseHoverOpen = (event) =>
        event.pointerType !== "touch" && window.matchMedia("(hover: hover) and (pointer: fine)").matches;

      const clearHoverClose = () => {
        if (!hoverCloseTimer) return;
        window.clearTimeout(hoverCloseTimer);
        hoverCloseTimer = null;
      };

      const openHoverTray = (event) => {
        if (!canUseHoverOpen(event)) return;

        clearHoverClose();
        setCardQuickAddHoverOpen(quickAdd, true);
      };

      const setToggleActive = (event, isActive) => {
        if (!canUseHoverOpen(event)) return;

        quickAdd.classList.toggle("is-toggle-active", isActive);
        syncCardQuickAddLayout(quickAdd);
      };

      const syncSizeHoverState = (event) => {
        if (!panel || !canUseHoverOpen(event)) return;

        const target = event.target instanceof Element ? event.target : null;
        const hoveredButton = target?.closest(".hcx-card-size-button");
        const canHoverButton =
          hoveredButton &&
          panel.contains(hoveredButton) &&
          !hoveredButton.matches(".is-disabled, :disabled, [aria-disabled='true']");

        panel.querySelectorAll(".hcx-card-size-button").forEach((button) => {
          button.classList.toggle("is-size-hovered", canHoverButton && button === hoveredButton);
        });
      };

      const clearSizeHoverState = (event) => {
        if (event && !canUseHoverOpen(event)) return;
        clearCardSizeHoverState(quickAdd);
      };

      const holdHoverTray = (event) => {
        if (!canUseHoverOpen(event)) return;
        clearHoverClose();
        if (
          quickAdd.classList.contains("is-hover-open") ||
          quickAdd.classList.contains("is-open") ||
          quickAdd.classList.contains("is-toggle-active")
        ) {
          syncCardQuickAddLayout(quickAdd);
        }
      };

      const scheduleHoverClose = (event) => {
        if (!canUseHoverOpen(event)) return;
        if (!quickAdd.classList.contains("is-hover-open") || quickAdd.classList.contains("is-open")) return;

        clearHoverClose();
        hoverCloseTimer = window.setTimeout(() => {
          hoverCloseTimer = null;
          if (quickAdd.matches(":hover") || panel?.matches(":hover") || toggle?.matches(":hover")) return;

          setCardQuickAddHoverOpen(quickAdd, false);
          quickAdd.classList.remove("is-toggle-active");
          syncCardQuickAddLayout(quickAdd);
        }, 520);
      };

      toggle?.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        setCardQuickAddOpen(quickAdd, !quickAdd.classList.contains("is-open"));
      }, true);

      toggle?.addEventListener("keydown", (event) => {
        if (event.key !== "Enter" && event.key !== " ") return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        quickAdd.classList.add("is-toggle-active");
        setCardQuickAddOpen(quickAdd, !quickAdd.classList.contains("is-open"));
      });

      quickAdd.addEventListener(
        "click",
        (event) => {
          const eventTarget = event.target instanceof Element ? event.target : event.target?.parentElement;
          const sizeControl = eventTarget?.closest("[data-hcx-card-variant-id]");
          if (!sizeControl || !quickAdd.contains(sizeControl)) return;

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          addCardQuickVariant(sizeControl);
        },
        true
      );

      quickAdd.addEventListener(
        "submit",
        (event) => {
          const submitter = event.submitter instanceof Element ? event.submitter : null;
          const sizeControl =
            submitter?.closest("[data-hcx-card-variant-id]") ||
            (event.target instanceof Element ? event.target.querySelector("[data-hcx-card-variant-id]") : null);
          if (!sizeControl || !quickAdd.contains(sizeControl)) return;

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          addCardQuickVariant(sizeControl);
        },
        true
      );

      toggle?.addEventListener("pointerenter", (event) => {
        setToggleActive(event, true);
        openHoverTray(event);
      });
      toggle?.addEventListener("mouseenter", (event) => {
        setToggleActive(event, true);
        openHoverTray(event);
      });
      toggle?.addEventListener("pointerleave", (event) => {
        setToggleActive(event, false);
        scheduleHoverClose(event);
      });
      toggle?.addEventListener("mouseleave", (event) => {
        setToggleActive(event, false);
        scheduleHoverClose(event);
      });
      toggle?.addEventListener("focus", () => {
        quickAdd.classList.add("is-toggle-active");
        syncCardQuickAddLayout(quickAdd);
      });
      toggle?.addEventListener("blur", () => {
        if (!quickAdd.classList.contains("is-open")) quickAdd.classList.remove("is-toggle-active");
        syncCardQuickAddLayout(quickAdd);
      });
      panel?.addEventListener("pointerenter", openHoverTray);
      panel?.addEventListener("mouseenter", openHoverTray);
      quickAdd.addEventListener("pointerenter", holdHoverTray, { passive: true });
      quickAdd.addEventListener("mouseenter", holdHoverTray, { passive: true });
      panel?.addEventListener("pointerover", syncSizeHoverState);
      panel?.addEventListener("pointermove", syncSizeHoverState);
      panel?.addEventListener("mouseover", syncSizeHoverState);
      panel?.addEventListener("pointerleave", clearSizeHoverState);
      panel?.addEventListener("mouseleave", clearSizeHoverState);
      panel?.addEventListener("pointerleave", scheduleHoverClose);
      panel?.addEventListener("mouseleave", scheduleHoverClose);
      const bindSizeButtonHover = () => panel?.querySelectorAll(".hcx-card-size-button").forEach((button) => {
        if (button.dataset.hcxSizeHoverBound === "true") return;
        button.dataset.hcxSizeHoverBound = "true";
        button.addEventListener("pointerenter", syncSizeHoverState);
        button.addEventListener("mouseenter", syncSizeHoverState);
        button.addEventListener("focus", syncSizeHoverState);
        button.addEventListener("pointerleave", clearSizeHoverState);
        button.addEventListener("mouseleave", clearSizeHoverState);
        button.addEventListener("blur", clearSizeHoverState);
      });
      quickAdd.addEventListener('hcx:card-sizes-ready', bindSizeButtonHover);
      bindSizeButtonHover();
      quickAdd.addEventListener("pointerleave", scheduleHoverClose, { passive: true });
      quickAdd.addEventListener("mouseleave", scheduleHoverClose, { passive: true });
      syncCardQuickAddLayout(quickAdd);
    });
  };

  const initCardQuickAddRefresh = () => {
    const observeQuickAddContainer = (container) => {
      if (!container || container.dataset.hcxCardQuickObserver === "true") return;

      container.dataset.hcxCardQuickObserver = "true";
      const observer = new MutationObserver(() => {
        window.requestAnimationFrame(() => {
          initCardQuickAdds();
          initCardImageGalleries(container);
          initHoverRevealScrollbars();
          initProductLowerRailWheelScroll();
          initProductLowerRailControls();
        });
      });

      observer.observe(container, {
        childList: true,
        subtree: true,
      });
    };

    observeQuickAddContainer(document.getElementById("ProductGridContainer"));
    document.querySelectorAll("product-recommendations, .related-products, .hcx-recently-viewed").forEach(observeQuickAddContainer);
  };

  const closeSearchQuickAdd = (quickAdd) => {
    if (!quickAdd) return;

    const toggle = quickAdd.querySelector("[data-hcx-search-quick-toggle]");
    const panel = quickAdd.querySelector("[data-hcx-search-size-panel]");
    quickAdd.classList.remove("is-open", "has-error");
    toggle?.setAttribute("aria-expanded", "false");
    if (panel) panel.hidden = true;
  };

  const closeOtherSearchQuickAdds = (currentQuickAdd = null) => {
    document.querySelectorAll("[data-hcx-search-quick-add].is-open").forEach((quickAdd) => {
      if (quickAdd !== currentQuickAdd) closeSearchQuickAdd(quickAdd);
    });
  };

  const setSearchQuickAddOpen = (quickAdd, isOpen) => {
    if (!quickAdd) return;

    const toggle = quickAdd.querySelector("[data-hcx-search-quick-toggle]");
    const panel = quickAdd.querySelector("[data-hcx-search-size-panel]");
    if (isOpen) closeOtherSearchQuickAdds(quickAdd);

    quickAdd.classList.toggle("is-open", isOpen);
    toggle?.setAttribute("aria-expanded", isOpen ? "true" : "false");
    if (panel) panel.hidden = !isOpen;
  };

  const addSearchQuickVariant = async (control) => {
    const variantId = control?.dataset?.hcxSearchVariantId;
    const quickAdd = control?.closest("[data-hcx-search-quick-add]");
    const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    if (
      !variantId ||
      !quickAdd ||
      control.disabled ||
      control.getAttribute("aria-disabled") === "true" ||
      quickAdd.classList.contains("is-loading")
    )
      return;

    quickAdd.classList.remove("has-error");
    quickAdd.classList.add("is-loading");
    control.classList.add("is-loading");
    control.setAttribute("aria-busy", "true");

    try {
      const formData = new FormData();
      formData.append("id", variantId);
      formData.append("quantity", "1");

      if (cart?.getSectionsToRender) {
        formData.append(
          "sections",
          cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        cart.setActiveElement?.(document.activeElement);
      }

      const config =
        typeof fetchConfig === "function"
          ? fetchConfig("javascript")
          : {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            };

      config.headers = {
        ...config.headers,
        "X-Requested-With": "XMLHttpRequest",
      };
      delete config.headers["Content-Type"];
      config.body = formData;

      const response = await fetch(getCardQuickAddUrl(), config);
      const parsedState = await response.json();

      if (!response.ok || parsedState.status) {
        throw new Error(parsedState.description || parsedState.message || "Unable to add this item.");
      }

      if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "hcx-search-quick-add",
          productVariantId: String(variantId),
          cartData: parsedState,
        });
      }

      closeSearchQuickAdd(quickAdd);

      const searchDetails = quickAdd.closest("details[open]");
      searchDetails?.removeAttribute("open");

      if (cart?.renderContents && parsedState.sections) {
        cart.renderContents(parsedState);
      } else if (!cart && window.routes?.cart_url) {
        window.location = window.routes.cart_url;
      }
    } catch (error) {
      quickAdd.classList.add("has-error");
      // Keep the failure visible without adding intrusive copy to the search grid.
      window.setTimeout(() => quickAdd.classList.remove("has-error"), 1600);
      console.error(error);
    } finally {
      quickAdd.classList.remove("is-loading");
      control.classList.remove("is-loading");
      control.removeAttribute("aria-busy");
    }
  };

  const initSearchQuickAdds = () => {
    if (document.documentElement.dataset.hcxSearchQuickBound === "true") return;
    document.documentElement.dataset.hcxSearchQuickBound = "true";

    document.addEventListener(
      "click",
      (event) => {
        const eventTarget = event.target instanceof Element ? event.target : event.target?.parentElement;
        if (!eventTarget) return;

        const toggle = eventTarget.closest("[data-hcx-search-quick-toggle]");
        const sizeControl = eventTarget.closest("[data-hcx-search-variant-id]");

        if (toggle) {
          event.preventDefault();
          event.stopPropagation();
          const quickAdd = toggle.closest("[data-hcx-search-quick-add]");
          setSearchQuickAddOpen(quickAdd, !quickAdd?.classList.contains("is-open"));
          return;
        }

        if (sizeControl) {
          event.preventDefault();
          event.stopPropagation();
          addSearchQuickVariant(sizeControl);
          return;
        }

        if (!eventTarget.closest("[data-hcx-search-quick-add]")) closeOtherSearchQuickAdds();
      },
      true
    );

    document.addEventListener(
      "pointerup",
      (event) => {
        const eventTarget = event.target instanceof Element ? event.target : event.target?.parentElement;
        const sizeControl = eventTarget?.closest("[data-hcx-search-variant-id]");
        if (!sizeControl) return;

        event.preventDefault();
        event.stopPropagation();
        addSearchQuickVariant(sizeControl);
      },
      true
    );

    document.addEventListener("keydown", (event) => {
      const eventTarget = event.target instanceof Element ? event.target : event.target?.parentElement;
      const activeControl = eventTarget?.closest("[data-hcx-search-quick-toggle], [data-hcx-search-variant-id]");
      if (activeControl && (event.key === "Enter" || event.key === " ")) {
        event.preventDefault();
        event.stopPropagation();
        activeControl.click();
        return;
      }

      if (event.key === "Escape") closeOtherSearchQuickAdds();
    });
  };

  document.addEventListener("click", (event) => {
    if (!event.target.closest("[data-hcx-card-quick-add]")) closeOtherCardQuickAdds();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeOtherCardQuickAdds();
  });

  document.addEventListener("click", (event) => {
    const previous = event.target.closest("[data-hcx-cart-rec-prev]");
    const next = event.target.closest("[data-hcx-cart-rec-next]");
    if (!previous && !next) return;

    const recommendations = event.target.closest(".hcx-cart-recommendations");
    const rail = recommendations?.querySelector("[data-hcx-cart-rec-rail]");
    if (!rail) return;

    const direction = next ? 1 : -1;
    rail.scrollBy({
      left: direction * Math.max(220, rail.clientWidth * 0.72),
      behavior: "smooth",
    });
  });

  document.addEventListener(
    "wheel",
    (event) => {
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      const rail = target?.closest("[data-hcx-cart-rec-rail]");
      if (!rail || rail.scrollWidth <= rail.clientWidth + 1) return;

      const delta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
      if (!delta) return;

      const maxScroll = rail.scrollWidth - rail.clientWidth;
      const atStart = rail.scrollLeft <= 0;
      const atEnd = rail.scrollLeft >= maxScroll - 1;
      if ((delta < 0 && atStart) || (delta > 0 && atEnd)) return;

      event.preventDefault();
      rail.scrollLeft += delta;
    },
    { passive: false }
  );

  const syncCartRecommendationScrollbar = (recommendations) => {
    const rail = recommendations?.querySelector("[data-hcx-cart-rec-rail]");
    const scrollbar = recommendations?.querySelector("[data-hcx-cart-rec-scrollbar]");
    const thumb = recommendations?.querySelector("[data-hcx-cart-rec-thumb]");
    if (!rail || !scrollbar || !thumb) return;

    const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
    const trackWidth = scrollbar.clientWidth || scrollbar.getBoundingClientRect().width || 0;
    const isScrollable = maxScroll > 1 && trackWidth > 0;

    recommendations.classList.toggle("hcx-cart-recommendations--scrollable", isScrollable);
    recommendations.classList.toggle("hcx-cart-recommendations--static", !isScrollable);

    if (!isScrollable) {
      thumb.style.setProperty("--hcx-cart-rec-thumb-width", "100%");
      thumb.style.setProperty("--hcx-cart-rec-thumb-x", "0px");
      return;
    }

    const visibleRatio = Math.min(1, rail.clientWidth / rail.scrollWidth);
    const thumbWidth = Math.max(42, trackWidth * visibleRatio);
    const maxThumbX = Math.max(0, trackWidth - thumbWidth);
    const thumbX = (rail.scrollLeft / maxScroll) * maxThumbX;

    thumb.style.setProperty("--hcx-cart-rec-thumb-width", `${thumbWidth}px`);
    thumb.style.setProperty("--hcx-cart-rec-thumb-x", `${thumbX}px`);
  };

  const initCartRecommendationScrollbars = () => {
    document.querySelectorAll(".hcx-cart-recommendations").forEach((recommendations) => {
      const rail = recommendations.querySelector("[data-hcx-cart-rec-rail]");
      const scrollbar = recommendations.querySelector("[data-hcx-cart-rec-scrollbar]");
      const thumb = recommendations.querySelector("[data-hcx-cart-rec-thumb]");
      if (!rail || !scrollbar || !thumb) return;

      const requestSync = () => {
        if (rail.dataset.hcxCartRecScrollFrame === "true") return;
        rail.dataset.hcxCartRecScrollFrame = "true";
        window.requestAnimationFrame(() => {
          rail.dataset.hcxCartRecScrollFrame = "false";
          syncCartRecommendationScrollbar(recommendations);
        });
      };

      if (scrollbar.dataset.hcxCartRecScrollbarBound !== "true") {
        scrollbar.dataset.hcxCartRecScrollbarBound = "true";
        rail.addEventListener("scroll", requestSync, { passive: true });
        window.addEventListener("resize", requestSync, { passive: true });

        scrollbar.addEventListener("pointerdown", (event) => {
          const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
          if (maxScroll <= 1) return;

          event.preventDefault();
          scrollbar.setPointerCapture?.(event.pointerId);

          const moveToPointer = (pointerEvent) => {
            const rect = scrollbar.getBoundingClientRect();
            const thumbWidth =
              Number.parseFloat(getComputedStyle(thumb).getPropertyValue("--hcx-cart-rec-thumb-width")) ||
              thumb.getBoundingClientRect().width ||
              1;
            const travel = Math.max(1, rect.width - thumbWidth);
            const targetX = Math.min(Math.max(pointerEvent.clientX - rect.left - thumbWidth / 2, 0), travel);
            rail.scrollLeft = (targetX / travel) * maxScroll;
            syncCartRecommendationScrollbar(recommendations);
          };

          const stopDragging = (pointerEvent) => {
            scrollbar.releasePointerCapture?.(pointerEvent.pointerId);
            scrollbar.removeEventListener("pointermove", moveToPointer);
            scrollbar.removeEventListener("pointerup", stopDragging);
            scrollbar.removeEventListener("pointercancel", stopDragging);
          };

          scrollbar.addEventListener("pointermove", moveToPointer);
          scrollbar.addEventListener("pointerup", stopDragging);
          scrollbar.addEventListener("pointercancel", stopDragging);
          moveToPointer(event);
        });
      }

      requestSync();
    });

    if (html.dataset.hcxCartRecObserverBound !== "true" && "MutationObserver" in window) {
      html.dataset.hcxCartRecObserverBound = "true";
      const cartRoot = document.querySelector("cart-drawer");
      let cartFrame = 0;
      if (cartRoot) new MutationObserver(() => {
        if (cartFrame) return;
        cartFrame = window.requestAnimationFrame(() => {
          cartFrame = 0;
          initCartRecommendationScrollbars();
        });
      }).observe(cartRoot, { childList: true, subtree: true });
    }
  };

  const normalizeText = (value) => value.replace(/\s+/g, " ").trim().toLowerCase();

  const removeCareCartAttribution = (root = document.body) => {
    if (!root || typeof Node === "undefined") return;

    const cleanTextNode = (node) => {
      let nextValue = node.nodeValue.replace(/\s*\bby\s+CareCart\b\.?/gi, "").replace(/\s{2,}/g, " ");
      if (/^\s*CareCart\.?\s*$/i.test(nextValue)) nextValue = "";
      if (nextValue !== node.nodeValue) node.nodeValue = nextValue.trimStart();
    };

    const hideCreditElement = (element) => {
      const text = normalizeText(element.textContent || "");
      if (text === "by carecart" || text === "carecart") element.hidden = true;
    };

    if (root.nodeType === Node.TEXT_NODE) {
      cleanTextNode(root);
      return;
    }

    if (![Node.ELEMENT_NODE, Node.DOCUMENT_NODE, Node.DOCUMENT_FRAGMENT_NODE].includes(root.nodeType)) return;

    if (typeof HTMLElement !== "undefined" && root instanceof HTMLElement) hideCreditElement(root);
    if (root.querySelectorAll) root.querySelectorAll("*").forEach(hideCreditElement);

    if (!document.createTreeWalker || typeof NodeFilter === "undefined") return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();
    while (node) {
      cleanTextNode(node);
      node = walker.nextNode();
    }
  };

  const initCareCartAttributionCleaner = () => {
    if (!document.body || !("MutationObserver" in window)) {
      removeCareCartAttribution(document.body);
      return;
    }

    if (html.dataset.hcxCareCartAttributionCleaner === "true") {
      removeCareCartAttribution(document.body);
      return;
    }

    html.dataset.hcxCareCartAttributionCleaner = "true";
    removeCareCartAttribution(document.body);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "characterData") {
          removeCareCartAttribution(mutation.target);
          return;
        }

        mutation.addedNodes.forEach(removeCareCartAttribution);
      });
    });

    observer.observe(document.body, { childList: true, characterData: true, subtree: true });
  };

  const sizeButtonText = "SELECT A SIZE";
  const selectedSizes = new Map();
  let pendingSelectedSize = "";
  let pendingSelectedSizeAt = 0;

  const getSizeFieldset = (productInfo) =>
    productInfo
      ? [...productInfo.querySelectorAll("variant-selects fieldset.product-form__input")].find((fieldset) => {
          const legend = fieldset.querySelector("legend");
          return legend && normalizeText(legend.textContent).startsWith("size");
        })
      : null;

  const getProductSubmitButton = (productInfo) => productInfo.querySelector(".product-form__submit");

  document.addEventListener("click", (event) => {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    const trigger = target?.closest(".hcx-product-size-note__link");
    const opener = trigger ? trigger.closest("modal-opener[data-modal]") : null;
    if (!trigger || !opener) return;

    const modal = document.querySelector(opener.getAttribute("data-modal"));
    if (!modal || typeof modal.show !== "function") return;

    event.preventDefault();
    modal.show(trigger);
  }, true);

  const initLinkedColourHoverLabels = () => {
    const getColourTile = (event) => {
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      return target?.closest(".hcx-linked-colour") || null;
    };

    const getColourName = (tile) =>
      tile?.dataset.hcxColourLabel ||
      tile?.getAttribute("aria-label") ||
      tile?.querySelector(".hcx-swatch-value")?.textContent?.trim() ||
      "";

    const getColourValueElement = (tile) => tile?.closest(".hcx-linked-colours")?.querySelector("[data-selected-value]") || null;

    const showColourForTile = (tile) => {
      const valueElement = getColourValueElement(tile);
      const colourName = getColourName(tile);
      if (!tile || !valueElement || !colourName) return;

      const fieldset = tile.closest(".hcx-linked-colours");
      if (!fieldset.dataset.hcxSelectedColour) fieldset.dataset.hcxSelectedColour = valueElement.textContent.trim();
      valueElement.textContent = colourName;
    };

    const restoreColourForTile = (tile) => {
      const fieldset = tile.closest(".hcx-linked-colours");
      const valueElement = fieldset?.querySelector("[data-selected-value]");
      if (!fieldset || !valueElement) return;

      valueElement.textContent = fieldset.dataset.hcxSelectedColour || valueElement.textContent.trim();
    };

    const setHoveredColour = (event) => showColourForTile(getColourTile(event));

    const restoreSelectedColour = (event) => {
      const tile = getColourTile(event);
      const relatedTarget = event.relatedTarget instanceof Node ? event.relatedTarget : null;
      if (!tile || (relatedTarget && tile.contains(relatedTarget))) return;
      restoreColourForTile(tile);
    };

    if (html.dataset.hcxLinkedColourHoverLabels !== "true") {
      html.dataset.hcxLinkedColourHoverLabels = "true";
      document.addEventListener("pointerover", setHoveredColour);
      document.addEventListener("pointerout", restoreSelectedColour);
      document.addEventListener("mouseover", setHoveredColour);
      document.addEventListener("mouseout", restoreSelectedColour);
      document.addEventListener("focusin", setHoveredColour);
      document.addEventListener("focusout", restoreSelectedColour);
    }

    document.querySelectorAll(".hcx-linked-colour").forEach((tile) => {
      if (tile.dataset.hcxColourHoverBound === "true") return;
      tile.dataset.hcxColourHoverBound = "true";
      tile.addEventListener("pointerenter", () => showColourForTile(tile));
      tile.addEventListener("pointerleave", () => restoreColourForTile(tile));
      tile.addEventListener("mouseenter", () => showColourForTile(tile));
      tile.addEventListener("mouseleave", () => restoreColourForTile(tile));
      tile.addEventListener("focus", () => showColourForTile(tile));
      tile.addEventListener("blur", () => restoreColourForTile(tile));
    });
  };

  const getProductSizeKey = (productInfo) => productInfo.dataset.productId || productInfo.dataset.url || window.location.pathname;

  const getCurrentProductPrice = (productInfo) => {
    const priceElement =
      productInfo.querySelector(".price--on-sale .price-item--sale") ||
      productInfo.querySelector(".price__regular .price-item--regular") ||
      productInfo.querySelector(".price-item--last") ||
      productInfo.querySelector(".price-item");

    return priceElement?.textContent.replace(/\s+/g, " ").replace(/\s+[A-Z]{3}\b/g, "").trim() || "";
  };

  const getAddToCartText = (productInfo, button) => {
    return (button.dataset.hcxOriginalText || window.variantStrings?.addToCart || "ADD TO CART")
      .replace(/\s*-\s*(?:\u00a3|GBP\s*)?\d+(?:[.,]\d{2})?\s*$/i, "")
      .trim()
      .toUpperCase();
  };

  const lockAddToCartForSize = (productInfo) => {
    const button = getProductSubmitButton(productInfo);
    const label = button?.querySelector("span");
    if (!button || !label) return;

    if (!button.dataset.hcxOriginalText) button.dataset.hcxOriginalText = normalizeText(label.textContent).includes("select a size") ? "ADD TO CART" : label.textContent.trim();
    button.dataset.hcxSizeLocked = "true";
    button.classList.add("hcx-size-required");
    button.setAttribute("disabled", "disabled");
    button.setAttribute("aria-disabled", "true");
    if (label.textContent !== sizeButtonText) label.textContent = sizeButtonText;
  };

  const unlockAddToCartForSize = (productInfo) => {
    const button = getProductSubmitButton(productInfo);
    const label = button?.querySelector("span");
    if (!button || !label) return;

    button.classList.remove("hcx-size-required");
    button.removeAttribute("disabled");
    button.removeAttribute("aria-disabled");
    const nextLabel = getAddToCartText(productInfo, button);
    if (label.textContent !== nextLabel) label.textContent = nextLabel;
    delete button.dataset.hcxSizeLocked;
  };

  const clearSelectedVariantInput = (productInfo) => {
    productInfo
      .querySelectorAll(`#product-form-${productInfo.dataset.section}, #product-form-installment-${productInfo.dataset.section}`)
      .forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        if (!input || input.value === "") return;

        input.value = "";
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
  };

  const hasChosenSize = (productInfo) => {
    const sizeFieldset = getSizeFieldset(productInfo);
    return (
      productInfo.dataset.hcxSizeSelected === "true" &&
      Boolean(sizeFieldset?.querySelector("input[type='radio']:checked:not(:disabled)"))
    );
  };

  const getProductVariantData = (productInfo) => {
    if (!productInfo) return null;
    if (productInfo.hcxVariantData) return productInfo.hcxVariantData;

    const script = productInfo.querySelector("script[data-hcx-viewed-product-variants]");
    if (!script?.textContent) return null;

    try {
      productInfo.hcxVariantData = JSON.parse(script.textContent);
      return productInfo.hcxVariantData;
    } catch (error) {
      console.warn("Unable to read product variant data.", error);
      return null;
    }
  };

  const getSelectedProductOptions = (productInfo) => {
    const variantSelects = productInfo?.querySelector("variant-selects");
    if (!variantSelects) return [];

    return [...variantSelects.querySelectorAll(".product-form__input")].map((optionGroup) => {
      const select = optionGroup.querySelector("select");
      if (select) return select.value;

      const checkedInput = optionGroup.querySelector("input[type='radio']:checked");
      return checkedInput?.value || "";
    });
  };

  const getSelectedProductVariant = (productInfo) => {
    const variantData = getProductVariantData(productInfo);
    const selectedOptions = getSelectedProductOptions(productInfo);
    if (!variantData?.variants?.length || !selectedOptions.length) return null;

    return (
      variantData.variants.find((variant) => {
        if (!Array.isArray(variant.options) || variant.options.length !== selectedOptions.length) return false;
        return variant.options.every((optionValue, index) => optionValue === selectedOptions[index]);
      }) || null
    );
  };

  const syncSelectedVariantInput = (productInfo) => {
    const variant = getSelectedProductVariant(productInfo);
    if (!variant?.id) return null;

    productInfo
      .querySelectorAll(`#product-form-${productInfo.dataset.section}, #product-form-installment-${productInfo.dataset.section}`)
      .forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        if (!input || input.value === String(variant.id)) return;

        input.value = variant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });

    const saveButton = productInfo.querySelector("[data-hcx-save-product]");
    if (saveButton) saveButton.dataset.productVariantId = String(variant.id);

    return variant;
  };

  const restoreSelectedSize = (productInfo) => {
    const sizeFieldset = getSizeFieldset(productInfo);
    const selectedSize =
      selectedSizes.get(getProductSizeKey(productInfo)) ||
      (Date.now() - pendingSelectedSizeAt < 6000 ? pendingSelectedSize : "");
    if (!sizeFieldset || !selectedSize) return false;

    const selectedInput = [...sizeFieldset.querySelectorAll("input[type='radio']")].find(
      (input) => input.value === selectedSize
    );

    if (!selectedInput) return false;
    if (selectedInput.disabled) return false;

    selectedInput.checked = true;
    selectedInput.setAttribute("checked", "checked");
    productInfo.dataset.hcxSizeSelected = "true";
    selectedSizes.set(getProductSizeKey(productInfo), selectedSize);
    return true;
  };

  const refreshSizeGate = (productInfo) => {
    const sizeFieldset = getSizeFieldset(productInfo);
    if (!sizeFieldset) return;

    // Do not unlock a product form while its cart request is still in flight.
    if (getProductSubmitButton(productInfo)?.classList.contains("loading")) return;

    restoreSelectedSize(productInfo);

    if (hasChosenSize(productInfo)) {
      const variant = syncSelectedVariantInput(productInfo);
      if (variant?.available) {
        unlockAddToCartForSize(productInfo);
      } else {
        lockAddToCartForSize(productInfo);
      }
      return;
    }

    sizeFieldset.querySelectorAll("input[type='radio']:checked").forEach((input) => {
      input.checked = false;
      input.removeAttribute("checked");
    });
    clearSelectedVariantInput(productInfo);
    lockAddToCartForSize(productInfo);
  };

  const initRequiredSizeSelection = (productInfo) => {
    if (!productInfo || productInfo.dataset.productGiftCard === "true" || productInfo.dataset.hcxSizeGateBound === "true") return;

    productInfo.dataset.hcxSizeGateBound = "true";
    productInfo.dataset.hcxSizeSelected = "false";

    productInfo.addEventListener(
      "change",
      (event) => {
        const sizeFieldset = getSizeFieldset(productInfo);
        if (!sizeFieldset || !sizeFieldset.contains(event.target) || event.target.type !== "radio") return;
        if (event.target.disabled) return;

        productInfo.dataset.hcxSizeSelected = "true";
        selectedSizes.set(getProductSizeKey(productInfo), event.target.value);
        pendingSelectedSize = event.target.value;
        pendingSelectedSizeAt = Date.now();
        const variant = syncSelectedVariantInput(productInfo);
        if (variant?.available) {
          unlockAddToCartForSize(productInfo);
        } else {
          lockAddToCartForSize(productInfo);
        }
      },
      true
    );

    productInfo.addEventListener(
      "submit",
      (event) => {
        if (hasChosenSize(productInfo)) {
          const variant = syncSelectedVariantInput(productInfo);
          if (variant?.available) {
            unlockAddToCartForSize(productInfo);
            return;
          }
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        refreshSizeGate(productInfo);

        const firstSizeInput =
          getSizeFieldset(productInfo)?.querySelector("input[type='radio']:not(:disabled)") ||
          getSizeFieldset(productInfo)?.querySelector("input[type='radio']");
        firstSizeInput?.focus({ preventScroll: true });
      },
      true
    );

    // Batch section/app updates. Idempotent labels above prevent our own refresh
    // from creating a new childList mutation on every animation frame.
    let sizeGateFrame = 0;
    const observer = new MutationObserver(() => {
      if (sizeGateFrame || !productInfo.isConnected) return;
      sizeGateFrame = window.requestAnimationFrame(() => {
        sizeGateFrame = 0;
        if (productInfo.isConnected) refreshSizeGate(productInfo);
      });
    });
    observer.observe(productInfo, { childList: true, subtree: true });

    refreshSizeGate(productInfo);
  };

  const initAllRequiredSizeSelections = () => {
    document.querySelectorAll("product-info").forEach(initRequiredSizeSelection);
  };

  const sizeRank = ["XXS", "XS", "S", "M", "L", "XL", "XXL", "3XL", "4XL", "5XL", "6XL"];
  const fitSizeRank = ["XXS", "XS", "S", "M", "L", "XL", "XXL", "3XL", "4XL", "5XL", "6XL"];
  const defaultFitMeasurements = {
    bottom: {
      S: { primary: '30-32"', secondary: "76 CM" },
      M: { primary: '32-34"', secondary: "77 CM" },
      L: { primary: '34-36"', secondary: "78 CM" },
      XL: { primary: '36-38"', secondary: "79 CM" },
      XXL: { primary: '38-40"', secondary: "80 CM" },
      "3XL": { primary: '40-42"', secondary: "81 CM" },
    },
    short: {
      S: { primary: '30-32"', secondary: "44 CM" },
      M: { primary: '32-34"', secondary: "46 CM" },
      L: { primary: '34-36"', secondary: "48 CM" },
      XL: { primary: '36-38"', secondary: "50 CM" },
      XXL: { primary: '38-40"', secondary: "52 CM" },
      "3XL": { primary: '40-42"', secondary: "54 CM" },
    },
    tank: {
      S: { primary: "43 CM", secondary: "66 CM" },
      M: { primary: "45 CM", secondary: "68 CM" },
      L: { primary: "47 CM", secondary: "70 CM" },
      XL: { primary: "49 CM", secondary: "72 CM" },
      XXL: { primary: "51 CM", secondary: "74 CM" },
      "3XL": { primary: "53 CM", secondary: "76 CM" },
    },
    hoodie: {
      XS: { primary: "57 CM", secondary: "65 CM" },
      S: { primary: "60 CM", secondary: "67 CM" },
      M: { primary: "63 CM", secondary: "69 CM" },
      L: { primary: "66 CM", secondary: "71 CM" },
      XL: { primary: "69 CM", secondary: "73 CM" },
      XXL: { primary: "72 CM", secondary: "75 CM" },
      "3XL": { primary: "75 CM", secondary: "77 CM" },
    },
    top: {
      XS: { primary: "51 CM", secondary: "68 CM" },
      S: { primary: "54 CM", secondary: "70 CM" },
      M: { primary: "57 CM", secondary: "72 CM" },
      L: { primary: "60 CM", secondary: "74 CM" },
      XL: { primary: "63 CM", secondary: "76 CM" },
      XXL: { primary: "66 CM", secondary: "78 CM" },
      "3XL": { primary: "69 CM", secondary: "80 CM" },
    },
  };

  const normalizeSizeValue = (value = "") => {
    const cleaned = String(value)
      .toUpperCase()
      .replace(/\bEXTRA EXTRA EXTRA LARGE\b/g, "3XL")
      .replace(/\bEXTRA EXTRA LARGE\b/g, "XXL")
      .replace(/\bEXTRA LARGE\b/g, "XL")
      .replace(/\bLARGE\b/g, "L")
      .replace(/\bMEDIUM\b/g, "M")
      .replace(/\bSMALL\b/g, "S")
      .replace(/\bXXXXXXL\b/g, "6XL")
      .replace(/\bXXXXXL\b/g, "5XL")
      .replace(/\bXXXXL\b/g, "4XL")
      .replace(/\b2XL\b/g, "XXL")
      .replace(/\bXXXL\b/g, "3XL")
      .replace(/[^A-Z0-9]/g, "");

    return sizeRank.find((size) => cleaned === size) || cleaned;
  };

  const isStripedSportSweatpantsProfile = (...parts) => {
    const profile = parts
      .filter(Boolean)
      .map((part) => String(part).toLowerCase())
      .join(" ");
    const normalizedProfile = profile.replace(/[^a-z0-9]+/g, " ");

    return (
      normalizedProfile.includes("sport oversized sweatpants") ||
      normalizedProfile.includes("striped sport") ||
      normalizedProfile.includes("stripe sweatpant") ||
      normalizedProfile.includes("striped sweatpant")
    );
  };

  const getSizeRankIndex = (size) => {
    const index = sizeRank.indexOf(normalizeSizeValue(size));
    return index >= 0 ? index : 2;
  };

  const clampSizeIndex = (index) => Math.max(0, Math.min(sizeRank.length - 1, index));

  const isFitSizeInRange = (size) => fitSizeRank.includes(normalizeSizeValue(size));

  const getClosestFitSize = (size, allowedSizes = fitSizeRank) => {
    const sizes = fitSizeRank.filter((candidate) => allowedSizes.includes(candidate));
    if (!sizes.length) return "";

    const normalizedSize = normalizeSizeValue(size);
    if (sizes.includes(normalizedSize)) return normalizedSize;

    const targetIndex = getSizeRankIndex(normalizedSize);
    return sizes
      .slice()
      .sort((a, b) => {
        const distance = Math.abs(getSizeRankIndex(a) - targetIndex) - Math.abs(getSizeRankIndex(b) - targetIndex);
        return distance || getSizeRankIndex(a) - getSizeRankIndex(b);
      })[0];
  };

  const getClosestFitSizeAtOrAbove = (size, allowedSizes = fitSizeRank) => {
    const sizes = fitSizeRank.filter((candidate) => allowedSizes.includes(candidate));
    if (!sizes.length) return "";

    const targetIndex = getSizeRankIndex(size);
    return sizes.find((candidate) => getSizeRankIndex(candidate) >= targetIndex) || sizes[sizes.length - 1];
  };

  const getLargestFitSize = (sizes = [], allowedSizes = fitSizeRank) => {
    const candidates = sizes.map(normalizeSizeValue).filter((size) => allowedSizes.includes(size));
    if (!candidates.length) return "";

    return candidates
      .slice()
      .sort((a, b) => getSizeRankIndex(b) - getSizeRankIndex(a))[0];
  };

  const getProductSizeOptions = (productInfo) => {
    const fieldset = getSizeFieldset(productInfo);
    if (!fieldset) return [];
    const seenSizes = new Set();

    return [...fieldset.querySelectorAll("input[type='radio']")]
      .map((input) => ({
        raw: input.value,
        size: normalizeSizeValue(input.value),
        input,
        available: !input.disabled && !input.classList.contains("disabled"),
        missing: input.dataset.hcxMissingSize === "true" || input.classList.contains("hcx-size-missing"),
      }))
      .filter((item) => {
        if (!item.size || !isFitSizeInRange(item.size) || item.missing || seenSizes.has(item.size)) return false;
        seenSizes.add(item.size);
        return true;
      });
  };

  const getProductFitSizes = (productInfo) => {
    const fieldset = getSizeFieldset(productInfo);
    if (!fieldset) return [];

    const productSizes = getProductSizeOptions(productInfo).map((item) => item.size);
    if (!productSizes.length) return [];

    return fitSizeRank.filter((size) => productSizes.includes(size));
  };

  const getProductFitRows = (rows = [], productInfo) => {
    const fitSizes = new Set(getProductFitSizes(productInfo));
    return rows.filter((row) => fitSizes.has(normalizeSizeValue(row.size)));
  };

  const getAvailableProductSizes = (productInfo) => {
    return getProductSizeOptions(productInfo).filter((item) => item.available);
  };

  const getProductDisplaySizeLabel = (productInfo, size = "") => {
    const normalizedSize = normalizeSizeValue(size);
    const productSize = getProductSizeOptions(productInfo).find((item) => item.size === normalizedSize);
    const rawSize = String(productSize?.raw || size || "").trim();

    if (/^2xl$/i.test(rawSize)) return "2XL";
    if (/^xxxl$/i.test(rawSize)) return "3XL";
    return rawSize || normalizedSize;
  };

  const toMeasurementNumber = (value = "") => {
    const text = String(value).replace(/,/g, ".");
    const matches = [...text.matchAll(/(\d+(?:\.\d+)?)/g)].map((match) => Number(match[1]));
    if (!matches.length) return null;
    return matches.reduce((sum, number) => sum + number, 0) / matches.length;
  };

  const getTableHeaders = (table) => {
    const explicitHeaders = [...table.querySelectorAll("thead th, thead td")].map((cell) => normalizeText(cell.textContent || ""));
    if (explicitHeaders.length) return explicitHeaders;

    const firstRow = table.querySelector("tr");
    return firstRow ? [...firstRow.children].map((cell) => normalizeText(cell.textContent || "")) : [];
  };

  const getProductSizeGuideKeywords = (widget) => {
    const genericWords = new Set([
      "hercxles",
      "the",
      "and",
      "for",
      "with",
      "size",
      "guide",
      "oversized",
      "regular",
      "classic",
      "heavyweight",
      "shirt",
      "tshirt",
      "tee",
      "hoodie",
      "sweatpant",
      "sweatpants",
      "jogger",
      "pants",
      "short",
      "shorts",
    ]);
    const source = `${widget.dataset.productTitle || ""} ${widget.dataset.productHandle || ""}`;

    return normalizeText(source)
      .split(/[^a-z0-9]+/)
      .map((word) => word.replace(/[^a-z0-9]/g, ""))
      .filter((word, index, words) => word.length > 2 && !genericWords.has(word) && words.indexOf(word) === index);
  };

  const getClosestTableHeadings = (table) => {
    const chunks = [];
    const caption = table.querySelector("caption");
    if (caption) chunks.push(caption.textContent || "");

    ["aria-label", "data-product", "data-product-handle", "data-size-guide"].forEach((attribute) => {
      if (table.hasAttribute(attribute)) chunks.push(table.getAttribute(attribute) || "");
    });

    let previous = table.previousElementSibling;
    let steps = 0;
    while (previous && steps < 5) {
      if (/^H[1-6]$/.test(previous.tagName) || previous.matches("p, strong")) {
        chunks.push(previous.textContent || "");
      }
      previous = previous.previousElementSibling;
      steps += 1;
    }

    let parent = table.parentElement;
    let parentSteps = 0;
    while (parent && parentSteps < 4 && !parent.matches(".hcx-size-guide-modal__content")) {
      ["aria-label", "data-product", "data-product-handle", "data-size-guide"].forEach((attribute) => {
        if (parent.hasAttribute(attribute)) chunks.push(parent.getAttribute(attribute) || "");
      });

      const heading = [...parent.children].find((child) => {
        if (!/^H[1-6]$/.test(child.tagName)) return false;
        return child.compareDocumentPosition(table) & Node.DOCUMENT_POSITION_FOLLOWING;
      });
      if (heading) chunks.push(heading.textContent || "");

      parent = parent.parentElement;
      parentSteps += 1;
    }

    return normalizeText(chunks.join(" "));
  };

  const getTableContextText = (table) => {
    return normalizeText(`${getClosestTableHeadings(table)} ${table.textContent || ""}`);
  };

  const scoreSizeGuideTable = (table, widget) => {
    const text = getTableContextText(table);
    const headingText = getClosestTableHeadings(table);
    const headers = getTableHeaders(table).join(" ");
    const title = normalizeText(widget.dataset.productTitle || "");
    const handle = normalizeText(widget.dataset.productHandle || "");
    const profile = `${title} ${handle} ${normalizeText(widget.dataset.fitLabel || "")}`;
    const keywords = getProductSizeGuideKeywords(widget);
    const kind = widget.dataset.productKind || "top";
    let baseScore = 0;
    let productScore = 0;
    let kindScore = 0;

    if (headers.includes("size")) baseScore += 4;
    if (headers.includes("cm") || text.includes("cm")) baseScore += 3;
    if (/(chest|pit|width|waist|inseam|outseam|length|body|hip|seat)/.test(headers)) baseScore += 3;

    if (title && headingText.includes(title)) productScore += 12;
    if (handle && headingText.includes(handle)) productScore += 12;
    keywords.forEach((word) => {
      if (headingText.includes(word)) productScore += 5;
      else if (text.includes(word)) productScore += 2;
    });

    if (profile.includes("oversized") && headingText.includes("oversized")) productScore += 4;
    if (/\b(?:cuffed|cuff|jogger|athletic|athletics)\b/.test(profile) && /\b(?:cuffed|cuff|jogger|athletic|athletics)\b/.test(headingText)) {
      productScore += 3;
    }

    const productInfoSelector = widget.dataset.productInfo;
    const productInfo = widget.closest("product-info") || (productInfoSelector ? document.querySelector(productInfoSelector) : null);
    const productSizes = productInfo ? getProductFitSizes(productInfo) : [];
    const tableSizes = parseAnySizeGuideTable(table)?.rows?.map((row) => normalizeSizeValue(row.size)).filter(Boolean) || [];
    if (productSizes.length && tableSizes.length) {
      const coveredSizes = productSizes.filter((size) => tableSizes.includes(size));
      const missingSizes = productSizes.filter((size) => !tableSizes.includes(size));

      if (coveredSizes.length === productSizes.length) productScore += 4;
      else if (coveredSizes.length) productScore += Math.min(2, coveredSizes.length / productSizes.length * 2);
      if (missingSizes.includes("XXL")) productScore -= 3;
    }

    if (kind === "hoodie" && /hoodie|sweatshirt|jumper|top/.test(text)) kindScore += 4;
    if (kind === "tank" && /tank|vest|sleeveless|top/.test(text)) kindScore += 4;
    if (kind === "top" && /t-shirt|tee|top|shirt/.test(text)) kindScore += 4;
    if (kind === "bottom" && /sweatpant|jogger|pants|bottom|trouser/.test(text)) kindScore += 4;
    if (kind === "short" && /short/.test(text)) kindScore += 4;

    return {
      baseScore,
      productScore,
      kindScore,
      total: baseScore + productScore + kindScore,
    };
  };

  const parseSizeGuideTable = (table) => {
    const headers = getTableHeaders(table);
    if (!headers.length) return null;

    const sizeIndex = Math.max(0, headers.findIndex((header) => header.includes("size")));
    const hasExplicitHeaders = Boolean(table.querySelector("thead th, thead td"));
    const rows = [...table.querySelectorAll("tbody tr")];
    const allRows = [...table.querySelectorAll("tr")];
    const sourceRows = hasExplicitHeaders ? (rows.length ? rows : allRows) : allRows.slice(1);

    const parsedRows = sourceRows
      .map((row) => {
        const cells = [...row.children];
        const rawSize = cells[sizeIndex]?.textContent?.trim() || "";
        const size = normalizeSizeValue(rawSize);
        if (!size || size === "SIZE" || (!sizeRank.includes(size) && !/^\d{2,3}$/.test(size))) return null;

        const metrics = headers.map((header, index) => {
          const label = cells[index]?.textContent?.replace(/\s+/g, " ").trim() || "";
          const displayHeader = header || `column ${index + 1}`;

          return normalizeFitMeasurementMetric({
            header: displayHeader,
            displayHeader,
            label,
            value: toMeasurementNumber(label),
          });
        });

        return { size, rawSize, metrics };
      })
      .filter(Boolean);

    if (!parsedRows.length) return null;
    return { headers, rows: parsedRows };
  };

  const parseTransposedSizeGuideTable = (table) => {
    const allRows = [...table.querySelectorAll("tr")].map((row) => [...row.children]);
    if (allRows.length < 2) return null;

    const firstRow = allRows[0].map((cell) => normalizeText(cell.textContent || ""));
    const sizeColumns = firstRow
      .map((header, index) => ({ size: normalizeSizeValue(header), index }))
      .filter((item) => item.index > 0 && item.size && sizeRank.includes(item.size));

    if (!sizeColumns.length) return null;

    const parsedRows = sizeColumns
      .map(({ size, index }) => {
        const metrics = allRows.slice(1).map((row, rowIndex) => {
          const header = normalizeText(row[0]?.textContent || `row ${rowIndex + 1}`);
          const label = row[index]?.textContent?.replace(/\s+/g, " ").trim() || "";

          return normalizeFitMeasurementMetric({
            header,
            displayHeader: row[0]?.textContent?.replace(/\s+/g, " ").trim() || header,
            label,
            value: toMeasurementNumber(label),
          });
        });

        return { size, rawSize: allRows[0][index]?.textContent?.trim() || size, metrics };
      })
      .filter((row) => row.metrics.some((metric) => metric.value !== null));

    if (!parsedRows.length) return null;
    return { headers: ["size", ...allRows.slice(1).map((row) => normalizeText(row[0]?.textContent || ""))], rows: parsedRows };
  };

  const parseAnySizeGuideTable = (table) => parseSizeGuideTable(table) || parseTransposedSizeGuideTable(table);

  const normalizeFitUnit = (unit = "") => {
    const cleaned = String(unit).toLowerCase();
    return cleaned.includes("in") ? "inch" : "cm";
  };

  const getFitMeasurementUnitFromText = (value = "") => {
    const text = String(value).toLowerCase();
    if (/\bcm\b|centimet(?:er|re)/i.test(text)) return "cm";
    if (/"|\bin\b|inch|inches/i.test(text)) return "inch";
    return "";
  };

  const getFitMeasurementNumbers = (value = "") =>
    [...String(value).replace(/,/g, ".").matchAll(/(\d+(?:\.\d+)?)/g)].map((match) => Number(match[1]));

  const formatFitMeasurementNumber = (value, unit) => {
    if (!Number.isFinite(value)) return "";
    if (normalizeFitUnit(unit) === "cm") return String(Math.round(value));

    const rounded = Math.round(value * 2) / 2;
    return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
  };

  const formatFitMeasurementValue = (numbers = [], unit) => {
    const normalizedUnit = normalizeFitUnit(unit);
    const values = numbers.map((number) => formatFitMeasurementNumber(number, normalizedUnit)).filter(Boolean);
    if (!values.length) return "";

    const suffix = normalizedUnit === "inch" ? '"' : " CM";
    return `${values.join("-")}${suffix}`;
  };

  const ensureFitMeasurementUnitSuffix = (value, unit) => {
    const text = String(value || "").replace(/\s+/g, " ").trim();
    if (!text) return "";

    const normalizedUnit = normalizeFitUnit(unit);
    if (getFitMeasurementUnitFromText(text) === normalizedUnit) {
      return normalizedUnit === "cm" ? text.replace(/\s*cm\b/gi, " CM") : text;
    }

    return `${text}${normalizedUnit === "inch" ? '"' : " CM"}`;
  };

  const convertFitMeasurementValue = (value, fromUnit, toUnit) => {
    const normalizedFromUnit = normalizeFitUnit(fromUnit);
    const normalizedToUnit = normalizeFitUnit(toUnit);
    const numbers = getFitMeasurementNumbers(value);
    if (!numbers.length) return "";

    const converted = numbers.map((number) =>
      normalizedFromUnit === normalizedToUnit
        ? number
        : normalizedToUnit === "cm"
          ? number * 2.54
          : number / 2.54
    );

    return formatFitMeasurementValue(converted, normalizedToUnit);
  };

  const normalizeFitMeasurementMetric = (metric) => {
    const headerText = `${metric?.displayHeader || ""} ${metric?.header || ""}`;
    const labelText = String(metric?.label || "").replace(/\s+/g, " ").trim();
    const existingUnits = metric?.units || {};
    const sourceUnit =
      metric?.valueUnit ||
      getFitMeasurementUnitFromText(`${labelText} ${headerText}`) ||
      (isFilledMeasurement(existingUnits.cm) ? "cm" : "") ||
      (isFilledMeasurement(existingUnits.inch) ? "inch" : "");

    if (!sourceUnit) return metric;

    const normalizedSourceUnit = normalizeFitUnit(sourceUnit);
    let cm = String(existingUnits.cm || "").replace(/\s+/g, " ").trim();
    let inch = String(existingUnits.inch || "").replace(/\s+/g, " ").trim();

    if (!cm && normalizedSourceUnit === "cm") {
      cm = formatFitMeasurementValue(getFitMeasurementNumbers(labelText), "cm") || labelText;
    }
    if (!inch && normalizedSourceUnit === "inch") {
      inch = formatFitMeasurementValue(getFitMeasurementNumbers(labelText), "inch") || labelText;
    }
    if (!cm && inch) cm = convertFitMeasurementValue(inch, "inch", "cm");
    if (!inch && cm) inch = convertFitMeasurementValue(cm, "cm", "inch");
    if (isFilledMeasurement(cm)) cm = ensureFitMeasurementUnitSuffix(cm, "cm");
    if (isFilledMeasurement(inch)) inch = ensureFitMeasurementUnitSuffix(inch, "inch");

    return {
      ...metric,
      label: normalizedSourceUnit === "inch" ? inch || labelText : cm || labelText,
      value: Number.isFinite(Number(metric?.value)) ? metric.value : toMeasurementNumber(labelText),
      valueUnit: normalizedSourceUnit,
      units: { inch, cm },
    };
  };

  const normalizeFitSizeGuideUnits = (data) => {
    if (!data?.rows?.length) return data;

    const rows = data.rows.map((row) => ({
      ...row,
      metrics: row.metrics.map((metric) => normalizeFitMeasurementMetric(metric)),
    }));
    const hasUnitToggle = rows.some((row) =>
      row.metrics.some((metric) => isFilledMeasurement(metric?.units?.inch) && isFilledMeasurement(metric?.units?.cm))
    );

    return {
      ...data,
      rows,
      hasUnitToggle: Boolean(data.hasUnitToggle || hasUnitToggle),
    };
  };

  const getEmbeddedProductSizeGuide = (widget) => {
    const modal = document.querySelector(widget.dataset.sizeGuideModal || ".hcx-size-guide-modal");
    const script = modal?.querySelector("[data-hcx-product-size-chart]");
    if (!script?.textContent?.trim()) return null;

    try {
      const payload = JSON.parse(script.textContent);
      const sizes = Array.isArray(payload.sizes) ? payload.sizes.map(normalizeSizeValue).filter(Boolean) : [];
      const measurements = Array.isArray(payload.measurements) ? payload.measurements : [];
      if (!sizes.length || !measurements.length) return null;

      const rows = sizes
        .map((size) => {
          const metrics = measurements
            .map((measurement) => {
              const rawLabel = String(measurement.label || "").replace(/\s+/g, " ").trim();
              if (!rawLabel) return null;

              const values = measurement.values?.[size] || measurement.values?.[size.replace("XXL", "2XL")] || {};
              const inch = String(values.inch || "").replace(/\s+/g, " ").trim();
              const cm = String(values.cm || "").replace(/\s+/g, " ").trim();
              if (!inch && !cm) return null;

              return normalizeFitMeasurementMetric({
                header: normalizeText(rawLabel),
                displayHeader: rawLabel,
                label: cm || inch,
                value: toMeasurementNumber(cm || inch),
                valueUnit: cm ? "cm" : "inch",
                units: { inch, cm },
              });
            })
            .filter(Boolean);

          return metrics.length ? { size, rawSize: size, metrics } : null;
        })
        .filter(Boolean);

      if (!rows.length) return null;

      return normalizeFitSizeGuideUnits({
        headers: ["size", ...measurements.map((measurement) => normalizeText(measurement.label || ""))],
        rows,
        source: "Size chart",
        itemNumber: String(payload.itemNumber || ""),
        fitReference: payload.fitReference || null,
        hasUnitToggle: true,
      });
    } catch (_error) {
      return null;
    }
  };

  const getSizeGuideData = (widget) => {
    const embedded = getEmbeddedProductSizeGuide(widget);
    if (embedded) return embedded;

    const modal = document.querySelector(widget.dataset.sizeGuideModal || ".hcx-size-guide-modal");
    const tables = modal ? [...modal.querySelectorAll("table")].filter((table) => !widget.contains(table)) : [];
    const rankedTables = tables
      .map((table) => ({ table, score: scoreSizeGuideTable(table, widget) }))
      .sort((a, b) => b.score.total - a.score.total);
    const parsedTables = rankedTables
      .map((candidate) => ({ ...candidate, parsed: parseAnySizeGuideTable(candidate.table) }))
      .filter((candidate) => candidate.parsed);
    const hasProductSpecificMatch = parsedTables.some((candidate) => candidate.score.productScore > 0);

    for (const candidate of parsedTables) {
      if (candidate.score.baseScore >= 6 && candidate.score.productScore > 0) {
        return normalizeFitSizeGuideUnits({ ...candidate.parsed, source: "Size guide" });
      }
    }

    if (!hasProductSpecificMatch) {
      for (const candidate of parsedTables) {
        if (candidate.score.baseScore >= 6 && candidate.score.kindScore > 0) {
          return normalizeFitSizeGuideUnits({ ...candidate.parsed, source: "Size guide" });
        }
      }
    }

    const fallbackTable = widget.querySelector("[data-hcx-fit-measurements-table]");
    const fallback = fallbackTable ? parseAnySizeGuideTable(fallbackTable) : null;
    return fallback ? normalizeFitSizeGuideUnits({ ...fallback, source: "Garment guide" }) : null;
  };

  const hasUsableMetricValue = (metric, requireValue = true) => {
    if (!metric) return false;
    if (requireValue) return metric.value !== null;
    return Boolean(metric.header || metric.label);
  };

  const isFilledMeasurement = (value = "") => {
    const text = String(value).replace(/\s+/g, " ").trim();
    return Boolean(text && text !== "-" && text !== "—" && !/^n\/?a$/i.test(text));
  };

  const getPrimaryMetric = (row, kind, requireValue = true) => {
    const priority =
      kind === "bottom" || kind === "short"
        ? ["waist", "hip", "seat"]
        : ["chest", "pit", "bust", "width"];

    for (const key of priority) {
      const metric = row.metrics.find((item) => item.header.includes(key) && !/shoulder|sleeve|arm/.test(item.header) && hasUsableMetricValue(item, requireValue));
      if (metric) return metric;
    }

    return null;
  };

  const getSecondaryMetric = (row, kind, requireValue = true) => {
    const priority =
      kind === "bottom"
        ? ["inseam", "inside leg", "length"]
        : kind === "short"
          ? ["outseam", "length"]
          : ["length", "body"];

    for (const key of priority) {
      const metric = row.metrics.find((item) => item.header.includes(key) && !/sleeve|arm/.test(item.header) && hasUsableMetricValue(item, requireValue));
      if (metric) return metric;
    }

    return null;
  };

  const getSleeveMetric = (row, requireValue = true) => {
    const priority = ["sleeve length", "sleeve", "arm length", "arm"];

    for (const key of priority) {
      const metric = row.metrics.find((item) => {
        const header = item.header || "";
        return !header.includes("sleeveless") && header.includes(key) && hasUsableMetricValue(item, requireValue);
      });
      if (metric) return metric;
    }

    return null;
  };

  const getDefaultMeasurement = (kind, size, type) => {
    const normalizedKind = defaultFitMeasurements[kind] ? kind : "top";
    return defaultFitMeasurements[normalizedKind]?.[normalizeSizeValue(size)]?.[type] || "";
  };

  const getFallbackMetricLabel = (row, type, kind, fallbackData) => {
    const fallbackRow = fallbackData?.rows?.find((item) => item.size === row.size);
    const fallbackMetric = fallbackRow ? (type === "primary" ? getPrimaryMetric(fallbackRow, kind) : getSecondaryMetric(fallbackRow, kind)) : null;
    if (isFilledMeasurement(fallbackMetric?.label)) return fallbackMetric.label;

    return getDefaultMeasurement(kind, row.size, type);
  };

  const resolveMetricLabel = (row, metric, type, kind, fallbackData) => {
    if (isFilledMeasurement(metric?.label)) return metric.label;
    return getFallbackMetricLabel(row, type, kind, fallbackData) || "";
  };

  const getUnitMetricLabel = (metric, unit) => {
    const normalizedUnit = normalizeFitUnit(unit);
    const preferred = metric?.units?.[normalizedUnit] || "";
    if (isFilledMeasurement(preferred)) return preferred;
    const fallback = normalizedUnit === "cm" ? metric?.units?.inch : metric?.units?.cm;
    if (isFilledMeasurement(fallback)) return fallback;
    return metric?.label || "";
  };

  const getMetricHeading = (metric, fallback, unit, hasUnitToggle, clarifyFlatWidth = false) => {
    const label = String(metric?.displayHeader || metric?.header || fallback || "")
      .replace(/\s*\((?:cm|in|inch|inches)\)\s*/gi, " ")
      .replace(/\b(?:cm|inch|inches)\b/gi, " ")
      .replace(/\s+/g, " ")
      .trim();
    const formatted = String(label || fallback || "")
      .replace(/\b\w/g, (letter) => letter.toUpperCase())
      .replace(/\bCm\b/g, "CM")
      .replace(/\bInch\b/g, "IN");
    const clarified = clarifyFlatWidth
      ? /\bflat\b/i.test(formatted)
        ? formatted
        : /\bwidth\b/i.test(formatted)
          ? `${formatted} (Flat)`
          : `${formatted} Width (Flat)`
      : formatted;

    return hasUnitToggle ? `${clarified} (${normalizeFitUnit(unit) === "inch" ? "IN" : "CM"})` : clarified;
  };

  const renderFitMeasurements = (widget, data, productInfo) => {
    const reference = widget.querySelector("[data-hcx-fit-reference]");
    const chartNotice = widget.querySelector("[data-hcx-fit-chart-notice]");
    const garmentFields = widget.querySelector("[data-hcx-fit-garment-fields]");
    const hasProductChart = data?.source === "Size chart" && data?.rows?.length > 0;
    const weightLabel = widget.querySelector("[data-hcx-fit-weight-label]");
    if (weightLabel) weightLabel.textContent = data?.itemNumber === "MW0036" ? "Weight" : "Weight (optional)";
    if (reference) reference.hidden = !hasProductChart;
    if (chartNotice) chartNotice.hidden = Boolean(hasProductChart);
    if (garmentFields) garmentFields.hidden = !hasProductChart;
    const extraSupport = hasProductChart ? getDirectGarmentMeasurementSupport(getProductFitRows(data.rows, productInfo), widget.dataset.productKind || "top") : {};
    widget.querySelectorAll("[data-hcx-fit-extra-measurement]").forEach((label) => { label.hidden = !extraSupport[label.dataset.hcxFitExtraMeasurement]; });
    // Generic tables must not be presented as this garment's measurements.
    if (!hasProductChart) return;

    const source = widget.querySelector("[data-hcx-fit-measurements-source]");
    const table = widget.querySelector("[data-hcx-fit-measurements-table]");
    const body = widget.querySelector("[data-hcx-fit-measurements-body]");
    if (!table || !body) return;

    const kind = widget.dataset.productKind || "top";
    const unit = normalizeFitUnit(widget.dataset.hcxFitUnit || "cm");
    const fallbackTable = widget.querySelector("[data-hcx-fit-measurements-table]");
    const fallbackData = fallbackTable ? parseAnySizeGuideTable(fallbackTable) : null;
    const displayRows = getProductFitRows(data.rows, productInfo);
    const firstRow = displayRows[0] || data.rows.find((row) => isFitSizeInRange(row.size)) || data.rows[0];
    const primary = firstRow ? getPrimaryMetric(firstRow, kind, false) : null;
    const secondary = firstRow ? getSecondaryMetric(firstRow, kind, false) : null;
    const directSupport = getDirectGarmentMeasurementSupport(displayRows, kind);
    if (garmentFields) garmentFields.hidden = !directSupport.enabled;
    [
      ["primary", primary, kind === "bottom" || kind === "short" ? "Waist" : "Chest", directSupport.primary],
      ["secondary", secondary, kind === "short" ? "Outseam" : "Length", directSupport.secondary],
    ].forEach(([dimension, metric, fallback, supported]) => {
      const label = widget.querySelector(`[data-hcx-fit-garment-${dimension}-label]`);
      const input = widget.querySelector(`[data-hcx-fit-garment-${dimension}]`);
      if (label) label.textContent = getMetricHeading(metric, fallback, "cm", false,
        dimension === "primary" && isFlatGarmentMeasurement(metric, kind));
      if (input) input.disabled = !supported;
    });
    const sleeve = firstRow && kind !== "bottom" && kind !== "short" ? getSleeveMetric(firstRow, false) : null;
    const showSleeve = Boolean(sleeve && displayRows.some((row) => getSleeveMetric(row, false)));
    const headingRow = table.querySelector("thead tr");
    const hasUnitToggle = Boolean(data.hasUnitToggle);
    const unitToggle = widget.querySelector("[data-hcx-fit-unit-toggle]");

    if (source) source.textContent = data.source;
    if (unitToggle) {
      unitToggle.hidden = !hasUnitToggle;
      unitToggle.querySelectorAll("[data-hcx-fit-unit]").forEach((button) => {
        button.classList.toggle("is-active", normalizeFitUnit(button.dataset.hcxFitUnit) === unit);
        button.setAttribute("aria-pressed", normalizeFitUnit(button.dataset.hcxFitUnit) === unit ? "true" : "false");
      });
    }

    if (headingRow) {
      headingRow.replaceChildren();
      [
        "Size",
        getMetricHeading(
          primary,
          kind === "bottom" || kind === "short" ? "Waist" : "Chest",
          unit,
          hasUnitToggle,
          isFlatGarmentMeasurement(primary, kind)
        ),
        getMetricHeading(secondary, kind === "short" ? "Outseam" : "Length", unit, hasUnitToggle),
        ...(showSleeve ? [getMetricHeading(sleeve, "Sleeve length", unit, hasUnitToggle)] : []),
      ].forEach((label) => {
        const th = document.createElement("th");
        th.textContent = label;
        headingRow.appendChild(th);
      });
    }

    body.replaceChildren();
    displayRows.forEach((row) => {
      const tr = document.createElement("tr");
      const primaryMetric = getPrimaryMetric(row, kind, false);
      const secondaryMetric = getSecondaryMetric(row, kind, false);
      const sleeveMetric = showSleeve ? getSleeveMetric(row, false) : null;
      [
        getProductDisplaySizeLabel(productInfo, row.size || row.rawSize) || row.rawSize || row.size,
        hasUnitToggle
          ? getUnitMetricLabel(primaryMetric, unit)
          : resolveMetricLabel(row, primaryMetric, "primary", kind, fallbackData),
        hasUnitToggle
          ? getUnitMetricLabel(secondaryMetric, unit)
          : resolveMetricLabel(row, secondaryMetric, "secondary", kind, fallbackData),
        ...(showSleeve
          ? [
              hasUnitToggle
                ? getUnitMetricLabel(sleeveMetric, unit)
                : resolveMetricLabel(row, sleeveMetric, "sleeve", kind, fallbackData),
            ]
          : []),
      ].forEach((value) => {
        const td = document.createElement("td");
        td.textContent = value || "";
        tr.appendChild(td);
      });
      body.appendChild(tr);
    });
  };

  const clampNumber = (value, min, max) => Math.max(min, Math.min(max, value));

  const getAverageBodyScale = (height, weight) => {
    // Width is a rough weight-only estimate. Height changes length, never makes
    // this width target shrink. Keep the existing 78 kg reference, without BMI.
    return weight > 0 ? Math.sqrt(weight / 78) : 0;
  };

  const estimateChestCircumference = (height, weight) =>
    clampNumber(102 * getAverageBodyScale(height, weight), 78, 148);

  const estimateWaistCircumference = (height, weight) =>
    clampNumber(86 * getAverageBodyScale(height, weight), 66, 142);

  const estimateHipCircumference = (height, weight) =>
    clampNumber(estimateWaistCircumference(height, weight) + 10, 82, 152);

  const getMetricPreferenceOffset = (preference, kind, metric, isFlatMeasurement = false) => {
    const header = metric?.header || "";
    const direction = preference === "fitted" || preference === "neat" ? -1 : preference === "roomy" ? 1 : 0;
    if (!direction) return 0;

    if (kind === "bottom" || kind === "short") {
      if (/waist|hip|seat/.test(header)) {
        const bottomEase = preference === "roomy" ? 1.85 : 1;
        return direction * (isFlatMeasurement ? bottomEase : bottomEase * 2);
      }
      if (/inseam|inside leg|outseam|length/.test(header)) return direction * 0.35;
      return direction * 0.75;
    }

    if (/length|body/.test(header)) return direction * 0.5;
    return direction * (isFlatMeasurement ? 1.4 : 2.8);
  };

  const isMetricInInches = (metric) => {
    if (metric?.valueUnit) return normalizeFitUnit(metric.valueUnit) === "inch";
    if (isFilledMeasurement(metric?.units?.cm)) return false;
    const unitText = `${metric?.displayHeader || ""} ${metric?.header || ""} ${metric?.label || ""} ${metric?.units?.inch || ""}`;
    return /"|(?:^|\s)in(?:\s|$)|inch|inches/i.test(unitText);
  };

  const isFlatGarmentMeasurement = (metric, kind = "top") => {
    const value = Number(metric?.value || 0);
    if (!(value > 0)) return false;

    const header = `${metric?.displayHeader || ""} ${metric?.header || ""}`.toLowerCase();
    if (/circumference|around|body\s*(?:chest|bust|waist|hip)|to\s*fit/.test(header)) return false;
    if (/length|inseam|inside leg|outseam/.test(header)) return false;
    if (/flat|half|pit(?:\s*to\s*pit)?|width|across/.test(header)) return true;

    const labelNumbers = getFitMeasurementNumbers(metric?.label || "");
    if (labelNumbers.length > 1) return false;

    const valueInCm = isMetricInInches(metric) ? value * 2.54 : value;
    if (kind === "bottom" || kind === "short") {
      return /waist|hip|seat/.test(header) && valueInCm < 70;
    }

    return /chest|bust/.test(header) ? valueInCm < 90 : valueInCm < 70;
  };

  const convertCmTargetToMetricUnit = (targetCm, metric) => (isMetricInInches(metric) ? targetCm / 2.54 : targetCm);

  const getIntendedGarmentEase = (kind, fitProfile = "", itemNumber = "") => {
    const profile = String(fitProfile).toLowerCase();
    const isOversized = /oversized|oversize|loose|relaxed|boxy|drop shoulder/.test(profile);
    const isFitted = /fitted|slim|compression/.test(profile);

    // Conservative brand fit targets supplied by the owner, 19 October 2026.
    // These ease allowances remain estimates, not independently validated body measurements.
    // Owner fit calibration, 27 October 2026: MW0036 was recommending one size too large.
    // Keep the manufacturer chart intact and adjust the estimated chest room for this blank.
    if (kind === "hoodie" && itemNumber === "MW0036") return 24;
    if (kind === "hoodie") return isOversized ? 30 : isFitted ? 6 : 16;
    if (kind === "tank") return isOversized ? 14 : isFitted ? 2 : 6;
    return isOversized ? 22 : isFitted ? 4 : 10;
  };

  const estimateTargetMeasurement = (height, weight, preference, kind, metric, fitProfile = "", itemNumber = "") => {
    const header = metric?.header || "";
    const isFlatMeasurement = isFlatGarmentMeasurement(metric, kind);

    if (kind === "bottom" || kind === "short") {
      if (/inseam|inside leg|outseam|length/.test(header)) {
        const lengthRatio = kind === "short" ? 0.265 : header.includes("inseam") || header.includes("inside leg") ? 0.44 : 0.595;
        return convertCmTargetToMetricUnit(
          height * lengthRatio + getMetricPreferenceOffset(preference, kind, metric, isFlatMeasurement),
          metric
        );
      }

      const waist = estimateWaistCircumference(height, weight);
      const hip = estimateHipCircumference(height, weight);
      if (isFlatMeasurement) {
        if (/hip|seat/.test(header)) {
          const hipEase = /oversized|oversize|loose|relaxed|wide/.test(String(fitProfile).toLowerCase()) ? 16 : 10;
          return convertCmTargetToMetricUnit(
            (hip + hipEase) / 2 + getMetricPreferenceOffset(preference, kind, metric, true),
            metric
          );
        }

        const elasticAllowance = kind === "short" ? 10 : 14;
        return convertCmTargetToMetricUnit(
          (waist - elasticAllowance) / 2 + getMetricPreferenceOffset(preference, kind, metric, true),
          metric
        );
      }

      const circumference = /hip|seat/.test(header) ? hip : waist;
      return convertCmTargetToMetricUnit(
        circumference + getMetricPreferenceOffset(preference, kind, metric, false),
        metric
      );
    }

    if (/length|body/.test(header)) {
      const ratio = kind === "hoodie" ? 0.395 : kind === "tank" ? 0.393 : 0.405;
      return convertCmTargetToMetricUnit(
        height * ratio + getMetricPreferenceOffset(preference, kind, metric, isFlatMeasurement),
        metric
      );
    }

    const estimatedChest = estimateChestCircumference(height, weight);
    // Shirt fit uses a rough body estimate, not hundredth-centimetre precision.
    const chest = kind === "top" ? Math.round(estimatedChest) : estimatedChest;
    const garmentEase = getIntendedGarmentEase(kind, fitProfile, itemNumber);
    if (isFlatMeasurement) {
      return convertCmTargetToMetricUnit(
        (chest + garmentEase) / 2 + getMetricPreferenceOffset(preference, kind, metric, true),
        metric
      );
    }

    return convertCmTargetToMetricUnit(chest + garmentEase + getMetricPreferenceOffset(preference, kind, metric, false), metric);
  };

  const hasNumericFitMetric = (metric) => metric?.value != null && Number.isFinite(Number(metric.value)) && Number(metric.value) > 0;

  const isBodyFitMeasurement = (metric) =>
    /body\s*(?:chest|bust|waist|hip)|to\s*fit|recommended\s*(?:chest|waist|hip)/i.test(`${metric?.header || ""} ${metric?.displayHeader || ""}`);

  const getMetricValueCm = (metric) => hasNumericFitMetric(metric)
    ? Number(metric.value) * (isMetricInInches(metric) ? 2.54 : 1)
    : null;

  const getDirectGarmentMeasurementSupport = (rows, kind) => {
    const metrics = rows.flatMap((row) => [getPrimaryMetric(row, kind), getSecondaryMetric(row, kind)]).filter(hasNumericFitMetric);
    // A body-fit interval or relaxed/stretched range is not a single laid-flat garment dimension.
    const enabled = metrics.length > 0 && !metrics.some((metric) =>
      isBodyFitMeasurement(metric) || getFitMeasurementNumbers(metric.label || "").length > 1);
    return {
      enabled,
      primary: enabled && rows.some((row) => hasNumericFitMetric(getPrimaryMetric(row, kind))),
      secondary: enabled && rows.some((row) => hasNumericFitMetric(getSecondaryMetric(row, kind))),
      sleeve: enabled && rows.some((row) => hasNumericFitMetric(getSleeveMetric(row)) && row.metrics.some((m) => /shoulder/.test(m.header) && hasNumericFitMetric(m))),
      shoulder: enabled && rows.some((row) => hasNumericFitMetric(getSleeveMetric(row)) && row.metrics.some((m) => /shoulder/.test(m.header) && hasNumericFitMetric(m))),
      hip: enabled && (kind === "bottom" || kind === "short") && rows.some((row) => row.metrics.some((m) => /hip|seat/.test(m.header) && hasNumericFitMetric(m) && isFlatGarmentMeasurement(m, kind) && getFitMeasurementNumbers(m.label || "").length === 1)),
    };
  };

  const getVerticalMeasurementTargetCm = (kind, height, fitProfile = "", metric = null) => {
    const profile = String(fitProfile).toLowerCase();
    const header = String(metric?.header || "").toLowerCase();

    if (kind === "short") return height * 0.25;
    if (kind === "bottom") {
      return /inseam|inside leg/.test(header) ? height * 0.425 : height * 0.56;
    }
    if (kind === "hoodie") return height * 0.36;
    if (/cropped|crop/.test(profile)) return height * 0.36;
    if (/boxy/.test(profile)) return height * 0.375;
    if (kind === "tank") return height * 0.375;
    return height * 0.375;
  };

  const getSupplierReferenceLengthTargetCm = (data, kind, height) => {
    const reference = data?.fitReference;
    if (!["top", "tank"].includes(kind) || reference?.source !== "supplier-model" || reference?.style !== "longline") return 0;
    const referenceHeight = Number(reference.heightCm);
    if (!Number.isFinite(height) || height <= 0 || !Number.isFinite(referenceHeight) || referenceHeight < 90 || referenceHeight > 220) return 0;
    const referenceRow = data.rows.find((row) => normalizeSizeValue(row.size) === normalizeSizeValue(reference.size));
    const referenceLength = getMetricValueCm(getSecondaryMetric(referenceRow || { metrics: [] }, kind));
    if (!(referenceLength > 0)) return 0;
    const lengths = [...new Set(data.rows.map((row) => getMetricValueCm(getSecondaryMetric(row, kind))).filter((value) => value > 0))].sort((a, b) => a - b);
    if (!lengths.length) return 0;
    const scaledLength = referenceLength * height / referenceHeight;
    // Anchor this garment's longline styling to its published model and real chart rows.
    // Do not invent a new measurement or clamp a height beyond the chart to an available size.
    if (scaledLength > lengths[lengths.length - 1]) return scaledLength;
    return lengths.slice().sort((a, b) => Math.abs(a - scaledLength) - Math.abs(b - scaledLength) || b - a)[0];
  };

  const getBuildFitAllowance = (build, dimension) => {
    // Modest conservative room allowances, not asserted body measurements.
    if (build === "muscular") return dimension === "chest" || dimension === "hip" ? 2 : 0;
    if (build === "off-season") return dimension === "waist" ? 6 : dimension === "hip" ? 4 : 2;
    return 0;
  };

  const getMeasuredFitRecommendation = (rows, kind, height, weight, fitProfile = "", preference = "intended", direct = {}, build = "", referenceLengthCm = 0, itemNumber = "") => {
    const primary = rows.map((row) => getPrimaryMetric(row, kind)).find(hasNumericFitMetric);
    const secondary = rows.map((row) => getSecondaryMetric(row, kind)).find(hasNumericFitMetric);
    const resolveShoulder = (row) => row.metrics.find((metric) => /shoulder/.test(metric.header || "") && hasNumericFitMetric(metric));
    const resolveHip = (row) => row.metrics.find((metric) => /hip|seat/.test(metric.header || "") && hasNumericFitMetric(metric));
    const axes = [];
    const addAxis = (name, label, targetCm, directValue, resolve, factor = () => 1, scale = 4) => {
      axes.push({ name, label, targetCm, direct: Boolean(directValue), resolve, factor, scale });
    };
    if (primary && (direct.primary > 0 || weight > 0)) {
      const flatFactor = isFlatGarmentMeasurement(primary, kind) ? 2 : 1;
      const bodyDimension = /hip|seat/.test(primary.header) ? "hip" : /waist/.test(primary.header) ? "waist" : "chest";
      const bodyAllowance = getBuildFitAllowance(build, bodyDimension);
      let targetCm;
      if (direct.primary > 0) targetCm = direct.primary * flatFactor;
      else if (isBodyFitMeasurement(primary)) {
        targetCm = (bodyDimension === "hip" ? estimateHipCircumference(height, weight)
          : bodyDimension === "waist" ? estimateWaistCircumference(height, weight)
          : estimateChestCircumference(height, weight)) + bodyAllowance + getMetricPreferenceOffset(preference, kind, primary, false);
      } else targetCm = estimateTargetMeasurement(height, weight, preference, kind, primary, fitProfile, itemNumber)
        * (isMetricInInches(primary) ? 2.54 : 1) * flatFactor + bodyAllowance;
      addAxis("primary", getMetricHeading(primary, kind === "bottom" || kind === "short" ? "Waist" : "Chest", "cm", false, flatFactor === 2), targetCm, direct.primary, (row) => getPrimaryMetric(row, kind), () => flatFactor, 6);
    }
    const hip = rows.map(resolveHip).find(hasNumericFitMetric);
    if ((kind === "bottom" || kind === "short") && hip && (direct.hip > 0 || weight > 0 && !(direct.primary > 0))) {
      const factor = isFlatGarmentMeasurement(hip, kind) ? 2 : 1;
      const target = direct.hip > 0 ? direct.hip * factor
        : estimateTargetMeasurement(height, weight, preference, kind, hip, fitProfile, itemNumber) * (isMetricInInches(hip) ? 2.54 : 1) * factor + getBuildFitAllowance(build, "hip");
      addAxis("hip", "Hip width (flat)", target, direct.hip, resolveHip, () => factor, 8);
    }
    if (secondary && (direct.secondary > 0 || height > 0)) {
      const target = direct.secondary > 0 ? direct.secondary
        : Math.max(getVerticalMeasurementTargetCm(kind, height, fitProfile, secondary), referenceLengthCm) + getMetricPreferenceOffset(preference, kind, secondary, false);
      addAxis("secondary", getMetricHeading(secondary, "Length", "cm", false), target, direct.secondary, (row) => getSecondaryMetric(row, kind), () => 1, 6);
    }
    const longSleeve = kind === "hoodie" || /long.sleeve/.test(fitProfile);
    const canCompareReach = rows.some((row) => hasNumericFitMetric(getSleeveMetric(row)) && hasNumericFitMetric(resolveShoulder(row)));
    const hasReferenceReach = direct.sleeve > 0 && direct.shoulder > 0;
    if (canCompareReach && (hasReferenceReach || longSleeve && height > 0)) {
      // Drop shoulders trade shoulder width against sleeve-seam length.
      // Compare combined reach; never compare sleeve-seam length to a bare arm.
      const target = hasReferenceReach ? direct.shoulder / 2 + direct.sleeve : height * 0.47;
      axes.push({ name: "reach", label: "Shoulder plus sleeve reach", targetCm: target,
        direct: hasReferenceReach, scale: 4, combined: (row) => {
          const shoulder = getMetricValueCm(resolveShoulder(row));
          const sleeve = getMetricValueCm(getSleeveMetric(row));
          return shoulder === null || sleeve === null ? null : shoulder / 2 + sleeve;
        } });
    }
    if (!axes.length) return { incomplete: true };
    const candidates = rows.map((row) => {
      let score = 0;
      const values = {};
      for (const axis of axes) {
        const cm = axis.combined ? axis.combined(row) : getMetricValueCm(axis.resolve(row));
        if (cm === null) return null;
        const value = axis.combined ? cm : cm * axis.factor();
        values[axis.name] = value;
        const difference = (value - axis.targetCm) / axis.scale;
        score += difference * difference * (difference < 0 ? 16 : axis.name === "secondary" || axis.name === "reach" ? .1 : 1);
      }
      return { row, score, values };
    }).filter(Boolean);
    if (!candidates.length) return { incomplete: true };
    const meetsEveryTarget = (candidate) => axes.every((axis) => candidate.values[axis.name] >= axis.targetCm - 1e-8);
    const eligible = candidates.filter(meetsEveryTarget);
    const ranked = (eligible.length ? eligible : candidates).slice().sort((a, b) => {
      if (!eligible.length) {
        const deficit = (candidate) => axes.reduce((sum, axis) => sum + Math.max(0, axis.targetCm - candidate.values[axis.name]) / axis.scale, 0);
        const delta = deficit(a) - deficit(b);
        if (Math.abs(delta) > 1e-9) return delta;
      }
      return Math.abs(a.score - b.score) > 1e-9 ? a.score - b.score : getSizeRankIndex(a.row.size) - getSizeRankIndex(b.row.size);
    });
    const best = ranked[0];
    const boundaries = axes.filter((axis) => best.values[axis.name] < axis.targetCm - 1e-8).map((axis) => ({ dimension: axis.name, direction: "above", direct: axis.direct, label: axis.label }));
    const chartMeasurements = [getPrimaryMetric(best.row, kind), getSecondaryMetric(best.row, kind), ...(axes.some((axis) => axis.name === "reach") ? [getSleeveMetric(best.row), resolveShoulder(best.row)] : [])]
      .filter(hasNumericFitMetric).map((metric) => ({ label: getMetricHeading(metric, "Measurement", "cm", false, metric === getPrimaryMetric(best.row, kind) && isFlatGarmentMeasurement(metric, kind)), valueCm: getMetricValueCm(metric) }));
    const uncheckedDimensions = [];
    if (longSleeve && !canCompareReach) uncheckedDimensions.push("sleeve reach: no comparable shoulder and sleeve measurements");
    if ((kind === "bottom" || kind === "short") && !hip) uncheckedDimensions.push("hip: no product measurement");
    if ((kind === "bottom" || kind === "short") && !(direct.primary > 0)) uncheckedDimensions.push("waistband stretch: check the size chart");
    if (!axes.some((axis) => axis.name === "primary")) uncheckedDimensions.push(kind === "bottom" || kind === "short" ? "waist width" : "chest width");
    return { size: normalizeSizeValue(best.row.size), incomplete: false, boundaries, chartMeasurements,
      usedHeight: axes.some((axis) => (axis.name === "secondary" || axis.name === "reach") && !axis.direct),
      usedWeight: axes.some((axis) => (axis.name === "primary" || axis.name === "hip") && !axis.direct),
      usedDirect: axes.some((axis) => axis.direct), directOnly: axes.every((axis) => axis.direct),
      comparedDimensions: axes.length, uncheckedDimensions,
      fitBasis: axes.every((axis) => axis.direct) ? "reference-garment" : "estimated-brand-fit" };
  };


  const syncFitInputSystems = (widget) => {
    if (!widget) return;

    const heightSystem = widget.dataset.hcxFitHeightSystem === "metric" ? "metric" : "imperial";
    const weightSystem = widget.dataset.hcxFitWeightSystem === "imperial" ? "imperial" : "metric";
    widget.dataset.hcxFitHeightSystem = heightSystem;
    widget.dataset.hcxFitWeightSystem = weightSystem;

    const heightImperial = widget.querySelector("[data-hcx-fit-height-imperial]");
    const heightMetric = widget.querySelector("[data-hcx-fit-height-metric]");
    const weightMetric = widget.querySelector("[data-hcx-fit-weight-metric]");
    const weightImperial = widget.querySelector("[data-hcx-fit-weight-imperial]");

    if (heightImperial) heightImperial.hidden = heightSystem !== "imperial";
    if (heightMetric) heightMetric.hidden = heightSystem !== "metric";
    if (weightMetric) weightMetric.hidden = weightSystem !== "metric";
    if (weightImperial) weightImperial.hidden = weightSystem !== "imperial";

    widget.querySelectorAll("[data-hcx-fit-height-system]").forEach((button) => {
      const isActive = button.dataset.hcxFitHeightSystem === heightSystem;
      button.classList.toggle("is-active", isActive);
      button.setAttribute("aria-pressed", isActive ? "true" : "false");
    });

    widget.querySelectorAll("[data-hcx-fit-weight-system]").forEach((button) => {
      const isActive = button.dataset.hcxFitWeightSystem === weightSystem;
      button.classList.toggle("is-active", isActive);
      button.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  };

  // Keep exact measurements when unit controls only reformat their display.
  // A changed input signature automatically invalidates the cached measurement.
  const fitCanonicalMeasurements = new WeakMap();
  const readFitNumericInput = (input) => {
    const raw = String(input?.value ?? "").trim();
    if (input?.validity?.badInput) return { raw, empty: false, value: NaN, badInput: true };
    if (!raw) return { raw, empty: true, value: 0, badInput: false };
    const value = /^(?:\d+(?:\.\d*)?|\.\d+)$/.test(raw) ? Number(raw) : NaN;
    return { raw, empty: false, value: Number.isFinite(value) ? value : NaN, badInput: false };
  };
  const getFitMeasurementSignature = (widget, dimension) => {
    const heightSystem = widget.dataset.hcxFitHeightSystem === "metric" ? "metric" : "imperial";
    const weightSystem = widget.dataset.hcxFitWeightSystem === "imperial" ? "imperial" : "metric";
    const system = dimension === "height" ? heightSystem : weightSystem;
    const selectors = dimension === "height"
      ? system === "metric" ? ["[data-hcx-fit-height]"] : ["[data-hcx-fit-height-ft]", "[data-hcx-fit-height-in]"]
      : system === "metric" ? ["[data-hcx-fit-weight]"] : ["[data-hcx-fit-weight-lb]"];
    return JSON.stringify([system, ...selectors.map((selector) => {
      const input = readFitNumericInput(widget.querySelector(selector));
      return [input.raw, input.badInput];
    })]);
  };
  const rememberFitMeasurement = (widget, dimension, value) => {
    const measurements = fitCanonicalMeasurements.get(widget) || {};
    measurements[dimension] = { signature: getFitMeasurementSignature(widget, dimension), value };
    fitCanonicalMeasurements.set(widget, measurements);
    return value;
  };
  const formatFitMeasurement = (value) => String(Math.round((value + Number.EPSILON) * 100) / 100);

  const getFitHeightInCm = (widget) => {
    const cached = fitCanonicalMeasurements.get(widget)?.height;
    if (cached?.signature === getFitMeasurementSignature(widget, "height")) return cached.value;
    const heightSystem = widget.dataset.hcxFitHeightSystem === "metric" ? "metric" : "imperial";
    if (heightSystem === "metric") {
      const input = readFitNumericInput(widget.querySelector("[data-hcx-fit-height]"));
      const height = input.empty ? 0 : input.value > 0 ? input.value : NaN;
      return rememberFitMeasurement(widget, "height", height);
    }

    const feet = readFitNumericInput(widget.querySelector("[data-hcx-fit-height-ft]"));
    const inches = readFitNumericInput(widget.querySelector("[data-hcx-fit-height-in]"));
    if (!Number.isFinite(feet.value) || !Number.isFinite(inches.value) ||
        !Number.isInteger(feet.value) || feet.value < 0 || inches.value < 0 || inches.value >= 12) {
      return rememberFitMeasurement(widget, "height", NaN);
    }
    if (feet.empty) return rememberFitMeasurement(widget, "height", 0);
    const totalInches = feet.value * 12 + inches.value;
    return rememberFitMeasurement(widget, "height", totalInches > 0 ? totalInches * 2.54 : NaN);
  };

  const getFitWeightInKg = (widget) => {
    const cached = fitCanonicalMeasurements.get(widget)?.weight;
    if (cached?.signature === getFitMeasurementSignature(widget, "weight")) return cached.value;
    const weightSystem = widget.dataset.hcxFitWeightSystem === "imperial" ? "imperial" : "metric";
    const selector = weightSystem === "imperial" ? "[data-hcx-fit-weight-lb]" : "[data-hcx-fit-weight]";
    const input = readFitNumericInput(widget.querySelector(selector));
    const weight = input.empty ? 0 : input.value > 0 ? input.value * (weightSystem === "imperial" ? 0.45359237 : 1) : NaN;
    return rememberFitMeasurement(widget, "weight", weight);
  };

  const fitGarmentCanonicalMeasurements = new WeakMap();
  const getFitGarmentMeasurementSignature = (widget) => JSON.stringify([
    normalizeFitUnit(widget.querySelector("[data-hcx-fit-garment-unit]")?.value || "cm"),
    ...["primary", "secondary", "sleeve", "shoulder", "hip"].map((dimension) => {
      const input = readFitNumericInput(widget.querySelector(`[data-hcx-fit-garment-${dimension}]`));
      return [input.raw, input.badInput];
    }),
  ]);

  const getFitGarmentMeasurements = (widget) => {
    const signature = getFitGarmentMeasurementSignature(widget);
    const cached = fitGarmentCanonicalMeasurements.get(widget);
    if (cached?.signature === signature) return cached;
    const unit = normalizeFitUnit(widget.querySelector("[data-hcx-fit-garment-unit]")?.value || "cm");
    const measurements = { unit, signature };
    ["primary", "secondary", "sleeve", "shoulder", "hip"].forEach((dimension) => {
      const input = readFitNumericInput(widget.querySelector(`[data-hcx-fit-garment-${dimension}]`));
      measurements[dimension] = input.empty ? 0 : input.value > 0 ? input.value * (unit === "inch" ? 2.54 : 1) : NaN;
    });
    fitGarmentCanonicalMeasurements.set(widget, measurements);
    return measurements;
  };

  const setFitGarmentUnit = (widget, nextUnit) => {
    const select = widget.querySelector("[data-hcx-fit-garment-unit]");
    if (!select) return;
    const unit = normalizeFitUnit(nextUnit);
    const previousUnit = fitGarmentCanonicalMeasurements.get(widget)?.unit || widget.dataset.hcxFitGarmentUnit || "cm";
    // A select's change event runs after its value changes; read the inputs in their previous units first.
    select.value = previousUnit;
    const measurements = getFitGarmentMeasurements(widget);
    select.value = unit;
    ["primary", "secondary", "sleeve", "shoulder", "hip"].forEach((dimension) => {
      const input = widget.querySelector(`[data-hcx-fit-garment-${dimension}]`);
      const cm = measurements[dimension];
      if (input && Number.isFinite(cm)) input.value = cm > 0 ? formatFitMeasurement(unit === "inch" ? cm / 2.54 : cm) : "";
    });
    widget.dataset.hcxFitGarmentUnit = unit;
    fitGarmentCanonicalMeasurements.set(widget, { ...measurements, unit, signature: getFitGarmentMeasurementSignature(widget) });
  };

  const setFitHeightSystem = (widget, nextSystem) => {
    if (!widget) return;

    const normalizedNextSystem = nextSystem === "metric" ? "metric" : "imperial";
    const currentSystem = widget.dataset.hcxFitHeightSystem === "metric" ? "metric" : "imperial";
    if (currentSystem === normalizedNextSystem) {
      syncFitInputSystems(widget);
      return;
    }
    const heightCm = getFitHeightInCm(widget);
    // Do not hide invalid input or revive stale values from the other unit fields.
    if (!Number.isFinite(heightCm)) return;
    widget.dataset.hcxFitHeightSystem = normalizedNextSystem;

    if (normalizedNextSystem === "metric") {
      const heightInput = widget.querySelector("[data-hcx-fit-height]");
      if (heightInput) heightInput.value = heightCm > 0 ? formatFitMeasurement(heightCm) : "";
    } else {
      const totalInches = Math.round((heightCm / 2.54) * 100) / 100;
      const feetInput = widget.querySelector("[data-hcx-fit-height-ft]");
      const inchesInput = widget.querySelector("[data-hcx-fit-height-in]");
      if (feetInput) feetInput.value = heightCm > 0 ? String(Math.floor(totalInches / 12)) : "";
      if (inchesInput) inchesInput.value = heightCm > 0 ? formatFitMeasurement(totalInches % 12) : "";
    }

    rememberFitMeasurement(widget, "height", heightCm);
    syncFitInputSystems(widget);
  };

  const setFitWeightSystem = (widget, nextSystem) => {
    if (!widget) return;

    const normalizedNextSystem = nextSystem === "imperial" ? "imperial" : "metric";
    const currentSystem = widget.dataset.hcxFitWeightSystem === "imperial" ? "imperial" : "metric";
    if (currentSystem === normalizedNextSystem) {
      syncFitInputSystems(widget);
      return;
    }
    const weightKg = getFitWeightInKg(widget);
    if (!Number.isFinite(weightKg)) return;
    widget.dataset.hcxFitWeightSystem = normalizedNextSystem;

    if (normalizedNextSystem === "imperial") {
      const poundsInput = widget.querySelector("[data-hcx-fit-weight-lb]");
      if (poundsInput) poundsInput.value = weightKg > 0 ? formatFitMeasurement(weightKg / 0.45359237) : "";
    } else {
      const weightInput = widget.querySelector("[data-hcx-fit-weight]");
      if (weightInput) weightInput.value = weightKg > 0 ? formatFitMeasurement(weightKg) : "";
    }

    rememberFitMeasurement(widget, "weight", weightKg);
    syncFitInputSystems(widget);
  };

  const getClosestAvailableSize = (productInfo, recommendedSize) => {
    const available = getAvailableProductSizes(productInfo);
    if (!available.length) return recommendedSize;

    const exact = available.find((item) => item.size === normalizeSizeValue(recommendedSize));
    if (exact) return exact.size;

    const targetIndex = getSizeRankIndex(recommendedSize);
    return available
      .slice()
      .sort((a, b) => Math.abs(getSizeRankIndex(a.size) - targetIndex) - Math.abs(getSizeRankIndex(b.size) - targetIndex))[0].size;
  };

  const recommendFitSize = (widget, productInfo) => {
    const height = getFitHeightInCm(widget);
    const weight = getFitWeightInKg(widget);
    const preference = widget.querySelector("input[name^='hcx-fit-preference']:checked")?.value || "intended";
    const kind = widget.dataset.productKind || "top";
    const blocked = (reason, message) => ({ size: "", canApply: false, reason, message, preference });
    const productSizes = getProductFitSizes(productInfo);
    if (!productSizes.length) return blocked("incomplete-chart", "We cannot estimate a size for these options. Please use the product's measurements or contact us for sizing help.");
    const data = getSizeGuideData(widget);
    const fitProfile = `${widget.dataset.garmentFit || `${widget.dataset.fitLabel || ""} ${widget.dataset.productTitle || ""}`} ${widget.dataset.garmentFigure || ""}`;
    const hasProductMeasurementData = data?.source === "Size chart";
    if (!hasProductMeasurementData || !data?.rows?.length) {
      return blocked("missing-chart", "We do not have a verified product-specific chart for this item, so we cannot give a reliable size estimate. Please contact us for its measurements.");
    }
    const productRows = getProductFitRows(data.rows, productInfo)
      .sort((a, b) => getSizeRankIndex(a.size) - getSizeRankIndex(b.size));
    const support = getDirectGarmentMeasurementSupport(productRows, kind);
    const entered = getFitGarmentMeasurements(widget);
    const direct = Object.fromEntries(["primary", "secondary", "sleeve", "shoulder", "hip"].map((key) => [key, support[key] ? entered[key] : 0]));
    const build = "";
    if (Object.values(direct).some((value) => !Number.isFinite(value) || value < 0)) {
      return blocked("invalid-input", "Enter a positive number for each garment measurement, or leave it blank. Check whether you selected CM or IN.");
    }
    const directLimits = { primary: kind === "bottom" || kind === "short" ? [10, 100] : [20, 130], secondary: kind === "bottom" || kind === "short" ? [15, 160] : [35, 130], sleeve: [10, 110], shoulder: [15, 110], hip: [20, 130] };
    if (Object.entries(direct).some(([key, value]) => value > 0 && (value < directLimits[key][0] || value > directLimits[key][1]))) return blocked("invalid-input", "Check your garment measurements and whether you selected CM or IN.");
    if ((direct.sleeve > 0) !== (direct.shoulder > 0)) return blocked("incomplete-sleeve", "For a sleeve comparison, enter both shoulder width and sleeve length from the same garment.");
    if (height === 0 && !Object.values(direct).some((value) => value > 0)) return null;
    if ((!(direct.secondary > 0) && (!Number.isFinite(height) || (height !== 0 && (height < 90 - 1e-8 || height > 220 + 1e-8)))) ||
        (!(direct.primary > 0) && (!Number.isFinite(weight) || (weight !== 0 && (weight < 35 - 1e-8 || weight > 180 + 1e-8))))) {
      return blocked("invalid-input", "Enter a height from 90–220 cm and, if included, a weight from 35–180 kg.");
    }
    if (data.itemNumber === "MW0036" && !(weight > 0) && !(direct.primary > 0)) {
      return blocked("missing-chest", "For this hoodie, add your weight to estimate chest room. Height alone cannot check chest room.");
    }
    const measured = getMeasuredFitRecommendation(productRows, kind, direct.secondary > 0 ? 0 : height,
      direct.primary > 0 ? 0 : weight, fitProfile, preference, direct, build, getSupplierReferenceLengthTargetCm(data, kind, height), data.itemNumber);
    if (measured.incomplete) {
      return blocked("incomplete-chart", "There are no usable chart rows for those measurements. Please contact us for sizing help.");
    }
    const recommendedSize = measured.size;
    const largestProductSize = productSizes[productSizes.length - 1];
    const availableMatch = getAvailableProductSizes(productInfo).find((item) => item.size === normalizeSizeValue(recommendedSize));
    return {
      ...measured,
      size: recommendedSize,
      source: measured.usedDirect ? "your garment measurements and this product's chart" : "your measurements and this product's chart",
      preference,
      canApply: Boolean(availableMatch) && !measured.boundaries.some((boundary) => boundary.direction === "above"),
      inStock: Boolean(availableMatch),
      build,
      usedMeasurements: true,
      outsideChart: measured.boundaries.length > 0,
      sizeRangeInsufficient: measured.boundaries.some((boundary) => boundary.direction === "above"),
      maxedOut: preference === "roomy" && recommendedSize === normalizeSizeValue(largestProductSize),
    };
  };

  const applyRecommendedSize = (productInfo, size) => {
    const fieldset = getSizeFieldset(productInfo);
    if (!fieldset || !size) return false;

    const normalizedSize = normalizeSizeValue(size);
    const input = [...fieldset.querySelectorAll("input[type='radio']")].find((candidate) => {
      const label = candidate.id ? fieldset.querySelector(`label[for='${CSS.escape(candidate.id)}']`) : null;
      return normalizeSizeValue(candidate.value) === normalizedSize || normalizeSizeValue(label?.textContent || "") === normalizedSize;
    });

    if (!input || input.disabled || input.classList.contains("disabled")) return false;

    input.checked = true;
    input.setAttribute("checked", "checked");
    productInfo.dataset.hcxSizeSelected = "true";
    selectedSizes.set(getProductSizeKey(productInfo), input.value);
    pendingSelectedSize = input.value;
    pendingSelectedSizeAt = Date.now();
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));
    unlockAddToCartForSize(productInfo);
    return true;
  };

  const showFitResult = (widget, recommendation, productInfo) => {
    const result = widget.querySelector("[data-hcx-fit-result]");
    const size = widget.querySelector("[data-hcx-fit-result-size]");
    const copy = widget.querySelector("[data-hcx-fit-result-copy]");
    const apply = widget.querySelector("[data-hcx-fit-apply]");
    if (!result || !size || !copy || !apply) return;

    if (!recommendation) {
      result.hidden = false;
      size.textContent = "-";
      copy.textContent = "Enter your height for a size estimate. Add your weight for a closer estimate.";
      apply.hidden = true;
      delete widget.dataset.hcxRecommendedSize;
      return;
    }

    if (recommendation.reason) {
      result.hidden = false;
      size.textContent = "—";
      copy.textContent = recommendation.message;
      apply.hidden = true;
      delete widget.dataset.hcxRecommendedSize;
      return;
    }

    widget.dataset.hcxRecommendedSize = recommendation.size;
    const displaySize = getProductDisplaySizeLabel(productInfo, recommendation.size);
    result.hidden = false;
    size.textContent = displaySize;
    const basis = recommendation.directOnly ? "your garment measurements"
      : recommendation.usedDirect ? `your garment measurements${recommendation.usedHeight ? " and height" : ""}${recommendation.usedWeight ? " and weight" : ""}`
        : recommendation.usedWeight ? `your height, weight${recommendation.build ? " and build" : ""}` : "your height";
    const fitCopy = recommendation.preference === "roomy" ? " with extra room"
      : recommendation.preference === "fitted" || recommendation.preference === "neat" ? " for a closer fit" : "";
    const measurementsCopy = (recommendation.chartMeasurements || []).map((measurement) =>
      `${measurement.label}: ${measurement.valueLabelCm || formatFitMeasurement(measurement.valueCm)} cm`).join("; ");
    const matchCopy = `${displaySize} is the closest chart match to ${basis}${fitCopy}. ${measurementsCopy}.`;
    const above = recommendation.boundaries?.find((boundary) => boundary.direction === "above");
    const below = recommendation.boundaries?.find((boundary) => boundary.direction === "below");
    const boundaryCopy = above
      ? ` ${above.direct ? "Your garment's" : "The estimated"} ${above.label.toLowerCase()} exceeds this chart's range, so this size may be tighter or shorter than wanted.`
      : below ? ` ${below.direct ? "Your garment's" : "The estimated"} ${below.label.toLowerCase()} is below this chart's range, so this size may be roomier than wanted.` : "";
    const estimateCopy = recommendation.directOnly ? "" : " Height and weight give an estimate. Check the size chart before choosing.";
    const stockCopy = recommendation.inStock === false ? " This size is currently sold out for this colour." : "";
    const unsupportedCopy = recommendation.uncheckedDimensions?.length ? ` Still to check: ${recommendation.uncheckedDimensions.join(", ")}.` : "";
    const rangeCopy = recommendation.sizeRangeInsufficient ? " Contact us before ordering; no listed size meets every target." : "";
    copy.textContent = `${matchCopy}${boundaryCopy}${estimateCopy}${unsupportedCopy}${rangeCopy}${stockCopy}`;
    apply.hidden = !recommendation.canApply;
  };

  const initFitConfidenceSystem = () => {
    document.querySelectorAll("[data-hcx-fit-confidence]").forEach((widget) => {
      if (widget.dataset.hcxFitBound === "true") return;
      const productInfoSelector = widget.dataset.productInfo;
      const productInfo = widget.closest("product-info") || (productInfoSelector ? document.querySelector(productInfoSelector) : null);
      if (!productInfo) return;

      widget.dataset.hcxFitBound = "true";
      widget.dataset.hcxFitUnit = normalizeFitUnit(widget.dataset.hcxFitUnit || "cm");
      widget.dataset.hcxFitHeightSystem = widget.dataset.hcxFitHeightSystem === "metric" ? "metric" : "imperial";
      widget.dataset.hcxFitWeightSystem = widget.dataset.hcxFitWeightSystem === "imperial" ? "imperial" : "metric";
      widget.dataset.hcxFitGarmentUnit = normalizeFitUnit(widget.querySelector("[data-hcx-fit-garment-unit]")?.value || "cm");
      getFitGarmentMeasurements(widget);
      syncFitInputSystems(widget);
      renderFitMeasurements(widget, getSizeGuideData(widget), productInfo);

      widget.querySelectorAll("[data-hcx-fit-unit]").forEach((button) => {
        button.addEventListener("click", () => {
          widget.dataset.hcxFitUnit = normalizeFitUnit(button.dataset.hcxFitUnit);
          renderFitMeasurements(widget, getSizeGuideData(widget), productInfo);
        });
      });

      widget.querySelectorAll("[data-hcx-fit-height-system]").forEach((button) => {
        button.addEventListener("click", () => {
          setFitHeightSystem(widget, button.dataset.hcxFitHeightSystem);
          refreshFitRecommendation();
        });
      });

      widget.querySelectorAll("[data-hcx-fit-weight-system]").forEach((button) => {
        button.addEventListener("click", () => {
          setFitWeightSystem(widget, button.dataset.hcxFitWeightSystem);
          refreshFitRecommendation();
        });
      });

      const refreshFitRecommendation = (showWhenHidden = false) => {
        const result = widget.querySelector("[data-hcx-fit-result]");
        if (!showWhenHidden && result?.hidden && !widget.dataset.hcxRecommendedSize) return;
        showFitResult(widget, recommendFitSize(widget, productInfo), productInfo);
      };

      widget.querySelector("[data-hcx-fit-submit]")?.addEventListener("click", () => {
        refreshFitRecommendation(true);
      });

      widget.querySelectorAll("input[name^='hcx-fit-preference'], input[name^='hcx-fit-build']").forEach((input) => {
        input.addEventListener("change", () => {
          refreshFitRecommendation();
        });
      });

      widget.querySelectorAll("[data-hcx-fit-height], [data-hcx-fit-height-ft], [data-hcx-fit-height-in], [data-hcx-fit-weight], [data-hcx-fit-weight-lb]").forEach((input) => {
        input.addEventListener("input", () => {
          const measurements = fitCanonicalMeasurements.get(widget);
          if (measurements) {
            const dimension = input.hasAttribute("data-hcx-fit-weight") || input.hasAttribute("data-hcx-fit-weight-lb") ? "weight" : "height";
            delete measurements[dimension];
          }
          refreshFitRecommendation();
        });
      });

      widget.querySelectorAll("[data-hcx-fit-garment-primary], [data-hcx-fit-garment-secondary], [data-hcx-fit-garment-sleeve], [data-hcx-fit-garment-shoulder], [data-hcx-fit-garment-hip]").forEach((input) => {
        input.addEventListener("input", () => {
          getFitGarmentMeasurements(widget);
          refreshFitRecommendation();
        });
      });
      widget.querySelector("[data-hcx-fit-garment-unit]")?.addEventListener("change", (event) => {
        setFitGarmentUnit(widget, event.target.value);
        refreshFitRecommendation();
      });

      widget.querySelector("[data-hcx-fit-apply]")?.addEventListener("click", () => {
        applyRecommendedSize(productInfo, widget.dataset.hcxRecommendedSize);
      });
    });
  };

  const refreshProductTitleRhythm = () => {
    document.querySelectorAll(".template-product .product__info-container").forEach((container) => {
      const title = container.querySelector(".product__title h1");
      if (!title) return;

      const styles = window.getComputedStyle(title);
      const lineHeight = parseFloat(styles.lineHeight);
      const lines = lineHeight > 0 ? Math.round(title.getBoundingClientRect().height / lineHeight) : 1;
      container.classList.toggle("hcx-title-multiline", lines > 1);
    });
  };

  const initProductTitleRhythm = () => {
    if (document.documentElement.dataset.hcxTitleRhythmBound === "true") {
      refreshProductTitleRhythm();
      return;
    }

    document.documentElement.dataset.hcxTitleRhythmBound = "true";
    refreshProductTitleRhythm();
    window.addEventListener("resize", () => window.requestAnimationFrame(refreshProductTitleRhythm), { passive: true });
  };

  const initInStockSizeFiltering = () => {
    if (document.documentElement.dataset.hcxSizeFilterBound === "true") return;
    document.documentElement.dataset.hcxSizeFilterBound = "true";

    document.addEventListener(
      "input",
      (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || input.type !== "checkbox" || !input.checked) return;

        const inputName = (input.name || "").toLowerCase();
        const filterShell = input.closest(".js-filter");
        const filterId = (filterShell?.id || "").toLowerCase();
        const filterText = normalizeText(filterShell?.querySelector("summary, .mobile-facets__close-button")?.textContent || "");
        const isSizeFilter =
          inputName.includes("option.size") ||
          filterId.includes("size") ||
          filterText === "size" ||
          filterText.startsWith("size ");

        if (!isSizeFilter) return;

        const form = input.form || input.closest("form");
        if (!form) return;

        const availabilityInputs = [...form.querySelectorAll('input[type="checkbox"]')].filter((item) =>
          (item.name || "").toLowerCase().includes("availability")
        );
        const inStockInput =
          availabilityInputs.find((item) => String(item.value) === "1") ||
          availabilityInputs.find((item) => normalizeText(item.closest("label")?.textContent || "").includes("in stock"));

        if (inStockInput && !inStockInput.checked && !inStockInput.disabled) {
          inStockInput.checked = true;
          inStockInput.setAttribute("checked", "checked");
        }
      },
      true
    );
  };

  const normalizeHcxColourDisplayLabel = (value = "", context = "product") => {
    const label = String(value || "")
      .replace(/gray/gi, "grey")
      .replace(/\s+/g, " ")
      .trim();
    const key = label.toLowerCase().replace(/[-_]+/g, " ").replace(/\s+/g, " ").trim();
    const isFilter = context === "filter";

    if (!key) return label;
    if (key === "black beauty") return "Black";
    if (key.includes("charcoal")) return "Charcoal";
    if (key.includes("pirate black") || key.includes("dark grey")) return "Dark Grey";
    if (key === "grey" || key.includes("light grey") || key.includes("formal grey") || key.includes("flower grey")) return "Light Grey";
    if (key.includes("lucent white")) return "White";
    if (key === "navy") return isFilter ? "Blue" : "Navy";
    if (key.includes("navy blue")) return isFilter ? "Blue" : "Navy";
    if (isFilter && key.includes("blue")) return "Blue";
    if (key.includes("eden green")) return "Green";
    if (key.includes("army green")) return isFilter ? "Green" : "Army Green";
    if (isFilter && key.includes("green")) return "Green";

    return label;
  };

  const readFacetItemCount = (item) => {
    const storedCount = Number(item?.dataset?.hcxColourFilterOriginalCount);
    if (Number.isFinite(storedCount) && storedCount >= 0) return storedCount;

    const match = String(item?.textContent || "").match(/\((\d+)\)/);
    const count = match ? Number(match[1]) : 0;
    if (item?.dataset) item.dataset.hcxColourFilterOriginalCount = String(count);
    return count;
  };

  const updateFacetItemText = (item, label) => {
    const visibleText = item.querySelector(".facet-checkbox__text");
    const labelNode = item.querySelector(".facet-checkbox__text-label");

    if (labelNode && labelNode.textContent.trim() !== label) {
      labelNode.textContent = label;
    }

    if (visibleText) {
      const countNode = [...visibleText.childNodes].find(
        (node) => node.nodeType === Node.TEXT_NODE && /\(\d+\)/.test(node.textContent || "")
      );

      // Colour aliases can overlap on the same product. Their summed counts
      // aren't unique product totals, so keep the group label without a count.
      if (countNode) countNode.remove();
    }

    const hiddenText = item.querySelector(".visually-hidden");
    if (hiddenText) {
      const hiddenLabel = label;
      if (hiddenText.textContent.trim() !== hiddenLabel) hiddenText.textContent = hiddenLabel;
    }
  };

  const isColourFilterShell = (filter) => {
    const filterText = normalizeText(
      [
        filter?.id,
        filter?.dataset?.index,
        filter?.querySelector("summary")?.textContent,
        filter?.querySelector(".mobile-facets__close-button")?.textContent,
      ]
        .filter(Boolean)
        .join(" ")
    );

    return filterText.includes("color") || filterText.includes("colour");
  };

  const refreshColourFilterGroups = () => {
    document.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter").forEach((filter) => {
      if (!isColourFilterShell(filter)) return;

      const rows = [...filter.querySelectorAll("li")]
        .map((item) => {
          const input = item.querySelector('input[type="checkbox"][name]');
          if (!(input instanceof HTMLInputElement)) return null;

          const rawValue = input.value || item.querySelector(".facet-checkbox__text-label")?.textContent || "";
          return {
            item,
            input,
            label: normalizeHcxColourDisplayLabel(rawValue, "filter"),
            count: readFacetItemCount(item),
          };
        })
        .filter(Boolean);

      if (!rows.length) return;

      const groups = new Map();
      rows.forEach((row) => {
        const groupRows = groups.get(row.label) || [];
        groupRows.push(row);
        groups.set(row.label, groupRows);
      });

      filter.dataset.hcxColourFilterGrouped = "true";

      groups.forEach((groupRows, label) => {
        const representative = groupRows.find((row) => row.input.checked) || groupRows.find((row) => !row.input.disabled) || groupRows[0];
        const totalCount = groupRows.reduce((sum, row) => sum + row.count, 0);
        const isChecked = groupRows.some((row) => row.input.checked);

        groupRows.forEach((row) => {
          const isRepresentative = row === representative;
          row.item.classList.toggle("hcx-colour-filter-member-hidden", !isRepresentative);
          row.item.classList.toggle("hcx-colour-filter-representative", isRepresentative);
          row.item.dataset.hcxColourFilterGroup = label;
          row.input.dataset.hcxColourFilterGroup = label;

          if (!isRepresentative) return;

          row.input.checked = isChecked;
          if (isChecked) row.input.setAttribute("checked", "checked");
          else row.input.removeAttribute("checked");
          row.input.disabled = totalCount <= 0 && !isChecked;
          updateFacetItemText(row.item, label, totalCount);
        });
      });
    });
  };

  const getSelectedCollectionColourGroups = () => {
    const groups = new Set();
    const params = new URLSearchParams(window.location.search);

    params.getAll("filter.v.option.color").forEach((value) => {
      const group = normalizeHcxColourDisplayLabel(value, "filter");
      if (group) groups.add(group);
    });

    document
      .querySelectorAll(
        "#FacetFiltersForm .js-filter[data-hcx-colour-filter-grouped='true'] input[type='checkbox']:checked, #FacetFiltersFormMobile .js-filter[data-hcx-colour-filter-grouped='true'] input[type='checkbox']:checked"
      )
      .forEach((input) => {
        const group = input.dataset.hcxColourFilterGroup || normalizeHcxColourDisplayLabel(input.value, "filter");
        if (group) groups.add(group);
      });

    return groups;
  };

  const getCollectionCardColourGroup = (item) => {
    const colour = item.querySelector(".hcx-card-meta__colour")?.textContent || "";
    return normalizeHcxColourDisplayLabel(colour, "filter");
  };

  const refreshCollectionColourCardVisibility = () => {
    const isCollectionPage = body?.classList.contains("template-collection") || body?.classList.contains("template-search");
    if (!isCollectionPage) return;

    // Shopify has already matched these products to the requested variants.
    // A card's default image/colour must never discard a matching result.
    const grid = document.getElementById("product-grid");
    if (grid?.dataset.hcxNativeResults === "true") {
      grid.querySelectorAll(".hcx-colour-filter-card-hidden").forEach((item) => {
        item.classList.remove("hcx-colour-filter-card-hidden");
        item.removeAttribute("hidden");
      });
      return;
    }

    const selectedGroups = getSelectedCollectionColourGroups();
    const hasColourFilter = selectedGroups.size > 0;

    document.querySelectorAll("#product-grid .grid__item").forEach((item) => {
      const cardColourGroup = getCollectionCardColourGroup(item);
      const shouldHide = hasColourFilter && (!cardColourGroup || !selectedGroups.has(cardColourGroup));
      item.classList.toggle("hcx-colour-filter-card-hidden", shouldHide);
      item.toggleAttribute("hidden", shouldHide);
    });
  };

  const syncColourFilterGroupInput = (input) => {
    const filter = input.closest(".js-filter[data-hcx-colour-filter-grouped='true']");
    const groupLabel = input.dataset.hcxColourFilterGroup;
    if (!filter || !groupLabel) return;

    filter.querySelectorAll('input[type="checkbox"][data-hcx-colour-filter-group]').forEach((candidate) => {
      if (!(candidate instanceof HTMLInputElement) || candidate.dataset.hcxColourFilterGroup !== groupLabel) return;
      if (candidate.disabled && candidate !== input) return;

      candidate.checked = input.checked;
      if (input.checked) candidate.setAttribute("checked", "checked");
      else candidate.removeAttribute("checked");
    });
  };

  const initColourFilterGrouping = () => {
    refreshColourFilterGroups();

    if (html.dataset.hcxColourFilterGroupingBound === "true") return;
    html.dataset.hcxColourFilterGroupingBound = "true";

    document.addEventListener(
      "input",
      (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || input.type !== "checkbox") return;
        syncColourFilterGroupInput(input);
        window.requestAnimationFrame(() => {
          refreshColourFilterGroups();
          refreshCollectionColourCardVisibility();
        });
      },
      true
    );

    document.addEventListener(
      "click",
      (event) => {
        const item = event.target?.closest?.(".hcx-colour-filter-representative");
        if (!(item instanceof HTMLElement)) return;
        if (event.target?.closest?.("input, label, button, a")) return;

        const input = item.querySelector('input[type="checkbox"]');
        if (input instanceof HTMLInputElement && !input.disabled) input.click();
      },
      true
    );

    let colourFilterRefreshQueued = false;
    const queueColourFilterRefresh = () => {
      if (colourFilterRefreshQueued) return;
      colourFilterRefreshQueued = true;
      window.requestAnimationFrame(() => {
        colourFilterRefreshQueued = false;
        refreshColourFilterGroups();
        refreshCollectionColourCardVisibility();
      });
    };

    const filterObserver = new MutationObserver(queueColourFilterRefresh);
    filterObserver.observe(document.body, { childList: true, subtree: true });
    refreshCollectionColourCardVisibility();
  };

  const deliveryTimeZone = "Europe/London";
  const deliveryLocale = "en-GB";

  const getTimeZoneOffset = (date, timeZone) => {
    const parts = new Intl.DateTimeFormat(deliveryLocale, {
      timeZone,
      timeZoneName: "shortOffset",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hourCycle: "h23",
    }).formatToParts(date);
    const zoneName = parts.find((part) => part.type === "timeZoneName")?.value || "GMT";
    const match = zoneName.match(/GMT([+-])(\d{1,2})(?::?(\d{2}))?/);
    if (!match) return 0;

    const sign = match[1] === "-" ? -1 : 1;
    const hours = Number(match[2] || 0);
    const minutes = Number(match[3] || 0);
    return sign * ((hours * 60 + minutes) * 60000);
  };

  const makeZonedDate = ({ year, month, day }, hour = 0, minute = 0, second = 0) => {
    let timestamp = Date.UTC(year, month - 1, day, hour, minute, second);

    for (let i = 0; i < 2; i += 1) {
      timestamp = Date.UTC(year, month - 1, day, hour, minute, second) - getTimeZoneOffset(new Date(timestamp), deliveryTimeZone);
    }

    return new Date(timestamp);
  };

  const getZonedParts = (date) => {
    const parts = new Intl.DateTimeFormat(deliveryLocale, {
      timeZone: deliveryTimeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hourCycle: "h23",
    }).formatToParts(date);

    return parts.reduce((result, part) => {
      if (part.type !== "literal") result[part.type] = Number(part.value);
      return result;
    }, {});
  };

  const getWeekday = ({ year, month, day }) => new Date(Date.UTC(year, month - 1, day, 12)).getUTCDay();

  const isDeliveryWorkingDay = (dateParts, includeSaturday = false) => {
    const weekday = getWeekday(dateParts);
    return weekday !== 0 && (includeSaturday || weekday !== 6);
  };

  const addCalendarDays = ({ year, month, day }, days) => {
    const date = new Date(Date.UTC(year, month - 1, day + days, 12));
    return {
      year: date.getUTCFullYear(),
      month: date.getUTCMonth() + 1,
      day: date.getUTCDate(),
    };
  };

  const addWorkingDays = (dateParts, days, includeSaturday = false) => {
    let result = dateParts;
    let added = 0;

    while (added < days) {
      result = addCalendarDays(result, 1);
      if (isDeliveryWorkingDay(result, includeSaturday)) added += 1;
    }

    return result;
  };

  const getNextCutoff = (now, cutoffHour, includeSaturday = false, startFromToday = false) => {
    const today = getZonedParts(now);
    const todayParts = { year: today.year, month: today.month, day: today.day };
    const todayCutoff = makeZonedDate(todayParts, cutoffHour);

    if ((startFromToday || isDeliveryWorkingDay(todayParts, includeSaturday)) && now < todayCutoff) {
      return { cutoffDate: todayCutoff, cutoffParts: todayParts, isToday: true };
    }

    let nextParts = todayParts;
    do {
      nextParts = addCalendarDays(nextParts, 1);
    } while (!isDeliveryWorkingDay(nextParts, includeSaturday));

    return { cutoffDate: makeZonedDate(nextParts, cutoffHour), cutoffParts: nextParts, isToday: false };
  };

  const getNextDeliveryRefresh = (now, cutoffHour, includeSaturday = false, startFromToday = false) => {
    const nextCutoff = getNextCutoff(now, cutoffHour, includeSaturday, startFromToday).cutoffDate;
    return new Date(nextCutoff.getTime() + 1000);
  };

  const getDeliveryCutoffHour = (vendor, origin, configuredHour) => {
    const vendorKey = String(vendor || "").toUpperCase();
    const originKey = String(origin || "").toLowerCase();

    if (vendorKey.includes("ODMPOD") || originKey === "international" || originKey === "partner") return 24;
    if (vendorKey.includes("HERCXLES") || originKey === "uk") return 20;

    const parsedHour = Number(configuredHour);
    return Number.isFinite(parsedHour) ? parsedHour : 20;
  };

  const isPartnerDelivery = (vendor, origin) => {
    const vendorKey = String(vendor || "").toUpperCase();
    const originKey = String(origin || "").toLowerCase();
    return vendorKey.includes("ODMPOD") || originKey === "international" || originKey === "partner";
  };

  const formatDate = (dateParts) =>
    new Intl.DateTimeFormat(deliveryLocale, {
      timeZone: deliveryTimeZone,
      weekday: "short",
      day: "numeric",
      month: "short",
    }).format(new Date(Date.UTC(dateParts.year, dateParts.month - 1, dateParts.day, 12)));

  const initDeliveryPromise = (element) => {
    if (!element || element.dataset.hcxDeliveryBound === "true") return;
    element.dataset.hcxDeliveryBound = "true";

    const main = element.querySelector("[data-hcx-delivery-main]");
    const sub = element.querySelector("[data-hcx-delivery-sub]");
    const range = element.querySelector("[data-hcx-delivery-range]");
    const serviceCountdown = element.querySelector("[data-hcx-service-countdown]");
    if (!serviceCountdown && (!main || !range)) return;

    if (serviceCountdown) {
      const vendor = element.dataset.vendor || "HERCXLES";
      const origin = element.dataset.origin || (vendor.toUpperCase().includes("ODMPOD") ? "international" : "uk");
      const minDays = Number(element.dataset.minDays || 3);
      const maxDays = Number(element.dataset.maxDays || 5);
      const cutoffHour = getDeliveryCutoffHour(vendor, origin, element.dataset.cutoffHour);
      const includeSaturday = element.dataset.includeSaturday === "true" || isPartnerDelivery(vendor, origin);
      const startFromToday = element.dataset.startFromToday === "true" || isPartnerDelivery(vendor, origin);

      const renderServiceDeliveryDate = () => {
        const cutoff = getNextCutoff(new Date(), cutoffHour, includeSaturday, startFromToday);
        const deliveryFrom = addWorkingDays(cutoff.cutoffParts, minDays, includeSaturday);
        const deliveryTo = addWorkingDays(cutoff.cutoffParts, maxDays, includeSaturday);
        serviceCountdown.textContent =
          minDays === maxDays ? formatDate(deliveryFrom) : `${formatDate(deliveryFrom)} - ${formatDate(deliveryTo)}`;
      };

      renderServiceDeliveryDate();
      window.setInterval(renderServiceDeliveryDate, 60000);
      return;
    }

    if (sub) {
      sub.textContent = "";
      sub.append(range);
    }

    const vendor = element.dataset.vendor || "HERCXLES";
    const origin = element.dataset.origin || (vendor.toUpperCase().includes("ODMPOD") ? "international" : "uk");
    const minDays = Number(element.dataset.minDays || 3);
    const maxDays = Number(element.dataset.maxDays || 5);
    const cutoffHour = getDeliveryCutoffHour(vendor, origin, element.dataset.cutoffHour);
    const includeSaturday = element.dataset.includeSaturday === "true" || isPartnerDelivery(vendor, origin);
    const startFromToday = element.dataset.startFromToday === "true" || isPartnerDelivery(vendor, origin);

    let deliveryRefreshTimer;

    const render = () => {
      const now = new Date();
      const cutoff = getNextCutoff(now, cutoffHour, includeSaturday, startFromToday);
      const deliveryFrom = addWorkingDays(cutoff.cutoffParts, minDays, includeSaturday);
      const deliveryTo = addWorkingDays(cutoff.cutoffParts, maxDays, includeSaturday);
      const dateRange =
        minDays === maxDays ? formatDate(deliveryFrom) : `${formatDate(deliveryFrom)} - ${formatDate(deliveryTo)}`;

      main.textContent = "Order now and receive";
      range.textContent = " ";
      const dateRangeElement = document.createElement("strong");
      dateRangeElement.textContent = dateRange;
      range.append(dateRangeElement);
    };

    const scheduleDeliveryRefresh = () => {
      window.clearTimeout(deliveryRefreshTimer);
      const delay = Math.max(
        1000,
        getNextDeliveryRefresh(new Date(), cutoffHour, includeSaturday, startFromToday).getTime() - Date.now(),
      );
      deliveryRefreshTimer = window.setTimeout(() => {
        render();
        scheduleDeliveryRefresh();
      }, Math.min(delay, 2147483647));
    };

    render();
    scheduleDeliveryRefresh();
  };

  const initDeliveryPromises = () => {
    document.querySelectorAll("[data-hcx-delivery-promise]").forEach(initDeliveryPromise);
  };

  const savesKey = "hcx:saves:v1";
  const savesDismissedKey = "hcx:saves-dismissed:v1";
  const savesAutoViewThreshold = 3;
  const savesLimit = 20;
  const lckdInCutOffHandles = new Set([
    "lckd-in-training-cut-off-tank-top-black",
    "lckd-in-training-cut-off-tank-top-grey",
    "lckd-in-training-cut-off-tank-top-teal-blue",
    "lckd-in-cut-off-tank-top-black",
    "lckd-in-cut-off-tank-top-white",
    "lckd-in-cut-off-tank-top-grey",
    "lckd-in-cut-off-tank-top-blue",
  ]);
  const sportCutOffHandles = new Set([
    "sport-cut-off-black",
    "sport-cut-off-grey",
  ]);
  const sportTShirtHandles = new Set([
    "sport-tee-black",
    "sport-tee-white",
  ]);
  const lckdInSportTShirtHandles = new Set([
    "lckd-in-boxy-t-shirt-black",
    "lckd-in-boxy-t-shirt-white",
  ]);
  const replacedProductHandles = new Set([
    "sport-cut-off-grey",
    "angel-raw-edge-t-shirt",
  ]);
  const lckdInCutOffTitle = "LCKD IN Cut Off";
  const sportCutOffTitle = "Sport Cut Off";
  const sportTShirtTitle = "Sport T-Shirt";
  const lckdInSportTShirtTitle = "LCKD IN T-Shirt";

  const getHcxProductHandleFromUrl = (url = "") => {
    try {
      const productUrl = new URL(url, window.location.origin);
      const match = productUrl.pathname.match(/\/products\/([^/?#]+)/);
      return match?.[1]?.trim().toLowerCase() || "";
    } catch (error) {
      return "";
    }
  };

  let hcxProductCardPriceSyncFrame = 0;
  let hcxProductCardPriceSyncObserver = null;
  const formatHcxProductCardPrice = (value) => {
    const cents = Number(value);
    if (!Number.isFinite(cents) || cents <= 0) return "";

    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(cents / 100);
  };

  const getHcxProductCardPriceMap = () => {
    const products = window.ShopifyAnalytics?.meta?.products;
    const priceMap = new Map();
    if (!Array.isArray(products)) return priceMap;

    products.forEach((product) => {
      const handle = String(product?.handle || "").trim().toLowerCase();
      if (!handle || priceMap.has(handle)) return;

      const variants = Array.isArray(product?.variants) ? product.variants : [];
      const pricedVariant = variants.find((variant) => Number(variant?.price) > 0);
      const price = formatHcxProductCardPrice(pricedVariant?.price || product?.price);
      if (price) priceMap.set(handle, price);
    });

    return priceMap;
  };

  const getHcxProductCardHandle = (priceRoot) => {
    const container = priceRoot.closest(
      ".card-wrapper, .hcx-search-product-card, .hcx-cart-rec, .predictive-search__item, .grid__item, li, article"
    );
    const link = container?.querySelector('a[href*="/products/"]') || priceRoot.closest('a[href*="/products/"]');
    return getHcxProductHandleFromUrl(link?.getAttribute("href") || link?.href || "");
  };

  const setHcxProductCardPrice = (priceRoot, price) => {
    const priceItems = priceRoot.matches(".hcx-cart-rec__price")
      ? priceRoot.querySelectorAll("span")
      : priceRoot.querySelectorAll(".price-item");
    const targets = Array.from(priceItems).filter((node) => !node.closest("s, .price__compare"));

    if (targets.length) {
      targets.forEach((node) => {
        node.textContent = price;
      });
    } else if (priceRoot.textContent.match(/\u00a3\s?\d/)) {
      priceRoot.textContent = price;
    }

    priceRoot.dataset.hcxSyncedPrice = price;
  };

  const syncHcxProductCardPrices = () => {
    hcxProductCardPriceSyncFrame = 0;
    const priceMap = getHcxProductCardPriceMap();
    if (!priceMap.size) return;

    document
      .querySelectorAll(
        ".card-wrapper .price, .hcx-search-product-card .price, .predictive-search__item .price, .hcx-cart-rec__price"
      )
      .forEach((priceRoot) => {
        const handle = getHcxProductCardHandle(priceRoot);
        const price = priceMap.get(handle);
        if (!price || priceRoot.dataset.hcxSyncedPrice === price) return;
        setHcxProductCardPrice(priceRoot, price);
      });
  };

  const scheduleHcxProductCardPriceSync = () => {
    if (hcxProductCardPriceSyncFrame) return;
    hcxProductCardPriceSyncFrame = window.requestAnimationFrame(syncHcxProductCardPrices);
  };

  const initHcxProductCardPriceSync = () => {
    scheduleHcxProductCardPriceSync();
    window.setTimeout(scheduleHcxProductCardPriceSync, 250);
    window.setTimeout(scheduleHcxProductCardPriceSync, 1000);

    if (hcxProductCardPriceSyncObserver) return;
    hcxProductCardPriceSyncObserver = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.addedNodes.length)) {
        scheduleHcxProductCardPriceSync();
      }
    });
    hcxProductCardPriceSyncObserver.observe(document.body, { childList: true, subtree: true });
  };

  const normalizeHcxProductTitle = (title = "") =>
    String(title)
      .replace(/\bKuro\b/gi, "Scorpion")
      .replace(/\bHRCXLS\s+Athlete\b/gi, "Vintage Athlete")
      .replace(/\bVintage\s+Athlete\s+(?:(?:Light|Dark)\s+)?(?:Black|White|Grey|Gray|Navy)\s+/gi, "Vintage Athlete ")
      .replace(/\bHercxles\s+Studios\s+Black\s+Zip\s+Up\b/gi, "Hercxles Studios Zip Up")
      .replace(/\bLCKD\s+IN\s+Drawstring\s+Shorts\b/gi, 'LCKD IN 7" Shorts')
      .replace(/\bSport\s+Drawstring\s+Shorts\b/gi, 'Sport 7" Shorts')
      .replace(/\bSport\s+5(?:"|\s*Inch)?\s+Shorts\b/gi, "Sport Running Shorts")
      .replace(/\b5\s+INCH\s+SHORTS\b/gi, "Sport Running Shorts")
      .replace(/\bTiger\s+Hoodie\b/gi, "Tiger X Studios Hoodie")
      .replace(/\bDragon\s+Hoodie\b/gi, "Dragon X Studios Hoodie");

  const getStoredProductHandle = (item) =>
    getHcxProductHandleFromUrl(item?.url) || String(item?.handle || "").trim().toLowerCase();

  const isReplacedStoredProduct = (item) => replacedProductHandles.has(getStoredProductHandle(item));

  // Keep saved/recent product identities aligned with the September 2026 rename.
  const scorpionRenamedProducts = new Map([
    ["14976054788472", "scorpion-oversized-straight-leg-sweatpants-1"],
    ["14976054886776", "scorpion-oversized-t-shirt-red"],
    ["14976058261880", "scorpion-oversized-t-shirt-green"],
    ["14976059900280", "scorpion-oversized-t-shirt-white"],
    ["14976060293496", "scorpion-light-oversized-t-shirt"],
    ["14976183599480", "scorpion-relaxed-zip-up-hoodie-2"],
    ["14976184418680", "scorpion-relaxed-zip-up-hoodie"],
    ["14976184910200", "scorpion-relaxed-zip-hoodie-grey"],
    ["14988681150840", "scorpion-relaxed-zip-up-hoodie-next-day"],
    ["15006736515448", "scorpion-oversized-t-shirt-washed-green-style-344"],
    ["15006737629560", "scorpion-oversized-t-shirt-light-grey"],
    ["15010919088504", "scorpion-v3-oversized-hoodie-light-grey"],
    ["15037017620856", "scorpion-oversized-t-shirt-washed-green"],
    ["15037018767736", "scorpion-v3-oversized-hoodie-light-grey-style-2"],
    ["15037019029880", "scorpion-relaxed-zip-up-hoodie-flower-gray"],
    ["15050582688120", "scorpion-t-shirt-red-warehouse-sale"],
    ["15052177342840", "scorpion-7-inch-shorts-black"],
  ]);

  const normalizeStoredProductIdentity = (item) => {
    if (!item || typeof item !== "object") return item;

    const handle = getHcxProductHandleFromUrl(item.url) || String(item.handle || "").trim().toLowerCase();
    const nextItem = {
      ...item,
      title: normalizeHcxProductTitle(item.title || ""),
    };

    const renamedHandle = scorpionRenamedProducts.get(String(item.id || "").split("/").pop());
    if (renamedHandle) {
      nextItem.handle = renamedHandle;
      nextItem.url = /\/products\/[^?#/]+/.test(String(item.url || ""))
        ? String(item.url).replace(/\/products\/[^?#/]+/, `/products/${renamedHandle}`)
        : `/products/${renamedHandle}`;
    }

    if (lckdInCutOffHandles.has(handle)) {
      nextItem.title = lckdInCutOffTitle;
    } else if (sportCutOffHandles.has(handle)) {
      nextItem.title = sportCutOffTitle;
    } else if (sportTShirtHandles.has(handle)) {
      nextItem.title = sportTShirtTitle;
    } else if (lckdInSportTShirtHandles.has(handle)) {
      nextItem.title = lckdInSportTShirtTitle;
    }

    return nextItem;
  };

  const normalizeSaveItems = (items) => {
    const seen = new Set();

    return (Array.isArray(items) ? items : [])
      .map(normalizeStoredProductIdentity)
      .filter((item) => !isReplacedStoredProduct(item))
      .filter((item) => item && typeof item === "object" && item.id)
      .filter((item) => {
        const id = String(item.id);
        if (seen.has(id)) return false;

        seen.add(id);
        return true;
      })
      .slice(0, savesLimit);
  };

  const readSaves = () => {
    try {
      const value = window.localStorage.getItem(savesKey);
      const parsed = value ? JSON.parse(value) : [];
      const normalized = normalizeSaveItems(parsed);

      if (JSON.stringify(parsed) !== JSON.stringify(normalized)) {
        window.localStorage.setItem(savesKey, JSON.stringify(normalized));
      }

      return normalized;
    } catch (error) {
      return [];
    }
  };

  const writeSaves = (items) => {
    try {
      window.localStorage.setItem(savesKey, JSON.stringify(normalizeSaveItems(items)));
    } catch (error) {
      return;
    }
  };

  const readDismissedSaves = () => {
    try {
      const value = window.localStorage.getItem(savesDismissedKey);
      const parsed = value ? JSON.parse(value) : [];
      return Array.isArray(parsed) ? parsed.map(String) : [];
    } catch (error) {
      return [];
    }
  };

  const writeDismissedSaves = (items) => {
    try {
      window.localStorage.setItem(savesDismissedKey, JSON.stringify([...new Set(items.map(String))].slice(0, 100)));
    } catch (error) {
      return;
    }
  };

  const escapeHtml = (value = "") =>
    String(value).replace(/[&<>"']/g, (character) => {
      const entities = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      };
      return entities[character];
    });

  const getSavePayload = (button) => ({
    id: button.dataset.productId || button.dataset.productUrl,
    title: button.dataset.productTitle || "Saved product",
    url: button.dataset.productUrl || "#",
    image: button.dataset.productImage || "",
    price: button.dataset.productPrice || "",
    variantId: button.dataset.productVariantId || "",
    source: "saved",
  });

  const formatRecentlyViewedPriceCents = (value) => {
    const cents = Number(value);
    if (!Number.isFinite(cents) || cents <= 0) return "";
    const minimumFractionDigits = cents % 100 === 0 ? 0 : 2;

    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits,
      maximumFractionDigits: 2,
    }).format(cents / 100);
  };

  const getRecentlyViewedDisplayPrice = (item = {}, fallbackPrice = "") => {
    return String(item?.price || fallbackPrice || "").trim();
  };

  const isSaved = (items, id) => items.some((item) => String(item.id) === String(id));

  const recentlyViewedKey = "hcx:recently-viewed:v1";
  const recentlyViewedLimit = 5;
  const recentlyViewedStoreLimit = 40;
  const recentlyViewedEnrichmentHandles = new Set();
  const normalizeRecentlyViewedItem = (item) => {
    if (!item || typeof item !== "object") return item;

    const normalizedItem = normalizeStoredProductIdentity(item);
    const displayPrice = getRecentlyViewedDisplayPrice(normalizedItem, normalizedItem.price);

    return displayPrice && displayPrice !== normalizedItem.price
      ? { ...normalizedItem, price: displayPrice }
      : normalizedItem;
  };

  const readRecentlyViewed = () => {
    try {
      const value = window.localStorage.getItem(recentlyViewedKey);
      const parsed = value ? JSON.parse(value) : [];
      const normalized = Array.isArray(parsed) ? parsed.map(normalizeRecentlyViewedItem) : [];
      if (JSON.stringify(parsed) !== JSON.stringify(normalized)) {
        window.localStorage.setItem(recentlyViewedKey, JSON.stringify(normalized));
      }
      return normalized;
    } catch (error) {
      return [];
    }
  };

  const writeRecentlyViewed = (items) => {
    try {
      window.localStorage.setItem(recentlyViewedKey, JSON.stringify((Array.isArray(items) ? items : []).map(normalizeRecentlyViewedItem)));
    } catch (error) {
      return;
    }
  };

  const recentlyViewedSizeLadder = ["XS", "S", "M", "L", "XL", "XXL", "3XL"];
  const recentlyViewedSizeAliases = {
    XS: ["xs", "extrasmall", "xsmall"],
    S: ["s", "small"],
    M: ["m", "medium"],
    L: ["l", "large"],
    XL: ["xl", "xlarge", "extralarge"],
    XXL: ["xxl", "2xl", "xxlarge", "2xlarge", "doublexl"],
    "3XL": ["3xl", "xxxl", "3xlarge", "triplexl"],
  };

  const createDomId = (prefix, ...parts) => {
    const value = [prefix, ...parts]
      .filter((part) => part !== null && part !== undefined && part !== "")
      .join("-");

    return (value || prefix).replace(/[^A-Za-z0-9_-]/g, "-");
  };

  const normalizeOptionToken = (value = "") => String(value).trim().toLowerCase().replace(/[\s_-]+/g, "");

  const toIntegerOrNull = (value) => {
    const number = Number(value);
    return Number.isInteger(number) && number >= 0 ? number : null;
  };

  const getHcxProductFeaturePresentation = (item = {}) => {
    const handle = getHcxProductHandleFromUrl(item?.url) || String(item?.handle || "").trim().toLowerCase();
    if (handle === "hercstudios-vintage-fleece-boxy-hoodie-white-print" || handle === "hercstudios-vintage-fleece-boxy-hoodie-tonal") {
      return { label: "THICK VINTAGE FLEECE", displayTitle: "HERCSTUDIOS Boxy Hoodie" };
    }
    if (handle.startsWith("lifting-club-vintage-oversized-t-shirt-")) {
      return { label: "VINTAGE OVERSIZED", displayTitle: "Lifting Club T-Shirt" };
    }
    // Keep the new MW0036 hoodies consistent on cached recent and cart cards.
    const standardOversizedHoodieTitles = {
      "sport-heavyweight-hoodie": "Sport Hoodie",
      "hercstudios-tonal-heavyweight-hoodie": "HERCSTUDIOS Tonal Hoodie",
      "bodybuilding-tonal-heavyweight-hoodie": "Bodybuilding Tonal Hoodie",
      "lifting-club-vintage-heavyweight-hoodie-v2": "Lifting Club Vintage Hoodie V2",
      "gothic-multi-logo-heavyweight-hoodie": "Logo Hoodie",
      "hrcxls-bodybuilding-heavyweight-hoodie": "HRCXLS Bodybuilding Hoodie",
      "gothic-heavyweight-hoodie-charcoal": "Gothic Hoodie",
      "gothic-heavyweight-hoodie-black": "Gothic Hoodie",
      "fallen-angel-heavyweight-hoodie": "Fallen Angel Hoodie",
      "venom-heavyweight-hoodie-2663094": "Venom Hoodie",
      "bodybuilding-heavyweight-hoodie": "Bodybuilding Hoodie",
      "hercstudios-heavyweight-hoodie": "HERCSTUDIOS Hoodie",
      "lifting-club-vintage-heavyweight-hoodie": "Lifting Club Hoodie",
      "lifting-club-heavyweight-hoodie": "Lifting Club Hoodie",
      "lifting-club-tonal-heavyweight-hoodie": "Lifting Club Tonal Hoodie",
      "athlete-edition-heavyweight-hoodie-mw0036": "Athlete Edition Hoodie",
      "rush-heavyweight-hoodie": "Sport Hoodie"
    };
    if (standardOversizedHoodieTitles[handle]) {
      return { label: "STANDARD OVERSIZED FIT", displayTitle: standardOversizedHoodieTitles[handle] };
    }
    const sourceTitle = normalizeHcxProductTitle(item?.title || "Viewed product").replace(/\s+/g, " ").trim();
    const hugeTeeTitle = getHcxHugeTeeDisplayTitle(handle, sourceTitle);
    const normalizedTitle = hugeTeeTitle || sourceTitle;
    const type = String(item?.type || item?.product_type || "");
    const tags = Array.isArray(item?.tags) ? item.tags.join(" ") : String(item?.tags || "");
    const description = String(item?.description || item?.body_html || "").replace(/<[^>]*>/g, " ");
    const fit = String(item?.fit || item?.typeOfFit || item?.type_of_fit || "");
    const normalizeProfile = (value = "") =>
      ` ${String(value).toLowerCase().replace(/[-_/]+/g, " ").replace(/[^a-z0-9\s\"]/g, " ").replace(/\s+/g, " ").trim()} `;
    const nameProfile = normalizeProfile(`${handle} ${normalizedTitle} ${type}`);
    const supportProfile = normalizeProfile(`${fit} ${tags} ${description}`);
    const fullProfile = `${nameProfile}${supportProfile}`;
    const explicitFeatureTag = (Array.isArray(item?.tags) ? item.tags : String(item?.tags || "").split(","))
      .map((tag) => String(tag || "").trim())
      .find((tag) => /^feature\s+(?:sticker|label)\s*:/i.test(tag));
    let label = explicitFeatureTag ? explicitFeatureTag.split(":").slice(1).join(":").trim().toUpperCase() : "";
    const isTshirt = nameProfile.includes(" t shirt ") || nameProfile.includes(" tee ");
    const isHoodie = nameProfile.includes(" hoodie ");
    const supportsOversized = /\b(?:oversized|drop shoulder|loose|boxy)\b/.test(supportProfile);

    if (!label) {
      if (/gift card/.test(nameProfile)) label = "DIGITAL";
      else if (/\bmuscle tee\b|\bperformance tank top\b/.test(nameProfile)) label = "FITTED";
      else if (/\brag long sleeve\b|\bwaffle\b/.test(nameProfile)) label = "WAFFLE KNIT";
      else if (/\braw edge\b/.test(nameProfile)) label = "RAW EDGE";
      else if (isHoodie && /\bsnow wash(?:ed)?\b/.test(fullProfile)) label = "SNOW WASHED";
      else if (/\bdistressed\b/.test(nameProfile)) label = "DISTRESSED";
      else if (/\bfaded\b/i.test(normalizedTitle)) label = "FADED";
      else if (isHoodie && /\bboxy\b/.test(nameProfile)) label = "BOXY";
      else if (/\bheavyweight\b|\bheavy oversized\b/.test(nameProfile)) label = "HEAVYWEIGHT";
      else if (/vintage-wash-t-shirt|grunge-vintage-t-shirt|bodybuilding-vintage-t-shirt|vintage-athlete-shorts|lifting-club-vintage-oversized-t-shirt|property-of-vintage-oversized-t-shirt/.test(handle)) label = "VINTAGE WASH";
      else if (/\breflective\b/.test(nameProfile)) label = "REFLECTIVE";
      else if (/\b(?:oversized|giant)\b/.test(nameProfile)) label = "OVERSIZED";
      else if (/\bribbed tank\b/.test(nameProfile)) label = "RIBBED";
      else if (/\btank\b/.test(nameProfile) && /\bfitted silhouette\b/.test(supportProfile)) label = "FITTED";
      else if (/\bcut off\b/.test(nameProfile)) label = "LOOSE FIT";
      else if (/\bdrawstring shorts\b/.test(nameProfile)) label = "STRETCH";
      else if (/\brunning shorts\b|\bsport 5(?:\"| inch)? shorts\b/.test(nameProfile)) label = "REFLECTIVE";
      else if (/\bbungee cord\b/.test(nameProfile)) label = "BUNGEE CORD";
      else if (/\bjogger\b/.test(nameProfile)) label = "JOGGER";
      else if (/\bquarter zip\b/.test(nameProfile)) label = "QUARTER ZIP";
      else if (/\bpolo sweater\b/.test(nameProfile)) label = "POLO";
      else if (/\bmesh jacket\b/.test(nameProfile) || /\bjacquard mesh\b/.test(supportProfile)) label = "MESH";
      else if (/\bzip (?:hoodie|up|through)\b/.test(nameProfile)) {
        if (/\bwashed zip hoodie\b/.test(supportProfile)) label = "WASHED";
        else if (/\brelaxed\b/.test(nameProfile)) label = "RELAXED";
        else label = "ZIP-UP";
      } else if (/\bsweatshirt\b/.test(nameProfile) && /\bboxy\b/.test(supportProfile)) label = "BOXY";
      else if (/\bsweatpants?\b/.test(nameProfile) && /\boversized\b/.test(supportProfile)) label = "OVERSIZED";
      else if (isHoodie && supportsOversized) label = "OVERSIZED";
      else if (isTshirt && supportsOversized) label = "OVERSIZED";
      else if (/\btank\b/.test(nameProfile) && /\bfitted\b/.test(supportProfile)) label = "FITTED";
      else if (/\blong sleeve\b/.test(nameProfile)) label = "WAFFLE KNIT";
      else if (/\bsweatshirt\b/.test(nameProfile)) label = "BOXY";
      else if (/\bsweatpants?\b/.test(nameProfile)) label = "OVERSIZED";
      else if (isHoodie || isTshirt) label = "OVERSIZED";
      else if (/\bshorts\b/.test(nameProfile)) label = "STRETCH";
      else if (/\btank\b/.test(nameProfile)) label = "FITTED";
      else label = "ESSENTIAL";
    }

    if (handle.startsWith("lifting-club-heavyweight-hoodie-")) label = "HEAVYWEIGHT OVERSIZED";
    if (handle === "lifting-club-boxy-cut-off") label = "BOXY";
    if (hugeTeeTitle) label = "VERY OVERSIZED";

    let displayTitle = normalizedTitle;
    const removeTitleWords = (pattern) => {
      displayTitle = displayTitle.replace(pattern, " ").replace(/\s+/g, " ").trim();
    };

    switch (label) {
      case "FITTED":
        removeTitleWords(/\b(?:muscle fit|slim fit|muscle|performance|fitted)\b/gi);
        break;
      case "WAFFLE KNIT":
        removeTitleWords(/\b(?:rag|waffle)\b/gi);
        break;
      case "RAW EDGE":
        removeTitleWords(/\braw edge\b/gi);
        break;
      case "SNOW WASHED":
        removeTitleWords(/\bsnow wash(?:ed)?\b/gi);
        break;
      case "DISTRESSED":
        removeTitleWords(/\bdistressed\b/gi);
        break;
      case "FADED":
        removeTitleWords(/\bfaded\b/gi);
        break;
      case "BOXY":
        removeTitleWords(/\bboxy\b/gi);
        break;
      case "HEAVYWEIGHT OVERSIZED":
      case "HEAVYWEIGHT":
        removeTitleWords(/\b(?:heavyweight|heavy)\b/gi);
        break;
      case "VINTAGE WASH":
        removeTitleWords(/\bvintage(?: wash)?\b/gi);
        break;
      case "REFLECTIVE":
        removeTitleWords(/\breflective\b/gi);
        break;
      case "OVERSIZED":
        removeTitleWords(/\b(?:oversized|giant)\b/gi);
        break;
      case "RIBBED":
        removeTitleWords(/\bribbed\b/gi);
        break;
      case "BUNGEE CORD":
        removeTitleWords(/\bbungee cord\b/gi);
        break;
      case "JOGGER":
        removeTitleWords(/\bjogger\b/gi);
        break;
      case "RELAXED":
        removeTitleWords(/\brelaxed\b/gi);
        break;
      case "QUARTER ZIP":
        removeTitleWords(/\bquarter zip\b/gi);
        break;
      case "POLO":
        removeTitleWords(/\bpolo\b/gi);
        break;
      case "MESH":
        removeTitleWords(/\bmesh\b/gi);
        break;
      case "ZIP-UP":
        removeTitleWords(/\bzip(?:[-\s]+(?:up|through))?\b/gi);
        break;
      default:
        break;
    }

    if (/^vintage-wash-t-shirt/.test(handle) && /^t-?shirt$/i.test(displayTitle)) displayTitle = "HERCXLES T-Shirt";
    return { label, displayTitle: displayTitle || normalizedTitle };
  };

  const getRecentlyViewedDisplayTitle = (title = "", item = {}) =>
    getHcxProductFeaturePresentation({ ...item, title }).displayTitle;

  const getRecentlyViewedCollectionCardTitle = (title = "") => String(title || "").toUpperCase();

  const sizeLabelMatchesValue = (label, value) => {
    const aliases = recentlyViewedSizeAliases[label] || [label];
    return aliases.includes(normalizeOptionToken(value));
  };

  const normalizeRecentlyViewedVariants = (item) => {
    const variants = Array.isArray(item?.variants) ? item.variants : [];

    return variants
      .map((variant) => ({
        id: variant?.id || variant?.variantId || "",
        available: variant?.available === true || variant?.available === "true",
        title: variant?.title || "",
        options: Array.isArray(variant?.options) ? variant.options.map((option) => String(option || "")) : [],
        price: Number(variant?.price) || 0,
        compareAtPrice: Number(variant?.compareAtPrice ?? variant?.compare_at_price) || 0,
      }))
      .filter((variant) => variant.id);
  };

  const getVariantSizeValue = (variant, sizeOptionIndex) => {
    if (Number.isInteger(sizeOptionIndex) && variant.options?.[sizeOptionIndex]) {
      return variant.options[sizeOptionIndex];
    }

    return (
      variant.options?.find((option) =>
        recentlyViewedSizeLadder.some((sizeLabel) => sizeLabelMatchesValue(sizeLabel, option))
      ) ||
      variant.title ||
      ""
    );
  };

  const getRecentlyViewedVariantPayload = () => {
    const source = document.querySelector("[data-hcx-viewed-product-variants]");
    if (!source) return {};

    try {
      const parsed = JSON.parse(source.textContent || "{}");
      return {
        sizeOptionIndex: toIntegerOrNull(parsed.sizeOptionIndex),
        selectedOptions: Array.isArray(parsed.selectedOptions)
          ? parsed.selectedOptions.map((option) => String(option || ""))
          : [],
        variants: normalizeRecentlyViewedVariants(parsed),
      };
    } catch (error) {
      return {};
    }
  };

  const getViewedPayload = (element) => ({
    id: element.dataset.productId || element.dataset.productUrl,
    title: element.dataset.productTitle || "Viewed product",
    url: element.dataset.productUrl || "#",
    image: element.dataset.productImage || "",
    hoverImage: element.dataset.productHoverImage || "",
    price: element.dataset.productPrice || "",
    colour: element.dataset.productColour || "",
    variantId: element.dataset.productVariantId || "",
    ...getRecentlyViewedVariantPayload(),
  });

  const getRecentlyViewedVariantPool = (item, variants, sizeOptionIndex) => {
    const selectedOptions = Array.isArray(item?.selectedOptions) ? item.selectedOptions : [];
    if (!Number.isInteger(sizeOptionIndex) || !selectedOptions.length) return variants;

    const matchingVariants = variants.filter((variant) =>
      selectedOptions.every((selectedOption, index) => {
        if (index === sizeOptionIndex || !selectedOption) return true;
        return normalizeOptionToken(variant.options?.[index]) === normalizeOptionToken(selectedOption);
      })
    );

    return matchingVariants.length ? matchingVariants : variants;
  };

  const getRecentlyViewedSizeOptions = (item) => {
    const variants = normalizeRecentlyViewedVariants(item);
    const sizeOptionIndex = toIntegerOrNull(item?.sizeOptionIndex);
    const variantPool = getRecentlyViewedVariantPool(item, variants, sizeOptionIndex);
    const hideStripedSportXxl = isStripedSportSweatpantsProfile(item?.title, item?.url);

    if (!variantPool.length) return [];

    const hasKnownSizes = variantPool.some((variant) =>
      recentlyViewedSizeLadder.some((sizeLabel) => sizeLabelMatchesValue(sizeLabel, getVariantSizeValue(variant, sizeOptionIndex)))
    );

    if (!hasKnownSizes) {
      return variantPool.slice(0, 6).map((variant, index) => ({
        label: getVariantSizeValue(variant, sizeOptionIndex) || (variantPool.length === 1 ? "Add" : `Option ${index + 1}`),
        variantId: variant.id,
        available: variant.available,
      }));
    }

    return recentlyViewedSizeLadder
      .map((sizeLabel) => {
        const matches = variantPool.filter((variant) =>
          sizeLabelMatchesValue(sizeLabel, getVariantSizeValue(variant, sizeOptionIndex))
        );
        const variant = matches.find((match) => match.available) || matches[0];
        const shouldHide =
          (hideStripedSportXxl && sizeLabel === "XXL") ||
          (sizeLabel === "XS" && (!variant || !variant.available)) ||
          (sizeLabel === "3XL" && !variant);

        if (shouldHide) return null;

        return {
          label: sizeLabel,
          variantId: variant?.id || "",
          available: variant ? variant.available : false,
        };
      })
      .filter(Boolean);
  };

  const renderRecentlyViewedLoadingSpinner = () => `
    <div class="loading__spinner hidden">
      <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
      </svg>
    </div>
  `;

  const renderRecentlyViewedSizeButton = (item, option, quickId, index) => {
    const displayTitle = getRecentlyViewedDisplayTitle(item?.title || "Viewed product", item);
    const label = escapeHtml(option.label || "Add");
    const ariaLabel = option.label === "Add" ? `Add ${displayTitle} to cart` : `Add ${displayTitle} size ${option.label} to cart`;

    if (!option.variantId || !option.available) {
      return `
        <button
          type="button"
          class="hcx-card-size-button is-disabled"
          aria-label="${escapeHtml(option.label || "Option")} unavailable for ${escapeHtml(displayTitle)}"
          disabled="disabled"
          aria-disabled="true"
        >
          <span>${label}</span>
        </button>
      `;
    }

    return `
      <product-form class="hcx-card-size-form" data-section-id="recently-viewed" data-hide-errors="true">
        <form
          method="post"
          action="${escapeHtml(window.routes?.cart_add_url || "/cart/add")}"
          id="${escapeHtml(createDomId(quickId, "form", index))}"
          class="form"
          enctype="multipart/form-data"
          novalidate
          data-type="add-to-cart-form"
        >
          <input type="hidden" name="id" value="${escapeHtml(option.variantId)}" class="product-variant-id">
          <button
            type="submit"
            name="add"
            class="hcx-card-size-button"
            aria-label="${escapeHtml(ariaLabel)}"
            data-hcx-card-variant-id="${escapeHtml(option.variantId)}"
          >
            <span>${label}</span>
            ${renderRecentlyViewedLoadingSpinner()}
          </button>
        </form>
      </product-form>
    `;
  };

  const renderRecentlyViewedQuickAdd = (item, index) => {
    const sizeOptions = getRecentlyViewedSizeOptions(item);
    if (!sizeOptions.some((option) => option.available && option.variantId)) return "";
    const displayOptions = sizeOptions;

    const quickId = createDomId("HcxRecentQuickToggle", item?.id || item?.variantId || index);
    const panelId = createDomId("HcxRecentSizes", item?.id || item?.variantId || index);
    const displayTitle = getRecentlyViewedDisplayTitle(item?.title || "Viewed product", item);

    return `
      <div class="hcx-card-quick-add" data-hcx-card-quick-add>
        <input
          type="checkbox"
          id="${escapeHtml(quickId)}"
          class="hcx-card-quick-add__input"
          aria-label="Choose size for ${escapeHtml(displayTitle)}"
          data-hcx-card-quick-input
        >
        <label
          for="${escapeHtml(quickId)}"
          class="hcx-card-quick-add__toggle"
          role="button"
          tabindex="0"
          aria-expanded="false"
          aria-controls="${escapeHtml(panelId)}"
          data-hcx-card-quick-toggle
        >
          <span class="visually-hidden">Choose size for ${escapeHtml(displayTitle)}</span>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-plus" viewBox="0 0 10 10" aria-hidden="true" focusable="false">
            <path fill="currentColor" fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z" clip-rule="evenodd"></path>
          </svg>
        </label>
        <div id="${escapeHtml(panelId)}" class="hcx-card-sizes" data-hcx-card-size-panel>
          ${displayOptions.map((option, optionIndex) => renderRecentlyViewedSizeButton(item, option, panelId, optionIndex)).join("")}
        </div>
      </div>
    `;
  };

  const normalizeRecentlyViewedColour = (value = "") =>
    normalizeHcxColourDisplayLabel(value);

  const getRecentlyViewedSwatchStyle = (value = "") => {
    const key = String(value || "").toLowerCase().replace(/[-_]+/g, " ").replace(/\s+/g, " ").trim();
    const style = {
      bg: "#d8d8d8",
      border: "rgba(5, 5, 5, .28)",
      extraClass: "",
    };

    if (key.includes("faded black")) {
      style.bg = "#2d2d2d";
    } else if (key.includes("acid black")) {
      style.bg = "#242424";
    } else if (key.includes("washed black")) {
      style.bg = "#2b2a29";
    } else if (key.includes("black")) {
      style.bg = "#080808";
    } else if (key.includes("charcoal")) {
      style.bg = "#303131";
    } else if (key.includes("snow wash dark grey") || key.includes("snow wash dark gray")) {
      style.bg = "#4b4d50";
    } else if (key.includes("dark grey") || key.includes("dark gray")) {
      style.bg = "#56585a";
    } else if (key.includes("snow wash light grey") || key.includes("snow wash light gray")) {
      style.bg = "#c9cacc";
      style.extraClass = " hcx-card-swatch--light";
    } else if (key.includes("light grey") || key.includes("light gray")) {
      style.bg = "#d7d9d8";
      style.extraClass = " hcx-card-swatch--light";
    } else if (key.includes("washed grey") || key.includes("washed gray") || key.includes("snow wash grey") || key.includes("snow wash gray")) {
      style.bg = "#85878a";
    } else if (key.includes("grey") || key.includes("gray")) {
      style.bg = "#8e9092";
    } else if (key.includes("white")) {
      style.bg = "#f7f7f5";
      style.extraClass = " hcx-card-swatch--light";
    } else if (key.includes("cream") || key.includes("ecru") || key.includes("stone")) {
      style.bg = "#e9e1d1";
      style.extraClass = " hcx-card-swatch--light";
    } else if (key.includes("navy")) {
      style.bg = "#162033";
    } else if (key.includes("light blue")) {
      style.bg = "#93b9d8";
    } else if (key.includes("teal blue")) {
      style.bg = "#2c7f91";
    } else if (key.includes("teal")) {
      style.bg = "#4b9c8d";
    } else if (key.includes("cobalt blue")) {
      style.bg = "#275da4";
    } else if (key.includes("royal blue") || key.includes("klein blue")) {
      style.bg = "#1e4fa3";
    } else if (key.includes("blue")) {
      style.bg = "#416fa6";
    } else if (key.includes("army green") || key.includes("olive")) {
      style.bg = "#626957";
    } else if (key.includes("green")) {
      style.bg = "#5e927d";
    } else if (key.includes("coffee")) {
      style.bg = "#74675d";
    } else if (key.includes("brown") || key.includes("mocha")) {
      style.bg = "#725943";
    } else if (key.includes("red")) {
      style.bg = "#9d1e25";
    } else if (key.includes("pink")) {
      style.bg = "#d996aa";
    } else if (key.includes("lilac") || key.includes("purple")) {
      style.bg = "#b7a7d8";
    }

    return style;
  };

  const renderRecentlyViewedMeta = (item) => {
    const colour = normalizeRecentlyViewedColour(item?.colour);
    if (!colour) return "";
    const swatchStyle = getRecentlyViewedSwatchStyle(colour);

    return `
      <p class="hcx-card-meta hcx-card-swatches" aria-label="Available colours">
        <span class="hcx-card-swatches__row">
          <span class="hcx-card-swatches__list">
            <span
              class="hcx-card-swatch${swatchStyle.extraClass}"
              style="--hcx-card-swatch-bg: ${escapeHtml(swatchStyle.bg)}; --hcx-card-swatch-border: ${escapeHtml(swatchStyle.border)};"
              title="${escapeHtml(colour)}"
              aria-current="true"
            >
              <span class="visually-hidden">${escapeHtml(colour)}</span>
            </span>
          </span>
        </span>
        <span class="hcx-card-meta__count"></span>
      </p>
    `;
  };

  const renderRecentlyViewedFeatureMeta = (item = {}) => {
    const featureLabel = getHcxProductFeaturePresentation(item).label;
    const swatches = renderRecentlyViewedMeta(item);
    if (!featureLabel && !swatches) return "";

    return `
      <div class="hcx-card-meta-stack">
        ${
          featureLabel
            ? `<p class="hcx-card-feature-line" data-hcx-feature-label="${escapeHtml(featureLabel)}">${escapeHtml(featureLabel)}</p>`
            : ""
        }
        ${swatches}
      </div>
    `;
  };

  const renderRecentlyViewedPrice = (item = {}) => {
    const price = getRecentlyViewedDisplayPrice(item);
    if (!price) return "";
    const compareAtPrice = String(item?.compareAtPrice || "").trim();
    const isOnSale = Boolean(compareAtPrice && compareAtPrice !== price);

    if (isOnSale) {
      return `
        <div class="card-information">
          <span class="caption-large light"></span>
          <div class="price price--on-sale">
            <div class="price__container">
              <div class="price__sale">
                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                <span class="price__compare">
                  <s class="price-item price-item--regular">${escapeHtml(compareAtPrice)}</s>
                </span>
                <span class="visually-hidden visually-hidden--inline">Sale price</span>
                <span class="price-item price-item--sale price-item--last price__current">${escapeHtml(price)}</span>
              </div>
            </div>
          </div>
        </div>
      `;
    }

    return `
      <div class="card-information">
        <span class="caption-large light"></span>
        <div class="price ">
          <div class="price__container">
            <div class="price__regular">
              <span class="visually-hidden visually-hidden--inline">Regular price</span>
              <span class="price-item price-item--regular">${escapeHtml(price)}</span>
            </div>
          </div>
        </div>
      </div>
    `;
  };

  const renderRecentlyViewedSaleBadges = (item = {}) => {
    const compareAtPrice = String(item?.compareAtPrice || "").trim();
    const price = getRecentlyViewedDisplayPrice(item);
    const discountPercent = Number(item?.discountPercent);
    const isOnSale = Boolean(compareAtPrice && price && compareAtPrice !== price);
    if (!isOnSale) return "";

    return `
      <span class="hcx-card-sale-tag" aria-label="Sale">SALE</span>
      ${
        Number.isFinite(discountPercent) && discountPercent > 0
          ? `<span class="hcx-card-discount-badge" aria-label="${discountPercent} percent off">
              <span class="hcx-card-discount-badge__arrow" aria-hidden="true"></span>
              <span>${discountPercent}% OFF</span>
            </span>`
          : ""
      }
    `;
  };

  const isRecentlyViewedLckdMeshJacket = (item, image = "") =>
    /lckd-in-full-zip-mesh-jacket|lckd in full zip mesh jacket/i.test(`${item?.title || ""} ${item?.url || ""} ${image}`);

  const getRecentlyViewedThemeAssetUrl = (filename, token) => {
    const assetUrl = getHcxThemeAssetUrl(filename);
    return assetUrl ? `${assetUrl}?hcx=${token}` : "";
  };

  const getRecentlyViewedPinnedBackImage = (item = {}) => {
    const productUrl = String(item?.url || "");
    if (!/\/products\/athlete-edition-oversized-t-shirt-black(?:[/?#]|$)/i.test(productUrl)) return "";

    return "//cdn.shopify.com/s/files/1/0266/7908/3188/files/02-athlete-edition-oversized-t-shirt-black-mr5lc6sq.png?v=1783123090";
  };

  // Repair saved back photos for these front-printed hoodies, including older viewing history.
  const liftingClubHeavyweightFrontImages = {
    "lifting-club-heavyweight-hoodie-black": "//cdn.shopify.com/s/files/1/0266/7908/3188/files/74a023966bbc46c1825fa257cb02d556.png?v=1788622053&width=720",
    "lifting-club-heavyweight-hoodie-black-tonal": "//cdn.shopify.com/s/files/1/0266/7908/3188/files/2dc785d024474138862b86cdf8b87bf7.png?v=1788622053&width=720",
    "lifting-club-heavyweight-hoodie-navy": "//cdn.shopify.com/s/files/1/0266/7908/3188/files/14b60cacc15a45dc9ad49ccb7e056381.png?v=1788646859&width=720",
    "lifting-club-heavyweight-hoodie-heather-grey": "//cdn.shopify.com/s/files/1/0266/7908/3188/files/46fc14ef239440bfb26cfb72349c0fd6.png?v=1788646859&width=720",
    "lifting-club-heavyweight-hoodie-chocolate": "//cdn.shopify.com/s/files/1/0266/7908/3188/files/6bfa55d965b242829c0f00d33d0bc259.png?v=1789597332&width=720",
    "lifting-club-heavyweight-hoodie-dark-grey": "//cdn.shopify.com/s/files/1/0266/7908/3188/files/28e1fbe4989a42fe880ca77d08339256.png?v=1788646859&width=720"
};

  const getRecentlyViewedDisplayImage = (item) => {
    const frontImage = liftingClubHeavyweightFrontImages[getProductHandleFromUrl(item?.url)];
    if (frontImage && (!item?.image || /Heavy_hoodie_back_/i.test(item.image))) return frontImage;

    const pinnedBackImage = getRecentlyViewedPinnedBackImage(item);
    if (pinnedBackImage) return pinnedBackImage;

    const image = String(item?.image || "");
    if (!image) return "";

    const source = `${item?.title || ""} ${item?.url || ""} ${image}`;
    if (isRecentlyViewedLckdMeshJacket(item, image) && /LCKD_IN_Jacket\.png/i.test(image)) {
      return (
        getRecentlyViewedThemeAssetUrl(
          "hcx-lckd-in-full-zip-mesh-jacket-flatlay-front.jpg",
          "20260623-flatlay-primary"
        ) || image
      );
    }
    if (!/tank/i.test(source) || !/Ribbed_tank_top_/i.test(image)) return image;

    const isStudiosTank = /studios-ribbed-tank-top|studios ribbed tank/i.test(source);
    return image.replace(/Ribbed_tank_top_(black|grey|charcoal|white|green)_back/gi, (_match, colour) => {
      const prefix = isStudiosTank && colour.toLowerCase() !== "green" ? "Ribbed_tank_top_studios_" : "Ribbed_tank_top_";
      return `${prefix}${colour}`;
    });
  };

  const getRecentlyViewedImageUrl = (candidate) => {
    if (!candidate) return "";
    if (typeof candidate === "string") return candidate;

    return String(
      candidate.src ||
        candidate.url ||
        candidate.image?.src ||
        candidate.image?.url ||
        candidate.preview_image?.src ||
        candidate.preview_image?.url ||
        candidate.featured_image ||
        ""
    );
  };

  const getRecentlyViewedImageFingerprint = (url = "") => {
    const value = String(url || "").trim();
    if (!value) return "";

    try {
      const parsed = new URL(value, window.location.origin);
      return (parsed.pathname.split("/").pop() || "").toLowerCase().replace(/_\d+x(?=\.)/g, "");
    } catch (error) {
      return value.split("?")[0].split("/").pop().toLowerCase().replace(/_\d+x(?=\.)/g, "");
    }
  };

  const isSameRecentlyViewedImage = (first = "", second = "") => {
    const firstFingerprint = getRecentlyViewedImageFingerprint(first);
    const secondFingerprint = getRecentlyViewedImageFingerprint(second);
    return firstFingerprint && secondFingerprint && firstFingerprint === secondFingerprint;
  };

  const getRecentlyViewedImageDescriptor = (candidate) => {
    if (!candidate || typeof candidate === "string") return String(candidate || "");

    return [
      candidate.alt,
      candidate.altText,
      candidate.image?.alt,
      candidate.image?.altText,
      candidate.preview_image?.alt,
      candidate.preview_image?.altText,
      candidate.src,
      candidate.url,
      candidate.image?.src,
      candidate.image?.url,
      candidate.preview_image?.src,
      candidate.preview_image?.url,
    ]
      .filter(Boolean)
      .join(" ");
  };

  const isRecentlyViewedModelImage = (candidate) =>
    /\b(model|lifestyle|wearing|worn|on[_-]?body|feature\s*detail|match|gym|shoot|close[-_\s]*up)\b/i.test(
      getRecentlyViewedImageDescriptor(candidate)
    );

  const isRecentlyViewedFlatLayImage = (candidate) =>
    /\b(flat[-_\s]*(?:lay|product)|pack[-_\s]*shot|packshot|cut[-_\s]*out)\b/i.test(
      getRecentlyViewedImageDescriptor(candidate)
    );

  const getRecentlyViewedProductPrimaryImage = (product, item = {}) => {
    const handle = getProductHandleFromUrl(product?.url || item?.url);
    if (liftingClubHeavyweightFrontImages[handle]) {
      return getRecentlyViewedImageUrl(product?.featured_image || product?.featured_media) || liftingClubHeavyweightFrontImages[handle];
    }

    const productMedia = Array.isArray(product?.media) ? product.media : [];
    const mediaCandidates = productMedia
      .filter((media) => !media.media_type || media.media_type === "image")
      .map((media) => ({ source: media, url: getRecentlyViewedImageUrl(media) }))
      .filter((candidate) => candidate.url);
    const productImages = Array.isArray(product?.images) ? product.images : [];
    const imageCandidates = productImages
      .map((image) => ({ source: image, url: getRecentlyViewedImageUrl(image) }))
      .filter((candidate) => candidate.url);
    const primaryCandidate =
      mediaCandidates.find((candidate) => isRecentlyViewedFlatLayImage(candidate.source)) ||
      mediaCandidates.find((candidate) => !isRecentlyViewedModelImage(candidate.source)) ||
      imageCandidates.find((candidate) => isRecentlyViewedFlatLayImage(candidate.source)) ||
      imageCandidates.find((candidate) => !isRecentlyViewedModelImage(candidate.source));

    return getRecentlyViewedDisplayImage({
      ...item,
      title: product?.title || item?.title,
      url: product?.url || item?.url,
      image:
        primaryCandidate?.url ||
        getRecentlyViewedImageUrl(product?.featured_image || product?.featured_media) ||
        item?.image ||
        "",
    });
  };

  const getRecentlyViewedProductHoverImage = (product, item = {}) => {
    if (getRecentlyViewedPinnedBackImage({ ...item, url: product?.url || item?.url })) return "";

    const featuredImage = getRecentlyViewedImageUrl(item?.image || product?.featured_image || product?.featured_media);
    const productMedia = Array.isArray(product?.media) ? product.media : [];
    const mediaCandidates = productMedia
      .filter((media) => !media.media_type || media.media_type === "image")
      .map((media) => ({ source: media, url: getRecentlyViewedImageUrl(media) }))
      .filter((candidate) => candidate.url && !isSameRecentlyViewedImage(candidate.url, featuredImage));
    const modelMedia = mediaCandidates.find((candidate) => isRecentlyViewedModelImage(candidate.source));
    if (modelMedia?.url) return modelMedia.url;
    if (mediaCandidates[0]?.url) return mediaCandidates[0].url;

    const productImages = Array.isArray(product?.images) ? product.images : [];
    const imageCandidates = productImages
      .map((image) => ({ source: image, url: getRecentlyViewedImageUrl(image) }))
      .filter((candidate) => candidate.url && !isSameRecentlyViewedImage(candidate.url, featuredImage));
    const modelImage = imageCandidates.find((candidate) => isRecentlyViewedModelImage(candidate.source));

    return modelImage?.url || imageCandidates[0]?.url || "";
  };

  const getRecentlyViewedHoverImage = (item) => {
    if (getRecentlyViewedPinnedBackImage(item)) return "";

    const hoverImage = String(item?.hoverImage || item?.modelImage || item?.secondaryImage || item?.hover_image || "");
    const displayImage = getRecentlyViewedDisplayImage(item);
    if (isRecentlyViewedLckdMeshJacket(item, hoverImage || displayImage)) {
      return (
        getRecentlyViewedThemeAssetUrl(
          "hcx-lckd-in-full-zip-mesh-jacket-model-black.jpg",
          "20260603-model-hover"
        ) || hoverImage
      );
    }
    if (!hoverImage || (displayImage && isSameRecentlyViewedImage(hoverImage, displayImage))) return "";

    return hoverImage;
  };

  const renderRecentlyViewedCard = (item, index) => {
    const displayTitle = getRecentlyViewedDisplayTitle(item?.title || "Viewed product", item);
    const cardTitle = getRecentlyViewedCollectionCardTitle(displayTitle);
    const productUrl = item?.url || "#";
    const cardId = createDomId("RecentlyViewedCard", item?.id || item?.variantId || index);
    const productHandle = getProductHandleFromUrl(productUrl);
    const displayImage = getRecentlyViewedDisplayImage(item);
    const hoverImage = getRecentlyViewedHoverImage({ ...item, image: displayImage });
    const mediaMarkup = displayImage
      ? `
        <div class="card__media">
          <div class="media media--transparent media--hover-effect"${hoverImage ? " data-hcx-card-gallery" : ""}>
            <img
              src="${escapeHtml(displayImage)}"
              sizes="(min-width: 990px) 25vw, (min-width: 750px) 33vw, 50vw"
              alt="${escapeHtml(displayTitle)}"
              class="motion-reduce hcx-card-cycle-image is-hcx-active"
              data-hcx-card-image
              loading="lazy"
              width="720"
              height="900"
            >
            ${
              hoverImage
                ? `<img
                    src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%201%201%22%2F%3E"
                    data-hcx-lazy-src="${escapeHtml(hoverImage)}"
                    data-hcx-lazy-hover-image="true"
                    sizes="(min-width: 990px) 25vw, (min-width: 750px) 33vw, 50vw"
                    alt="${escapeHtml(displayTitle)} worn by model"
                    class="motion-reduce hcx-card-hover-image hcx-card-cycle-image hcx-card-hover-image--model"
                    data-hcx-card-image
                    loading="lazy"
                    decoding="async"
                    width="720"
                    height="900"
                  >`
                : ""
            }
          </div>
        </div>
      `
      : "";

    return `
      <li class="grid__item hcx-recently-viewed__item">
        <div class="card-wrapper product-card-wrapper underline-links-hover${productHandle ? ` hcx-card-product--${escapeHtml(productHandle)}` : ""} hcx-card-wrapper--has-feature hcx-card-media--flatlay${hoverImage ? " hcx-card-wrapper--has-hover-image" : ""} hcx-card-wrapper--quick-size">
          <div class="card card--standard card--media" style="--ratio-percent: 125%;">
            <div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 125%;">
              ${mediaMarkup}
              <a
                href="${escapeHtml(productUrl)}"
                class="hcx-card-media-link"
                aria-label="View ${escapeHtml(displayTitle)}"
                tabindex="-1"
              ></a>
              ${renderRecentlyViewedSaleBadges(item)}
              ${
                hoverImage
                  ? `<div class="hcx-card-gallery-arrows" data-hcx-card-gallery-arrows>
                      <button class="hcx-card-gallery-arrow hcx-card-gallery-arrow--prev" type="button" aria-label="Previous image for ${escapeHtml(displayTitle)}" data-hcx-card-gallery-prev>
                        <span aria-hidden="true">&lsaquo;</span>
                      </button>
                      <button class="hcx-card-gallery-arrow hcx-card-gallery-arrow--next" type="button" aria-label="Next image for ${escapeHtml(displayTitle)}" data-hcx-card-gallery-next>
                        <span aria-hidden="true">&rsaquo;</span>
                      </button>
                    </div>`
                  : ""
              }
              ${renderRecentlyViewedQuickAdd(item, index)}
            </div>
            <div class="card__content">
              <div class="card__information">
                <h3 class="card__heading h5" id="title-${escapeHtml(cardId)}">
                  <a
                    href="${escapeHtml(productUrl)}"
                    id="CardLink-${escapeHtml(cardId)}"
                    class="full-unstyled-link"
                    aria-labelledby="CardLink-${escapeHtml(cardId)}"
                  >
                    ${escapeHtml(cardTitle)}
                  </a>
                </h3>
                ${renderRecentlyViewedFeatureMeta(item)}
                ${renderRecentlyViewedPrice(item)}
              </div>
              <div class="card__badge bottom left"></div>
            </div>
          </div>
        </div>
      </li>
    `;
  };

  const getProductHandleFromUrl = (url) => {
    try {
      const productUrl = new URL(url, window.location.origin);
      const match = productUrl.pathname.match(/\/products\/([^/?#]+)/);
      return match?.[1] || "";
    } catch (error) {
      return "";
    }
  };

  const hiddenRecentlyViewedHandles = new Set([
    "reflection-striped-straight-leg-sweatpants-7",
    "reflection-striped-straight-leg-sweatpants-8",
  ]);

  const canonicalRecentlyViewedHandleMap = {
    "reflection-striped-straight-leg-sweatpants-7": "reflection-striped-straight-leg-sweatpants-5",
    "reflection-striped-straight-leg-sweatpants-8": "reflection-striped-straight-leg-sweatpants-6",
  };

  const getCanonicalRecentlyViewedHandle = (handle = "") => {
    const normalizedHandle = String(handle || "").trim().toLowerCase();
    return canonicalRecentlyViewedHandleMap[normalizedHandle] || normalizedHandle;
  };

  const getRecentlyViewedIdentity = (item) => {
    const handle = getCanonicalRecentlyViewedHandle(getProductHandleFromUrl(item?.url));
    if (handle) return `handle:${handle}`;

    const title = String(item?.title || "").trim().toLowerCase().replace(/\s+/g, " ");
    const colour = normalizeRecentlyViewedColour(item?.colour).toLowerCase();
    if (title || colour) return `title:${title}|colour:${colour}`;

    return item?.id ? `id:${item.id}` : "";
  };

  const getCurrentViewedIdentity = () => {
    const marker = document.querySelector("[data-hcx-track-viewed-product]");
    if (!marker) return "";

    return getRecentlyViewedIdentity({
      id: marker.dataset.productId || marker.dataset.productUrl,
      title: marker.dataset.productTitle,
      url: marker.dataset.productUrl,
      colour: marker.dataset.productColour,
    });
  };

  const getUniqueRecentlyViewedItems = (items, { excludeCurrent = false } = {}) => {
    if (!Array.isArray(items)) return [];

    const seen = new Set();
    const currentIdentity = excludeCurrent ? getCurrentViewedIdentity() : "";

    return items.filter((item) => {
      const handle = String(getProductHandleFromUrl(item?.url) || "").trim().toLowerCase();
      if (hiddenRecentlyViewedHandles.has(handle) || replacedProductHandles.has(handle)) return false;

      const identity = getRecentlyViewedIdentity(item);
      if (!identity || (currentIdentity && identity === currentIdentity) || seen.has(identity)) return false;

      seen.add(identity);
      return true;
    });
  };

  const getSizeOptionIndexFromProductJson = (product) => {
    const options = Array.isArray(product?.options) ? product.options : [];
    const sizeIndex = options.findIndex((option) => {
      const optionName = typeof option === "string" ? option : option?.name;
      return String(optionName || "").toLowerCase().includes("size");
    });

    return sizeIndex >= 0 ? sizeIndex : null;
  };

  const normalizeProductJsonVariant = (variant) => {
    const options = Array.isArray(variant?.options)
      ? variant.options
      : [variant?.option1, variant?.option2, variant?.option3].filter(Boolean);

    return {
      id: variant?.id || "",
      available: variant?.available === true || variant?.available === "true",
      title: variant?.title || "",
      options: options.map((option) => String(option || "")),
      price: Number(variant?.price) || 0,
      compareAtPrice: Number(variant?.compare_at_price ?? variant?.compareAtPrice) || 0,
    };
  };

  const formatShopifyProductJsonPrice = (value) => {
    return formatRecentlyViewedPriceCents(value);
  };

  const enrichRecentlyViewedItem = async (item) => {
    const handle = getProductHandleFromUrl(item?.url);
    if (!handle || recentlyViewedEnrichmentHandles.has(handle)) return null;

    recentlyViewedEnrichmentHandles.add(handle);

    try {
      const response = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      });
      if (!response.ok) return null;

      const product = await response.json();
      const variants = Array.isArray(product?.variants)
        ? product.variants.map(normalizeProductJsonVariant).filter((variant) => variant.id)
        : [];
      if (!variants.length) return null;

      const selectedVariant =
        variants.find((variant) => String(variant.id) === String(item.variantId)) ||
        variants.find((variant) => variant.available) ||
        variants[0];
      const productImage = getRecentlyViewedProductPrimaryImage(product, item);
      const productHoverImage = getRecentlyViewedProductHoverImage(product, {
        ...item,
        image: productImage || item.image,
      });
      const selectedPriceCents = Number(selectedVariant?.price || product?.price) || 0;
      const selectedCompareAtCents = Number(selectedVariant?.compareAtPrice) || 0;
      const currentPrice = formatShopifyProductJsonPrice(selectedPriceCents);
      const compareAtPrice =
        selectedCompareAtCents > selectedPriceCents ? formatShopifyProductJsonPrice(selectedCompareAtCents) : "";
      const campaignPriceCents = selectedCompareAtCents * 0.8;
      const campaignPriceDifference = Math.abs(selectedPriceCents - campaignPriceCents);
      const discountPercent = compareAtPrice
        ? campaignPriceDifference <= 50
          ? 20
          : Math.round(((selectedCompareAtCents - selectedPriceCents) * 100) / selectedCompareAtCents)
        : 0;

      return {
        id: item.id,
        title: product?.title || item.title,
        url: product?.url || `/products/${handle}`,
        type: product?.type || item.type || "",
        tags: product?.tags || item.tags || [],
        description: product?.description || item.description || "",
        price: currentPrice || item.price,
        compareAtPrice,
        discountPercent,
        variantId: selectedVariant?.id || item.variantId,
        image: productImage || item.image,
        hoverImage: productHoverImage || item.hoverImage,
        sizeOptionIndex: getSizeOptionIndexFromProductJson(product),
        selectedOptions: selectedVariant?.options || item.selectedOptions || [],
        variants,
      };
    } catch (error) {
      return null;
    }
  };

  const cartRecentOrdersKey = "hcx:cart-recent-orders:v2";
  const cartRecentOrderLimit = 8;
  const cartRecentOrderWindowMs = 60 * 24 * 60 * 60 * 1000;
  const cartRecentProductCache = new Map();

  const cleanCartRecentText = (value = "", fallback = "") =>
    String(value || fallback)
      .replace(/\s+/g, " ")
      .trim();

  const normalizeCartRecentProductUrl = (value = "") => {
    const urlText = cleanCartRecentText(value);
    if (!urlText || urlText === "#") return "";

    try {
      const parsedUrl = new URL(urlText, window.location.origin);
      if (parsedUrl.origin !== window.location.origin || !parsedUrl.pathname.includes("/products/")) return "";

      return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
    } catch (error) {
      return "";
    }
  };

  const getCartRecentHandleFromTitle = (value = "") =>
    cleanCartRecentText(value)
      .toLowerCase()
      .replace(/&/g, " and ")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

  const getCartRecentOrderLineItems = (order) => {
    const lineItems = Array.isArray(order?.items)
      ? order.items
      : Array.isArray(order?.line_items)
        ? order.line_items
        : Array.isArray(order?.lineItems)
          ? order.lineItems
          : [];

    return lineItems.length ? lineItems : [order];
  };

  const getCartRecentLineItemTitle = (order, lineItem) =>
    cleanCartRecentText(
      lineItem?.item ||
        lineItem?.title ||
        lineItem?.product_title ||
        lineItem?.product ||
        lineItem?.name ||
        order?.item ||
        order?.title ||
        order?.product_title ||
        order?.product ||
        order?.line_item
    );

  const getCartRecentLineItemUrl = (order, lineItem) =>
    normalizeCartRecentProductUrl(
      lineItem?.url ||
        lineItem?.product_url ||
        lineItem?.productUrl ||
        lineItem?.href ||
        order?.url ||
        order?.product_url ||
        order?.productUrl ||
        order?.product_href ||
        order?.href
    );

  const getCartRecentLineItemHandle = (order, lineItem, url, title) =>
    cleanCartRecentText(
      lineItem?.handle ||
        lineItem?.product_handle ||
        lineItem?.productHandle ||
        order?.handle ||
        order?.product_handle ||
        order?.productHandle ||
        getHcxProductHandleFromUrl(url) ||
        getCartRecentHandleFromTitle(title)
    ).toLowerCase();

  const normalizeCartRecentOrders = (orders) => {
    const normalizedByHandle = new Map();
    const now = Date.now();

    (Array.isArray(orders) ? orders : []).forEach((order, orderIndex) => {
      const orderedAtValue =
        order?.orderedAt || order?.ordered_at || order?.created_at || order?.timestamp || order?.date || Date.now();
      const orderedAt = new Date(orderedAtValue);
      if (Number.isNaN(orderedAt.getTime())) return;
      const orderAge = now - orderedAt.getTime();
      if (orderAge < 0 || orderAge > cartRecentOrderWindowMs) return;
      const orderedAtIso = orderedAt.toISOString();
      const handlesSeenInOrder = new Set();

      getCartRecentOrderLineItems(order).forEach((lineItem, lineIndex) => {
        const title = getCartRecentLineItemTitle(order, lineItem);
        const url = getCartRecentLineItemUrl(order, lineItem);
        const handle = getCartRecentLineItemHandle(order, lineItem, url, title);
        if (!handle) return;

        const rawQuantity = Number(lineItem?.quantity || lineItem?.qty || 1);
        const quantity = Number.isFinite(rawQuantity) && rawQuantity > 0 ? rawQuantity : 1;
        const existing = normalizedByHandle.get(handle) || {
          id: cleanCartRecentText(order?.id || order?.order_id || `${handle}:${orderedAtIso}:${lineIndex}`),
          handle,
          title,
          url: url || `/products/${handle}`,
          orderedAt: orderedAtIso,
          orderCount: 0,
          quantity: 0,
        };

        existing.quantity += quantity;
        if (!handlesSeenInOrder.has(handle)) {
          existing.orderCount += 1;
          handlesSeenInOrder.add(handle);
        }

        if (new Date(orderedAtIso) >= new Date(existing.orderedAt)) {
          existing.id = cleanCartRecentText(order?.id || order?.order_id || existing.id);
          existing.title = title || existing.title;
          existing.url = url || existing.url;
          existing.orderedAt = orderedAtIso;
        }

        normalizedByHandle.set(handle, existing);
      });
    });

    const mixedOrders = [...normalizedByHandle.values()];
    for (let index = mixedOrders.length - 1; index > 0; index -= 1) {
      const swapIndex = Math.floor(Math.random() * (index + 1));
      [mixedOrders[index], mixedOrders[swapIndex]] = [mixedOrders[swapIndex], mixedOrders[index]];
    }
    return mixedOrders;
  };

  const readCachedCartRecentOrders = () => {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(cartRecentOrdersKey) || "[]");
      return normalizeCartRecentOrders(parsed);
    } catch (error) {
      return [];
    }
  };

  const writeCachedCartRecentOrders = (orders) => {
    try {
      window.localStorage.setItem(cartRecentOrdersKey, JSON.stringify(normalizeCartRecentOrders(orders)));
    } catch (error) {
      return;
    }
  };

  const fetchCartRecentOrders = async (recommendations) => {
    const feedUrl = cleanCartRecentText(recommendations?.dataset?.hcxRecentOrdersUrl);
    if (!feedUrl) return [];

    try {
      const response = await fetch(feedUrl, {
        cache: "no-store",
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      });
      if (!response.ok) return [];

      const data = await response.json();
      const orders = Array.isArray(data) ? data : Array.isArray(data?.orders) ? data.orders : [];
      const normalized = normalizeCartRecentOrders(orders);
      if (normalized.length) writeCachedCartRecentOrders(normalized);
      return normalized;
    } catch (error) {
      return [];
    }
  };

  const normalizeCartRecentTitleKey = (value = "") =>
    cleanCartRecentText(value)
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, " ")
      .trim();

  const fetchCartRecentProductByHandle = async (handle) => {
    const normalizedHandle = cleanCartRecentText(handle).toLowerCase();
    if (!normalizedHandle || replacedProductHandles.has(normalizedHandle)) return null;

    if (!cartRecentProductCache.has(normalizedHandle)) {
      cartRecentProductCache.set(
        normalizedHandle,
        fetch(`/products/${encodeURIComponent(normalizedHandle)}.js`, {
          credentials: "same-origin",
          headers: { Accept: "application/json" },
        })
          .then((response) => (response.ok ? response.json() : null))
          .catch(() => null)
      );
    }

    return cartRecentProductCache.get(normalizedHandle);
  };

  const fetchCartRecentProduct = async (orderItem) => {
    const title = cleanCartRecentText(orderItem?.title);
    const titleKey = normalizeCartRecentTitleKey(title);
    const inferredHandle = cleanCartRecentText(
      orderItem?.handle || getHcxProductHandleFromUrl(orderItem?.url)
    ).toLowerCase();
    const directProduct = await fetchCartRecentProductByHandle(inferredHandle);
    if (directProduct && (!titleKey || normalizeCartRecentTitleKey(directProduct.title) === titleKey)) {
      return directProduct;
    }
    if (!titleKey) return null;

    const searchCacheKey = `search:${titleKey}`;
    if (!cartRecentProductCache.has(searchCacheKey)) {
      cartRecentProductCache.set(
        searchCacheKey,
        (async () => {
          try {
            const searchUrl = new URL("/search/suggest.json", window.location.origin);
            searchUrl.searchParams.set("q", title);
            searchUrl.searchParams.set("resources[type]", "product");
            searchUrl.searchParams.set("resources[limit]", "10");
            searchUrl.searchParams.set("resources[options][unavailable_products]", "hide");
            const response = await fetch(`${searchUrl.pathname}${searchUrl.search}`, {
              credentials: "same-origin",
              headers: { Accept: "application/json" },
            });
            if (!response.ok) return null;

            const payload = await response.json();
            const products = payload?.resources?.results?.products;
            const exactProduct = (Array.isArray(products) ? products : []).find(
              (product) => normalizeCartRecentTitleKey(product?.title) === titleKey
            );
            const resolvedHandle = cleanCartRecentText(
              exactProduct?.handle || getHcxProductHandleFromUrl(exactProduct?.url)
            ).toLowerCase();
            return fetchCartRecentProductByHandle(resolvedHandle);
          } catch (error) {
            return null;
          }
        })()
      );
    }

    return cartRecentProductCache.get(searchCacheKey);
  };

  const getCartRecentProductImage = (product) =>
    getRecentlyViewedProductPrimaryImage(product, {
      title: product?.title,
      url: product?.url,
      image: product?.featured_image || product?.images?.[0] || "",
    });

  const getCartRecentMediaClass = (product, image = "") => {
    const profile = `${product?.title || ""} ${product?.product_type || ""} ${image}`.toLowerCase();
    if (/\b(model|lifestyle|worn|wearing|on[_-]?body|gym|shoot|close[-_ ]?up)\b/.test(profile)) {
      return "hcx-cart-rec--lifestyle";
    }

    return "hcx-cart-rec--flatlay";
  };

  const isCartRecommendationSizeOption = (option) => {
    const value = cleanCartRecentText(option).toLowerCase();
    return [
      "xxs",
      "xs",
      "s",
      "m",
      "l",
      "xl",
      "xxl",
      "2xl",
      "3xl",
      "4xl",
      "small",
      "medium",
      "large",
    ].includes(value);
  };

  const getCartRecentProductPayload = (product, orderItem, preferredSize = "") => {
    const variants = Array.isArray(product?.variants)
      ? product.variants.map(normalizeProductJsonVariant).filter((variant) => variant.id)
      : [];
    const preferredSizeKey = cleanCartRecentText(preferredSize).toLowerCase();
    const selectedVariant =
      (preferredSizeKey
        ? variants.find(
            (variant) =>
              variant.available &&
              variant.options.some((option) => cleanCartRecentText(option).toLowerCase() === preferredSizeKey)
          )
        : null) ||
      variants.find((variant) => variant.available) ||
      variants[0];
    if (!selectedVariant?.id || selectedVariant.available === false) return null;

    const rawProductUrl = product?.url || orderItem?.url || `/products/${orderItem?.handle}`;
    let productUrl = rawProductUrl;
    try {
      const parsedProductUrl = new URL(rawProductUrl, window.location.origin);
      parsedProductUrl.searchParams.set("variant", selectedVariant.id);
      productUrl = `${parsedProductUrl.pathname}${parsedProductUrl.search}${parsedProductUrl.hash}`;
    } catch (error) {
      productUrl = rawProductUrl;
    }
    const image = getCartRecentProductImage(product);
    const currentPrice = formatShopifyProductJsonPrice(selectedVariant?.price || product?.price);
    const title = product?.title || orderItem?.title || "Product";
    const sizeLabel = selectedVariant.options.find(isCartRecommendationSizeOption) || "";

    return {
      id: product?.id || orderItem?.id || orderItem?.handle,
      handle: getHcxProductHandleFromUrl(productUrl) || orderItem?.handle,
      title,
      displayTitle: getRecentlyViewedDisplayTitle(title, { ...product, title, url: productUrl }),
      url: productUrl,
      image,
      price: getRecentlyViewedDisplayPrice(
        {
          title,
          url: productUrl,
          type: product?.type,
          productType: product?.product_type,
        },
        currentPrice
      ),
      variantId: selectedVariant.id,
      sizeLabel,
      mediaClass: getCartRecentMediaClass(product, image),
      orderedAt: orderItem?.orderedAt,
    };
  };

  const renderCartRecentRecommendationCard = (item, index) => {
    const formId = createDomId("hcx-cart-recent-rec", item.id || item.handle, index);

    return `
      <li
        class="hcx-cart-rec hcx-cart-rec--recent ${escapeHtml(item.mediaClass || "hcx-cart-rec--flatlay")}"
        data-hcx-cart-rec-card
        data-hcx-cart-rec-dynamic="true"
        data-hcx-cart-rec-source="${escapeHtml(item.source || "recent-orders")}"
        data-hcx-cart-rec-product-id="${escapeHtml(item.id)}"
        data-hcx-cart-rec-product-handle="${escapeHtml(item.handle)}"
        data-hcx-cart-rec-title="${escapeHtml(item.title)}"
        data-hcx-cart-rec-url="${escapeHtml(item.url)}"
        data-hcx-cart-rec-ordered-at="${escapeHtml(item.orderedAt)}"
        ${item.salesRank ? `data-hcx-cart-rec-sales-rank="${escapeHtml(item.salesRank)}"` : ""}
      >
        <a href="${escapeHtml(item.url)}" class="hcx-cart-rec__media" aria-label="${escapeHtml(item.displayTitle)}">
          ${
            item.image
              ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.displayTitle)}" class="hcx-cart-rec__image" loading="eager" width="420" height="530">`
              : `<span class="hcx-cart-rec__image placeholder-svg"></span>`
          }
        </a>

        <div class="hcx-cart-rec__content">
          <a href="${escapeHtml(item.url)}" class="hcx-cart-rec__title">${escapeHtml(item.displayTitle)}</a>
          ${
            item.price
              ? `<div class="hcx-cart-rec__price"><span>${escapeHtml(item.price)}</span></div>`
              : ""
          }
          <product-form class="hcx-cart-rec__form" data-section-id="cart-drawer" data-hide-errors="true">
            <form method="post" action="${escapeHtml(window.routes?.cart_add_url || "/cart/add")}" id="${escapeHtml(formId)}" class="form" enctype="multipart/form-data" novalidate data-type="add-to-cart-form">
              <input type="hidden" name="id" value="${escapeHtml(item.variantId)}" class="product-variant-id">
              <input type="hidden" name="quantity" value="1">
              <button type="submit" name="add" class="hcx-cart-rec__action${item.sizeLabel ? " hcx-cart-rec__action--sized" : ""}" aria-label="Add ${escapeHtml(item.displayTitle)}${item.sizeLabel ? `, size ${escapeHtml(item.sizeLabel)}` : ""} to cart">
                <span>${item.sizeLabel ? `Add · ${escapeHtml(item.sizeLabel)}` : "Add"}</span>
                ${renderRecentlyViewedLoadingSpinner()}
              </button>
            </form>
          </product-form>
        </div>
      </li>
    `;
  };

  const resetCartRecentOrderCard = (card) => {
    if (card?.dataset?.hcxCartRecDynamic === "true") {
      card.remove();
      return;
    }

    const badge = card?.querySelector(".hcx-cart-rec__badge");
    if (badge && card.dataset.hcxCartRecOriginalBadge !== undefined) {
      badge.textContent = card.dataset.hcxCartRecOriginalBadge;
      badge.hidden = false;
    }
    card?.classList.remove("hcx-cart-rec--recent");
    if (card?.dataset) card.dataset.hcxCartRecSource = "theme";
  };

  const setCartRecentOrderBadge = (card) => {
    if (!card) return;

    const badge = card.querySelector(".hcx-cart-rec__badge");
    if (badge) {
      if (card.dataset.hcxCartRecOriginalBadge === undefined) {
        card.dataset.hcxCartRecOriginalBadge = badge.textContent || "";
      }
      badge.textContent = "";
      badge.hidden = true;
    }

    card.dataset.hcxCartRecSource = "recent-orders";
    card.classList.add("hcx-cart-rec--recent");
  };

  const findCartRecentExistingCard = (rail, handle) =>
    [...rail.querySelectorAll("[data-hcx-cart-rec-card]")].find(
      (card) => cleanCartRecentText(card.dataset.hcxCartRecProductHandle).toLowerCase() === handle
    );

  const isCartRecentExcluded = (recommendations, product) => {
    const handle = cleanCartRecentText(product?.handle).toLowerCase();
    const productId = cleanCartRecentText(product?.id);
    const cartHandles = recommendations?.dataset?.hcxCartProductHandles || "";
    const cartIds = recommendations?.dataset?.hcxCartProductIds || "";
    const completeSetHandles = recommendations?.dataset?.hcxCartCompleteSetProductHandles || "";
    const completeSetIds = recommendations?.dataset?.hcxCartCompleteSetProductIds || "";
    const replacedHandles = recommendations?.dataset?.hcxCartReplacedProductHandles || "";

    return (
      !handle ||
      cartHandles.includes(`|${handle}|`) ||
      cartIds.includes(`,${productId},`) ||
      completeSetHandles.includes(`|${handle}|`) ||
      completeSetIds.includes(`,${productId},`) ||
      replacedHandles.includes(`|${handle}|`) ||
      replacedProductHandles.has(handle)
    );
  };

  const renderCartRecentOrders = async (recommendations, orders) => {
    const rail = recommendations?.querySelector("[data-hcx-cart-rec-rail]");
    if (!rail || !orders.length) return;
    const preferredSize = cleanCartRecentText(recommendations?.dataset?.hcxPreferredSize);

    rail.querySelectorAll("[data-hcx-cart-rec-source='recent-orders']").forEach(resetCartRecentOrderCard);

    const nextCards = [];
    const seenHandles = new Set();

    for (const orderItem of orders) {
      if (nextCards.length >= cartRecentOrderLimit) break;

      const handle = cleanCartRecentText(orderItem.handle || getHcxProductHandleFromUrl(orderItem.url)).toLowerCase();
      if (!handle || seenHandles.has(handle)) continue;
      if ((recommendations.dataset.hcxCartProductHandles || "").includes(`|${handle}|`)) continue;
      if ((recommendations.dataset.hcxCartReplacedProductHandles || "").includes(`|${handle}|`)) continue;
      if (replacedProductHandles.has(handle)) continue;

      const existingCard = findCartRecentExistingCard(rail, handle);
      if (existingCard) {
        setCartRecentOrderBadge(existingCard);
        nextCards.push(existingCard);
        seenHandles.add(handle);
        continue;
      }

      const product = await fetchCartRecentProduct(orderItem);
      const item = getCartRecentProductPayload(product, orderItem, preferredSize);
      if (!item || isCartRecentExcluded(recommendations, item)) continue;
      if (seenHandles.has(item.handle)) continue;

      const template = document.createElement("template");
      template.innerHTML = renderCartRecentRecommendationCard(item, nextCards.length).trim();
      const card = template.content.firstElementChild;
      if (!card) continue;

      nextCards.push(card);
      seenHandles.add(item.handle);
    }

    if (!rail.isConnected || !nextCards.length) {
      recommendations.hidden = true;
      return;
    }

    rail.prepend(...nextCards);
    recommendations.hidden = false;
    recommendations.classList.add("hcx-cart-recommendations--recent-orders");
    recommendations.dataset.hcxRecentOrdersRendered = "true";
    window.requestAnimationFrame(() => {
      syncCartRecommendationScrollbar(recommendations);
      initCartRecommendationScrollbars();
    });
  };

  const cartBestSellerFeeds = new Map();

  const fetchCartBestSellers = (feedUrl) => {
    if (!cartBestSellerFeeds.has(feedUrl)) {
      cartBestSellerFeeds.set(feedUrl, (async () => {
        try {
          const response = await fetch(feedUrl, {
            credentials: "same-origin",
            headers: { Accept: "application/json" },
          });
          if (!response.ok) return [];
          const payload = await response.json();
          if (payload.sort !== "net-units-sold" || payload.windowDays !== 60 || !Array.isArray(payload.products)) return [];
          return payload;
        } catch (error) {
          cartBestSellerFeeds.delete(feedUrl);
          return [];
        }
      })());
    }
    return cartBestSellerFeeds.get(feedUrl);
  };

  const renderCartBestSellers = async (recommendations, feed) => {
    const rail = recommendations.querySelector("[data-hcx-cart-rec-rail]");
    if (!rail?.isConnected || !Array.isArray(feed?.products)) return;
    const preferredSize = cleanCartRecentText(recommendations.dataset.hcxPreferredSize);
    const cards = [];
    const seenHandles = new Set();

    // Net units come from the complete 60-day order window, grouped by product ID.
    // Load current prices/available variants in batches without changing sales order.
    const eligible = feed.products.filter((product) => product.rank > 0 && !isCartRecentExcluded(recommendations, product));
    for (let offset = 0; offset < eligible.length && cards.length < cartRecentOrderLimit; offset += cartRecentOrderLimit) {
      const batch = eligible.slice(offset, offset + cartRecentOrderLimit);
      const products = await Promise.all(batch.map((ranked) => fetchCartRecentProductByHandle(ranked.handle)));
      if (!rail.isConnected) return;
      for (const [index, product] of products.entries()) {
        if (cards.length >= cartRecentOrderLimit) break;
        const ranked = batch[index];
        if (!product || String(product.id) !== String(ranked.id) || seenHandles.has(product.handle) || isCartRecentExcluded(recommendations, product)) continue;
        const item = getCartRecentProductPayload(product, { url: `/products/${product.handle}`, handle: product.handle }, preferredSize);
        if (!item) continue;
        item.source = "shopify-sales-last-60-days";
        item.salesRank = ranked.rank;
        cards.push(renderCartRecentRecommendationCard(item, cards.length));
        seenHandles.add(product.handle);
      }
    }

    rail.innerHTML = cards.join("");
    recommendations.hidden = cards.length === 0;
    recommendations.dataset.hcxBestSellersWindowDays = String(feed.windowDays);
    recommendations.dataset.hcxBestSellersGeneratedAt = feed.generatedAt;
    recommendations.dataset.hcxBestSellersRendered = "true";
    window.requestAnimationFrame(() => {
      syncCartRecommendationScrollbar(recommendations);
      initCartRecommendationScrollbars();
    });
  };

  const initRecentCartRecommendations = () => {
    document.querySelectorAll(".hcx-cart-recommendations[data-hcx-best-sellers-url]").forEach((recommendations) => {
      const rail = recommendations.querySelector("[data-hcx-cart-rec-rail]");
      if (!rail || rail.dataset.hcxBestSellersBound === "true") return;
      rail.dataset.hcxBestSellersBound = "true";
      fetchCartBestSellers(recommendations.dataset.hcxBestSellersUrl).then((products) => {
        renderCartBestSellers(recommendations, products);
      });
    });

    document.querySelectorAll(".hcx-cart-recommendations[data-hcx-recent-orders-url]").forEach((recommendations) => {
      const rail = recommendations.querySelector("[data-hcx-cart-rec-rail]");
      if (!rail || rail.dataset.hcxRecentOrdersBound === "true") return;

      rail.dataset.hcxRecentOrdersBound = "true";

      fetchCartRecentOrders(recommendations).then((orders) => {
        if (orders.length) renderCartRecentOrders(recommendations, orders);
      });
    });

    if (html.dataset.hcxRecentCartRecObserverBound !== "true" && "MutationObserver" in window) {
      html.dataset.hcxRecentCartRecObserverBound = "true";
      const cartRoot = document.querySelector("cart-drawer");
      let cartFrame = 0;
      if (cartRoot) new MutationObserver(() => {
        if (cartFrame) return;
        cartFrame = window.requestAnimationFrame(() => {
          cartFrame = 0;
          initRecentCartRecommendations();
        });
      }).observe(cartRoot, { childList: true, subtree: true });
    }
  };

  const enrichRecentlyViewedItems = (items) => {
    const refreshableItems = items.filter((item) => {
      const handle = getProductHandleFromUrl(item?.url);
      return handle && !recentlyViewedEnrichmentHandles.has(handle);
    });

    if (!refreshableItems.length) return;

    Promise.all(refreshableItems.map(enrichRecentlyViewedItem)).then((results) => {
      const enrichedItems = results.filter(Boolean);
      if (!enrichedItems.length) return;

      let didUpdate = false;
      const currentItems = readRecentlyViewed();
      const nextItems = currentItems.map((item) => {
        const enrichedItem = enrichedItems.find((candidate) => String(candidate.id) === String(item.id));
        if (!enrichedItem) return item;

        didUpdate = true;
        return {
          ...item,
          title: enrichedItem.title || item.title,
          url: enrichedItem.url || item.url,
          price: enrichedItem.price || item.price,
          compareAtPrice: enrichedItem.compareAtPrice || "",
          discountPercent: enrichedItem.discountPercent || 0,
          sizeOptionIndex: enrichedItem.sizeOptionIndex,
          selectedOptions: enrichedItem.selectedOptions,
          variants: enrichedItem.variants,
          image: enrichedItem.image || item.image,
          hoverImage: enrichedItem.hoverImage || item.hoverImage,
        };
      });

      if (didUpdate) {
        writeRecentlyViewed(nextItems);
        renderRecentlyViewed();
      }
    });
  };

  const trackRecentlyViewedProduct = () => {
    const marker = document.querySelector("[data-hcx-track-viewed-product]");
    if (!marker || marker.dataset.hcxTrackedViewed === "true") return;

    marker.dataset.hcxTrackedViewed = "true";

    const payload = getViewedPayload(marker);
    if (!payload.id) return;

    const currentItems = getUniqueRecentlyViewedItems(readRecentlyViewed());
    const payloadIdentity = getRecentlyViewedIdentity(payload);
    const existing = currentItems.find(
      (item) => String(item.id) === String(payload.id) || getRecentlyViewedIdentity(item) === payloadIdentity
    );
    const nextPayload = {
      ...existing,
      ...payload,
      views: (Number(existing?.views || existing?.viewCount || 0) || 0) + 1,
      lastViewedAt: Date.now(),
    };
    const nextItems = getUniqueRecentlyViewedItems([
      nextPayload,
      ...currentItems.filter((item) => getRecentlyViewedIdentity(item) !== payloadIdentity),
    ]).slice(0, recentlyViewedStoreLimit);
    writeRecentlyViewed(nextItems);
  };

  const renderRecentlyViewed = () => {
    const sections = document.querySelectorAll("[data-hcx-recently-viewed-section]");
    if (!sections.length) return;

    const rawStoredItems = readRecentlyViewed();
    const cleanedStoredItems = getUniqueRecentlyViewedItems(rawStoredItems).slice(0, recentlyViewedStoreLimit);
    if (cleanedStoredItems.length !== rawStoredItems.length) {
      writeRecentlyViewed(cleanedStoredItems);
    }

    const storedItems = getUniqueRecentlyViewedItems(cleanedStoredItems, { excludeCurrent: true }).slice(0, recentlyViewedLimit);

    sections.forEach((section) => {
      const list = section.querySelector("[data-hcx-recently-viewed-list]");
      if (!list) return;

      const items = storedItems.slice(0, recentlyViewedLimit);

      if (!items.length) {
        list.innerHTML = "";
        list.style.removeProperty("--hcx-recently-viewed-count");
        section.style.removeProperty("--hcx-recently-viewed-count");
        section.hidden = true;
        return;
      }

      list.innerHTML = items.map(renderRecentlyViewedCard).join("");
      list.style.setProperty(
        "--hcx-recently-viewed-count",
        String(Math.max(1, Math.min(recentlyViewedLimit, items.length)))
      );
      section.style.setProperty(
        "--hcx-recently-viewed-count",
        String(Math.max(1, Math.min(recentlyViewedLimit, items.length)))
      );
      section.hidden = false;
      initCardQuickAdds();
      initCardImageGalleries(section);
      enrichRecentlyViewedItems(items);
    });
  };

  const initCustomerVoiceCarousels = () => {
    document.querySelectorAll("[data-hcx-review-carousel]").forEach((carousel) => {
      if (carousel.dataset.hcxCarouselBound === "true") return;
      carousel.dataset.hcxCarouselBound = "true";

      const track = carousel.querySelector("[data-hcx-review-track]");
      const previous = carousel.querySelector("[data-hcx-review-prev]");
      const next = carousel.querySelector("[data-hcx-review-next]");
      if (!track || !previous || !next) return;

      const getStep = () => {
        const card = track.querySelector(".hcx-customer-review-card");
        if (!card) return Math.max(track.clientWidth * 0.72, 320);

        const styles = window.getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;
        return card.getBoundingClientRect().width + gap;
      };

      const updateControls = () => {
        const canScroll = track.scrollWidth > track.clientWidth + 2;
        previous.hidden = !canScroll;
        next.hidden = !canScroll;
      };

      const scrollTrack = (direction, event) => {
        event?.preventDefault();

        updateControls();

        const maxLeft = Math.max(0, track.scrollWidth - track.clientWidth);
        if (maxLeft <= 2) return;

        let target = track.scrollLeft + (getStep() * direction);

        if (direction > 0 && track.scrollLeft >= maxLeft - 2) target = 0;
        if (direction < 0 && track.scrollLeft <= 2) target = maxLeft;

        track.scrollTo({
          left: Math.max(0, Math.min(maxLeft, target)),
          behavior: "smooth",
        });
      };

      previous.addEventListener("click", (event) => scrollTrack(-1, event));
      next.addEventListener("click", (event) => scrollTrack(1, event));
      track.addEventListener("scroll", () => window.requestAnimationFrame(updateControls), { passive: true });
      window.addEventListener("resize", updateControls);
      updateControls();
    });
  };

  const initMobileMenuClose = (root = document) => {
    const forceMobileMenuClosed = (drawer, details, summary) => {
      details?.removeAttribute("open");
      details?.classList.remove("menu-opening");
      details?.querySelectorAll("details").forEach((nestedDetails) => {
        nestedDetails.removeAttribute("open");
        nestedDetails.classList.remove("menu-opening");
      });
      details?.querySelectorAll(".submenu-open").forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });

      summary?.setAttribute("aria-expanded", "false");
      const headerSection = drawer?.closest(".section-header") || document.querySelector(".section-header");
      headerSection?.classList.remove("menu-open");
      document.body.classList.remove("hcx-menu-open", "overflow-hidden", "overflow-hidden-tablet", "overflow-hidden-desktop");
    };

    root.querySelectorAll("[data-hcx-mobile-menu-close]").forEach((button) => {
      if (button.dataset.hcxMobileMenuCloseBound === "true") return;
      button.dataset.hcxMobileMenuCloseBound = "true";

      button.addEventListener("click", (event) => {
        event.preventDefault();

        const drawer = button.closest("header-drawer");
        const details = drawer?.querySelector("#Details-menu-drawer-container");
        const summary = details?.querySelector(".header__icon--menu");

        if (!drawer || !details || !summary) return;

        if (details.hasAttribute("open") && typeof drawer.closeMenuDrawer === "function") {
          drawer.closeMenuDrawer(event, summary);
          summary.setAttribute("aria-expanded", "false");
          window.setTimeout(() => forceMobileMenuClosed(drawer, details, summary), 460);
          return;
        }

        forceMobileMenuClosed(drawer, details, summary);
      });
    });
  };

  const initMobileMenuSearch = (root = document) => {
    root.querySelectorAll("[data-hcx-mobile-menu-search]").forEach((trigger) => {
      if (trigger.dataset.hcxMobileMenuSearchBound === "true") return;
      trigger.dataset.hcxMobileMenuSearchBound = "true";

      trigger.addEventListener("click", (event) => {
        const searchSummary =
          document.querySelector(".hcx-mobile-header-search .header__search details > summary") ||
          document.querySelector(".header > .header__icons .header__search details > summary") ||
          document.querySelector(".header__search details > summary");

        if (!searchSummary) return;

        event.preventDefault();

        const drawer = trigger.closest("header-drawer");
        const details = drawer?.querySelector("#Details-menu-drawer-container");
        const menuSummary = details?.querySelector(".header__icon--menu");

        const openSearch = () => {
          const searchDetails = searchSummary.closest("details");
          if (searchDetails?.hasAttribute("open")) return;
          searchSummary.click();
        };

        if (drawer && details?.hasAttribute("open") && menuSummary && typeof drawer.closeMenuDrawer === "function") {
          // Wait for the actual close, not a timer racing the frame-based animation.
          // The interaction guard blocks Search until the menu's open attribute clears.
          const afterClose = new MutationObserver(() => {
            if (details.hasAttribute("open")) return;
            afterClose.disconnect();
            openSearch();
          });
          afterClose.observe(details, { attributes: true, attributeFilter: ["open"] });
          drawer.closeMenuDrawer(event, menuSummary);
          menuSummary.setAttribute("aria-expanded", "false");
          if (!details.hasAttribute("open")) {
            afterClose.disconnect();
            openSearch();
          }
          return;
        }

        openSearch();
      });
    });
  };

  const initMobileMenuInteractionGuard = () => {
    if (html.dataset.hcxMobileMenuGuardBound === "true") return;
    html.dataset.hcxMobileMenuGuardBound = "true";

    const mobileMenuMedia = window.matchMedia("(max-width: 989px), (hover: none), (pointer: coarse)");
    const getOpenMenu = () => document.querySelector("#Details-menu-drawer-container[open]");
    const isMenuOwnedTarget = (target) => {
      if (!(target instanceof Element)) return false;

      return Boolean(
        target.closest(
          "#Details-menu-drawer-container, #menu-drawer, header-drawer, [data-hcx-saves-drawer], cart-drawer, .cart-drawer"
        )
      );
    };
    const blockClickThrough = (event) => {
      if (!mobileMenuMedia.matches || !getOpenMenu()) return;
      if (isMenuOwnedTarget(event.target)) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function") event.stopImmediatePropagation();
    };

    ["pointerdown", "pointerup", "touchstart", "touchend", "click"].forEach((eventName) => {
      document.addEventListener(eventName, blockClickThrough, { capture: true, passive: false });
    });
  };

  const getSavesForDisplay = () => {
    const dismissed = new Set(readDismissedSaves());
    const savedItems = readSaves()
      .filter((item) => item?.id && !dismissed.has(String(item.id)))
      .map((item) => ({ ...item, source: "saved" }));
    const savedIds = new Set(savedItems.map((item) => String(item.id)));
    const autoItems = readRecentlyViewed()
      .filter((item) => item?.id && !savedIds.has(String(item.id)) && !dismissed.has(String(item.id)))
      .filter((item) => Number(item.views || item.viewCount || 0) >= savesAutoViewThreshold)
      .map((item) => ({ ...item, source: "viewed", views: Number(item.views || item.viewCount || 0) }))
      .sort((a, b) => Number(b.lastViewedAt || 0) - Number(a.lastViewedAt || 0));

    return [...savedItems, ...autoItems].slice(0, savesLimit);
  };

  const removeSaveItem = (id) => {
    if (!id) return;
    writeSaves(readSaves().filter((item) => String(item.id) !== String(id)));
    writeDismissedSaves([...readDismissedSaves(), String(id)]);
  };

  let savesToastTimeout;

  const getSavesToast = () => {
    let toast = document.querySelector("[data-hcx-saves-toast]");
    if (toast) return toast;

    toast = document.createElement("div");
    toast.className = "hcx-saves-toast";
    toast.setAttribute("role", "status");
    toast.setAttribute("aria-live", "polite");
    toast.setAttribute("aria-atomic", "true");
    toast.dataset.hcxSavesToast = "";
    document.body.appendChild(toast);

    return toast;
  };

  const showSavesToast = (message) => {
    if (!document.body) return;

    const toast = getSavesToast();
    toast.textContent = message;
    toast.classList.add("is-active");

    window.clearTimeout(savesToastTimeout);
    savesToastTimeout = window.setTimeout(() => {
      toast.classList.remove("is-active");
    }, 2400);
  };

  const updateSavesScrollControls = () => {
    const list = document.querySelector("[data-hcx-saves-list]");
    const controls = document.querySelectorAll("[data-hcx-saves-scroll]");
    const canScroll = Boolean(list?.querySelector(".hcx-save-item")) && list.scrollWidth > list.clientWidth + 2;

    controls.forEach((control) => {
      control.hidden = !canScroll;
      if (!canScroll) {
        control.disabled = true;
        return;
      }

      const atStart = list.scrollLeft <= 2;
      const atEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
      control.disabled = control.dataset.hcxSavesScroll === "previous" ? atStart : atEnd;
    });
  };

  const setSavesDrawerOpen = (isOpen) => {
    const drawer = document.querySelector("[data-hcx-saves-drawer]");
    if (!drawer) return;

    drawer.hidden = !isOpen;
    html.classList.toggle("hcx-saves-open", isOpen);
    document.querySelectorAll("[data-hcx-saves-open]").forEach((button) => {
      button.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });

    if (isOpen) {
      renderSaves();
      drawer.querySelector("[data-hcx-saves-close]")?.focus({ preventScroll: true });
    }
  };

  const toggleProductSave = (saveButton) => {
    const payload = getSavePayload(saveButton);
    if (!payload.id) return;

    const items = readSaves();
    const displayItems = getSavesForDisplay();
    const active = isSaved(displayItems, payload.id);
    const nextItems = active
      ? items.filter((item) => String(item.id) !== String(payload.id))
      : [payload, ...items.filter((item) => String(item.id) !== String(payload.id))].slice(0, savesLimit);

    if (active) {
      writeDismissedSaves([...readDismissedSaves(), String(payload.id)]);
    } else {
      writeDismissedSaves(readDismissedSaves().filter((id) => String(id) !== String(payload.id)));
    }

    writeSaves(nextItems);
    renderSaves();
    showSavesToast(active ? "Removed from liked box" : "Added to your liked box");
  };

  const initSavesControls = (root = document) => {
    root.querySelectorAll("[data-hcx-save-product]").forEach((button) => {
      if (button.dataset.hcxSaveProductBound === "true") return;
      button.dataset.hcxSaveProductBound = "true";

      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        toggleProductSave(button);
      });
    });

    root.querySelectorAll("[data-hcx-saves-open]").forEach((button) => {
      if (button.dataset.hcxSavesOpenBound === "true") return;
      button.dataset.hcxSavesOpenBound = "true";

      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        setSavesDrawerOpen(true);
      });
    });

    root.querySelectorAll("[data-hcx-saves-close]").forEach((button) => {
      if (button.dataset.hcxSavesCloseBound === "true") return;
      button.dataset.hcxSavesCloseBound = "true";

      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        setSavesDrawerOpen(false);
      });
    });
  };

  function renderSaves() {
    const items = getSavesForDisplay();
    const list = document.querySelector("[data-hcx-saves-list]");
    const summary = document.querySelector("[data-hcx-saves-summary]");
    if (summary) summary.textContent = items.length === 1 ? "1 item" : `${items.length} items`;

    document.querySelectorAll("[data-hcx-saves-count]").forEach((count) => {
      const isHeaderCount = count.classList.contains("hcx-header-saves-link__count");
      count.textContent = isHeaderCount ? "" : items.length;
      count.hidden = isHeaderCount;
    });

    document.querySelectorAll("[data-hcx-save-product]").forEach((button) => {
      const payload = getSavePayload(button);
      const active = Boolean(payload.id) && isSaved(items, payload.id);
      button.classList.toggle("is-saved", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
      button.setAttribute("aria-label", `${active ? "Remove" : "Save"} ${payload.title}`);
    });

    if (!list) return;

    if (!items.length) {
      list.innerHTML = '<p class="hcx-saves-drawer__empty">Saved products will show here</p>';
      updateSavesScrollControls();
      return;
    }

    list.innerHTML = items
      .map(
        (item) => `
          <article class="hcx-save-item">
            <a href="${escapeHtml(item.url)}" class="hcx-save-item__media">
              ${
                item.image
                  ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy">`
                  : '<span aria-hidden="true"></span>'
              }
            </a>
            <div class="hcx-save-item__content">
              <a href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a>
              ${item.price ? `<span>${escapeHtml(item.price)}</span>` : ""}
              <em>${item.source === "viewed" ? `Viewed ${escapeHtml(item.views)} times` : "Saved"}</em>
            </div>
            <div class="hcx-save-item__actions">
              ${
                item.variantId
                  ? `<button class="hcx-save-item__add" type="button" data-hcx-save-add="${escapeHtml(item.variantId)}">Add to cart</button>`
                  : `<a class="hcx-save-item__add" href="${escapeHtml(item.url)}">View item</a>`
              }
              <button class="hcx-save-item__remove" type="button" data-hcx-save-remove="${escapeHtml(item.id)}">Remove</button>
            </div>
          </article>
        `
      )
      .join("");
    list.scrollLeft = 0;
    window.requestAnimationFrame(updateSavesScrollControls);
  }

  document.addEventListener("click", (event) => {
    const saveButton = event.target.closest("[data-hcx-save-product]");
    if (!saveButton) return;

    event.preventDefault();
    event.stopPropagation();
    toggleProductSave(saveButton);
  });

  document.addEventListener("click", (event) => {
    if (event.target.closest("[data-hcx-saves-open]")) {
      event.preventDefault();
      setSavesDrawerOpen(true);
      return;
    }

    if (event.target.closest("[data-hcx-saves-close]")) {
      event.preventDefault();
      setSavesDrawerOpen(false);
      return;
    }

    const scrollButton = event.target.closest("[data-hcx-saves-scroll]");
    if (scrollButton) {
      event.preventDefault();
      const list = document.querySelector("[data-hcx-saves-list]");
      if (!list) return;

      const direction = scrollButton.dataset.hcxSavesScroll === "previous" ? -1 : 1;
      list.scrollBy({ left: direction * list.clientWidth, behavior: "smooth" });
      window.setTimeout(updateSavesScrollControls, 420);
      return;
    }

    const addButton = event.target.closest("[data-hcx-save-add]");
    if (addButton) {
      event.preventDefault();
      const variantId = addButton.dataset.hcxSaveAdd;
      if (!variantId || addButton.dataset.hcxAdding === "true") return;

      addButton.dataset.hcxAdding = "true";
      const defaultText = addButton.textContent;
      addButton.textContent = "Adding";

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      })
        .then((response) => {
          if (!response.ok) throw new Error("Could not add item");
          addButton.textContent = "Added";
          document.dispatchEvent(new CustomEvent("hcx:cart-updated"));
        })
        .catch(() => {
          addButton.textContent = "Try again";
        })
        .finally(() => {
          window.setTimeout(() => {
            addButton.dataset.hcxAdding = "false";
            if (addButton.textContent !== "Adding") addButton.textContent = defaultText;
          }, 1400);
        });
      return;
    }

    const removeButton = event.target.closest("[data-hcx-save-remove]");
    if (removeButton) {
      const id = removeButton.dataset.hcxSaveRemove;
      removeSaveItem(id);
      renderSaves();
      showSavesToast("Removed from liked box");
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") setSavesDrawerOpen(false);
  });

  document.addEventListener(
    "scroll",
    (event) => {
      if (event.target?.matches?.("[data-hcx-saves-list]")) updateSavesScrollControls();
    },
    true
  );

  window.addEventListener("resize", updateSavesScrollControls);

  const hcxEscapeHtml = (value) =>
    String(value ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");

  const hcxHandleText = (value) =>
    String(value ?? "")
      .trim()
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "");

  const hcxClamp = (value, min, max) => Math.min(Math.max(value, min), max);

  const HCX_REVIEW_REGION_CODES =
    "AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW EU UN".split(
      " "
    );

  const normaliseHcxReviewCountryValue = (value) =>
    String(value ?? "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/&/g, " and ")
      .replace(/[^a-zA-Z0-9]+/g, "")
      .toUpperCase();

  let hcxReviewCountryDisplayNames;

  const getHcxReviewCountryDisplayNames = () => {
    if (hcxReviewCountryDisplayNames !== undefined) return hcxReviewCountryDisplayNames;

    try {
      hcxReviewCountryDisplayNames = typeof Intl !== "undefined" && Intl.DisplayNames ? new Intl.DisplayNames(["en"], { type: "region" }) : null;
    } catch (_error) {
      hcxReviewCountryDisplayNames = null;
    }

    return hcxReviewCountryDisplayNames;
  };

  const getHcxReviewCountryDisplayName = (countryCode) => {
    try {
      return getHcxReviewCountryDisplayNames()?.of(countryCode) || countryCode;
    } catch (_error) {
      return countryCode;
    }
  };

  let hcxReviewCountryLookup;

  const getHcxReviewCountryLookup = () => {
    if (hcxReviewCountryLookup) return hcxReviewCountryLookup;

    hcxReviewCountryLookup = {
      UK: "GB",
      GREATBRITAIN: "GB",
      BRITAIN: "GB",
      UNITEDKINGDOM: "GB",
      ENGLAND: "GB",
      SCOTLAND: "GB",
      WALES: "GB",
      NORTHERNIRELAND: "GB",
      UNITEDSTATES: "US",
      UNITEDSTATESOFAMERICA: "US",
      USA: "US",
      AMERICA: "US",
      UAE: "AE",
      CZECHREPUBLIC: "CZ",
      TURKIYE: "TR",
      TURKEY: "TR",
      SOUTHKOREA: "KR",
      KOREASOUTH: "KR",
      NORTHKOREA: "KP",
      KOREANORTH: "KP",
      RUSSIA: "RU",
      VIETNAM: "VN",
      KOSOVO: "XK",
      EUROPEANUNION: "EU",
      UNITEDNATIONS: "UN",
    };

    HCX_REVIEW_REGION_CODES.forEach((countryCode) => {
      hcxReviewCountryLookup[countryCode] = countryCode;
      hcxReviewCountryLookup[normaliseHcxReviewCountryValue(getHcxReviewCountryDisplayName(countryCode))] = countryCode;
    });

    return hcxReviewCountryLookup;
  };

  const hcxAverage = (values, fallback) => {
    const filtered = values.filter((value) => Number.isFinite(value));
    if (!filtered.length) return fallback;
    return Math.round(filtered.reduce((sum, value) => sum + value, 0) / filtered.length);
  };

  const formatHcxReviewDate = (value) => {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    return new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    }).format(date);
  };

  const formatHcxReviewName = (review) => {
    const firstName = review.firstName || review.first_name || "Customer";
    const lastName = review.lastName || review.last_name || "";
    const lastInitial = lastName.trim().charAt(0);
    return `${firstName}${lastInitial ? ` ${lastInitial}.` : ""}`;
  };

  const getHcxReviewCountryCode = (review) => {
    const countryValue = [
      review.countryCode,
      review.country_code,
      review.country,
      review.countryName,
      review.country_name,
      review.location,
    ].find((value) => String(value ?? "").trim());
    const countryKey = normaliseHcxReviewCountryValue(countryValue);

    if (!countryKey) return "GB";
    return getHcxReviewCountryLookup()[countryKey] || "";
  };

  const getHcxCountryFlagImageUrl = (countryCode) => {
    if (!/^[A-Z]{2}$/.test(countryCode)) return "";
    const codepoints = Array.from(countryCode)
      .map((letter) => 127397 + letter.charCodeAt(0))
      .map((codePoint) => codePoint.toString(16))
      .join("-");

    return `https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/${codepoints}.svg`;
  };

  const renderHcxReviewCountryFlag = (review) => {
    const countryCode = getHcxReviewCountryCode(review);
    if (!countryCode) return "";

    const flagUrl = getHcxCountryFlagImageUrl(countryCode);
    if (!flagUrl) return "";

    const countryLabel = getHcxReviewCountryDisplayName(countryCode);
    return `<span class="hcx-review-country-flag hcx-review-country-flag--image" role="img" aria-label="${hcxEscapeHtml(countryLabel)}" title="${hcxEscapeHtml(countryLabel)}"><img src="${hcxEscapeHtml(flagUrl)}" alt="" width="18" height="18" loading="lazy" decoding="async"></span>`;
  };


  const getHcxReviewSize = (review) => {
    const valueLooksLikeSize = (value) => /^(xxs|xs|s|m|l|xl|2xl|xxl|3xl|xxxl)$/i.test(String(value || "").trim());

    if (review.productVariants) {
      const variantSize = String(review.productVariants)
        .split("/")
        .map((part) => part.trim())
        .find(valueLooksLikeSize);
      if (variantSize) return variantSize.replace(/^2xl$/i, "XXL").replace(/^xxxl$/i, "3XL");
    }

    if (Array.isArray(review.variants)) {
      const optionSize = review.variants.find((variant) => /size/i.test(variant.option || "") && valueLooksLikeSize(variant.value));
      const looseSize = optionSize || review.variants.find((variant) => valueLooksLikeSize(variant.value));
      if (looseSize?.value) return String(looseSize.value).trim().replace(/^2xl$/i, "XXL").replace(/^xxxl$/i, "3XL");
    }

    return "";
  };

  const renderHcxReviewStars = (rating) => {
    const roundedRating = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
    return Array.from({ length: 5 }, (_, index) => `<span class="${index < roundedRating ? "is-filled" : ""}">&#9733;</span>`).join("");
  };

  const normaliseHcxReviewCopy = (value) =>
    String(value || "")
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/p>/gi, "\n")
      .replace(/<[^>]*>/g, " ")
      .replace(/[ \t]+/g, " ")
      .replace(/\n\s+/g, "\n")
      .trim();

  const getHcxReviewTextValue = (review) =>
    normaliseHcxReviewCopy(review?.content || review?.body || review?.reviewBody || review?.review_body || review?.description || "");

  const getHcxReviewNameValue = (review) => {
    const reviewer = review?.reviewer || {};
    return normaliseHcxReviewCopy(
      review?.name ||
        review?.reviewerName ||
        review?.reviewer_name ||
        reviewer.name ||
        [review?.firstName || review?.first_name, review?.lastName || review?.last_name].filter(Boolean).join(" ")
    );
  };

  const getHcxReviewIdentity = (review) => {
    const directId = review.id || review._id || review.reviewId || review.review_id || review.uuid;
    if (directId) {
      const source = String(review.source || review.provider || review.app || "").trim().toLowerCase();
      return `${source || "review"}:${directId}`;
    }

    return [review.createdAt || review.created_at, getHcxReviewNameValue(review), getHcxReviewTextValue(review)]
      .map((value) => String(value || "").trim().toLowerCase())
      .join("|");
  };

  const getHcxReviewContentIdentity = (review) =>
    [review.createdAt || review.created_at, getHcxReviewNameValue(review), getHcxReviewTextValue(review)]
      .map((value) => String(value || "").trim().toLowerCase())
      .join("|");

  const getHcxReviewLooseContentIdentity = (review) => {
    const content = getHcxReviewTextValue(review).replace(/\s+/g, " ").trim().toLowerCase();
    if (content.length < 36) return "";
    const name = hcxHandleText(getHcxReviewNameValue(review));
    return [name, Math.round(getHcxReviewRatingValue(review)), content].filter(Boolean).join("|");
  };

  const getHcxReviewDuplicateContentIdentity = (review) => {
    const content = getHcxReviewTextValue(review).replace(/\s+/g, " ").trim().toLowerCase();
    if (content.length < 36) return "";

    return [
      String(review.createdAt || review.created_at || "").slice(0, 10),
      hcxHandleText(getHcxReviewNameValue(review)),
      hcxHandleText(getHcxReviewProductTitleValue(review)),
      hcxHandleText(review.productVariants || review.product_variants || getHcxReviewSize(review)),
      Math.round(getHcxReviewRatingValue(review)),
      content,
    ]
      .filter(Boolean)
      .join("|");
  };

  const getHcxReviewProductTitleValue = (review) => {
    const product = review?.product || (Array.isArray(review?.products) ? review.products[0] : null) || {};
    return normaliseHcxReviewCopy(product.title || product.name || review?.productTitle || review?.product_title || "");
  };

  const dedupeHcxReviews = (reviews) => {
    const seen = new Set();
    const looseSeenBySource = new Map();
    return reviews.filter((review) => {
      const directId = review?.id || review?._id || review?.reviewId || review?.review_id || review?.uuid;
      const source = String(review?.source || review?.provider || review?.app || "air").trim().toLowerCase();
      const keys = [
        directId ? `id:${String(directId).trim().toLowerCase()}` : "",
        getHcxReviewIdentity(review),
        getHcxReviewContentIdentity(review),
        getHcxReviewDuplicateContentIdentity(review),
      ].filter(Boolean);
      const looseContentIdentity = getHcxReviewLooseContentIdentity(review);
      const looseSeenSource = looseContentIdentity ? looseSeenBySource.get(looseContentIdentity) : "";
      if (looseContentIdentity && looseSeenSource && looseSeenSource !== source) return false;
      if (!directId && looseContentIdentity) keys.push(`loose:${looseContentIdentity}`);
      if (!keys.length || keys.some((key) => seen.has(key))) return false;
      keys.forEach((key) => seen.add(key));
      if (looseContentIdentity && !looseSeenSource) looseSeenBySource.set(looseContentIdentity, source);
      return true;
    });
  };

  const getHcxReviewAverage = (reviews) => {
    const ratings = reviews.map(getHcxReviewRatingValue).filter((rating) => rating > 0);
    if (!ratings.length) return 0;
    return ratings.reduce((sum, rating) => sum + rating, 0) / ratings.length;
  };

  const getHcxReviewRatingValue = (review) => {
    const rawRating = review?.rate ?? review?.rating ?? review?.score ?? review?.reviewRating ?? review?.review_rating;
    const rating = Number(typeof rawRating === "object" ? rawRating?.value || rawRating?.rating || rawRating?.score : rawRating);
    return Number.isFinite(rating) && rating > 0 ? hcxClamp(rating, 0, 5) : 0;
  };

  // Exact records hidden by the store owner; preserve exclusions across feed refreshes and imports.
  const hcxSuppressedReviewIds = new Set([
    "P00bPxTcn0cXcq9h6mSj",
    "eab725cf-4347-4d39-b3ae-f63f96c73338",
    "f37381ce-2889-5bd0-b712-abd49bb4c96d",
    "EWtOVz5ElPp0aOD1n5Ke",
    "336e3229-5a67-5d9f-aab6-a3dbeb59ad18",
  ]);
  const hcxSuppressedReviewSignatures = new Map([
    ["ross", "feels like a smaller size than the large athlete zip up hoodie i got last year. the quality of material is good."],
    ["ross rippin", "feels like a smaller size than the large athlete zip up hoodie i got last year. the quality of material is good."],
    ["elio watson", "sent me the wrong colour shirt, shirts seem nice though"],
    ["alexnader", "i have been over a month. still havent got it. bs."],
    ["sam crick", "other products: athletics sport straight leg sweatpants - gray / xl 0.0 send review"],
  ]);
  const isHcxSuppressedReview = (review) => {
    const id = String(review?.id || review?._id || review?.reviewId || review?.review_id || review?.uuid || "").trim().replace(/^judgeme-/, "");
    if (hcxSuppressedReviewIds.has(id)) return true;
    const name = getHcxReviewNameValue(review).replace(/\s+/g, " ").trim().toLowerCase();
    const excludedCopy = hcxSuppressedReviewSignatures.get(name);
    if (!excludedCopy) return false;
    const copy = getHcxReviewTextValue(review).replace(/\s+/g, " ").trim().toLowerCase();
    return copy.endsWith(excludedCopy);
  };

  const isHcxDisplayableReview = (review) => {
    if (!review) return false;
    if (isHcxSuppressedReview(review)) return false;
    if (review.hidden === true || review.isHidden === true || review.deleted === true || review.isDeleted === true || review.spam === true) return false;
    if (review.published === false || review.isPublished === false || review.approved === false) return false;
    if (review.isProductExists === false) return false;
    if (!getHcxReviewTextValue(review)) return false;
    if (getHcxReviewRatingValue(review) <= 0) return false;

    const status = String(review.status || review.state || "").trim().toLowerCase();
    if (!status) return true;

    return ["approved", "published", "active", "visible"].includes(status);
  };

  const cleanHcxDisplayReviews = (reviews) =>
    dedupeHcxReviews(reviews).filter(isHcxDisplayableReview);

  const isHcxStoreDisplayableReview = (review) => {
    if (!review) return false;
    if (isHcxSuppressedReview(review)) return false;
    if (review.hidden === true || review.isHidden === true || review.deleted === true || review.isDeleted === true || review.spam === true) return false;
    if (review.published === false || review.isPublished === false || review.approved === false) return false;
    if (!getHcxReviewTextValue(review)) return false;
    if (getHcxReviewRatingValue(review) <= 0) return false;

    const status = String(review.status || review.state || "").trim().toLowerCase();
    if (!status) return true;

    return ["approved", "published", "active", "visible"].includes(status);
  };

  const cleanHcxStoreDisplayReviews = (reviews) =>
    dedupeHcxReviews(reviews).filter(isHcxStoreDisplayableReview);

  const getHcxReviewRatingBucket = (review) => {
    const rating = getHcxReviewRatingValue(review);
    return rating > 0 ? hcxClamp(Math.round(rating), 1, 5) : 0;
  };

  const isHcxPooledReviewFamily = (section) =>
    ["t-shirt", "hoodie", "zip-hoodie"].includes(String(section?.dataset?.hcxReviewFamilyKey || "").trim().toLowerCase());

  const updateHcxProductReviewSummary = (section, reviews) => {
    const count = isHcxPooledReviewFamily(section)
      ? Math.max(reviews.length, Number(section?.dataset?.hcxReviewCount) || 0)
      : reviews.length;
    const average = getHcxReviewAverage(reviews);
    const averageLabel = average ? average.toFixed(1) : "0.0";
    const countLabel = `${count} review${count === 1 ? "" : "s"}`;
    const productRatingCountLabel = `${count} Review${count === 1 ? "" : "s"}`;
    const stars = renderHcxReviewStars(average);

    section.hidden = count <= 0;
    section.dataset.hcxReviewAverage = averageLabel;
    section.dataset.hcxReviewCount = String(count);

    const averageDisplay = section.querySelector("[data-hcx-review-average-display]");
    const starsDisplay = section.querySelector("[data-hcx-review-stars]");
    const countDisplay = section.querySelector("[data-hcx-review-count-display]");

    if (averageDisplay) averageDisplay.textContent = averageLabel;
    if (starsDisplay) {
      starsDisplay.innerHTML = stars;
      starsDisplay.setAttribute("aria-label", `${averageLabel} out of 5 stars`);
    }
    if (countDisplay) countDisplay.textContent = `Based on ${countLabel}`;

    document.querySelectorAll("[data-hcx-product-rating-summary]").forEach((rating) => {
      const title = rating.closest(".product__title");
      rating.hidden = count <= 0;
      rating.setAttribute("aria-label", `${averageLabel} out of 5 stars from ${countLabel}`);
      title?.classList.toggle("hcx-product-title--has-rating", count > 0);

      const ratingStars = rating.querySelector("[data-hcx-product-rating-stars]");
      const ratingCount = rating.querySelector("[data-hcx-product-rating-count]");
      if (ratingStars) ratingStars.innerHTML = stars;
      if (ratingCount) ratingCount.textContent = productRatingCountLabel;
    });
  };

  const setHcxButtonLeadingText = (button, text) => {
    if (!button) return;
    const textNode = [...button.childNodes].find((node) => node.nodeType === Node.TEXT_NODE);
    if (textNode) {
      textNode.nodeValue = text;
      return;
    }
    button.prepend(document.createTextNode(text));
  };

  const setProductReviewMetric = (section, button) => {
    if (!section || !button) return;

    const buttons = [...section.querySelectorAll("[data-hcx-review-metric]")];
    const marker = section.querySelector("[data-hcx-review-range-marker]");
    const leftLabel = section.querySelector("[data-hcx-review-range-left]");
    const centerLabel = section.querySelector("[data-hcx-review-range-center]");
    const rightLabel = section.querySelector("[data-hcx-review-range-right]");
    const note = section.querySelector("[data-hcx-review-metric-note]");

    buttons.forEach((item) => {
      const isActive = item === button;
      item.classList.toggle("is-active", isActive);
      item.style.borderRadius = "0";
      item.style.border = `1px solid ${isActive ? "#050505" : "#cfcfcf"}`;
      item.style.backgroundColor = isActive ? "#050505" : "#fff";
      item.style.color = isActive ? "#fff" : "#050505";
      item.style.minHeight = "39px";
    });
    if (marker) marker.style.left = `${button.dataset.position || 50}%`;
    if (leftLabel) leftLabel.textContent = button.dataset.left || leftLabel.textContent;
    if (centerLabel) centerLabel.textContent = button.dataset.center || centerLabel.textContent;
    if (rightLabel) rightLabel.textContent = button.dataset.right || rightLabel.textContent;
    if (note) note.textContent = button.dataset.note || "";
  };

  const analyseHcxProductReviews = (reviews, averageRating) => {
    const metrics = {
      length: { scores: [], note: "No length pattern has appeared yet.", phrases: new Set() },
      value: { scores: [], note: "Value is inferred from rating and repeat-purchase language.", phrases: new Set() },
      sizing: { scores: [], note: "No sizing pattern has appeared yet.", phrases: new Set() },
      quality: { scores: [], note: "Quality is inferred from review language.", phrases: new Set() },
      "quality-of-product": { scores: [], note: "Quality is inferred from review language.", phrases: new Set() },
      comfort: { scores: [], note: "Comfort is inferred from review language.", phrases: new Set() },
    };

    const evidence = {
      fit: 0,
      quality: 0,
      comfort: 0,
      value: 0,
    };

    const addScore = (key, score, phrase) => {
      if (!metrics[key]) return;
      metrics[key].scores.push(score);
      if (phrase) metrics[key].phrases.add(phrase);
    };

    reviews.forEach((review) => {
      const copy = `${review.content || ""} ${review.productVariants || ""}`.toLowerCase();

      if (/too short|not long enough|short in the leg|short length/.test(copy)) {
        addScore("length", 24, "too short");
        evidence.fit += 1;
      } else if (/too long|length is long|dragging/.test(copy)) {
        addScore("length", 78, "too long");
        evidence.fit += 1;
      } else if (/long enough|just right|fit(?:s|ting)? (?:perfect|perfectly|well)|fits? really well|good fit|great fit|sits perfectly|perfect fit/.test(copy)) {
        addScore("length", 52, "spot on");
        evidence.fit += 1;
      } else if (/oversized|baggy|spacious|roomy/.test(copy)) {
        addScore("length", 58, "roomy");
        evidence.fit += 1;
      }

      if (/runs small|too small|tight|size up/.test(copy)) {
        addScore("sizing", 28, "runs small");
        evidence.fit += 1;
      } else if (/runs large|too big|too large|size down/.test(copy)) {
        addScore("sizing", 74, "runs large");
        evidence.fit += 1;
      } else if (/true to size|just right|fit(?:s|ting)? (?:perfect|perfectly|well)|fits? really well|good fit|great fit|sits perfectly|perfect fit/.test(copy)) {
        addScore("sizing", 52, "true to size");
        evidence.fit += 1;
      } else if (/oversized|baggy|spacious|roomy/.test(copy)) {
        addScore("sizing", 60, "relaxed");
        evidence.fit += 1;
      }

      if (/quality|durable|material|thick|heavy|fluffy|fleece|second to none|holds? well|top tier|premium/.test(copy)) {
        addScore("quality", 90, "quality");
        addScore("quality-of-product", 90, "quality");
        evidence.quality += 1;
      }

      if (/(?:bad|poor|thin|faulty|ripped|faded) (?:quality|material)|quality (?:is )?(?:bad|poor)/.test(copy)) {
        addScore("quality", 25, "quality concern");
        addScore("quality-of-product", 25, "quality concern");
      }

      if (/comfy|comfortable|comfort|soft|fluffy|warm|stretch|easy to workout|winter training/.test(copy)) {
        addScore("comfort", 88, "comfort");
        evidence.comfort += 1;
      }

      if (/would purchase|purchase again|buy again|only brand|recommend|best|favourite|favorite|worth|rate them/.test(copy)) {
        addScore("value", 86, "value");
        evidence.value += 1;
      }

      if (/overpriced|expensive|not worth/.test(copy) && !/other brands? (?:that are )?overpriced/.test(copy)) {
        addScore("value", 28, "value concern");
      }
    });

    const ratingFallback = hcxClamp(50 + ((Number(averageRating) || 0) - 3) * 18, 45, 92);
    const result = {
      length: {
        position: hcxAverage(metrics.length.scores, evidence.fit ? 52 : 50),
        left: "Too short",
        center: "Spot on",
        right: "Too long",
      },
      value: {
        position: hcxAverage(metrics.value.scores, ratingFallback),
        left: "Poor value",
        center: "Worth it",
        right: "Premium value",
      },
      sizing: {
        position: hcxAverage(metrics.sizing.scores, evidence.fit ? 52 : 50),
        left: "Runs small",
        center: "True to size",
        right: "Runs large",
      },
      quality: {
        position: hcxAverage(metrics.quality.scores, ratingFallback),
        left: "Low",
        center: "Strong",
        right: "Elite",
      },
      "quality-of-product": {
        position: hcxAverage(metrics["quality-of-product"].scores, ratingFallback),
        left: "Low",
        center: "Strong",
        right: "Elite",
      },
      comfort: {
        position: hcxAverage(metrics.comfort.scores, ratingFallback),
        left: "Firm",
        center: "Comfortable",
        right: "Cloud soft",
      },
    };

    Object.keys(result).forEach((key) => {
      const metric = result[key];
      const position = metric.position;

      if (key === "length") {
        metric.note = position < 42 ? "Reviews lean shorter than expected." : position > 62 ? "Reviews lean roomy or longer." : "Review wording points to a spot-on length.";
      } else if (key === "sizing") {
        metric.note = position < 42 ? "Reviews suggest sizing runs small." : position > 62 ? "Reviews suggest a relaxed, roomier fit." : "Reviews point to true-to-size sizing.";
      } else if (key === "quality" || key === "quality-of-product") {
        metric.note = position >= 76 ? "Quality is the strongest repeated theme in the reviews." : "Quality sentiment is mixed or still developing.";
      } else if (key === "comfort") {
        metric.note = position >= 76 ? "Comfort language is strongly positive." : "Comfort sentiment is still developing.";
      } else if (key === "value") {
        metric.note = position >= 76 ? "Customers signal strong value through repeat-purchase and recommendation language." : "Value sentiment is still developing.";
      }
    });

    const themes = [];
    if (evidence.quality) themes.push("quality/material");
    if (evidence.fit) themes.push("fit");
    if (evidence.comfort) themes.push("comfort");
    if (evidence.value) themes.push("value");

    return {
      metrics: result,
      summary: `Review readout: ${reviews.length} review${reviews.length === 1 ? "" : "s"} trend ${Number(averageRating) >= 4.5 ? "very positive" : "mixed"}${themes.length ? `, with strongest mentions around ${themes.join(", ")}.` : "."}`,
    };
  };

  const updateHcxReviewSnapshot = (section, reviews) => {
    const counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    let ratedCount = 0;

    reviews.forEach((review) => {
      const rating = getHcxReviewRatingBucket(review);
      if (!rating) return;
      counts[rating] += 1;
      ratedCount += 1;
    });

    const total = ratedCount || 1;
    Object.keys(counts).forEach((rating) => {
      const row = section.querySelector(`[data-hcx-review-snapshot="${rating}"]`);
      if (!row) return;
      const bar = row.querySelector("i");
      const count = row.querySelector("b");
      const width = Math.round((counts[rating] / total) * 100);
      row.style.display = counts[rating] > 0 ? "" : "none";
      if (bar) bar.style.width = `${width}%`;
      if (count) count.textContent = counts[rating];
    });
  };

  const renderHcxProductReviewList = (section) => {
    const state = section._hcxReviewState;
    const list = section.querySelector("[data-hcx-review-list]");
    if (!state || !list) return;

    const search = section.querySelector("[data-hcx-review-search]");
    const query = (search?.value || "").trim().toLowerCase();
    let reviews = [...state.reviews];

    if (query) {
      reviews = reviews.filter((review) => {
        const haystack = [
          review.content,
          review.firstName,
          review.lastName,
          review.productVariants,
          getHcxReviewSize(review),
        ]
          .filter(Boolean)
          .join(" ")
          .toLowerCase();
        return haystack.includes(query);
      });
    }

    if (state.ratingFilter) {
      reviews = reviews.filter((review) => getHcxReviewRatingValue(review) >= state.ratingFilter);
    }

    if (state.sort === "highest") {
      reviews.sort((a, b) => getHcxReviewRatingValue(b) - getHcxReviewRatingValue(a));
    } else if (state.sort === "lowest") {
      reviews.sort((a, b) => getHcxReviewRatingValue(a) - getHcxReviewRatingValue(b));
    } else {
      reviews.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
    }

    if (!reviews.length) {
      list.innerHTML = '<p class="hcx-product-reviews__empty">No reviews match that search.</p>';
      return;
    }

    list.innerHTML = reviews
      .map((review) => {
        const rating = getHcxReviewRatingValue(review);
        const date = formatHcxReviewDate(review.createdAt);
        const size = getHcxReviewSize(review);
        const countryFlag = renderHcxReviewCountryFlag(review);

        return `
          <article class="hcx-product-review-card">
            <div class="hcx-product-review-card__customer">
              <h3>${countryFlag}${hcxEscapeHtml(formatHcxReviewName(review))}</h3>
              ${review.verifyBuyer ? '<p class="hcx-product-review-card__verified">Verified Buyer</p>' : ""}
              <div class="hcx-product-review-card__stars" aria-label="${rating} out of 5 stars">${renderHcxReviewStars(rating)}</div>
            </div>
            <div class="hcx-product-review-card__body">
              <p>${hcxEscapeHtml(review.content || "").replace(/\n/g, "<br>")}</p>
              ${size ? `<span>Size ${hcxEscapeHtml(size)}</span>` : ""}
            </div>
            <div class="hcx-product-review-card__side">
              ${date ? `<time datetime="${hcxEscapeHtml(review.createdAt)}">${hcxEscapeHtml(date)}</time>` : ""}
            </div>
          </article>
        `;
      })
      .join("");

    normaliseStoreTextCase(list);
  };

  const applyHcxReviewIntelligence = (section, reviews) => {
    const analysis = analyseHcxProductReviews(reviews, section.dataset.hcxReviewAverage);
    const aiBlock = section.querySelector("[data-hcx-review-ai]");
    const aiSummary = section.querySelector("[data-hcx-review-ai-summary]");

    if (aiBlock && aiSummary) {
      aiSummary.textContent = analysis.summary;
      aiBlock.hidden = false;
    }

    section.querySelectorAll("[data-hcx-review-metric]").forEach((button) => {
      const key = button.dataset.hcxReviewMetricKey || hcxHandleText(button.textContent);
      const metric = analysis.metrics[key] || analysis.metrics[key.replace(/-of-product$/, "")];
      if (!metric) return;
      button.dataset.position = metric.position;
      button.dataset.left = metric.left;
      button.dataset.center = metric.center;
      button.dataset.right = metric.right;
      button.dataset.note = metric.note;
    });

    setProductReviewMetric(section, section.querySelector("[data-hcx-review-metric].is-active") || section.querySelector("[data-hcx-review-metric]"));
  };

  const isHcxJudgeMeApprovedReview = (review) => {
    if (!review) return false;
    if (
      review.hidden === true ||
      review.isHidden === true ||
      review.deleted === true ||
      review.isDeleted === true ||
      review.spam === true ||
      review.published === false ||
      review.isPublished === false ||
      review.approved === false
    ) {
      return false;
    }

    if (review.published === true || review.isPublished === true || review.approved === true) return true;

    const status = String(review.status || review.state || review.moderation_status || review.moderationStatus || "")
      .trim()
      .toLowerCase();
    return ["approved", "published"].includes(status);
  };

  const normalizeHcxJudgeMeReview = (review) => {
    const rating = getHcxReviewRatingValue(review);
    const content = getHcxReviewTextValue(review);
    if (rating <= 0 || !content) return null;
    if (!isHcxJudgeMeApprovedReview(review)) return null;

    const reviewer = review.reviewer || {};
    const name = getHcxReviewNameValue(review) || normaliseHcxReviewCopy(reviewer.name) || "Customer";
    const title = normaliseHcxReviewCopy(review.title || review.reviewTitle || review.review_title || review.subject || "");
    const createdAt = review.createdAt || review.created_at || review.date || review.review_date || review.created || "";
    const verifiedValue = `${review.verified || review.verified_buyer || review.buyer_badge || review.badge || review.review_badge || ""}`.toLowerCase();
    const directId = review.id || review._id || review.reviewId || review.review_id || review.uuid || "";

    return {
      ...review,
      id: directId ? `judgeme-${directId}` : `judgeme-${hcxHandleText(`${createdAt}-${name}-${content}`).slice(0, 160)}`,
      source: "judgeme",
      rate: rating,
      title,
      content,
      firstName: name,
      lastName: "",
      createdAt,
      verifyBuyer: review.verified === true || review.verified_buyer === true || /verified|buyer/.test(verifiedValue),
      productVariants: normaliseHcxReviewCopy(review.productVariants || review.product_title || review.product?.title || ""),
    };
  };

  const parseHcxJudgeMeWidgetReviews = (html) => {
    const markup = String(html || "").trim();
    if (!markup || typeof DOMParser === "undefined") return [];

    const doc = new DOMParser().parseFromString(markup, "text/html");
    return [...doc.querySelectorAll(".jdgm-rev")]
      .map((node) => {
        const ratingNode = node.querySelector(".jdgm-rev__rating, [data-score]");
        const titleNode = node.querySelector(".jdgm-rev__title");
        const bodyNode = node.querySelector(".jdgm-rev__body, .jdgm-rev__content");
        const authorNode = node.querySelector(".jdgm-rev__author");
        const dateNode = node.querySelector(".jdgm-rev__timestamp, time");
        const productNode = node.querySelector(".jdgm-rev__prod-link, .jdgm-rev__product-title");
        const verifiedNode = node.querySelector(".jdgm-rev__buyer-badge, .jdgm-rev__verified-buyer-badge, .jdgm-rev__verified");
        const verifiedAttribute = String(node.getAttribute("data-verified-buyer") || "").toLowerCase();
        const productTitle = productNode?.textContent || node.getAttribute("data-product-title") || "";
        const productLink = productNode?.getAttribute("href") || node.getAttribute("data-product-url") || "";

        return normalizeHcxJudgeMeReview({
          id: node.getAttribute("data-review-id") || node.id || "",
          rating: ratingNode?.getAttribute("data-score") || node.getAttribute("data-rating") || node.getAttribute("data-score") || "",
          title: titleNode?.textContent || "",
          body: bodyNode?.innerHTML || bodyNode?.textContent || "",
          name: authorNode?.textContent || "",
          createdAt: dateNode?.getAttribute("datetime") || dateNode?.getAttribute("data-content") || dateNode?.textContent || "",
          verified: verifiedAttribute === "true" || Boolean(verifiedNode),
          product_title: productTitle,
          product: {
            title: productTitle,
            productLink,
          },
          approved: true,
          published: true,
          status: "published",
        });
      })
      .filter(Boolean);
  };

  const extractHcxJudgeMeReviews = (payload) => {
    const directReviews =
      payload?.reviews ||
      payload?.data?.reviews ||
      payload?.review_widget?.reviews ||
      payload?.product?.reviews ||
      payload?.data?.product?.reviews;
    if (Array.isArray(directReviews)) {
      return directReviews.map(normalizeHcxJudgeMeReview).filter(Boolean);
    }

    const html = payload?.widget || payload?.html || payload?.data?.widget || payload?.data?.html || payload?.review_widget || "";
    return parseHcxJudgeMeWidgetReviews(html);
  };

  const fetchHcxJudgeMeReviewsForProduct = (section, productId) => {
    const shopDomain = String(section.dataset.hcxJudgemeShopDomain || "").trim();
    const apiToken = String(section.dataset.hcxJudgemePublicToken || "").trim();
    const productHandle = String(section.dataset.hcxProductHandle || "").trim();
    const primaryProductId = String(section.dataset.hcxReviewProductId || "").trim();
    if (!shopDomain || !apiToken || !productId) return Promise.resolve([]);

    const fetchWidget = (params) => {
      const endpoint = new URL("https://judge.me/api/v1/widgets/product_review");
      endpoint.searchParams.set("shop_domain", shopDomain);
      endpoint.searchParams.set("api_token", apiToken);
      endpoint.searchParams.set("page", "1");
      Object.entries(params).forEach(([key, value]) => {
        if (value) endpoint.searchParams.set(key, value);
      });

      return fetch(endpoint.toString(), { headers: { Accept: "application/json" } }).then((response) => {
        if (!response.ok) throw new Error("Could not load Judge.me reviews");
        return response.json();
      });
    };

    return fetchWidget({ external_id: productId })
      .then((payload) => {
        const reviews = extractHcxJudgeMeReviews(payload);
        if (reviews.length || !productHandle || String(productId) !== primaryProductId) return reviews;
        return fetchWidget({ handle: productHandle }).then(extractHcxJudgeMeReviews);
      })
      .catch(() => []);
  };

  const loadHcxProductReviews = (section) => {
    if (!section || section.dataset.hcxReviewFeedBound === "true") return;

    const list = section.querySelector("[data-hcx-review-list]");
    const shopId = section.dataset.hcxReviewShopId;
    const productIds = String(section.dataset.hcxReviewProductIds || section.dataset.hcxReviewProductId || "")
      .split(",")
      .map((id) => id.trim())
      .filter(Boolean)
      .filter((id, index, ids) => ids.indexOf(id) === index);
    const hasJudgeMeFeed = Boolean(section.dataset.hcxJudgemeShopDomain && section.dataset.hcxJudgemePublicToken);
    if (!list || (!shopId && !hasJudgeMeFeed) || !productIds.length) return;

    const judgeMeProductIds = section.dataset.hcxJudgemeProductIds
      ? section.dataset.hcxJudgemeProductIds.split(",").map((id) => id.trim()).filter(Boolean)
      : productIds;

    section.dataset.hcxReviewFeedBound = "true";

    const limitPerProduct = "100";
    let hadFailure = false;

    const fetchReviewsForProduct = (productId) => {
      if (!shopId) return Promise.resolve([]);

      const endpoint = new URL("https://app.airreviews.io/review/loadReviews");
      endpoint.searchParams.set("shopId", shopId);
      endpoint.searchParams.set("productId", productId);
      endpoint.searchParams.set("limitPerPage", limitPerProduct);
      endpoint.searchParams.set("sort", "recent");

      return fetch(endpoint.toString(), { headers: { Accept: "application/json" } })
        .then((response) => {
          if (!response.ok) throw new Error("Could not load reviews");
          return response.json();
        })
        .then((payload) => (Array.isArray(payload?.data?.reviews) ? payload.data.reviews : []))
        .catch(() => {
          hadFailure = true;
          return [];
        });
    };

    Promise.all([Promise.all(productIds.map(fetchReviewsForProduct)), Promise.all(judgeMeProductIds.map((productId) => fetchHcxJudgeMeReviewsForProduct(section, productId)))])
      .then(([reviewGroups, judgeMeReviewGroups]) => {
        const search = section.querySelector("[data-hcx-review-search]");
        if (search) search.value = "";

        const reviews = cleanHcxDisplayReviews([...reviewGroups.flat(), ...judgeMeReviewGroups.flat()]);
        if (!reviews.length) {
          section.hidden = false;
          section.classList.add("hcx-product-reviews--empty");
          list.innerHTML = hadFailure ? '<p class="hcx-product-reviews__empty">Reviews are temporarily unavailable.</p>' : '<p class="hcx-product-reviews__empty">No reviews yet.</p>';
          if (window.location.hash === "#reviews") {
            window.requestAnimationFrame(() => scrollHcxProductReviewsIntoView("auto"));
          }
          return;
        }

        section.classList.remove("hcx-product-reviews--empty");
        const sortControl = section.querySelector("[data-hcx-review-sort]");
        const ratingControl = section.querySelector("[data-hcx-review-filter='rating']");

        section._hcxReviewState = {
          reviews,
          sort: sortControl?.matches?.("select") ? sortControl.value || "recent" : "recent",
          ratingFilter: ratingControl?.matches?.("select") ? Number(ratingControl.value) || 0 : 0,
        };

        updateHcxProductReviewSummary(section, reviews);
        updateHcxReviewSnapshot(section, reviews);
        applyHcxReviewIntelligence(section, reviews);
        renderHcxProductReviewList(section);

        if (window.location.hash === "#reviews") {
          window.requestAnimationFrame(() => scrollHcxProductReviewsIntoView("auto"));
        }
      })
      .catch(() => {
        list.innerHTML = '<p class="hcx-product-reviews__empty">Reviews are temporarily unavailable.</p>';
      });
  };

  const scrollHcxProductReviewsIntoView = (behavior = "smooth") => {
    const section = document.getElementById("reviews") || document.querySelector("[data-hcx-product-reviews]");
    if (!(section instanceof HTMLElement)) return false;

    section.hidden = false;

    const header = document.querySelector(".shopify-section-header-sticky, sticky-header, .header-wrapper");
    const headerRect = header?.getBoundingClientRect?.();
    const headerOffset = headerRect && headerRect.top <= 1 ? headerRect.height : 0;
    const targetTop = section.getBoundingClientRect().top + window.pageYOffset - headerOffset - 16;

    window.scrollTo({
      top: Math.max(0, targetTop),
      behavior,
    });

    window.setTimeout(() => {
      if (!section.hasAttribute("tabindex")) section.setAttribute("tabindex", "-1");
      section.focus({ preventScroll: true });
    }, behavior === "smooth" ? 260 : 0);

    return true;
  };

  const initProductReviewAnchorScroll = () => {
    if (html.dataset.hcxProductReviewAnchorBound === "true") return;
    html.dataset.hcxProductReviewAnchorBound = "true";

    document.addEventListener("click", (event) => {
      const trigger = event.target?.closest?.("[data-hcx-product-rating-summary]");
      if (!(trigger instanceof HTMLAnchorElement)) return;
      if (!document.querySelector("[data-hcx-product-reviews], #reviews")) return;

      event.preventDefault();

      if (window.history?.pushState) {
        window.history.pushState(null, "", `${window.location.pathname}${window.location.search}#reviews`);
      } else {
        window.location.hash = "reviews";
      }

      window.requestAnimationFrame(() => scrollHcxProductReviewsIntoView("smooth"));
    });

    if (window.location.hash === "#reviews") {
      window.requestAnimationFrame(() => scrollHcxProductReviewsIntoView("auto"));
    }
  };

  const normalizeHcxReviewProductTitle = (title) => {
    const value = String(title || "").trim();
    const key = value.toLowerCase().replace(/\s+/g, " ");
    if (key === "training t-shirt" || key === "training t shirt" || key === "training tee") {
      return "LCKD IN Training T-shirt";
    }
    return value;
  };

  const normalizeHcxReviewProductImage = (value) => {
    const rawValue =
      typeof value === "string"
        ? value
        : value?.url || value?.src || value?.originalSrc || value?.original_src || "";
    if (!rawValue) return "";

    try {
      const imageUrl = new URL(rawValue, window.location.origin);
      if (!["http:", "https:"].includes(imageUrl.protocol)) return "";
      if (imageUrl.hostname === "cdn.shopify.com" && !imageUrl.searchParams.has("width")) {
        imageUrl.searchParams.set("width", "240");
      }
      return imageUrl.toString();
    } catch (error) {
      return "";
    }
  };

  const hcxReviewFlatLayProductCache = new Map();

  const getHcxReviewVariantColour = (review) => {
    const variantText =
      review?.productVariants ||
      review?.product_variants ||
      (Array.isArray(review?.variants) ? review.variants.map((variant) => variant?.value || variant).join(" ") : "");
    const match = String(variantText || "")
      .toLowerCase()
      .replace(/\bgray\b/g, "grey")
      .match(/\b(light grey|dark grey|black|white|grey|red|blue|green|coffee|apricot)\b/);
    return match?.[1] || "";
  };

  const getHcxReviewFlatLayImage = (product, variantColour = "") => {
    const media = Array.isArray(product?.media) ? product.media : [];
    const candidates = media
      .filter((item) => !item?.media_type || item.media_type === "image")
      .map((item, index) => {
        const image = normalizeHcxReviewProductImage(
          item?.src || item?.originalSrc || item?.original_src || item?.preview_image?.src || item?.previewImage?.src
        );
        const description = `${item?.alt || ""} ${image}`.toLowerCase().replace(/\bgray\b/g, "grey");
        if (!image || /\b(model|lifestyle|lookbook|on[\s_-]?body|worn|gym[\s_-]?model)\b/.test(description)) return null;

        let score = 0;
        if (/\bflat[\s_-]?lay\b/.test(description)) score += 100;
        if (variantColour && description.includes(variantColour)) score += 40;
        if (/\bfront\b/.test(description)) score += 10;
        if (/\bback\b/.test(description)) score += 5;
        score -= index;

        return { image, score };
      })
      .filter(Boolean)
      .sort((a, b) => b.score - a.score);

    return candidates[0]?.image || "";
  };

  const fetchHcxReviewFlatLayProduct = (handle) => {
    const productHandle = String(handle || "").trim();
    if (!productHandle) return Promise.resolve({ resolved: false, product: null });
    if (hcxReviewFlatLayProductCache.has(productHandle)) return hcxReviewFlatLayProductCache.get(productHandle);

    const request = fetch(`/products/${encodeURIComponent(productHandle)}.js`, {
      headers: { Accept: "application/json" },
    })
      .then((response) => {
        if (!response.ok) return { resolved: false, product: null };
        return response.json().then((product) => ({ resolved: true, product }));
      })
      .catch(() => ({ resolved: false, product: null }));

    hcxReviewFlatLayProductCache.set(productHandle, request);
    return request;
  };

  const hydrateHcxReviewFlatLayImages = (section, reviews) => {
    const reviewsByHandle = new Map();

    reviews.forEach((review) => {
      if (review?.isProductExists === false) return;
      const product = review?.product || (Array.isArray(review?.products) ? review.products[0] : null) || {};
      const handle = String(product.handle || "").trim();
      if (!handle) return;
      if (!reviewsByHandle.has(handle)) reviewsByHandle.set(handle, []);
      reviewsByHandle.get(handle).push(review);
    });

    return Promise.all(
      [...reviewsByHandle.entries()].map(([handle, matchingReviews]) =>
        fetchHcxReviewFlatLayProduct(handle).then((result) => {
          if (!result.resolved) return;
          matchingReviews.forEach((review) => {
            review._hcxFlatLayImageResolved = true;
            review._hcxFlatLayImage = getHcxReviewFlatLayImage(result.product, getHcxReviewVariantColour(review));
          });
        })
      )
    ).then(() => {
      if (section?._hcxStoreReviewState) renderHcxStoreReviewList(section);
    });
  };

  const getHcxReviewProduct = (review) => {
    const product = review.product || (Array.isArray(review.products) ? review.products[0] : null) || {};
    const rawUrl = product.productLink || product.url || review.productLink || "";
    const rawImage = review._hcxFlatLayImageResolved
      ? review._hcxFlatLayImage
      : product.image ||
        product.featuredImage ||
        product.featured_image ||
        (Array.isArray(product.images) ? product.images[0] : null) ||
        review.productImage ||
        review.product_image ||
        "";
    let url = "";

    if (rawUrl) {
      try {
        const parsedUrl = new URL(rawUrl, window.location.origin);
        url = parsedUrl.pathname.startsWith("/products/") ? `${parsedUrl.pathname}${parsedUrl.search}` : rawUrl;
      } catch (error) {
        url = rawUrl.startsWith("/products/") ? rawUrl : "";
      }
    }

    if (!url && product.handle) url = `/products/${product.handle}`;

    return {
      title: normalizeHcxReviewProductTitle(product.title || review.productTitle || review.product_title || ""),
      url,
      image: normalizeHcxReviewProductImage(rawImage),
    };
  };

  const getHcxReviewTitle = (review) => {
    const title = String(review.title || review.reviewTitle || review.review_title || review.subject || "").trim();
    const content = String(review.content || "").trim();
    if (!title || title.toLowerCase() === content.toLowerCase()) return "";
    return title;
  };

  const cleanHcxReviewText = (value) => {
    let text = String(value || "");
    const otherProductsIndex = text.toLowerCase().indexOf("<h3>other products:");
    if (otherProductsIndex >= 0) text = text.slice(0, otherProductsIndex);

    return text
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/p>/gi, "\n")
      .replace(/<[^>]*>/g, " ")
      .replace(/[ \t]+/g, " ")
      .replace(/\n\s+/g, "\n")
      .trim();
  };

  const getHcxReviewCreatedTime = (review) => {
    const timestamp = new Date(review.createdAt || review.created_at || review.updatedAt || review.updated_at || 0).getTime();
    return Number.isFinite(timestamp) ? timestamp : 0;
  };

  const updateHcxStoreReviewSummary = (section, reviews) => {
    const count = reviews.length;
    const average = getHcxReviewAverage(reviews);
    const averageLabel = average ? average.toFixed(1) : "0.0";
    const countLabel = `${count} live review${count === 1 ? "" : "s"}`;
    const stars = renderHcxReviewStars(average);
    const breakdown = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    let ratedCount = 0;

    reviews.forEach((review) => {
      const rating = getHcxReviewRatingBucket(review);
      if (!rating) return;
      breakdown[rating] += 1;
      ratedCount += 1;
    });

    section.dataset.hcxReviewAverage = averageLabel;
    section.dataset.hcxReviewCount = String(count);
    section.dataset.hcxReviewRatedCount = String(ratedCount);

    const averageDisplay = section.querySelector("[data-hcx-all-review-average]");
    const starsDisplay = section.querySelector("[data-hcx-all-review-stars]");
    const countDisplay = section.querySelector("[data-hcx-all-review-count]");
    const tabCountDisplay = section.querySelector("[data-hcx-all-review-tab-count]");
    const breakdownRows = section.querySelectorAll("[data-hcx-all-review-breakdown-row]");

    if (averageDisplay) averageDisplay.textContent = averageLabel;
    if (starsDisplay) {
      starsDisplay.innerHTML = stars;
      starsDisplay.hidden = false;
      starsDisplay.setAttribute("aria-label", `${averageLabel} out of 5 stars`);
      starsDisplay.removeAttribute("aria-hidden");
    }
    if (countDisplay) countDisplay.textContent = count ? `Based on ${countLabel}` : "No live reviews yet";
    if (tabCountDisplay) tabCountDisplay.textContent = String(count);

    breakdownRows.forEach((row) => {
      const rating = Number(row.dataset.hcxAllReviewBreakdownRow) || 0;
      const ratingCount = breakdown[rating] || 0;
      const bar = row.querySelector("[data-hcx-all-review-bar]");
      const rowCount = row.querySelector("[data-hcx-all-review-row-count]");

      row.setAttribute("aria-label", `${rating} star${rating === 1 ? "" : "s"}: ${ratingCount} review${ratingCount === 1 ? "" : "s"}`);
      if (bar) bar.style.setProperty("--hcx-review-bar-width", `${ratedCount ? (ratingCount / ratedCount) * 100 : 0}%`);
      if (rowCount) rowCount.textContent = String(ratingCount);
    });
  };

  const getHcxStoreReviewProductIdentity = (review) => {
    if (review?.isProductExists === false) return { key: "", title: "" };
    const rawProduct = review?.product || (Array.isArray(review?.products) ? review.products[0] : null) || {};
    const title = normalizeHcxReviewProductTitle(rawProduct.title || review?.productTitle || review?.product_title || "");
    return {
      key: hcxHandleText(title || rawProduct.handle || ""),
      title,
    };
  };

  const getHcxStoreReviewProductStats = (reviews) => {
    const stats = new Map();

    reviews.forEach((review) => {
      const product = getHcxStoreReviewProductIdentity(review);
      if (!product.key || !product.title) return;
      const current = stats.get(product.key) || {
        key: product.key,
        title: product.title,
        count: 0,
        ratingTotal: 0,
        average: 0,
      };
      current.count += 1;
      current.ratingTotal += getHcxReviewRatingValue(review);
      current.average = current.count ? current.ratingTotal / current.count : 0;
      stats.set(product.key, current);
    });

    return stats;
  };

  const populateHcxStoreReviewProductFilter = (section, productStats) => {
    const select = section.querySelector("[data-hcx-all-review-filter='product']");
    if (!select?.matches?.("select")) return;

    while (select.options.length > 1) select.remove(1);
    [...productStats.values()]
      .sort((a, b) => b.count - a.count || a.title.localeCompare(b.title))
      .forEach((product) => {
        const option = document.createElement("option");
        option.value = product.key;
        option.textContent = `${product.title} (${product.count})`;
        select.append(option);
      });
  };

  const renderHcxStoreReviewList = (section) => {
    const state = section._hcxStoreReviewState;
    const list = section.querySelector("[data-hcx-all-review-list]");
    if (!state || !list) return;

    const search = section.querySelector("[data-hcx-all-review-search]");
    const query = (search?.value || "").trim().toLowerCase();
    let reviews = [...state.reviews];

    if (query) {
      reviews = reviews.filter((review) => {
        const product = getHcxReviewProduct(review);
        const haystack = [
          review.content,
          review.firstName,
          review.first_name,
          review.lastName,
          review.last_name,
          review.productVariants,
          product.title,
          getHcxReviewSize(review),
        ]
          .filter(Boolean)
          .join(" ")
          .toLowerCase();
        return haystack.includes(query);
      });
    }

    if (state.ratingFilter) {
      reviews = reviews.filter((review) => getHcxReviewRatingBucket(review) === state.ratingFilter);
    }

    if (state.productFilter) {
      reviews = reviews.filter((review) => getHcxStoreReviewProductIdentity(review).key === state.productFilter);
    }

    const visibleCountDisplay = section.querySelector("[data-hcx-all-review-visible-count]");
    const visibleLabelDisplay = section.querySelector("[data-hcx-all-review-visible-label]");
    if (visibleCountDisplay) visibleCountDisplay.textContent = String(reviews.length);
    if (visibleLabelDisplay) visibleLabelDisplay.textContent = reviews.length === 1 ? "review" : "reviews";

    const resetControl = section.querySelector("[data-hcx-all-review-reset]");
    if (resetControl) {
      resetControl.hidden = !(
        query ||
        state.sort !== "recent" ||
        state.ratingFilter ||
        state.productFilter
      );
    }

    const productStats = state.productStats || new Map();
    const getProductStats = (review) =>
      productStats.get(getHcxStoreReviewProductIdentity(review).key) || { count: 0, average: 0 };
    const compareRecent = (a, b) => getHcxReviewCreatedTime(b) - getHcxReviewCreatedTime(a);

    if (state.sort === "highest") {
      reviews.sort((a, b) => getHcxReviewRatingValue(b) - getHcxReviewRatingValue(a) || compareRecent(a, b));
    } else if (state.sort === "lowest") {
      reviews.sort((a, b) => getHcxReviewRatingValue(a) - getHcxReviewRatingValue(b) || compareRecent(a, b));
    } else if (state.sort === "oldest") {
      reviews.sort((a, b) => getHcxReviewCreatedTime(a) - getHcxReviewCreatedTime(b));
    } else if (state.sort === "most-reviewed") {
      reviews.sort((a, b) => {
        const aStats = getProductStats(a);
        const bStats = getProductStats(b);
        return bStats.count - aStats.count || bStats.average - aStats.average || compareRecent(a, b);
      });
    } else if (state.sort === "best-product") {
      reviews.sort((a, b) => {
        const aStats = getProductStats(a);
        const bStats = getProductStats(b);
        return bStats.average - aStats.average || bStats.count - aStats.count || compareRecent(a, b);
      });
    } else {
      reviews.sort(compareRecent);
    }

    if (!reviews.length) {
      list.innerHTML = '<p class="hcx-store-reviews__empty">No live reviews match those filters.</p>';
      return;
    }

    list.innerHTML = reviews
      .map((review) => {
        const rating = getHcxReviewRatingValue(review);
        const date = formatHcxReviewDate(review.createdAt || review.created_at);
        const product = getHcxReviewProduct(review);
        const productCanLink = product.url && review.isProductExists !== false;
        const productMarkup = product.title && review.isProductExists !== false
          ? `
            <div class="hcx-store-review__about">
              ${
                productCanLink
                  ? `<a href="${hcxEscapeHtml(product.url)}">${hcxEscapeHtml(product.title)}</a>`
                  : `<span>${hcxEscapeHtml(product.title)}</span>`
              }
            </div>
          `
          : "";
        const productImageMarkup = product.image && review.isProductExists !== false
          ? `
            ${
              productCanLink
                ? `<a class="hcx-store-review__media" href="${hcxEscapeHtml(product.url)}" aria-label="View ${hcxEscapeHtml(product.title || "reviewed product")}">`
                : '<span class="hcx-store-review__media">'
            }
              <img
                src="${hcxEscapeHtml(product.image)}"
                alt="${productCanLink ? "" : hcxEscapeHtml(product.title || "Reviewed product")}"
                width="240"
                height="300"
                loading="lazy"
                decoding="async"
                fetchpriority="low"
              >
            ${productCanLink ? "</a>" : "</span>"}
          `
          : "";
        const size = getHcxReviewSize(review);
        const title = getHcxReviewTitle(review);
        const content = hcxEscapeHtml(cleanHcxReviewText(review.content || "")).replace(/\n/g, "<br>");
        const flag = renderHcxReviewCountryFlag(review);
        const verified = review.verifyBuyer || review.verified;

        return `
          <article class="hcx-store-review">
            <div class="hcx-store-review__customer">
              ${flag ? `<span class="hcx-store-review__flag">${flag}</span>` : ""}
              <div>
                <strong>${hcxEscapeHtml(formatHcxReviewName(review))}</strong>
                ${verified ? "<em>Verified buyer</em>" : ""}
              </div>
            </div>

            <div class="hcx-store-review__content${productImageMarkup ? " has-image" : ""}">
              <div class="hcx-store-review__body">
                ${productMarkup}
                <div class="hcx-store-review__line">
                  <span class="hcx-store-review__stars" aria-label="${rating} out of 5 stars">${renderHcxReviewStars(rating)}</span>
                  ${title ? `<strong>${hcxEscapeHtml(title)}</strong>` : ""}
                </div>
                ${content ? `<p>${content}</p>` : ""}
                ${size ? `
                  <div class="hcx-store-review__meta">
                    ${size ? `<span>Size ${hcxEscapeHtml(size)}</span>` : ""}
                  </div>
                ` : ""}
              </div>
              ${productImageMarkup}
            </div>

            <div class="hcx-store-review__side">
              ${date ? `<time datetime="${hcxEscapeHtml(review.createdAt || review.created_at)}">${hcxEscapeHtml(date)}</time>` : ""}
            </div>
          </article>
        `;
      })
      .join("");
  };

  const fetchHcxStoreReviewPage = (section, after = "") => {
    const endpoint = new URL("https://app.airreviews.io/review/loadReviews");
    const limit = hcxClamp(Number(section.dataset.hcxReviewLimit) || 100, 10, 100);

    endpoint.searchParams.set("shopId", section.dataset.hcxReviewShopId);
    endpoint.searchParams.set("from", "all_reviews_block_widget");
    endpoint.searchParams.set("limitPerPage", String(limit));
    endpoint.searchParams.set("sort", "createdAt_desc");
    if (after) endpoint.searchParams.set("after", after);

    return fetch(endpoint.toString(), { headers: { Accept: "application/json" } })
      .then((response) => {
        if (!response.ok) throw new Error("Could not load reviews");
        return response.json();
      });
  };

  const fetchHcxJudgeMeStoreReviews = async (section) => {
    const shopDomain = String(section.dataset.hcxJudgemeShopDomain || "").trim();
    const apiToken = String(section.dataset.hcxJudgemePublicToken || "").trim();
    if (!shopDomain || !apiToken) return [];

    const pageSize = 25;
    const maxPages = hcxClamp(Number(section.dataset.hcxJudgemeMaxPages) || 20, 1, 50);
    const reviews = [];

    for (let page = 1; page <= maxPages; page += 1) {
      const endpoint = new URL("https://judge.me/api/v1/widgets/all_reviews_page");
      endpoint.searchParams.set("shop_domain", shopDomain);
      endpoint.searchParams.set("api_token", apiToken);
      endpoint.searchParams.set("page", String(page));

      const response = await fetch(endpoint.toString(), { headers: { Accept: "application/json" } });
      if (!response.ok) throw new Error("Could not load Judge.me reviews");

      const payload = await response.json();
      const markup = String(payload?.all_reviews || "");
      if (!markup) break;

      const pageReviews = parseHcxJudgeMeWidgetReviews(markup);
      reviews.push(...pageReviews);

      const reviewNodeCount =
        typeof DOMParser === "undefined"
          ? (markup.match(/class=(?:"|')jdgm-rev(?:\s|(?:"|'))/g) || []).length
          : new DOMParser().parseFromString(markup, "text/html").querySelectorAll(".jdgm-rev").length;
      if (reviewNodeCount < pageSize) break;
    }

    return reviews;
  };

  const loadHcxStoreReviews = (section) => {
    if (!section || section.dataset.hcxStoreReviewFeedBound === "true") return;

    const list = section.querySelector("[data-hcx-all-review-list]");
    const shopId = section.dataset.hcxReviewShopId;
    if (!list || !shopId) return;

    section.dataset.hcxStoreReviewFeedBound = "true";
    list.innerHTML = '<p class="hcx-store-reviews__loading">Loading live reviews</p>';

    const maxPages = hcxClamp(Number(section.dataset.hcxReviewMaxPages) || 20, 1, 50);

    (async () => {
      const airReviewsPromise = (async () => {
        const reviews = [];
        let after = "";
        let page = 0;
        let hasNext = true;

        while (hasNext && page < maxPages) {
          page += 1;
          const payload = await fetchHcxStoreReviewPage(section, after);
          const pageReviews = Array.isArray(payload?.data?.reviews) ? payload.data.reviews : [];
          reviews.push(...pageReviews);
          after = pageReviews[pageReviews.length - 1]?.id || "";
          hasNext = Boolean(payload?.data?.hasNext && pageReviews.length && after);
        }

        return reviews;
      })().catch(() => []);
      const judgeMeReviewsPromise = fetchHcxJudgeMeStoreReviews(section).catch(() => []);
      const [airReviews, judgeMeReviews] = await Promise.all([airReviewsPromise, judgeMeReviewsPromise]);
      const liveReviews = cleanHcxStoreDisplayReviews([...airReviews, ...judgeMeReviews]);
      const sortControl = section.querySelector("[data-hcx-all-review-sort]");
      const ratingControl = section.querySelector("[data-hcx-all-review-filter='rating']");
      const productControl = section.querySelector("[data-hcx-all-review-filter='product']");
      const productStats = getHcxStoreReviewProductStats(liveReviews);

      section._hcxStoreReviewState = {
        reviews: liveReviews,
        sort: sortControl?.matches?.("select") ? sortControl.value || "recent" : "recent",
        ratingFilter: ratingControl?.matches?.("select") ? Number(ratingControl.value) || 0 : 0,
        productFilter: productControl?.matches?.("select") ? productControl.value || "" : "",
        productStats,
      };

      populateHcxStoreReviewProductFilter(section, productStats);
      updateHcxStoreReviewSummary(section, liveReviews);
      renderHcxStoreReviewList(section);
      hydrateHcxReviewFlatLayImages(section, liveReviews);
    })().catch(() => {
      list.innerHTML = '<p class="hcx-store-reviews__empty">Live reviews are temporarily unavailable.</p>';
    });
  };

  const initHcxStoreReviews = () => {
    document.querySelectorAll("[data-hcx-store-reviews]").forEach((section) => {
      if (section.dataset.hcxStoreReviewsBound !== "true") {
        section.dataset.hcxStoreReviewsBound = "true";

        const search = section.querySelector("[data-hcx-all-review-search]");
        if (search) {
          ["input", "search", "change"].forEach((eventName) => {
            search.addEventListener(eventName, () => renderHcxStoreReviewList(section));
          });
        }

        const sortControl = section.querySelector("[data-hcx-all-review-sort]");
        if (sortControl) {
          if (sortControl.matches("select")) {
            sortControl.addEventListener("change", () => {
              if (!section._hcxStoreReviewState) return;
              section._hcxStoreReviewState.sort = sortControl.value || "recent";
              renderHcxStoreReviewList(section);
            });
          } else {
            sortControl.addEventListener("click", () => {
              if (!section._hcxStoreReviewState) return;
              const options = [
                ["recent", "Most recent"],
                ["highest", "Highest rating"],
              ];
              const currentIndex = options.findIndex(([key]) => key === section._hcxStoreReviewState.sort);
              const [nextKey, nextLabel] = options[(currentIndex + 1) % options.length];
              section._hcxStoreReviewState.sort = nextKey;
              setHcxButtonLeadingText(sortControl, `${nextLabel} `);
              renderHcxStoreReviewList(section);
            });
          }
        }

        const ratingControl = section.querySelector("[data-hcx-all-review-filter='rating']");
        if (ratingControl) {
          if (ratingControl.matches("select")) {
            ratingControl.addEventListener("change", () => {
              if (!section._hcxStoreReviewState) return;
              section._hcxStoreReviewState.ratingFilter = Number(ratingControl.value) || 0;
              renderHcxStoreReviewList(section);
            });
          } else {
            ratingControl.addEventListener("click", () => {
              if (!section._hcxStoreReviewState) return;
              section._hcxStoreReviewState.ratingFilter = 0;
              setHcxButtonLeadingText(ratingControl, "All ratings ");
              renderHcxStoreReviewList(section);
            });
          }
        }

        const productControl = section.querySelector("[data-hcx-all-review-filter='product']");
        if (productControl?.matches?.("select")) {
          productControl.addEventListener("change", () => {
            if (!section._hcxStoreReviewState) return;
            section._hcxStoreReviewState.productFilter = productControl.value || "";
            renderHcxStoreReviewList(section);
          });
        }

        const resetControl = section.querySelector("[data-hcx-all-review-reset]");
        if (resetControl) {
          resetControl.addEventListener("click", () => {
            const state = section._hcxStoreReviewState;
            if (!state) return;
            if (search) search.value = "";
            if (sortControl?.matches?.("select")) sortControl.value = "recent";
            if (ratingControl?.matches?.("select")) ratingControl.value = "";
            if (productControl?.matches?.("select")) productControl.value = "";
            state.sort = "recent";
            state.ratingFilter = 0;
            state.productFilter = "";
            renderHcxStoreReviewList(section);
          });
        }
      }

      loadHcxStoreReviews(section);
    });
  };

  const initHcxStoreReviewForm = () => {
    document.querySelectorAll("[data-hcx-store-review-form]").forEach((reviewForm) => {
      if (reviewForm.dataset.hcxStoreReviewFormBound === "true") return;

      const params = new URLSearchParams(window.location.search);
      if (params.get("hcx_store_review") !== "1") return;

      const productId = String(params.get("hcx_review_product_id") || "").trim();
      const orderName = String(params.get("hcx_review_order") || "").trim();
      const purchaseData = reviewForm.parentElement?.querySelector("[data-hcx-store-review-purchases]");
      let purchases = [];

      try {
        purchases = JSON.parse(purchaseData?.textContent || "[]");
      } catch (error) {
        purchases = [];
      }

      const purchase = purchases.find((item) => {
        const productMatches = String(item?.productId || "") === productId;
        const orderMatches = !orderName || String(item?.orderName || "") === orderName;
        return productMatches && orderMatches;
      });

      if (!purchase || !productId) return;

      reviewForm.dataset.hcxStoreReviewFormBound = "true";
      reviewForm.hidden = false;

      const form = reviewForm.querySelector("[data-hcx-store-review-submit-form]");
      const contentInput = reviewForm.querySelector("[data-hcx-store-review-content]");
      const submitButton = reviewForm.querySelector("[data-hcx-store-review-submit]");
      const status = reviewForm.querySelector("[data-hcx-store-review-status]");
      const ratingButtons = [...reviewForm.querySelectorAll("[data-hcx-store-review-rating]")];
      let selectedRating = 0;

      const setStatus = (message = "", type = "") => {
        if (!status) return;
        status.textContent = message;
        status.classList.toggle("is-error", type === "error");
        status.classList.toggle("is-success", type === "success");
      };

      const setRating = (rating) => {
        selectedRating = hcxClamp(Number(rating) || 0, 1, 5);
        ratingButtons.forEach((button) => {
          const buttonRating = Number(button.dataset.hcxStoreReviewRating) || 0;
          const isSelected = buttonRating <= selectedRating;
          button.classList.toggle("is-selected", isSelected);
          button.textContent = isSelected ? "\u2605" : "\u2606";
          button.setAttribute("aria-checked", buttonRating === selectedRating ? "true" : "false");
        });
        setStatus();
      };

      ratingButtons.forEach((button) => {
        button.addEventListener("click", () => setRating(button.dataset.hcxStoreReviewRating));
      });

      form?.addEventListener("submit", async (event) => {
        event.preventDefault();

        const content = String(contentInput?.value || "").trim();
        if (!selectedRating) {
          setStatus("Choose a star rating.", "error");
          ratingButtons[0]?.focus();
          return;
        }

        if (!content) {
          setStatus("Write your review before submitting.", "error");
          contentInput?.focus();
          return;
        }

        const email = String(reviewForm.dataset.hcxReviewEmail || "").trim();
        const firstName =
          String(reviewForm.dataset.hcxReviewFirstName || "").trim() ||
          email.split("@")[0] ||
          "Customer";
        const lastName = String(reviewForm.dataset.hcxReviewLastName || "").trim();
        const shopId = String(reviewForm.dataset.hcxReviewShopId || "").trim();
        const shopDomain = String(reviewForm.dataset.hcxReviewShopDomain || "").trim();

        if (!email || !shopId || !shopDomain) {
          setStatus("Your signed-in account could not be verified. Please refresh and try again.", "error");
          return;
        }

        const payload = {
          firstName,
          lastName,
          first_name: firstName,
          last_name: lastName,
          email,
          phone: "",
          rate: selectedRating,
          content,
          images: [],
          variants: [],
          status: "disapproved",
          shopId,
          productId: Number(productId) || productId,
          productHandle: "",
          productTitle: String(purchase.productTitle || "HERCXLES"),
          productSku: "",
          productImage: "https://cdnapps.avada.io/airReviews/imgCarrouselExm.png",
          shopDomain,
          generalSettings: {
            eligibility: "verified_buyers",
            autoSubmitPublish: "four-five",
            enableCountryFlag: true,
            enableUGCContent: true,
            isUsingPresetV2: true,
          },
          notificationSource: "email",
          ignoreContentValidation: false,
        };

        submitButton.disabled = true;
        submitButton.textContent = "Submitting";
        setStatus("Submitting your review.");

        try {
          const response = await fetch("https://app.airreviews.io/review/submit?id=", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json;charset=UTF-8",
            },
            body: JSON.stringify(payload),
          });
          const result = await response.json();

          if (!response.ok || !result?.success) {
            throw new Error(result?.message || "Your review could not be submitted.");
          }

          setStatus("Review submitted. Thank you.", "success");
          submitButton.textContent = "Submitted";
          ratingButtons.forEach((button) => {
            button.disabled = true;
          });
          if (contentInput) contentInput.disabled = true;

          window.setTimeout(() => {
            const storeReviews = reviewForm.closest("[data-hcx-store-reviews]");
            if (!storeReviews) return;
            storeReviews.dataset.hcxStoreReviewFeedBound = "false";
            loadHcxStoreReviews(storeReviews);
          }, 1200);
        } catch (error) {
          submitButton.disabled = false;
          submitButton.textContent = "Submit review";
          setStatus(error?.message || "Your review could not be submitted. Please try again.", "error");
        }
      });

      if (window.location.hash === "#write-review") {
        window.requestAnimationFrame(() => reviewForm.scrollIntoView({ behavior: "smooth", block: "start" }));
      }
    });
  };

  const initProductReviewMetrics = () => {
    document.querySelectorAll("[data-hcx-product-reviews]").forEach((section) => {
      if (section.dataset.hcxReviewsBound === "true") return;
      section.dataset.hcxReviewsBound = "true";

      const buttons = [...section.querySelectorAll("[data-hcx-review-metric]")];

      buttons.forEach((button) => {
        button.addEventListener("click", () => setProductReviewMetric(section, button));
      });

      const search = section.querySelector("[data-hcx-review-search]");
      if (search) {
        ["input", "search", "change"].forEach((eventName) => {
          search.addEventListener(eventName, () => renderHcxProductReviewList(section));
        });
      }

      const sortControl = section.querySelector("[data-hcx-review-sort]");
      if (sortControl) {
        if (sortControl.matches("select")) {
          sortControl.addEventListener("change", () => {
            if (!section._hcxReviewState) return;
            section._hcxReviewState.sort = sortControl.value || "recent";
            renderHcxProductReviewList(section);
          });
        } else {
          sortControl.addEventListener("click", () => {
            if (!section._hcxReviewState) return;
            const options = [
              ["recent", "Most recent"],
              ["highest", "Highest rating"],
            ];
            const currentIndex = options.findIndex(([key]) => key === section._hcxReviewState.sort);
            const [nextKey, nextLabel] = options[(currentIndex + 1) % options.length];
            section._hcxReviewState.sort = nextKey;
            setHcxButtonLeadingText(sortControl, `Sort by: ${nextLabel} `);
            renderHcxProductReviewList(section);
          });
        }
      }

      const ratingControl = section.querySelector("[data-hcx-review-filter='rating']");
      if (ratingControl) {
          if (ratingControl.matches("select")) {
            ratingControl.addEventListener("change", () => {
              if (!section._hcxReviewState) return;
              section._hcxReviewState.ratingFilter = Number(ratingControl.value) || 0;
              renderHcxProductReviewList(section);
            });
          } else {
            ratingControl.addEventListener("click", () => {
              if (!section._hcxReviewState) return;
              section._hcxReviewState.ratingFilter = 0;
              setHcxButtonLeadingText(ratingControl, "All ratings ");
              renderHcxProductReviewList(section);
            });
          }
      }

      setProductReviewMetric(section, section.querySelector("[data-hcx-review-metric].is-active") || buttons[0]);
      loadHcxProductReviews(section);
    });
  };

  const rerenderProductReviewApp = () => {
    if (typeof window.avadaAirReviewRerender !== "function") return;
    window.requestAnimationFrame(() => window.avadaAirReviewRerender());
  };

  const staleLegacyProgrammeTextPattern = /\b(gold|joy|thief)\b/i;
  const normaliseLegacyProgrammeCopy = (value = "") =>
    String(value)
      .replace(/\bthief\b/gi, (match) => {
        if (match === match.toUpperCase()) return "MORTAL";
        return match[0] === match[0].toUpperCase() ? "Mortal" : "mortal";
      })
      .replace(/\bgold\b/gi, (match) => (match[0] === "G" ? "Points" : "points"))
      .replace(/\bjoy\b/gi, (match) => (match === match.toUpperCase() ? "LEGACY" : "Legacy"));

  const normaliseJoyPointsLanguage = () => {
    const joy = window.AVADA_JOY;
    if (!joy || html.dataset.hcxJoyPointsLanguageNormalised === "true") return;

    html.dataset.hcxJoyPointsLanguageNormalised = "true";

    const visited = new Set();
    const rewrite = (value) => {
      if (typeof value === "string") {
        return normaliseLegacyProgrammeCopy(value);
      }

      if (!value || typeof value !== "object" || visited.has(value)) return value;
      visited.add(value);

      Object.keys(value).forEach((key) => {
        value[key] = rewrite(value[key]);
      });

      return value;
    };

    rewrite(joy);
  };

  const normaliseLegacyProgramText = (root) => {
    if (!root || !document.createTreeWalker) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || ["SCRIPT", "STYLE", "NOSCRIPT", "TEXTAREA"].includes(parent.tagName)) {
          return NodeFilter.FILTER_REJECT;
        }

        return staleLegacyProgrammeTextPattern.test(node.nodeValue || "")
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      },
    });

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      node.nodeValue = normaliseLegacyProgrammeCopy(node.nodeValue || "");
    });

    const attributeNodes = root.nodeType === Node.ELEMENT_NODE
      ? [root, ...root.querySelectorAll("*")]
      : [];
    attributeNodes.forEach((node) => {
      ["aria-label", "title", "alt", "placeholder", "value"].forEach((attribute) => {
        if (!node.hasAttribute?.(attribute)) return;
        const current = node.getAttribute(attribute) || "";
        if (!staleLegacyProgrammeTextPattern.test(current)) return;
        node.setAttribute(attribute, normaliseLegacyProgrammeCopy(current));
      });
    });
  };

  const initLoyaltyProgram = () => {
    normaliseJoyPointsLanguage();

    const formatPoints = (value) => Math.max(0, Math.round(value || 0)).toLocaleString("en-GB");
    const formatPounds = (value) =>
      new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "GBP",
        maximumFractionDigits: 0,
      }).format(Math.max(0, Math.floor(value || 0)));

    const getRewardAlertKey = (section) => {
      const customerKey = section.dataset.hcxRewardAlertKey || "guest";
      const rewardSteps = Math.max(0, Number(section.dataset.hcxAvailableRewardSteps || 0));

      return `hcx:legacy-reward-alert:${customerKey}:${rewardSteps}`;
    };

    const setRewardAlertState = (section, isActive) => {
      section.dataset.hcxRewardAlertActive = isActive ? "true" : "false";
      section.classList.toggle("hcx-has-reward-alert", isActive);
      section.querySelectorAll("[data-hcx-reward-alert-badge]").forEach((badge) => {
        badge.hidden = !isActive;
      });
      section.dispatchEvent(new CustomEvent("hcx:reward-alert-changed"));
    };

    const syncRewardAlert = (section) => {
      const rewardSteps = Math.max(0, Number(section.dataset.hcxAvailableRewardSteps || 0));
      let isDismissed = false;

      try {
        isDismissed = window.localStorage.getItem(getRewardAlertKey(section)) === "dismissed";
      } catch (error) {
        isDismissed = false;
      }

      setRewardAlertState(section, rewardSteps > 0 && !isDismissed);
    };

    const dismissRewardAlert = (section) => {
      if (!section || section.dataset.hcxRewardAlertActive !== "true") return;

      try {
        window.localStorage.setItem(getRewardAlertKey(section), "dismissed");
      } catch (error) {
        // Non-critical: private browsing can block localStorage.
      }

      setRewardAlertState(section, false);
    };

    const syncRewardPortalFallback = (section) => {
      const surface = section?.querySelector("[data-hcx-joy-app-surface]");
      const fallback = surface?.querySelector("[data-hcx-joy-fallback-panel]");
      if (!surface || !fallback) return;

      const hasRewardApp = [...surface.querySelectorAll(".hcx-loyalty-joy__block")].some((block) =>
        block.children.length > 0 || (block.textContent || "").trim().length > 0
      );
      fallback.hidden = hasRewardApp;
    };

    const getRewardSurface = (trigger, program) => {
      const selector = trigger.dataset.hcxRewardSurface || "";
      if (selector) {
        try {
          return program?.querySelector(selector) || document.querySelector(selector);
        } catch (error) {
          return null;
        }
      }

      return program?.querySelector("[data-hcx-joy-app-surface]") || document.querySelector("[data-hcx-joy-app-surface]");
    };

    const focusRewardSurface = (surface) => {
      if (!(surface instanceof HTMLElement)) return false;

      surface.hidden = false;
      surface.scrollIntoView({ behavior: "smooth", block: "start" });
      window.setTimeout(() => {
        if (!surface.hasAttribute("tabindex")) surface.setAttribute("tabindex", "-1");
        surface.focus({ preventScroll: true });
      }, 220);
      return true;
    };

    const bindLegacyTextNormaliser = (root) => {
      if (!root || root.dataset.hcxLegacyTextObserverBound === "true") return;

      normaliseLegacyProgramText(root);
      root.dataset.hcxLegacyTextObserverBound = "true";
      new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          const target =
            mutation.target.nodeType === Node.TEXT_NODE
              ? mutation.target.parentElement
              : mutation.target;
          normaliseLegacyProgramText(target);
        });
      }).observe(root, { childList: true, characterData: true, subtree: true, attributes: true });
    };

    const profileTextRoots = [...new Set([
      ...document.querySelectorAll("[data-hcx-loyalty-program], .customer.account, .hcx-account-legacy"),
      ...(document.body.classList.contains("template-customers-account")
        ? [document.getElementById("MainContent"), document.body]
        : []),
    ].filter(Boolean))];
    profileTextRoots.forEach(bindLegacyTextNormaliser);

    document.querySelectorAll("[data-hcx-loyalty-program]").forEach((section) => {
      if (section.dataset.hcxLoyaltyBound === "true") return;
      section.dataset.hcxLoyaltyBound = "true";

      syncRewardAlert(section);
      syncRewardPortalFallback(section);

      const rewardSurface = section.querySelector("[data-hcx-joy-app-surface]");
      if (rewardSurface) {
        new MutationObserver(() => syncRewardPortalFallback(section)).observe(rewardSurface, {
          childList: true,
          subtree: true,
        });
      }
    });

    if (html.dataset.hcxJoyTriggerBound === "true") return;
    html.dataset.hcxJoyTriggerBound = "true";

    document.addEventListener("click", (event) => {
      const trigger = event.target.closest("[data-hcx-open-joy]");
      if (!trigger) return;

      event.preventDefault();
      const program = trigger.closest("[data-hcx-loyalty-program]");
      const couponTrigger = trigger.closest("[data-hcx-coupon-value]");

      if (program && couponTrigger) {
        program.querySelectorAll("[data-hcx-coupon-value]").forEach((coupon) => {
          coupon.classList.toggle("is-selected", coupon === couponTrigger);
        });
        program.dataset.hcxSelectedCouponValue = couponTrigger.dataset.hcxCouponValue || "";
        program.dataset.hcxSelectedCouponPoints = couponTrigger.dataset.hcxCouponPoints || "";
      }

      dismissRewardAlert(program);

      const rewardSurface = getRewardSurface(trigger, program);

      if (typeof window.avadaJoyTrigger === "function") {
        try {
          window.avadaJoyTrigger();
        } catch (error) {
          // Keep the embedded rewards surface as the reliable fallback.
        }
      }

      if (focusRewardSurface(rewardSurface)) return;

      const fallback = trigger.dataset.hcxJoyFallback || trigger.getAttribute("href") || "/pages/legacy#legacy-rewards";
      if (fallback.startsWith("#")) {
        const fallbackSurface = document.querySelector(fallback);
        if (focusRewardSurface(fallbackSurface)) return;
      }

      window.location.href = fallback;
    });
  };

  const initLegacyRegisterForm = () => {
    document.querySelectorAll(".customer.register form, .hcx-legacy-signup-form").forEach((form) => {
      if (form.dataset.hcxLegacyRegisterBound === "true") return;

      const birthdayInput = form.querySelector("[data-hcx-birthday-input]");
      const emailInput = form.querySelector("[data-hcx-legacy-email], input[type='email'][required]");
      if (!birthdayInput) return;

      form.dataset.hcxLegacyRegisterBound = "true";

      const validateBirthday = () => {
        birthdayInput.setCustomValidity("");

        if (!birthdayInput.value) {
          birthdayInput.setCustomValidity("Enter your birthday.");
          return false;
        }

        const selectedDate = new Date(`${birthdayInput.value}T00:00:00`);
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (Number.isNaN(selectedDate.getTime()) || selectedDate > today) {
          birthdayInput.setCustomValidity("Enter a valid birthday.");
          return false;
        }

        return true;
      };

      const validateEmail = () => {
        if (!emailInput) return true;

        emailInput.setCustomValidity("");
        if (emailInput.validity.valid) return true;

        emailInput.setCustomValidity("Enter a valid email for your Legacy profile.");
        return false;
      };

      birthdayInput.addEventListener("input", validateBirthday);
      if (emailInput) emailInput.addEventListener("input", validateEmail);
      form.addEventListener("submit", (event) => {
        const hasValidEmail = validateEmail();
        const hasValidBirthday = validateBirthday();
        if (hasValidEmail && hasValidBirthday) return;

        event.preventDefault();
        const target = hasValidEmail ? birthdayInput : emailInput;
        target.reportValidity();
        target.focus({ preventScroll: false });
      });
    });
  };

  const initCookieConsentFallback = () => {
    if (html.dataset.hcxCookieConsentFallback === "true") return;
    html.dataset.hcxCookieConsentFallback = "true";

    const dialogSelector = ".shopify-pc__banner__dialog, [class*='shopify-pc__banner'][class*='dialog']";
    const privacySelector = [
      "[id*='shopify-pc']",
      "[class*='shopify-pc']",
      "[id*='shopify-privacy']",
      "[class*='shopify-privacy']",
      "[id*='privacy-banner']",
      "[class*='privacy-banner']",
    ].join(", ");
    // The broad button selector already includes buttons inside privacy surfaces.
    // Avoid six redundant ancestor-selector walks for every collection size button.
    const allConsentButtonSelector = "button, a[role='button'], [role='button']";

    const getElementText = (element) => (element?.textContent || "").trim().replace(/\s+/g, " ");
    const getButtonLabel = (button) =>
      [
        getElementText(button),
        button.getAttribute("aria-label") || "",
        button.getAttribute("data-action") || "",
        button.id || "",
        button.className || "",
      ]
        .join(" ")
        .toLowerCase();
    const isVisibleElement = (element) => {
      if (!(element instanceof Element)) return false;
      const rect = element.getBoundingClientRect();
      const style = window.getComputedStyle(element);
      return rect.width > 0 && rect.height > 0 && style.display !== "none" && style.visibility !== "hidden";
    };
    const getCookieSurface = (element) => {
      if (!(element instanceof Element)) return null;

      const directSurface = element.closest(privacySelector);
      if (directSurface) return directSurface;

      let node = element.parentElement;
      let depth = 0;
      while (node && node !== document.body && depth < 8) {
        const text = getElementText(node).toLowerCase();
        const looksLikeCookieSurface =
          /(cookie consent|cookies|privacy policy)/.test(text) &&
          /(accept|decline|reject|deny|manage preferences|save preferences)/.test(text);

        if (looksLikeCookieSurface) return node;
        node = node.parentElement;
        depth += 1;
      }

      return null;
    };
    const isCookieConsentButton = (button) => {
      if (!(button instanceof Element)) return false;
      // Reject product/size buttons before reading layout or walking ancestor text.
      // Large collection grids otherwise pay this cost on every DOM update and tap.
      if (!/(accept|allow|decline|reject|deny|manage preferences|save preferences|confirm)/.test(getButtonLabel(button))) return false;
      return isVisibleElement(button) && Boolean(getCookieSurface(button));
    };
    const prepareCookieConsentClickTargets = () => {
      document.querySelectorAll(allConsentButtonSelector).forEach((button) => {
        if (!isCookieConsentButton(button)) return;

        const surface = getCookieSurface(button);
        surface?.classList.add("hcx-cookie-consent-surface");
        button.classList.add("hcx-cookie-consent-button");

        const rect = button.getBoundingClientRect();
        const x = rect.left + rect.width / 2;
        const y = rect.top + rect.height / 2;
        const stack = typeof document.elementsFromPoint === "function" ? document.elementsFromPoint(x, y) : [];

        for (const element of stack) {
          if (!(element instanceof HTMLElement)) continue;
          if (element === button || button.contains(element) || element.closest(".hcx-cookie-consent-surface")) break;
          if (element === document.body || element === document.documentElement) continue;

          const style = window.getComputedStyle(element);
          const canBlockClick =
            style.pointerEvents !== "none" &&
            (["fixed", "sticky", "absolute"].includes(style.position) || style.zIndex !== "auto");

          if (canBlockClick) element.classList.add("hcx-cookie-click-through");
        }
      });
    };

    const hideBanner = (button) => {
      const dialog = button.closest(dialogSelector);
      const cookieSurface = getCookieSurface(button);
      const privacyAncestors = [];
      let node = button.parentElement;

      while (node && node !== document.body) {
        if (node.matches(privacySelector)) privacyAncestors.push(node);
        node = node.parentElement;
      }

      [dialog, cookieSurface, ...privacyAncestors].forEach((bannerNode) => {
        if (!bannerNode) return;
        bannerNode.classList.add("hcx-cookie-consent-hidden");
        bannerNode.setAttribute("aria-hidden", "true");
      });
    };

    const getConsentChoice = (button) => {
      const buttonText = button.textContent.trim().toLowerCase();
      const buttonName = `${button.className || ""} ${button.getAttribute("data-action") || ""}`.toLowerCase();
      const label = `${buttonName} ${buttonText}`;

      if (buttonText.includes("manage")) return null;
      if (/(decline|reject|deny)/.test(label)) return false;
      if (/(accept|allow)/.test(label)) return true;

      return null;
    };

    const nativeClickConsentButton = (button) => {
      if (button.dataset.hcxCookieActivating === "true") return;

      button.dataset.hcxCookieActivating = "true";
      window.setTimeout(() => {
        try {
          button.click();
        } catch (error) {
          window.HCXCookieConsentNativeClickError = true;
        }
        window.setTimeout(() => {
          delete button.dataset.hcxCookieActivating;
        }, 250);
      }, 0);
    };

    const applyConsentChoice = (button, consentChoice) => {
      const setTrackingConsent = window.Shopify?.customerPrivacy?.setTrackingConsent;
      if (typeof setTrackingConsent !== "function" || consentChoice === null) return false;

      try {
        setTrackingConsent.call(window.Shopify.customerPrivacy, consentChoice, () => hideBanner(button));
        return true;
      } catch (error) {
        return false;
      }
    };

    const getConsentButtonFromEvent = (event) => {
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      const directButton = target?.closest(allConsentButtonSelector);
      if (isCookieConsentButton(directButton)) return directButton;

      const stack =
        typeof document.elementsFromPoint === "function" && Number.isFinite(event.clientX) && Number.isFinite(event.clientY)
          ? document.elementsFromPoint(event.clientX, event.clientY)
          : [];

      for (const element of stack) {
        const button = element instanceof Element ? element.closest(allConsentButtonSelector) : null;
        if (isCookieConsentButton(button)) return button;
      }

      return null;
    };

    const activateConsentButton = (button) => {
      const consentChoice = getConsentChoice(button);

      if (consentChoice === null) {
        nativeClickConsentButton(button);
        return;
      }

      const usedConsentApi = applyConsentChoice(button, consentChoice);
      if (!usedConsentApi) nativeClickConsentButton(button);

      window.setTimeout(() => hideBanner(button), 250);
      window.setTimeout(() => hideBanner(button), 900);
      window.setTimeout(() => hideBanner(button), 1800);
    };

    let consentFrame = 0;
    const scheduleCookieConsentClickTargets = () => {
      if (consentFrame) return;
      consentFrame = window.requestAnimationFrame(() => {
        consentFrame = 0;
        prepareCookieConsentClickTargets();
      });
    };
    document.addEventListener("pointerdown", scheduleCookieConsentClickTargets, true);

    document.addEventListener(
      "click",
      (event) => {
        prepareCookieConsentClickTargets();

        const button = getConsentButtonFromEvent(event);
        if (!button) return;
        if (button.dataset.hcxCookieActivating === "true") return;

        const buttonText = button.textContent.trim().toLowerCase();
        const buttonName = `${button.className || ""} ${button.getAttribute("data-action") || ""}`.toLowerCase();
        const finalChoice =
          /(accept|decline|save|confirm|reject|deny)/.test(buttonName) ||
          /^(accept|decline|save|save preferences|confirm|reject all|deny)$/.test(buttonText);

        if (buttonText.includes("manage")) {
          event.preventDefault();
          event.stopPropagation();
          nativeClickConsentButton(button);
          return;
        }

        if (!finalChoice) return;

        event.preventDefault();
        event.stopPropagation();
        activateConsentButton(button);
      },
      true
    );

    prepareCookieConsentClickTargets();

    const observer = new MutationObserver(scheduleCookieConsentClickTargets);
    observer.observe(document.body, { childList: true, subtree: true });
  };

  const THREE_MODULE_URL = "https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.module.js";
  let hcxThreeModulePromise = null;

  const loadThreeModule = () => {
    if (!hcxThreeModulePromise) hcxThreeModulePromise = import(THREE_MODULE_URL);
    return hcxThreeModulePromise;
  };

  const drawRoundedRect = (context, x, y, width, height, radius) => {
    const r = Math.min(radius, width / 2, height / 2);

    context.beginPath();
    context.moveTo(x + r, y);
    context.lineTo(x + width - r, y);
    context.quadraticCurveTo(x + width, y, x + width, y + r);
    context.lineTo(x + width, y + height - r);
    context.quadraticCurveTo(x + width, y + height, x + width - r, y + height);
    context.lineTo(x + r, y + height);
    context.quadraticCurveTo(x, y + height, x, y + height - r);
    context.lineTo(x, y + r);
    context.quadraticCurveTo(x, y, x + r, y);
    context.closePath();
  };

  const clampValue = (value, min, max) => Math.min(Math.max(value, min), max);
  const smoothStep = (value) => value * value * (3 - 2 * value);

  const wrapCanvasText = (context, text, x, y, maxWidth, lineHeight, maxLines = 3) => {
    const words = String(text || "").split(/\s+/).filter(Boolean);
    let line = "";
    let lineCount = 0;

    words.forEach((word, index) => {
      const testLine = line ? `${line} ${word}` : word;
      const isLastWord = index === words.length - 1;

      if (context.measureText(testLine).width > maxWidth && line) {
        context.fillText(line, x, y + lineCount * lineHeight);
        line = word;
        lineCount += 1;
      } else {
        line = testLine;
      }

      if ((isLastWord || lineCount === maxLines - 1) && line) {
        const output = lineCount === maxLines - 1 && !isLastWord ? `${line.replace(/\.*$/, "")}...` : line;
        context.fillText(output, x, y + lineCount * lineHeight);
        line = "";
      }
    });
  };

  const normalizePhoneCopy = (value) =>
    String(value || "")
      .replace(/\u00c2?\u00a3/g, "GBP ")
      .replace(/\s+/g, " ")
      .trim();

  const getLoyaltyPhoneTimeText = () => {
    const now = new Date();

    try {
      const formatter = new Intl.DateTimeFormat(typeof navigator !== "undefined" ? navigator.language : undefined, {
        hour: "numeric",
        minute: "2-digit",
      });
      const parts = formatter.formatToParts(now);
      const hour = parts.find((part) => part.type === "hour")?.value;
      const minute = parts.find((part) => part.type === "minute")?.value;
      const separator =
        parts.find((part, index) => part.type === "literal" && parts[index - 1]?.type === "hour" && parts[index + 1]?.type === "minute")?.value ||
        ":";

      if (hour && minute) return `${hour}${separator}${minute}`.replace(/\s+/g, "");

      return formatter.format(now).replace(/\s?(AM|PM|am|pm)\s?/g, "").trim();
    } catch (error) {
      return now.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" }).replace(/\s?(AM|PM|am|pm)\s?/g, "").trim();
    }
  };

  const drawLoyaltyPhoneOrderNotification = (context, notification) => {
    if (!notification?.item) return;

    const item = normalizePhoneCopy(notification.item).slice(0, 54);
    const timeAgo = normalizePhoneCopy(notification.timeAgo || "now").slice(0, 20);
    const x = 34;
    const y = 90;
    const width = 452;
    const height = 122;

    context.save();
    context.shadowColor = "rgba(0, 0, 0, 0.42)";
    context.shadowBlur = 28;
    context.shadowOffsetY = 14;
    const cardGradient = context.createLinearGradient(x, y, x + width, y + height);
    cardGradient.addColorStop(0, "rgba(255, 255, 255, 0.96)");
    cardGradient.addColorStop(.48, "rgba(242, 242, 242, 0.9)");
    cardGradient.addColorStop(1, "rgba(217, 217, 217, 0.82)");
    context.fillStyle = cardGradient;
    drawRoundedRect(context, x, y, width, height, 30);
    context.fill();
    context.shadowBlur = 0;
    context.shadowOffsetY = 0;
    context.strokeStyle = "rgba(255, 255, 255, 0.86)";
    context.lineWidth = 1.4;
    drawRoundedRect(context, x, y, width, height, 30);
    context.stroke();

    context.fillStyle = "rgba(255, 255, 255, 0.28)";
    drawRoundedRect(context, x + 14, y + 8, width - 28, 2.4, 1.2);
    context.fill();

    context.fillStyle = "rgba(5, 5, 5, 0.94)";
    drawRoundedRect(context, x + 20, y + 28, 46, 46, 14);
    context.fill();
    context.fillStyle = "rgba(255, 255, 255, 0.96)";
    context.font = '900 19px "Swiss 721", "Helvetica Neue", Arial, sans-serif';
    context.textAlign = "center";
    context.textBaseline = "middle";
    context.fillText("H", x + 43, y + 51);
    context.textAlign = "left";
    context.textBaseline = "alphabetic";

    context.fillStyle = "rgba(5, 5, 5, 0.62)";
    context.font = '800 12px "Swiss 721", "Helvetica Neue", Arial, sans-serif';
    context.fillText("HERCXLES", x + 82, y + 32);
    context.textAlign = "right";
    context.fillStyle = "rgba(5, 5, 5, 0.48)";
    context.fillText(timeAgo.toUpperCase(), x + width - 24, y + 32);
    context.textAlign = "left";

    context.fillStyle = "rgba(5, 5, 5, 0.96)";
    context.font = '800 17px "Swiss 721", "Helvetica Neue", Arial, sans-serif';
    context.fillText("Someone bought", x + 82, y + 58);
    context.fillStyle = "rgba(5, 5, 5, 0.68)";
    context.font = '700 15px "Swiss 721", "Helvetica Neue", Arial, sans-serif';
    wrapCanvasText(context, item, x + 82, y + 84, width - 112, 18, 2);
    context.restore();
  };

  const createLoyaltyPhoneTexture = (THREE, pointsText, tierText, isBack = false, screenSpec = null, phoneTimeText = getLoyaltyPhoneTimeText()) => {
    const textureCanvas = document.createElement("canvas");
    textureCanvas.width = 520;
    textureCanvas.height = 1040;
    const context = textureCanvas.getContext("2d");
    if (isBack) {
      context.fillStyle = "#101010";
    } else {
      const screenBackground = context.createLinearGradient(0, 0, 520, 1040);
      screenBackground.addColorStop(0, screenSpec ? "#575757" : "#464646");
      screenBackground.addColorStop(.46, screenSpec ? "#303030" : "#343434");
      screenBackground.addColorStop(1, screenSpec ? "#4b4b4b" : "#3f3f3f");
      context.fillStyle = screenBackground;
    }
    context.fillRect(0, 0, 520, 1040);

    if (!screenSpec) {
      context.strokeStyle = "rgba(218, 218, 218, 0.16)";
      context.lineWidth = 2;
      for (let y = 88; y < 980; y += 74) {
        context.beginPath();
        context.moveTo(52, y);
        context.lineTo(468, y);
        context.stroke();
      }
    }

    context.fillStyle = "rgba(218, 218, 218, 1)";
    context.font = '600 32px "Swiss 721", "Helvetica Neue", Arial, sans-serif';
    context.letterSpacing = "4px";
    if (!screenSpec) context.fillText("LEGACY", 56, 96);

    if (isBack) {
      context.fillStyle = "rgba(255, 255, 255, 1)";
      context.font = '700 43px "Swiss 721", "Helvetica Neue", Arial, sans-serif';
      context.fillText("HERCXLES", 56, 512);
      context.fillStyle = "rgba(218, 218, 218, 0.86)";
      context.font = '500 22px "Swiss 721", "Helvetica Neue", Arial, sans-serif';
      context.fillText("LEGACY DEVICE", 56, 556);
    } else if (screenSpec) {
      const pages = screenSpec.pages || ["Welcome", "Points", "Tiers", "Orders"];
      const activePage = Math.max(0, Number(screenSpec.index || 0));
      const hoveredPage = Number.isFinite(Number(screenSpec.hoverIndex)) ? Number(screenSpec.hoverIndex) : -1;
      const accountLabel = normalizePhoneCopy(screenSpec.accountLabel || "Guest").slice(0, 18).toUpperCase();
      const defaultPageSummaries = [
        `${pointsText || "0"} pts / ${tierText || "Mortal"}`,
        "Earn and redeem",
        "Tier progress",
        "Orders and returns",
      ];
      const pageSummaries = screenSpec.pageSummaries || pages.map((page, index) => defaultPageSummaries[index] || `${page} panel`);

      context.letterSpacing = "0px";

      context.fillStyle = "rgba(0, 0, 0, 0.96)";
      drawRoundedRect(context, 188, 38, 144, 40, 20);
      context.fill();
      context.strokeStyle = "rgba(255, 255, 255, 0.1)";
      context.stroke();

      context.fillStyle = "rgba(255, 255, 255, 0.84)";
      context.font = '600 17px "Helvetica Neue", Arial, sans-serif';
      context.fillText(phoneTimeText, 40, 68);
      context.fillStyle = "rgba(255, 255, 255, 0.6)";
      drawRoundedRect(context, 438, 52, 34, 15, 5);
      context.fill();
      context.fillStyle = "rgba(255, 255, 255, 0.34)";
      drawRoundedRect(context, 476, 57, 4, 5, 2);
      context.fill();

      context.fillStyle = "rgba(255, 255, 255, 0.96)";
      context.font = '600 24px "Helvetica Neue", Arial, sans-serif';
      context.fillText(accountLabel, 34, 126);
      context.fillStyle = "rgba(218, 218, 218, 0.66)";
      context.font = '500 12px "Helvetica Neue", Arial, sans-serif';
      context.fillText("LEGACY ACCOUNT", 36, 150);

      context.fillStyle = "rgba(255, 255, 255, 0.1)";
      drawRoundedRect(context, 36, 170, 448, 7, 4);
      context.fill();
      const progressWidth = 448 * ((activePage + 1) / Math.max(pages.length, 1));
      const progressGradient = context.createLinearGradient(36, 0, 484, 0);
      progressGradient.addColorStop(0, "#f5f5f5");
      progressGradient.addColorStop(1, "#a8a8a8");
      context.fillStyle = progressGradient;
      drawRoundedRect(context, 36, 170, progressWidth, 7, 4);
      context.fill();

      context.fillStyle = "rgba(255, 255, 255, 0.92)";
      context.font = '600 17px "Helvetica Neue", Arial, sans-serif';
      context.fillText(normalizePhoneCopy(screenSpec.eyebrow || "01 / PROFILE"), 34, 220);

      context.fillStyle = "rgba(255, 255, 255, 0.58)";
      context.font = '500 12px "Helvetica Neue", Arial, sans-serif';
      context.fillText("SCROLL TO SELECT", 34, 243);

      pages.slice(0, 7).forEach((page, index) => {
        const rowY = 280 + index * 93;
        const selected = index === activePage;
        const hovered = !selected && index === hoveredPage;
        const rowGradient = context.createLinearGradient(28, rowY, 492, rowY + 76);

        rowGradient.addColorStop(0, selected ? "rgba(245, 245, 245, 0.92)" : hovered ? "rgba(255, 255, 255, 0.22)" : "rgba(255, 255, 255, 0.13)");
        rowGradient.addColorStop(1, selected ? "rgba(190, 190, 190, 0.78)" : hovered ? "rgba(255, 255, 255, 0.11)" : "rgba(255, 255, 255, 0.06)");
        if (hovered) {
          context.save();
          context.shadowColor = "rgba(255, 255, 255, 0.16)";
          context.shadowBlur = 20;
        }
        context.fillStyle = rowGradient;
        drawRoundedRect(context, 28, rowY, 464, 76, 24);
        context.fill();
        if (hovered) context.restore();
        context.strokeStyle = selected ? "rgba(255, 255, 255, 0.72)" : hovered ? "rgba(255, 255, 255, 0.34)" : "rgba(218, 218, 218, 0.16)";
        context.stroke();

        context.fillStyle = selected ? "rgba(5, 5, 5, 0.74)" : hovered ? "rgba(255, 255, 255, 0.72)" : "rgba(218, 218, 218, 0.58)";
        context.font = '600 13px "Helvetica Neue", Arial, sans-serif';
        context.fillText(String(index + 1).padStart(2, "0"), 54, rowY + 32);

        context.fillStyle = selected ? "rgba(5, 5, 5, 0.98)" : hovered ? "rgba(255, 255, 255, 1)" : "rgba(255, 255, 255, 0.94)";
        context.font = '600 24px "Helvetica Neue", Arial, sans-serif';
        context.fillText(normalizePhoneCopy(page).toUpperCase(), 104, rowY + 35);

        context.fillStyle = selected ? "rgba(5, 5, 5, 0.62)" : "rgba(255, 255, 255, 0.5)";
        context.font = '500 13px "Helvetica Neue", Arial, sans-serif';
        context.fillText(normalizePhoneCopy(pageSummaries[index]).slice(0, 38), 104, rowY + 60);

        if (selected) {
          context.fillStyle = "rgba(5, 5, 5, 0.92)";
          drawRoundedRect(context, 446, rowY + 22, 28, 32, 14);
          context.fill();

          context.fillStyle = "rgba(255, 255, 255, 0.96)";
          context.font = '600 15px "Helvetica Neue", Arial, sans-serif';
          context.fillText(">", 456, rowY + 43);
        }

        if (screenSpec.rewardAlert && index === (screenSpec.rewardAlertIndex ?? pages.length - 1)) {
          const countText = Number(screenSpec.rewardAlertCount || 0) > 9 ? "9+" : String(Math.max(1, Number(screenSpec.rewardAlertCount || 1)));

          context.save();
          context.shadowColor = "rgba(255, 255, 255, 0.34)";
          context.shadowBlur = 16;
          context.fillStyle = "#f2f2f2";
          drawRoundedRect(context, 452, rowY - 6, countText.length > 1 ? 32 : 24, 24, 12);
          context.fill();
          context.shadowBlur = 0;
          context.strokeStyle = "rgba(255, 255, 255, 0.92)";
          context.lineWidth = 3;
          drawRoundedRect(context, 452, rowY - 6, countText.length > 1 ? 32 : 24, 24, 12);
          context.stroke();
          context.fillStyle = "#050505";
          context.font = '600 13px "Helvetica Neue", Arial, sans-serif';
          context.textAlign = "center";
          context.textBaseline = "middle";
          context.fillText(countText, 452 + (countText.length > 1 ? 16 : 12), rowY + 6);
          context.restore();
        }
      });

      context.fillStyle = "rgba(255, 255, 255, 0.58)";
      context.font = '500 12px "Helvetica Neue", Arial, sans-serif';
      context.fillText(normalizePhoneCopy(screenSpec.footer || "Current tab highlighted").toUpperCase(), 34, 946);

      drawLoyaltyPhoneOrderNotification(context, screenSpec.orderNotification);
    } else {
      context.fillStyle = "rgba(255, 255, 255, 1)";
      context.font = '500 138px "Swiss 721", "Helvetica Neue", Arial, sans-serif';
      context.fillText(pointsText || "0", 54, 286);

      context.fillStyle = "rgba(255, 255, 255, 0.58)";
      context.font = '600 22px "Swiss 721", "Helvetica Neue", Arial, sans-serif';
      context.fillText("POINTS BALANCE", 58, 330);

      const rows = [
        ["TIER", tierText || "Mortal"],
        ["NEXT REWARD", "GBP 10"],
        ["LEGACY", "READY"],
      ];

      rows.forEach(([label, value], index) => {
        const rowY = 448 + index * 142;

        context.fillStyle = "rgba(255, 255, 255, 0.06)";
        drawRoundedRect(context, 48, rowY - 68, 424, 96, 28);
        context.fill();
        context.strokeStyle = "rgba(218, 218, 218, 0.18)";
        context.lineWidth = 2;
        context.stroke();

        context.fillStyle = "rgba(218, 218, 218, 0.82)";
        context.font = '600 19px "Swiss 721", "Helvetica Neue", Arial, sans-serif';
        context.fillText(label, 74, rowY - 26);

        context.fillStyle = "rgba(255, 255, 255, 0.94)";
        context.font = '600 31px "Swiss 721", "Helvetica Neue", Arial, sans-serif';
        context.fillText(value, 74, rowY + 14);
      });

      const progressX = 56;
      const progressY = 884;
      context.fillStyle = "rgba(255, 255, 255, 0.12)";
      drawRoundedRect(context, progressX, progressY, 408, 18, 9);
      context.fill();
      const progressGradient = context.createLinearGradient(progressX, 0, progressX + 360, 0);
      progressGradient.addColorStop(0, "#e1e1e1");
      progressGradient.addColorStop(1, "#a8a8a8");
      context.fillStyle = progressGradient;
      drawRoundedRect(context, progressX, progressY, 286, 18, 9);
      context.fill();

      context.fillStyle = "rgba(255, 255, 255, 0.6)";
      context.font = '500 20px "Swiss 721", "Helvetica Neue", Arial, sans-serif';
      context.fillText("200 PTS = GBP 10 REWARD", 56, 946);
    }

    const texture = new THREE.CanvasTexture(textureCanvas);
    if ("colorSpace" in texture && THREE.SRGBColorSpace) texture.colorSpace = THREE.SRGBColorSpace;
    texture.anisotropy = 4;
    texture.needsUpdate = true;

    return texture;
  };

  const createPhoneGlassTexture = (THREE) => {
    const textureCanvas = document.createElement("canvas");
    textureCanvas.width = 520;
    textureCanvas.height = 1040;
    const context = textureCanvas.getContext("2d");

    context.clearRect(0, 0, 520, 1040);
    const glassSweep = context.createLinearGradient(0, 0, 520, 1040);
    glassSweep.addColorStop(0, "rgba(255, 255, 255, 0.18)");
    glassSweep.addColorStop(.14, "rgba(255, 255, 255, 0.035)");
    glassSweep.addColorStop(.32, "rgba(255, 255, 255, 0)");
    glassSweep.addColorStop(.72, "rgba(255, 255, 255, 0.045)");
    glassSweep.addColorStop(1, "rgba(255, 255, 255, 0)");
    context.fillStyle = glassSweep;
    context.fillRect(0, 0, 520, 1040);

    const edgeShade = context.createRadialGradient(260, 520, 180, 260, 520, 620);
    edgeShade.addColorStop(0, "rgba(0, 0, 0, 0)");
    edgeShade.addColorStop(1, "rgba(0, 0, 0, 0.2)");
    context.fillStyle = edgeShade;
    context.fillRect(0, 0, 520, 1040);

    const texture = new THREE.CanvasTexture(textureCanvas);
    if ("colorSpace" in texture && THREE.SRGBColorSpace) texture.colorSpace = THREE.SRGBColorSpace;
    texture.anisotropy = 4;
    texture.needsUpdate = true;

    return texture;
  };

  const createLoyaltyPhonePanelTexture = (THREE, panel) => {
    const textureCanvas = document.createElement("canvas");
    textureCanvas.width = 640;
    textureCanvas.height = 900;
    const context = textureCanvas.getContext("2d");
    const panelGradient = context.createLinearGradient(0, 0, 640, 900);

    panelGradient.addColorStop(0, "#202020");
    panelGradient.addColorStop(.5, "#0d0d0d");
    panelGradient.addColorStop(1, "#050505");
    context.fillStyle = panelGradient;
    context.fillRect(0, 0, 640, 900);

    context.strokeStyle = "rgba(218, 218, 218, 0.18)";
    context.lineWidth = 2;
    drawRoundedRect(context, 24, 24, 592, 852, 44);
    context.stroke();

    context.fillStyle = "rgba(218, 218, 218, 0.92)";
    context.font = '600 24px "Swiss 721", "Helvetica Neue", Arial, sans-serif';
    context.fillText(panel.eyebrow || "LEGACY PAGE", 56, 96);

    context.fillStyle = "rgba(255, 255, 255, 0.98)";
    context.font = '600 66px "Swiss 721", "Helvetica Neue", Arial, sans-serif';
    context.fillText(panel.title || "LEGACY", 56, 174);

    context.fillStyle = "rgba(255, 255, 255, 0.62)";
    context.font = '500 24px "Swiss 721", "Helvetica Neue", Arial, sans-serif';
    wrapCanvasText(context, panel.body || "", 58, 230, 520, 34, 3);

    const rows = panel.rows || [];

    rows.forEach(([label, value], index) => {
      const rowY = 390 + index * 106;

      context.fillStyle = "rgba(255, 255, 255, 0.055)";
      drawRoundedRect(context, 52, rowY - 62, 536, 82, 24);
      context.fill();
      context.strokeStyle = "rgba(218, 218, 218, 0.13)";
      context.stroke();

      context.fillStyle = "rgba(218, 218, 218, 0.78)";
      context.font = '600 18px "Swiss 721", "Helvetica Neue", Arial, sans-serif';
      context.fillText(label, 78, rowY - 28);

      context.fillStyle = "rgba(255, 255, 255, 0.95)";
      context.font = '600 30px "Swiss 721", "Helvetica Neue", Arial, sans-serif';
      context.fillText(value, 78, rowY + 10);
    });

    context.fillStyle = "rgba(255, 255, 255, 0.5)";
    context.font = '500 20px "Swiss 721", "Helvetica Neue", Arial, sans-serif';
    context.fillText(panel.footer || "SCROLL TO OPEN NEXT PART", 56, 810);

    const texture = new THREE.CanvasTexture(textureCanvas);
    if ("colorSpace" in texture && THREE.SRGBColorSpace) texture.colorSpace = THREE.SRGBColorSpace;
    texture.anisotropy = 4;
    texture.needsUpdate = true;

    return texture;
  };

  const createRoundedPhoneShape = (THREE, width, height, radius) => {
    const shape = new THREE.Shape();
    const x = -width / 2;
    const y = -height / 2;
    const r = Math.min(radius, width / 2, height / 2);

    shape.moveTo(x + r, y);
    shape.lineTo(x + width - r, y);
    shape.quadraticCurveTo(x + width, y, x + width, y + r);
    shape.lineTo(x + width, y + height - r);
    shape.quadraticCurveTo(x + width, y + height, x + width - r, y + height);
    shape.lineTo(x + r, y + height);
    shape.quadraticCurveTo(x, y + height, x, y + height - r);
    shape.lineTo(x, y + r);
    shape.quadraticCurveTo(x, y, x + r, y);

    return shape;
  };

  const normalizePhoneGeometryUv = (THREE, geometry) => {
    geometry.computeBoundingBox();

    const box = geometry.boundingBox;
    if (!box) return geometry;

    const position = geometry.attributes.position;
    const width = box.max.x - box.min.x || 1;
    const height = box.max.y - box.min.y || 1;
    const uvs = [];

    for (let index = 0; index < position.count; index += 1) {
      uvs.push(
        (position.getX(index) - box.min.x) / width,
        (position.getY(index) - box.min.y) / height
      );
    }

    geometry.setAttribute("uv", new THREE.Float32BufferAttribute(uvs, 2));
    geometry.attributes.uv.needsUpdate = true;

    return geometry;
  };

  const initLoyaltyInterface = () => {
    document.querySelectorAll("[data-hcx-loyalty-program]").forEach((section) => {
      if (section.dataset.hcxLegacyInterfaceBound === "true") return;

      const isMobileLegacyTabs = window.matchMedia("(max-width: 749px)").matches;
      if (isMobileLegacyTabs) {
        section.dataset.hcxLegacyMobileTabs = "true";
        section.classList.add("hcx-legacy-mobile-tabs-mode", "hcx-legacy-mobile-pages-mode");
        html.classList.add("hcx-legacy-mobile-snap");
      }

      const phoneStage = section.querySelector(":scope > .hcx-loyalty-phone-stage");
      const hero = section.querySelector(":scope > .hcx-loyalty-program__hero");
      const system = section.querySelector(":scope > .hcx-loyalty-program__system");
      const earn = section.querySelector(":scope > .hcx-loyalty-earn");
      const body = section.querySelector(":scope > .hcx-loyalty-program__body");
      const tiers = body?.querySelector(".hcx-loyalty-tiers");
      const review = section.querySelector(":scope > .hcx-loyalty-review-panel");
      const joy = section.querySelector(":scope > .hcx-loyalty-joy");
      const ordersPanel = section.querySelector(":scope > .hcx-legacy-orders-panel");
      const tracking = ordersPanel?.querySelector("[data-hcx-tracking-hub]") || section.querySelector(":scope > .hcx-tracking-hub");

      if (!phoneStage || !hero || !system || !earn || !tiers || !review) return;

      section.dataset.hcxLegacyInterfaceBound = "true";
      section.dataset.hcxLoyaltyInterface = "true";
      section.classList.add("hcx-legacy-interface", "hcx-legacy-flyouts");

      const pointsText = section.querySelector(".hcx-loyalty-profile > strong")?.textContent.trim() || "0";
      const tierText = section.querySelector(".hcx-loyalty-profile__topline em")?.textContent.trim() || "Mortal";
      const pointsPerPound = Number(section.dataset.hcxPointsPerPound || 1);
      const tierCount = tiers.querySelectorAll(".hcx-loyalty-tier").length || 6;
      const ordersSummary = tracking?.dataset.hcxTrackingSummary || "Track and return";
      const spendUnitText = `${pointsPerPound} / \u00a31`;

      const createElement = (tag, className, text) => {
        const element = document.createElement(tag);
        if (className) element.className = className;
        if (text) element.textContent = text;
        return element;
      };

      const createPanelHeader = (kicker, title, copy) => {
        const header = createElement("div", "hcx-legacy-panel__header");
        const titleBlock = createElement("div");
        const kickerNode = createElement("p", "hcx-kicker", kicker);
        const titleNode = createElement("h2", "", title);

        titleBlock.append(kickerNode, titleNode);
        header.append(titleBlock);
        if (copy) header.append(createElement("p", "", copy));

        return header;
      };

      const stage = createElement("div", "hcx-legacy-stage");
      stage.dataset.hcxLegacyStage = "";
      const rockfield = createElement("div", "hcx-legacy-rockfield");
      rockfield.setAttribute("aria-hidden", "true");
      Array.from({ length: 16 }).forEach((_, index) => {
        const rock = createElement("span", "hcx-legacy-rockfield__rock");
        rock.dataset.hcxLegacyRock = String(index);
        rockfield.append(rock);
      });
      const sticky = createElement("div", "hcx-legacy-stage__sticky");
      const phoneColumn = createElement("aside", "hcx-legacy-phone-column");
      phoneColumn.setAttribute("aria-label", "Legacy phone controller");
      const notificationLink = createElement("a", "hcx-legacy-order-notification-link");
      notificationLink.dataset.hcxOrderNotificationLink = "";
      notificationLink.href = "/collections/all";
      notificationLink.textContent = "Open product";
      notificationLink.setAttribute("aria-label", "Open product from order notification");
      notificationLink.hidden = true;
      const detail = createElement("div", "hcx-legacy-detail");
      detail.dataset.hcxLegacyDetail = "";
      const progress = createElement("div", "hcx-legacy-progress");
      progress.setAttribute("aria-hidden", "true");
      const progressLabel = createElement("span", "", "01 / WELCOME");
      progressLabel.setAttribute("data-hcx-preserve-case", "");
      progressLabel.dataset.hcxLegacyProgressLabel = "";
      const progressTrack = createElement("i");
      const progressBar = createElement("b");
      progressBar.dataset.hcxLegacyProgressBar = "";

      progressTrack.append(progressBar);
      progress.append(progressLabel, progressTrack);
      detail.append(progress);

      const tabData = [
        ["Welcome", tierText, "hcx-legacy-panel-profile"],
        ["Points", spendUnitText, "hcx-legacy-panel-points"],
        ...(joy ? [["Redeem", "Coupons", "hcx-legacy-panel-redeem"]] : []),
        ["Tiers", `${tierCount} tiers`, "hcx-legacy-panel-tiers"],
        ...(ordersPanel ? [["Orders", ordersSummary, "hcx-legacy-panel-orders"]] : []),
      ];

      const phoneHotspots = createElement("div", "hcx-legacy-phone-hotspots");
      phoneHotspots.setAttribute("aria-label", "Legacy phone screens");
      phoneHotspots.setAttribute("role", "tablist");
      tabData.forEach(([label, , panelId], index) => {
        const button = createElement("button", "hcx-legacy-phone-hotspot");
        button.type = "button";
        button.dataset.hcxLoyaltyTab = String(index);
        button.dataset.hcxPhoneHotspot = label;
        button.style.setProperty("--hcx-phone-hotspot-top", `${26.9 + index * 8.94}%`);
        button.setAttribute("aria-controls", panelId);
        button.setAttribute("aria-label", `Show ${label}`);
        button.setAttribute("aria-selected", index === 0 ? "true" : "false");
        button.setAttribute("role", "tab");
        phoneHotspots.append(button);
      });

      const mobileTabs = createElement("div", "hcx-legacy-mobile-tabs");
      mobileTabs.setAttribute("aria-label", "Legacy sections");
      mobileTabs.setAttribute("role", "tablist");
      tabData.forEach(([label, meta, panelId], index) => {
        const button = createElement("button");
        button.type = "button";
        button.dataset.hcxLoyaltyTab = String(index);
        button.setAttribute("aria-controls", panelId);
        button.setAttribute("aria-selected", index === 0 ? "true" : "false");
        button.setAttribute("role", "tab");
        button.append(createElement("span", "", label), createElement("strong", "", meta));
        mobileTabs.append(button);
      });

      phoneColumn.append(phoneStage, phoneHotspots, notificationLink);

      const panels = [
        {
          id: "hcx-legacy-panel-profile",
          modifier: "profile",
          nodes: [hero],
          title: "Welcome",
        },
        {
          header: createPanelHeader(
            "Points",
            "Earn. Redeem. Repeat.",
            `Every paid order earns ${spendUnitText}. Convert points into vouchers and use them at checkout.`
          ),
          id: "hcx-legacy-panel-points",
          nodes: [system],
          title: "Points",
        },
        ...(joy ? [{
          header: createPanelHeader(
            "Redeem",
            "Get coupons.",
            "Turn points into checkout coupons. Open coupons to claim what is available on your account."
          ),
          id: "hcx-legacy-panel-redeem",
          modifier: "redeem",
          nodes: [joy],
          title: "Redeem",
        }] : []),
        {
          header: createPanelHeader(
            "Tiers",
            "Your Legacy path.",
            "Move up as your lifetime spend grows. Your Legacy tier updates automatically."
          ),
          id: "hcx-legacy-panel-tiers",
          nodes: [tiers],
          title: "Tiers",
        },
      ];
      if (ordersPanel) {
        panels.push({
          id: "hcx-legacy-panel-orders",
          header: createPanelHeader(
            "Orders",
            "Orders in one place.",
            "Track fulfilment, open order details and start a return or exchange when needed."
          ),
          nodes: [ordersPanel, review],
          title: "Orders",
        });
      }
      section.dataset.hcxPanelCount = String(panels.length);

      panels.forEach((panel, index) => {
        const article = createElement("article", `hcx-legacy-panel${panel.modifier ? ` hcx-legacy-panel--${panel.modifier}` : ""}`);
        article.id = panel.id;
        article.dataset.hcxLoyaltyPanel = String(index);
        article.tabIndex = -1;
        if (index === 0) {
          article.classList.add("is-active");
        } else if (!isMobileLegacyTabs) {
          article.setAttribute("aria-hidden", "true");
        }
        if (panel.header) article.append(panel.header);
        panel.nodes.forEach((node) => article.append(node));
        detail.append(article);
      });

      if (body && !body.children.length) body.remove();

      const scrollSteps = createElement("div", "hcx-legacy-scroll-steps");
      scrollSteps.setAttribute("aria-hidden", "true");
      panels.forEach((_, index) => {
        const step = createElement("span");
        step.dataset.hcxLoyaltyTabStep = String(index);
        scrollSteps.append(step);
      });

      sticky.append(rockfield, phoneColumn, mobileTabs, detail);
      stage.append(sticky, scrollSteps);
      section.prepend(stage);

      const reviewTargetPanelId = ordersPanel ? "hcx-legacy-panel-orders" : "hcx-legacy-panel-points";
      const reviewTargetPanelIndex = panels.findIndex((panel) => panel.id === reviewTargetPanelId);
      section.querySelectorAll('a[href="#review-reward"]').forEach((link) => {
        link.dataset.hcxLoyaltyTab = String(reviewTargetPanelIndex >= 0 ? reviewTargetPanelIndex : 1);
        link.setAttribute("href", `#${reviewTargetPanelId}`);
        link.setAttribute("role", "button");
      });

      const panelElements = Array.from(section.querySelectorAll("[data-hcx-loyalty-panel]"));
      const steps = Array.from(section.querySelectorAll("[data-hcx-loyalty-tab-step]"));
      const panelCount = Math.max(panelElements.length, 1);
      stage.style.setProperty("--hcx-legacy-stage-height", `${Math.max(panelCount * 112, 520)}vh`);
      scrollSteps.style.gridTemplateRows = `repeat(${panelCount}, minmax(0, 1fr))`;
      const ordersPanelIndex = panelElements.findIndex((panel) => panel.id === "hcx-legacy-panel-orders");
      section.querySelectorAll('a[href="#legacy-orders"]').forEach((link) => {
        if (ordersPanelIndex < 0) return;
        link.dataset.hcxLoyaltyTab = String(ordersPanelIndex);
        link.setAttribute("href", "#hcx-legacy-panel-orders");
        link.setAttribute("role", "button");
      });
      const tabButtons = Array.from(section.querySelectorAll("[data-hcx-loyalty-tab]"));
      const rocks = Array.from(rockfield.querySelectorAll("[data-hcx-legacy-rock]")).map((rock, index) => ({
        node: rock,
        x: [-38, 22, 56, -18, 44, -64, 78, 8, -82, 68, -8, 34, -52, 88, -72, 62][index] || 0,
        y: [-24, 18, -42, 36, 28, -8, 54, -36, 46, -18, 64, -54, 12, 36, -30, 48][index] || 0,
        r: [-7, 10, -14, 8, -4, 13, -10, 6, -12, 14, -6, 9, -8, 11, -10, 12][index] || 0,
      }));
      let activeIndex = -1;
      let ticking = false;
      let programmaticScrollIndex = null;
      let programmaticScrollTimer = null;
      let programmaticScrollFrame = null;
      let hashPanelLockIndex = null;
      let hashPanelLockScrollY = 0;
      let wheelLocked = false;
      let wheelLockTimer = null;
      let touchStartX = 0;
      let touchStartY = 0;
      let touchSnapStarted = false;
      let mobileHeightFrame = null;
      let mobileHeightTimer = null;

      const isCompactLegacyViewport = () => window.matchMedia("(max-width: 749px)").matches;

      const syncLegacyMobileMode = () => {
        const isCompact = isCompactLegacyViewport();
        section.dataset.hcxLegacyMobileTabs = isCompact ? "true" : "false";
        section.classList.toggle("hcx-legacy-mobile-tabs-mode", isCompact);
        section.classList.toggle("hcx-legacy-mobile-pages-mode", isCompact);
        html.classList.toggle("hcx-legacy-mobile-snap", isCompact && document.body.classList.contains("hcx-legacy-page"));

        panelElements.forEach((panel) => {
          const panelIndex = Number(panel.dataset.hcxLoyaltyPanel);
          if (isCompact) {
            panel.removeAttribute("aria-hidden");
          } else {
            panel.toggleAttribute("aria-hidden", activeIndex >= 0 && panelIndex !== activeIndex);
          }
        });

        return isCompact;
      };

      const clearMobilePanelHeight = () => {
        [section, stage, sticky].forEach((node) => {
          node.style.removeProperty("height");
          node.style.removeProperty("min-height");
        });
        delete section.dataset.hcxLegacyMobileHeight;
      };

      const syncMobilePanelHeight = () => {
        if (!isCompactLegacyViewport()) {
          clearMobilePanelHeight();
          return;
        }

        const lastPanel = panelElements[panelElements.length - 1];
        if (!lastPanel) return;

        const stickyStyles = window.getComputedStyle(sticky);
        const paddingTop = parseFloat(stickyStyles.paddingTop) || 0;
        const paddingBottom = parseFloat(stickyStyles.paddingBottom) || 0;
        const panelBottoms = panelElements.map((panel) => {
          const panelRect = panel.getBoundingClientRect();
          const detailRect = detail.getBoundingClientRect();
          return Math.max(0, panelRect.bottom - detailRect.top);
        });
        const detailHeight = Math.max(
          detail.scrollHeight || 0,
          detail.offsetHeight || 0,
          detail.getBoundingClientRect().height || 0,
          ...panelBottoms
        );
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
        const nextHeight = Math.ceil(Math.max(viewportHeight, paddingTop + detailHeight + paddingBottom));

        [section, stage, sticky].forEach((node) => {
          node.style.setProperty("height", `${nextHeight}px`, "important");
          node.style.setProperty("min-height", `${nextHeight}px`, "important");
        });
        section.dataset.hcxLegacyMobileHeight = String(nextHeight);
      };

      const queueMobilePanelHeight = () => {
        if (mobileHeightFrame !== null) {
          window.cancelAnimationFrame(mobileHeightFrame);
          mobileHeightFrame = null;
        }
        window.clearTimeout(mobileHeightTimer);

        mobileHeightFrame = window.requestAnimationFrame(() => {
          mobileHeightFrame = null;
          syncMobilePanelHeight();
        });
        mobileHeightTimer = window.setTimeout(syncMobilePanelHeight, 220);
      };

      const updateRockfield = (progressValue) => {
        const panelTravel = Math.max(panelElements.length - 1, 1);
        const tabProgress = clampValue(progressValue, 0, 1) * panelTravel;

        section.style.setProperty("--hcx-rock-phase", tabProgress.toFixed(3));
        section.style.setProperty("--hcx-rock-pane-a-x", `${(-1.2 * tabProgress).toFixed(2)}rem`);
        section.style.setProperty("--hcx-rock-pane-a-y", `${(.25 * tabProgress).toFixed(2)}rem`);
        section.style.setProperty("--hcx-rock-pane-b-x", `${(1 * tabProgress).toFixed(2)}rem`);
        section.style.setProperty("--hcx-rock-pane-b-y", `${(-.45 * tabProgress).toFixed(2)}rem`);
        rocks.forEach(({ node, x, y, r }, index) => {
          const sway = Math.sin((tabProgress * .92 + index * .63) * Math.PI) * 5.5;
          node.style.setProperty("--hcx-rock-x", `${(tabProgress * x + sway).toFixed(2)}px`);
          node.style.setProperty("--hcx-rock-y", `${(tabProgress * y + Math.cos(tabProgress + index) * 3.4).toFixed(2)}px`);
          node.style.setProperty("--hcx-rock-r", `${(tabProgress * r).toFixed(2)}deg`);
        });
      };

      const setActive = (index, shouldFocus = false) => {
        const nextIndex = clampValue(index, 0, panelElements.length - 1);
        if (nextIndex === activeIndex) {
          queueMobilePanelHeight();
          if (shouldFocus) panelElements[nextIndex]?.focus({ preventScroll: true });
          return;
        }

        activeIndex = nextIndex;
        const stackedMobile = isCompactLegacyViewport();
        updateRockfield(nextIndex / Math.max(panelElements.length - 1, 1));

        tabButtons.forEach((button) => {
          const isActive = Number(button.dataset.hcxLoyaltyTab) === nextIndex;
          button.classList.toggle("is-active", isActive);
          if (button.matches(".hcx-legacy-phone-tabs button, .hcx-legacy-phone-hotspot, .hcx-legacy-mobile-tabs button")) {
            button.setAttribute("aria-selected", isActive ? "true" : "false");
          }
        });

        panelElements.forEach((panel) => {
          const panelIndex = Number(panel.dataset.hcxLoyaltyPanel);
          const isActive = panelIndex === nextIndex;
          const panelDelta = panelIndex - nextIndex;

          panel.style.setProperty("--hcx-panel-delta", String(panelDelta));
          panel.classList.toggle("is-active", isActive);
          panel.classList.toggle("is-before", panelDelta < 0);
          panel.classList.toggle("is-after", panelDelta > 0);
          if (stackedMobile) {
            panel.removeAttribute("aria-hidden");
          } else {
            panel.toggleAttribute("aria-hidden", !isActive);
          }
        });

        const label = tabData[nextIndex]?.[0] || "Legacy";
        progressLabel.textContent = `${String(nextIndex + 1).padStart(2, "0")} / ${label.toUpperCase()}`;
        progressBar.style.transform = `scaleX(${(nextIndex + 1) / panelElements.length})`;
        section.dataset.hcxLegacyActivePanel = String(nextIndex + 1);
        section.style.setProperty("--hcx-active-panel", String(nextIndex));
        queueMobilePanelHeight();

        if (shouldFocus) panelElements[nextIndex]?.focus({ preventScroll: true });
      };

      const getStageMetrics = () => {
        const rect = stage.getBoundingClientRect();
        const viewport = window.innerHeight || document.documentElement.clientHeight || 1;
        const travel = Math.max(stage.offsetHeight - viewport, viewport * Math.max(panelElements.length - 1, 1));

        return {
          rect,
          viewport,
          travel,
          top: window.scrollY + rect.top,
        };
      };

      const getStageProgress = () => {
        const { rect, travel } = getStageMetrics();

        return clampValue((0 - rect.top) / travel, 0, .999);
      };

      const getMobilePanelViewportOffset = () => {
        const header = document.querySelector(".section-header");
        const headerHeight = header?.getBoundingClientRect?.().height || 0;
        const tabsRect = mobileTabs.getBoundingClientRect();
        const tabsBottom = tabsRect.height ? tabsRect.bottom : headerHeight + 64;
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;

        return Math.round(Math.min(Math.max(tabsBottom + 12, headerHeight + 24), Math.max(112, viewportHeight * .3)));
      };

      const getNearestMobilePanelIndex = () => {
        const offset = getMobilePanelViewportOffset();
        let nearestIndex = activeIndex >= 0 ? activeIndex : 0;
        let nearestDistance = Number.POSITIVE_INFINITY;

        panelElements.forEach((panel) => {
          const panelIndex = Number(panel.dataset.hcxLoyaltyPanel);
          const rect = panel.getBoundingClientRect();
          const distance = Math.abs(rect.top - offset);
          const containsOffset = rect.top <= offset + 24 && rect.bottom >= offset + 24;
          const weightedDistance = containsOffset ? distance * .35 : distance;

          if (weightedDistance < nearestDistance) {
            nearestDistance = weightedDistance;
            nearestIndex = panelIndex;
          }
        });

        return clampValue(nearestIndex, 0, panelElements.length - 1);
      };

      const scrollToPanel = (index, shouldFocus = false, behavior = "smooth") => {
        const nextIndex = clampValue(index, 0, panelElements.length - 1);
        const { top } = getStageMetrics();
        const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

        if (isCompactLegacyViewport()) {
          const targetPanel = panelElements[nextIndex];

          window.clearTimeout(programmaticScrollTimer);
          if (programmaticScrollFrame !== null) {
            window.cancelAnimationFrame(programmaticScrollFrame);
            programmaticScrollFrame = null;
          }

          programmaticScrollIndex = nextIndex;
          setActive(nextIndex, shouldFocus);

          const scrollMobilePanelIntoView = (scrollBehavior = behavior) => {
            const panelTop = targetPanel
              ? window.scrollY + targetPanel.getBoundingClientRect().top - getMobilePanelViewportOffset()
              : top;

            window.scrollTo({
              behavior: reducedMotion ? "auto" : scrollBehavior,
              top: Math.max(0, panelTop),
            });
          };

          scrollMobilePanelIntoView(behavior);
          window.requestAnimationFrame(() => scrollMobilePanelIntoView("auto"));
          window.setTimeout(() => {
            if (programmaticScrollIndex === nextIndex) scrollMobilePanelIntoView("auto");
          }, 180);

          programmaticScrollTimer = window.setTimeout(() => {
            if (programmaticScrollIndex === nextIndex) {
              programmaticScrollIndex = null;
              requestSync();
            }
          }, reducedMotion ? 80 : 1050);
          return;
        }

        window.clearTimeout(programmaticScrollTimer);
        if (programmaticScrollFrame !== null) {
          window.cancelAnimationFrame(programmaticScrollFrame);
          programmaticScrollFrame = null;
        }

        programmaticScrollIndex = null;
        setActive(nextIndex, shouldFocus);
        panelElements[nextIndex]?.scrollTo?.({
          behavior: reducedMotion ? "auto" : behavior,
          top: 0,
        });
      };

      const getHashPanelViewportOffset = () => {
        if (isCompactLegacyViewport()) return getMobilePanelViewportOffset();

        const header = document.querySelector(".section-header");
        const headerHeight = header?.getBoundingClientRect?.().height || 0;

        return Math.min(Math.max(headerHeight + 18, 24), 116);
      };

      const scrollHashPanelIntoView = (index, shouldFocus = false, behavior = "auto") => {
        const nextIndex = clampValue(index, 0, panelElements.length - 1);
        const { travel, top } = getStageMetrics();

        hashPanelLockIndex = nextIndex;
        if (isCompactLegacyViewport()) {
          const targetPanel = panelElements[nextIndex];
          hashPanelLockScrollY = targetPanel
            ? Math.max(0, window.scrollY + targetPanel.getBoundingClientRect().top - getHashPanelViewportOffset())
            : top;
        } else {
          const targetStep = steps[nextIndex];
          hashPanelLockScrollY = targetStep
            ? window.scrollY + targetStep.getBoundingClientRect().top
            : top + travel * (nextIndex / Math.max(panelElements.length - 1, 1));
        }

        scrollToPanel(nextIndex, shouldFocus, behavior);
      };

      const getPanelIndexFromHash = (hash = "") => {
        const hashId = String(hash || "").replace(/^#/, "");
        if (!hashId) return -1;
        if (hashId === "legacy-orders") return ordersPanelIndex;

        const directPanelIndex = panelElements.findIndex((panel) => panel.id === hashId);
        if (directPanelIndex >= 0) return directPanelIndex;

        const anchorTarget = document.getElementById(hashId);
        const anchorPanel = anchorTarget?.closest?.("[data-hcx-loyalty-panel]");
        if (!anchorPanel || !section.contains(anchorPanel)) return -1;

        const anchorPanelIndex = Number(anchorPanel.dataset.hcxLoyaltyPanel);
        return Number.isFinite(anchorPanelIndex) ? anchorPanelIndex : -1;
      };

      const clearPanelHashLock = () => {
        if (getPanelIndexFromHash(window.location.hash) < 0) return;

        hashPanelLockIndex = null;
        if (window.history?.replaceState) {
          window.history.replaceState(window.history.state, "", `${window.location.pathname}${window.location.search}`);
        }
      };

      const openHashPanel = (hash = window.location.hash, behavior = "auto") => {
        const requestedHash = String(hash || "");
        const hashPanelIndex = getPanelIndexFromHash(hash);
        if (hashPanelIndex < 0) return false;

        scrollHashPanelIntoView(hashPanelIndex, true, behavior);
        [140, 520, 1200, 2200].forEach((delay) => {
          window.setTimeout(() => {
            if (requestedHash && window.location.hash !== requestedHash) return;
            const targetPanel = panelElements[hashPanelIndex];
            const panelRect = targetPanel?.getBoundingClientRect();
            const isUsable =
              targetPanel?.classList.contains("is-active") &&
              panelRect &&
              panelRect.bottom > getHashPanelViewportOffset() + 48 &&
              panelRect.top < (window.innerHeight || document.documentElement.clientHeight || 1) - 48;
            if (isUsable) return;

            scrollHashPanelIntoView(hashPanelIndex, false, "auto");
          }, delay);
        });
        return true;
      };

      const syncFromScroll = () => {
        ticking = false;
        if (isCompactLegacyViewport()) {
          syncLegacyMobileMode();
          const nextIndex = getNearestMobilePanelIndex();
          const progressValue = nextIndex / Math.max(panelElements.length - 1, 1);

          section.dataset.hcxLegacyScroll = progressValue.toFixed(3);
          updateRockfield(progressValue);
          if (programmaticScrollIndex === null && nextIndex !== activeIndex) setActive(nextIndex);
          return;
        }

        if (hashPanelLockIndex !== null && activeIndex !== hashPanelLockIndex) {
          setActive(hashPanelLockIndex);
        }
      };

      const requestSync = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(syncFromScroll);
      };

      const getWheelScrollContext = (target, clientX, clientY) => {
        if (!(target instanceof Element)) return null;

        const activePanelFromTarget = target.closest(".hcx-legacy-panel.is-active");
        const activePanel = activePanelFromTarget || section.querySelector(".hcx-legacy-panel.is-active");
        if (!activePanel || !detail.contains(activePanel)) return null;

        if (!isCompactLegacyViewport()) {
          const stickyRect = sticky.getBoundingClientRect();
          const isPointerOverStage =
            clientX >= stickyRect.left &&
            clientX <= stickyRect.right &&
            clientY >= stickyRect.top &&
            clientY <= stickyRect.bottom;
          if (!isPointerOverStage) return null;

          const detailRect = detail.getBoundingClientRect();
          const isPointerOverDetail =
            clientX >= detailRect.left &&
            clientX <= detailRect.right &&
            clientY >= detailRect.top &&
            clientY <= detailRect.bottom;
          if (!isPointerOverDetail && !detail.contains(target)) return null;

          let desktopNode = activePanel.contains(target) ? target : activePanel;
          while (desktopNode && desktopNode !== stage) {
            const style = window.getComputedStyle(desktopNode);
            const canScrollY = /(auto|scroll|overlay)/.test(style.overflowY) && desktopNode.scrollHeight > desktopNode.clientHeight + 2;

            if (canScrollY) {
              return {
                allowPageAtBoundary: false,
                capturesWheel: true,
                scrollNode: desktopNode,
              };
            }
            if (desktopNode === activePanel) break;

            desktopNode = desktopNode.parentElement;
          }

          return {
            allowPageAtBoundary: false,
            capturesWheel: true,
            scrollNode: activePanel.scrollHeight > activePanel.clientHeight + 2 ? activePanel : null,
          };
        }

        const panelRect = activePanel.getBoundingClientRect();
        const isPointerOverPanel = clientX >= panelRect.left && clientX <= panelRect.right && clientY >= panelRect.top && clientY <= panelRect.bottom;
        if (!activePanelFromTarget && !isPointerOverPanel) return null;

        let node = activePanel.contains(target) ? target : activePanel;

        while (node && node !== stage) {
          const style = window.getComputedStyle(node);
          const canScrollY = /(auto|scroll|overlay)/.test(style.overflowY) && node.scrollHeight > node.clientHeight + 2;

          if (canScrollY) return { capturesWheel: true, scrollNode: node };
          if (node === activePanel) break;

          node = node.parentElement;
        }

        return { capturesWheel: true, scrollNode: activePanel.scrollHeight > activePanel.clientHeight + 2 ? activePanel : null };
      };

      const scrollNestedPanel = (target, delta, clientX, clientY) => {
        const scrollContext = getWheelScrollContext(target, clientX, clientY);
        if (!scrollContext) return false;
        if (!scrollContext.capturesWheel) return false;

        const scrollNode = scrollContext.scrollNode;
        if (!scrollNode) return !scrollContext.allowPageAtBoundary;

        const maxScrollTop = Math.max(0, scrollNode.scrollHeight - scrollNode.clientHeight);
        const nextScrollTop = clampValue(scrollNode.scrollTop + delta, 0, maxScrollTop);
        const canScrollDown = delta > 0 && scrollNode.scrollTop < maxScrollTop - 2;
        const canScrollUp = delta < 0 && scrollNode.scrollTop > 2;

        if (!canScrollDown && !canScrollUp) return !scrollContext.allowPageAtBoundary;

        scrollNode.scrollTop = nextScrollTop;
        return true;
      };

      const stepPanelFromDelta = (delta) => {
        if (isCompactLegacyViewport()) {
          const direction = delta > 0 ? 1 : -1;
          const baseIndex = activeIndex >= 0 ? activeIndex : getNearestMobilePanelIndex();
          const nextIndex = baseIndex + direction;
          if (nextIndex < 0 || nextIndex >= panelElements.length) return false;
        if (wheelLocked) return true;

        window.clearTimeout(wheelLockTimer);
        wheelLocked = true;
        clearPanelHashLock();
        scrollToPanel(nextIndex, false, "smooth");
        wheelLockTimer = window.setTimeout(() => {
          wheelLocked = false;
        }, window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 140 : 980);

          return true;
        }

        const { rect, viewport } = getStageMetrics();
        const isPinned = rect.top <= 8 && rect.bottom >= viewport - 8;
        if (!isPinned) return false;

        const direction = delta > 0 ? 1 : -1;
        const nextIndex = activeIndex + direction;
        if (nextIndex < 0 || nextIndex >= panelElements.length) return false;
        if (wheelLocked) return true;

        window.clearTimeout(wheelLockTimer);
        wheelLocked = true;
        clearPanelHashLock();
        scrollToPanel(nextIndex, false);
        wheelLockTimer = window.setTimeout(() => {
          wheelLocked = false;
        }, window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 120 : 280);

        return true;
      };

      section.addEventListener("click", (event) => {
        const trigger = event.target.closest("[data-hcx-loyalty-tab]");
        if (!trigger || !section.contains(trigger)) return;

        event.preventDefault();
        const index = Number(trigger.dataset.hcxLoyaltyTab || 0);
        const hash = trigger instanceof HTMLAnchorElement ? trigger.hash : "";

        if (!hash) clearPanelHashLock();
        scrollToPanel(index, true);

        if (hash.length > 1) {
          const anchorTarget = document.getElementById(hash.slice(1));
          if (!anchorTarget || !section.contains(anchorTarget)) return;

          const scrollActivePanelToAnchor = () => {
            const activePanel = anchorTarget.closest(".hcx-legacy-panel");
            if (!activePanel) return;

            let offset = 0;
            let offsetNode = anchorTarget;

            while (offsetNode instanceof HTMLElement && offsetNode !== activePanel) {
              offset += offsetNode.offsetTop || 0;
              offsetNode = offsetNode.offsetParent;

              if (offsetNode && offsetNode !== activePanel && !activePanel.contains(offsetNode)) {
                offsetNode = null;
                break;
              }
            }

            if (offsetNode !== activePanel) {
              const panelRect = activePanel.getBoundingClientRect();
              const targetRect = anchorTarget.getBoundingClientRect();
              offset = targetRect.top - panelRect.top + activePanel.scrollTop;
            }

            activePanel.scrollTop = Math.max(0, offset - 24);
          };

          [60, 180, 420].forEach((delay) => {
            window.setTimeout(scrollActivePanelToAnchor, delay);
          });
        }
      });

      stage.addEventListener(
        "wheel",
        (event) => {
          const delta = Math.abs(event.deltaY) >= Math.abs(event.deltaX) ? event.deltaY : event.deltaX;
          if (Math.abs(delta) < 7) return;
          if (isCompactLegacyViewport()) return;

          if (!isCompactLegacyViewport() && scrollNestedPanel(event.target, delta, event.clientX, event.clientY)) {
            event.preventDefault();
            return;
          }

          if (!stepPanelFromDelta(delta)) return;
          event.preventDefault();
        },
        { passive: false }
      );

      stage.addEventListener(
        "touchstart",
        (event) => {
          const touch = event.touches?.[0];
          if (!touch) return;

          touchStartX = touch.clientX;
          touchStartY = touch.clientY;
          touchSnapStarted = false;
        },
        { passive: true }
      );

      stage.addEventListener(
        "touchmove",
        (event) => {
          const touch = event.touches?.[0];
          if (!touch) return;

          const deltaX = touch.clientX - touchStartX;
          const deltaY = touch.clientY - touchStartY;

          if (isCompactLegacyViewport()) {
            return;
          }

          if (Math.abs(deltaY) < 34 || Math.abs(deltaY) < Math.abs(deltaX) * 1.2) return;

          if (!stepPanelFromDelta(deltaY > 0 ? -1 : 1)) return;
          event.preventDefault();
          touchStartX = touch.clientX;
          touchStartY = touch.clientY;
        },
        { passive: false }
      );

      stage.addEventListener(
        "touchend",
        () => {
          touchSnapStarted = false;
        },
        { passive: true }
      );

      stage.addEventListener(
        "touchcancel",
        () => {
          touchSnapStarted = false;
        },
        { passive: true }
      );

      window.addEventListener(
        "keydown",
        (event) => {
          if (!isCompactLegacyViewport()) return;
          if (event.defaultPrevented) return;

          const target = event.target;
          const isEditable =
            target instanceof HTMLElement &&
            (target.isContentEditable || /^(INPUT|SELECT|TEXTAREA|BUTTON)$/i.test(target.tagName));
          if (isEditable) return;

          const nextKeys = ["ArrowDown", "PageDown"];
          const previousKeys = ["ArrowUp", "PageUp"];
          const isSpace = event.key === " ";
          let delta = 0;

          if (nextKeys.includes(event.key) || (isSpace && !event.shiftKey)) delta = 1;
          if (previousKeys.includes(event.key) || (isSpace && event.shiftKey)) delta = -1;
          if (!delta) return;

          if (!stepPanelFromDelta(delta)) return;
          event.preventDefault();
        },
        { passive: false }
      );

      if ("ResizeObserver" in window) {
        const mobilePanelResizeObserver = new ResizeObserver(() => {
          if (isCompactLegacyViewport()) queueMobilePanelHeight();
        });
        mobilePanelResizeObserver.observe(detail);
        panelElements.forEach((panel) => mobilePanelResizeObserver.observe(panel));
      }

      window.addEventListener("scroll", () => {
        requestSync();
      }, { passive: true });
      window.addEventListener("resize", () => {
        syncLegacyMobileMode();
        if (isCompactLegacyViewport()) {
          queueMobilePanelHeight();
          requestSync();
          return;
        }

        clearMobilePanelHeight();
        requestSync();
      });
      window.addEventListener("hashchange", () => {
        openHashPanel(window.location.hash);
      });
      window.addEventListener("load", () => {
        openHashPanel(window.location.hash, "auto");
        queueMobilePanelHeight();
      }, { once: true });

      syncLegacyMobileMode();
      if (!openHashPanel(window.location.hash, "auto")) setActive(0);
      queueMobilePanelHeight();
      requestSync();
      section.classList.add("is-legacy-interface-ready");
    });
  };

  const initLoyaltyPhoneScenes = () => {
    document.querySelectorAll("[data-hcx-loyalty-phone-stage]").forEach((stage) => {
      if (stage.dataset.hcxPhoneBound === "true") return;

      const program = stage.closest("[data-hcx-loyalty-program]");
      if (program?.classList.contains("hcx-legacy-interface") && window.matchMedia("(max-width: 749px)").matches) {
        stage.dataset.hcxPhoneBound = "true";
        stage.dataset.hcxPhoneDisabledMobile = "true";
        return;
      }

      const canvas = stage.querySelector("[data-hcx-loyalty-phone-canvas]");
      if (!(canvas instanceof HTMLCanvasElement)) return;

      stage.dataset.hcxPhoneBound = "true";

      loadThreeModule()
        .then((THREE) => {
          const pointsText = program?.querySelector(".hcx-loyalty-profile > strong")?.textContent.trim() || "0";
          const tierText = program?.querySelector(".hcx-loyalty-profile__topline em")?.textContent.trim() || "Mortal";
          const phonePointsPerPound = Number(program?.dataset.hcxPointsPerPound || 1);
          const customerName = (program?.dataset.hcxCustomerName || "").trim() || "Guest";
          const isInteractiveLayout = program?.classList.contains("hcx-legacy-interface") || program?.dataset.hcxLoyaltyInterface === "true";
          let rewardAlertActive = program?.dataset.hcxRewardAlertActive === "true";
          let rewardAlertCount = Math.max(0, Number(program?.dataset.hcxAvailableRewardSteps || 0));
          let orderNotification = program?.hcxLegacyOrderNotification || null;
          let requestPhoneRender = () => {};
          const scene = new THREE.Scene();
          const camera = new THREE.PerspectiveCamera(34, 1, .1, 100);
          const renderer = new THREE.WebGLRenderer({
            alpha: true,
            antialias: true,
            canvas,
            powerPreference: "high-performance",
          });
          const phone = new THREE.Group();
          const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
          let animationFrame = null;
          let isVisible = true;

          if ("outputColorSpace" in renderer && THREE.SRGBColorSpace) renderer.outputColorSpace = THREE.SRGBColorSpace;
          if ("toneMapping" in renderer && THREE.ACESFilmicToneMapping) {
            renderer.toneMapping = THREE.ACESFilmicToneMapping;
            renderer.toneMappingExposure = .9;
          }
          renderer.setClearColor(0x000000, 0);
          camera.position.set(0, 0, 8.3);

          scene.add(new THREE.AmbientLight(0xffffff, .54));
          const keyLight = new THREE.DirectionalLight(0xffffff, 2.15);
          keyLight.position.set(2.4, 3.6, 5.4);
          scene.add(keyLight);
          const rimLight = new THREE.PointLight(0xd8d8d8, 1.45, 10);
          rimLight.position.set(-3.2, 1.2, 3.8);
          scene.add(rimLight);

          const bodyGeometry = new THREE.ExtrudeGeometry(createRoundedPhoneShape(THREE, 2.52, 5.4, .44), {
            depth: .055,
            bevelEnabled: true,
            bevelSegments: 10,
            bevelSize: .016,
            bevelThickness: .018,
            curveSegments: 32,
          });
          bodyGeometry.center();

          const bodyMaterial = new THREE.MeshPhysicalMaterial({
            color: 0x050505,
            clearcoat: .5,
            clearcoatRoughness: .42,
            metalness: .18,
            roughness: .48,
          });
          const body = new THREE.Mesh(bodyGeometry, bodyMaterial);
          phone.add(body);
          const bodyEdges = new THREE.LineSegments(
            new THREE.EdgesGeometry(bodyGeometry, 16),
            new THREE.LineBasicMaterial({
              color: 0xd8d8d8,
              transparent: true,
              opacity: .012,
            })
          );
          phone.add(bodyEdges);

          const glassMaterial = new THREE.MeshPhysicalMaterial({
            color: 0x0a0a0a,
            clearcoat: 1,
            clearcoatRoughness: .16,
            metalness: .05,
            roughness: .22,
            transparent: true,
          });
          const screenMaterial = new THREE.MeshBasicMaterial({
            color: 0xffffff,
            map: createLoyaltyPhoneTexture(THREE, pointsText, tierText),
            side: THREE.FrontSide,
            transparent: false,
            opacity: 1,
            depthTest: true,
            depthWrite: true,
            toneMapped: false,
          });

          const screenGeometry = normalizePhoneGeometryUv(
            THREE,
            new THREE.ShapeGeometry(createRoundedPhoneShape(THREE, 2.44, 5.26, .42), 40)
          );
          const screen = new THREE.Mesh(screenGeometry, screenMaterial);
          screen.position.z = .052;
          phone.add(screen);

          const islandMaterial = new THREE.MeshPhysicalMaterial({
            color: 0x020202,
            clearcoat: .62,
            clearcoatRoughness: .34,
            metalness: 0,
            roughness: .42,
            transparent: false,
          });
          const island = new THREE.Mesh(
            new THREE.ShapeGeometry(createRoundedPhoneShape(THREE, .68, .17, .085), 28),
            islandMaterial
          );
          island.position.set(0, 2.34, .059);
          phone.add(island);

          const islandLens = new THREE.Mesh(
            new THREE.CircleGeometry(.027, 24),
            new THREE.MeshBasicMaterial({ color: 0x151515 })
          );
          islandLens.position.set(.2, 2.34, .062);
          phone.add(islandLens);

          const backMaterial = glassMaterial.clone();
          backMaterial.map = createLoyaltyPhoneTexture(THREE, pointsText, tierText, true);
          backMaterial.emissiveMap = backMaterial.map;
          backMaterial.emissive = new THREE.Color(0xc2c2c2);
          backMaterial.emissiveIntensity = .23;
          backMaterial.side = THREE.FrontSide;
          backMaterial.transparent = false;
          backMaterial.opacity = 1;
          backMaterial.depthTest = true;
          backMaterial.depthWrite = true;
          const backGeometry = normalizePhoneGeometryUv(
            THREE,
            new THREE.ShapeGeometry(createRoundedPhoneShape(THREE, 2.36, 5.12, .46), 36)
          );
          const back = new THREE.Mesh(backGeometry, backMaterial);
          back.position.z = -.052;
          back.rotation.y = Math.PI;
          phone.add(back);

          const lensMaterial = new THREE.MeshPhysicalMaterial({
            color: 0x020202,
            clearcoat: .9,
            metalness: .4,
            roughness: .18,
          });
          [[-.68, 1.78], [-.34, 1.42]].forEach(([x, y]) => {
            const lens = new THREE.Mesh(new THREE.CylinderGeometry(.14, .14, .035, 40), lensMaterial);
            lens.rotation.x = Math.PI / 2;
            lens.position.set(x, y, -.105);
            phone.add(lens);
          });

          const buttonMaterial = new THREE.MeshPhysicalMaterial({
            color: 0x151515,
            metalness: .8,
            roughness: .24,
          });
          const sideButton = new THREE.Mesh(new THREE.BoxGeometry(.035, .58, .08), buttonMaterial);
          sideButton.position.set(1.275, 1.28, .005);
          if (!isInteractiveLayout) phone.add(sideButton);

          const systemCards = Array.from(program?.querySelectorAll(".hcx-loyalty-program__system article") || []);
          const tierCards = Array.from(program?.querySelectorAll(".hcx-loyalty-tier") || []);
          const getCardLine = (card, selector, fallback) => card?.querySelector(selector)?.textContent.trim() || fallback;
          const cleanCurrencyLine = (value) =>
            String(value || "")
              .replace(/(?:\u00c3\u201a)?\u00c2?\u00a3/g, "GBP ")
              .replace(/\s+/g, " ")
              .trim();
          const phoneSpendUnitText = `${phonePointsPerPound} ${phonePointsPerPound === 1 ? "point" : "points"} per GBP 1`;
          const birthdayText = cleanCurrencyLine(getCardLine(systemCards[2], "h2", "300 birthday points"));
          const reviewRewardText = cleanCurrencyLine(getCardLine(systemCards[3], "h2", "200 review points"));
          const redeemCards = Array.from(program?.querySelectorAll(".hcx-loyalty-joy__summary span") || []);
          const redeemReadyText = cleanCurrencyLine(getCardLine(redeemCards[1], "strong", "200 pts"));
          const redeemRateText = cleanCurrencyLine(getCardLine(redeemCards[2], "strong", "200 points = GBP 10"));
          const firstTier = getCardLine(tierCards[0], "strong", "Mortal");
          const lastTier = getCardLine(tierCards[tierCards.length - 1], "strong", "Zeus");
          const firstThreshold = cleanCurrencyLine(getCardLine(tierCards[1], "em", "GBP 100 spend"));
          const finalThreshold = cleanCurrencyLine(getCardLine(tierCards[tierCards.length - 1], "em", "GBP 1500 lifetime spend"));
          const trackingHub = program?.querySelector("[data-hcx-tracking-hub]");
          const phoneTabLabels = Array.from(program?.querySelectorAll(".hcx-legacy-phone-hotspot") || [])
            .map((button) => (button.getAttribute("aria-label") || "").replace(/^Show\s+/i, "").trim())
            .filter(Boolean);
          const phonePageLabels = phoneTabLabels.length ? phoneTabLabels : [
            "Welcome",
            "Points",
            ...(program?.querySelector(".hcx-loyalty-joy") ? ["Redeem"] : []),
            "Tiers",
            ...(trackingHub ? ["Orders"] : []),
          ];
          const trackingTotal = trackingHub?.dataset.hcxTrackingTotal || "0";
          const trackingActive = trackingHub?.dataset.hcxTrackingActive || "0";
          const trackingDelivered = trackingHub?.dataset.hcxTrackingDelivered || "0";
          const phoneScreenSpecs = [];
          const findPhonePageIndex = (label, fallbackIndex) => {
            const pageIndex = phonePageLabels.findIndex((page) => page.toLowerCase() === label.toLowerCase());
            return pageIndex >= 0 ? pageIndex : fallbackIndex;
          };
          const hasRedeemPage = phonePageLabels.some((page) => page.toLowerCase() === "redeem");
          const getPhoneEyebrow = (label, fallbackIndex) =>
            `${String(findPhonePageIndex(label, fallbackIndex) + 1).padStart(2, "0")} / ${label.toUpperCase()}`;
          const cleanPageSummaries = phonePageLabels.map((page) => {
            const normalizedPage = page.toLowerCase();
            if (normalizedPage === "welcome") return `${pointsText || "0"} pts / ${tierText || "Mortal"}`;
            if (normalizedPage === "points") return "Earn and redeem";
            if (normalizedPage === "redeem") return "Coupons and codes";
            if (normalizedPage === "tiers") return "Tier progress";
            if (normalizedPage === "tracking" || normalizedPage === "orders") return "Orders and returns";
            return `${page} panel`;
          });
          const cleanPhoneScreenSpecs = [
            {
              body: "Balance, tier and quick actions.",
              eyebrow: getPhoneEyebrow("Welcome", 0),
              footer: "TAP OR SCROLL",
              hero: `${pointsText || "0"} points`,
              index: findPhonePageIndex("Welcome", 0),
              pageSummaries: cleanPageSummaries,
              pages: phonePageLabels,
              rows: [
                ["Tier", tierText || "Mortal"],
                ["Next", "Lifetime spend sets tiers"],
                ["Birthday", birthdayText],
              ],
              title: "Legacy",
            },
            {
              body: "Paid orders become points.",
              eyebrow: getPhoneEyebrow("Points", 1),
              footer: "EARN THEN REDEEM",
              hero: phoneSpendUnitText,
              index: findPhonePageIndex("Points", 1),
              pageSummaries: cleanPageSummaries,
              pages: phonePageLabels,
              rows: [
                ["Earn", cleanCurrencyLine(getCardLine(systemCards[0], "h2", phoneSpendUnitText))],
                ["Redeem", cleanCurrencyLine(getCardLine(systemCards[1], "h2", "200 points = GBP 10"))],
                ["Bonus", reviewRewardText],
              ],
              title: "Points",
            },
            ...(hasRedeemPage ? [{
              body: "Open coupons and claim available rewards.",
              eyebrow: getPhoneEyebrow("Redeem", 2),
              footer: "COUPONS",
              hero: "Redeem points",
              index: findPhonePageIndex("Redeem", 2),
              pageSummaries: cleanPageSummaries,
              pages: phonePageLabels,
              rows: [
                ["Balance", `${pointsText || "0"} pts`],
                ["Ready", redeemReadyText],
                ["Rate", redeemRateText],
              ],
              title: "Redeem",
            }] : []),
            {
              body: "Lifetime spend moves you through six Legacy tiers.",
              eyebrow: getPhoneEyebrow("Tiers", hasRedeemPage ? 3 : 2),
              footer: "FOLLOW THE PATH",
              hero: `${firstTier} to ${lastTier}`,
              index: findPhonePageIndex("Tiers", hasRedeemPage ? 3 : 2),
              pageSummaries: cleanPageSummaries,
              pages: phonePageLabels,
              rows: [
                ["Start", "Join Legacy"],
                ["First", firstThreshold],
                ["Final", finalThreshold],
              ],
              title: "Tiers",
            },
          ];
          if (trackingHub) {
            cleanPhoneScreenSpecs.push({
              body: "Track orders and start returns.",
              eyebrow: getPhoneEyebrow("Orders", hasRedeemPage ? 4 : 3),
              footer: "ORDER HUB",
              hero: "Orders",
              index: findPhonePageIndex("Orders", hasRedeemPage ? 4 : 3),
              pageSummaries: cleanPageSummaries,
              pages: phonePageLabels,
              rows: [
                ["Orders", trackingTotal],
                ["On way", trackingActive],
                ["Delivered", trackingDelivered],
                ["Returns", "Available"],
              ],
              title: "Orders",
            });
          }
          phoneScreenSpecs.splice(0, phoneScreenSpecs.length, ...cleanPhoneScreenSpecs);
          const legacyPanelSpecs = isInteractiveLayout ? [] : [
            {
              body: "Balance, tier and birthday reward stay connected.",
              eyebrow: "PART 01 / WELCOME",
              footer: "LEGACY PROFILE",
              rows: [
                ["BALANCE", `${pointsText || "0"} PTS`],
                ["TIER", tierText || "Mortal"],
                ["BIRTHDAY", birthdayText.toUpperCase()],
              ],
              title: "WELCOME",
            },
            {
              body: "Paid orders become points, then points become vouchers.",
              eyebrow: "PART 02 / POINTS",
              footer: "EARN THEN REDEEM",
              rows: [
                ["EARN", cleanCurrencyLine(getCardLine(systemCards[0], "h2", phoneSpendUnitText)).toUpperCase()],
                ["REDEEM", cleanCurrencyLine(getCardLine(systemCards[1], "h2", "200 points = GBP 10")).toUpperCase()],
                ["BONUS", reviewRewardText.toUpperCase()],
              ],
              title: "POINTS",
            },
            ...(hasRedeemPage ? [{
              body: "Available points can become checkout coupons.",
              eyebrow: "PART 03 / REDEEM",
              footer: "COUPONS",
              rows: [
                ["BALANCE", `${pointsText || "0"} PTS`],
                ["READY", redeemReadyText.toUpperCase()],
                ["RATE", redeemRateText.toUpperCase()],
              ],
              title: "REDEEM",
            }] : []),
            {
              body: "The tier map shows the next useful unlock.",
              eyebrow: hasRedeemPage ? "PART 04 / TIERS" : "PART 03 / TIERS",
              footer: "FOLLOW THE PATH",
              rows: [
                ["START", firstTier.toUpperCase()],
                ["FIRST UNLOCK", firstThreshold.toUpperCase()],
                ["FINAL", `${lastTier.toUpperCase()} / ${finalThreshold.toUpperCase()}`],
              ],
              title: "TIERS",
            },
            ...(trackingHub ? [{
              body: "Orders and returns live together.",
              eyebrow: hasRedeemPage ? "PART 05 / ORDERS" : "PART 04 / ORDERS",
              footer: "ORDER HUB",
              rows: [
                ["ORDERS", trackingTotal],
                ["ON WAY", trackingActive],
                ["DELIVERED", trackingDelivered],
              ],
              title: "ORDERS",
            }] : []),
          ];
          const panelGeometry = new THREE.ShapeGeometry(createRoundedPhoneShape(THREE, 1.94, 2.82, .22), 32);
          const legacyPanels = legacyPanelSpecs.map((panel, index) => {
            const panelGroup = new THREE.Group();
            const panelTexture = createLoyaltyPhonePanelTexture(THREE, panel);
            const panelMaterial = new THREE.MeshPhysicalMaterial({
              color: 0x101010,
              clearcoat: .82,
              clearcoatRoughness: .13,
              emissive: new THREE.Color(0xc2c2c2),
              emissiveIntensity: .42,
              emissiveMap: panelTexture,
              map: panelTexture,
              metalness: .16,
              opacity: 0,
              roughness: .2,
              side: THREE.DoubleSide,
              transparent: true,
            });
            const rewardsPanel = new THREE.Mesh(panelGeometry, panelMaterial);
            rewardsPanel.position.z = .18;
            panelGroup.add(rewardsPanel);

            const panelEdgesMaterial = new THREE.LineBasicMaterial({
              color: 0xd8d8d8,
              transparent: true,
              opacity: 0,
            });
            const panelEdges = new THREE.LineSegments(new THREE.EdgesGeometry(panelGeometry, 16), panelEdgesMaterial);
            panelEdges.position.z = .19;
            panelGroup.add(panelEdges);
            panelGroup.userData = {
              edgeMaterial: panelEdgesMaterial,
              index,
              material: panelMaterial,
            };
            scene.add(panelGroup);

            return panelGroup;
          });
          let phoneTimeText = getLoyaltyPhoneTimeText();
          const buildPhoneScreenSpec = (screenSpec, extra = {}) => ({
            ...screenSpec,
            accountLabel: customerName,
            orderNotification,
            rewardAlert: rewardAlertActive,
            rewardAlertCount,
            rewardAlertIndex: Math.max(0, phonePageLabels.indexOf("Redeem")),
            ...extra,
          });
          const buildPhoneScreenTextures = () =>
            isInteractiveLayout
              ? phoneScreenSpecs.map((screenSpec) =>
                  createLoyaltyPhoneTexture(
                    THREE,
                    pointsText,
                    tierText,
                    false,
                    buildPhoneScreenSpec(screenSpec),
                    phoneTimeText
                  )
                )
              : [];
          let phoneScreenTextures = buildPhoneScreenTextures();
          let activePhoneScreenIndex = -1;
          let hoveredPhoneScreenIndex = -1;
          let hoverPhoneScreenTexture = null;

          const disposeHoverPhoneScreenTexture = () => {
            hoverPhoneScreenTexture?.dispose?.();
            hoverPhoneScreenTexture = null;
          };

          const applyPhoneScreenTexture = () => {
            if (!phoneScreenTextures.length) return;

            const currentIndex = activePhoneScreenIndex >= 0 ? activePhoneScreenIndex : 0;
            const hoverIndex = hoveredPhoneScreenIndex >= 0 && hoveredPhoneScreenIndex !== currentIndex
              ? hoveredPhoneScreenIndex
              : -1;

            if (hoverIndex >= 0) {
              disposeHoverPhoneScreenTexture();
              hoverPhoneScreenTexture = createLoyaltyPhoneTexture(
                THREE,
                pointsText,
                tierText,
                false,
                buildPhoneScreenSpec(phoneScreenSpecs[currentIndex], { hoverIndex }),
                phoneTimeText
              );
              screenMaterial.map = hoverPhoneScreenTexture;
            } else {
              disposeHoverPhoneScreenTexture();
              screenMaterial.map = phoneScreenTextures[currentIndex];
            }

            screenMaterial.needsUpdate = true;
          };

          const setPhoneScreen = (index, force = false) => {
            if (!phoneScreenTextures.length) return;

            const nextIndex = clampValue(index, 0, phoneScreenTextures.length - 1);
            if (!force && nextIndex === activePhoneScreenIndex) return;

            activePhoneScreenIndex = nextIndex;
            applyPhoneScreenTexture();
            stage.dataset.hcxPhoneScreen = phoneScreenSpecs[nextIndex]?.title || phonePageLabels[nextIndex] || "Legacy";
            stage.dataset.hcxPhoneTime = phoneTimeText;
          };

          const setPhoneHover = (index) => {
            if (!phoneScreenTextures.length) return;

            const nextIndex = Number.isFinite(Number(index))
              ? clampValue(Number(index), 0, phoneScreenTextures.length - 1)
              : -1;

            if (nextIndex === hoveredPhoneScreenIndex) return;

            hoveredPhoneScreenIndex = nextIndex;
            applyPhoneScreenTexture();
          };

          const refreshPhoneTime = () => {
            if (!phoneScreenTextures.length) return;

            const nextPhoneTimeText = getLoyaltyPhoneTimeText();
            if (nextPhoneTimeText === phoneTimeText) return;

            const previousTextures = phoneScreenTextures;
            const currentIndex = activePhoneScreenIndex >= 0 ? activePhoneScreenIndex : 0;
            phoneTimeText = nextPhoneTimeText;
            phoneScreenTextures = buildPhoneScreenTextures();
            activePhoneScreenIndex = -1;
            setPhoneScreen(currentIndex, true);
            previousTextures.forEach((texture) => texture.dispose?.());
          };

          const refreshRewardAlert = () => {
            if (!phoneScreenTextures.length || !program) return;

            const nextActive = program.dataset.hcxRewardAlertActive === "true";
            const nextCount = Math.max(0, Number(program.dataset.hcxAvailableRewardSteps || 0));
            if (nextActive === rewardAlertActive && nextCount === rewardAlertCount) return;

            const previousTextures = phoneScreenTextures;
            const currentIndex = activePhoneScreenIndex >= 0 ? activePhoneScreenIndex : 0;
            rewardAlertActive = nextActive;
            rewardAlertCount = nextCount;
            phoneScreenTextures = buildPhoneScreenTextures();
            activePhoneScreenIndex = -1;
            setPhoneScreen(currentIndex, true);
            previousTextures.forEach((texture) => texture.dispose?.());
          };

          const refreshOrderNotification = (detail = null) => {
            const nextNotification = detail?.item
              ? {
                  item: String(detail.item).slice(0, 80),
                  country: String(detail.country || detail.location || "Online customer").slice(0, 40),
                  timeAgo: String(detail.timeAgo || "now").slice(0, 30),
                }
              : null;
            const same =
              (!nextNotification && !orderNotification) ||
              (nextNotification &&
                orderNotification &&
                nextNotification.item === orderNotification.item &&
                nextNotification.country === orderNotification.country &&
                nextNotification.timeAgo === orderNotification.timeAgo);

            if (same || !phoneScreenTextures.length) return;

            const previousTextures = phoneScreenTextures;
            const currentIndex = activePhoneScreenIndex >= 0 ? activePhoneScreenIndex : 0;
            orderNotification = nextNotification;
            phoneScreenTextures = buildPhoneScreenTextures();
            activePhoneScreenIndex = -1;
            setPhoneScreen(currentIndex, true);
            previousTextures.forEach((texture) => texture.dispose?.());
            requestPhoneRender();
          };

          program?.addEventListener("hcx:reward-alert-changed", refreshRewardAlert);
          program?.addEventListener("hcx:legacy-order-notification", (event) => {
            refreshOrderNotification(event.detail);
          });
          if (program?.hcxLegacyOrderNotification) refreshOrderNotification(program.hcxLegacyOrderNotification);
          program?.addEventListener("pointerover", (event) => {
            const trigger = event.target instanceof Element ? event.target.closest("[data-hcx-phone-hotspot]") : null;
            if (!trigger || !program.contains(trigger)) return;

            setPhoneHover(trigger.dataset.hcxLoyaltyTab);
          });
          program?.addEventListener("pointerout", (event) => {
            const trigger = event.target instanceof Element ? event.target.closest("[data-hcx-phone-hotspot]") : null;
            if (!trigger || !program.contains(trigger)) return;
            if (event.relatedTarget instanceof Element && trigger.contains(event.relatedTarget)) return;

            setPhoneHover(-1);
          });

          setPhoneScreen(0, true);

          phone.rotation.x = -.055;
          phone.rotation.y = -.075;
          phone.rotation.z = -.028;
          if (isInteractiveLayout) phone.scale.setScalar(.88);
          scene.add(phone);

          const resize = () => {
            const rect = stage.getBoundingClientRect();
            if (!rect.width || !rect.height) return;

            renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 1.7));
            renderer.setSize(rect.width, rect.height, false);
            camera.aspect = rect.width / rect.height;
            camera.updateProjectionMatrix();
          };

          const getScrollProgress = () => {
            const target = isInteractiveLayout ? program?.querySelector("[data-hcx-legacy-stage]") || program || stage : program || stage;
            const rect = target.getBoundingClientRect();
            const viewport = window.innerHeight || document.documentElement.clientHeight || 1;
            const travel = isInteractiveLayout
              ? Math.max(target.scrollHeight - viewport, viewport * 4)
              : Math.max(rect.height - viewport * .32, viewport * 1.45);

            return clampValue(((isInteractiveLayout ? 0 : viewport * .18) - rect.top) / travel, 0, 1);
          };

          const updatePhoneState = (time = 0) => {
            const rawProgress = getScrollProgress();
            const progress = smoothStep(rawProgress);
            const drift = reducedMotion ? 0 : Math.sin(time * .00052);
            const breathe = reducedMotion ? 0 : Math.sin(time * .00082);
            const spin = isInteractiveLayout
              ? Math.sin(progress * Math.PI * 1.08) * .032 + progress * .026
              : progress * Math.PI * 2.35;
            const panelCount = Number(program?.dataset.hcxPanelCount || legacyPanels.length || 1);
            const syncedPanel = Number(program?.dataset.hcxLegacyActivePanel || 0) - 1;
            const activePanel = isInteractiveLayout && Number.isFinite(syncedPanel) && syncedPanel >= 0
              ? clampValue(syncedPanel, 0, panelCount - 1)
              : clampValue(Math.floor(rawProgress * panelCount), 0, panelCount - 1);

            setPhoneScreen(activePanel);
            phone.position.set(-.39 + Math.sin(progress * Math.PI * 2) * (isInteractiveLayout ? .045 : .1), .02 + breathe * .024, 0);
            phone.rotation.x = (isInteractiveLayout ? -.064 : -.18) + Math.sin(progress * Math.PI * 1.45) * (isInteractiveLayout ? .022 : .19) + breathe * .01;
            phone.rotation.y = (isInteractiveLayout ? -.078 : -.76) + spin + drift * (isInteractiveLayout ? .006 : .034);
            phone.rotation.z = (isInteractiveLayout ? -.03 : -.1) + Math.sin(progress * Math.PI) * (isInteractiveLayout ? .016 : .14);

            legacyPanels.forEach((panelGroup, index) => {
              const start = .08 + index * .15;
              const open = smoothStep(clampValue((rawProgress - start) / .16, 0, 1));
              const close = smoothStep(clampValue((rawProgress - start - .38) / .18, 0, 1));
              const heldOpacity = 1 - close * .7;
              const isActive = index === activePanel;
              const focusBoost = isActive ? 1 : .76;
              const targetX = .94 + (index % 2) * .42 + Math.floor(index / 2) * .08;
              const targetY = 1.34 - index * .64;
              const targetZ = .24 + index * .065;
              const slideArc = Math.sin(open * Math.PI) * .18;
              const material = panelGroup.userData.material;
              const edgeMaterial = panelGroup.userData.edgeMaterial;

              panelGroup.position.set(
                phone.position.x + .34 + targetX * open,
                -.12 + (targetY + slideArc) * open,
                targetZ * open
              );
              panelGroup.rotation.x = -.06 + open * .05;
              panelGroup.rotation.y = -1.62 + open * (1.48 + index * .035) + progress * .08;
              panelGroup.rotation.z = .08 - open * (.06 + index * .01);
              panelGroup.scale.setScalar(.18 + open * (.72 - index * .025));
              material.opacity = open * heldOpacity * focusBoost * .95;
              edgeMaterial.opacity = open * heldOpacity * (isActive ? .58 : .38);
            });

            stage.dataset.hcxPhoneScroll = rawProgress.toFixed(3);
            stage.dataset.hcxPhoneActivePanel = String(activePanel + 1);
          };

          const renderOnce = (time = 0) => {
            if (!isVisible) return;

            updatePhoneState(time);
            renderer.render(scene, camera);
          };

          const animate = (time = 0) => {
            animationFrame = null;
            renderOnce(time);
            if (isVisible && !reducedMotion) animationFrame = window.requestAnimationFrame(animate);
          };

          const start = () => {
            if (animationFrame || reducedMotion) return;
            animationFrame = window.requestAnimationFrame(animate);
          };

          const stop = () => {
            if (!animationFrame) return;
            window.cancelAnimationFrame(animationFrame);
            animationFrame = null;
          };

          const requestRender = () => {
            if (!isVisible || animationFrame) return;
            animationFrame = window.requestAnimationFrame(animate);
          };
          requestPhoneRender = requestRender;

          if (isInteractiveLayout) {
            window.setInterval(() => {
              refreshPhoneTime();
              requestRender();
            }, 30000);
          }

          const resizeObserver = new ResizeObserver(() => {
            resize();
            requestRender();
          });
          resizeObserver.observe(stage);

          if ("IntersectionObserver" in window) {
            const observer = new IntersectionObserver((entries) => {
              isVisible = entries[0]?.isIntersecting ?? true;
              if (isVisible) {
                renderOnce();
                start();
              } else {
                stop();
              }
            });
            observer.observe(stage);
          }

          window.addEventListener("resize", () => {
            resize();
            requestRender();
          });
          window.addEventListener("scroll", requestRender, { passive: true });
          resize();
          renderOnce();
          start();
          stage.classList.add("is-three-ready");
        })
        .catch(() => {
          stage.classList.add("is-three-fallback");
        });
    });
  };

  const initLegacyOrderNotifications = () => {
    document.querySelectorAll("[data-hcx-loyalty-program]").forEach((program) => {
      if (program.dataset.hcxOrderNotificationsBound === "true") return;
      if (program.dataset.hcxOrderNotifications === "false") return;

      const stage = program.querySelector("[data-hcx-loyalty-phone-stage]");
      if (!stage) return;

      program.dataset.hcxOrderNotificationsBound = "true";
      const liveRegion = program.querySelector("[data-hcx-order-notification-live]");
      const notificationLink = program.querySelector("[data-hcx-order-notification-link]");
      const feedUrl = (program.dataset.hcxOrderNotificationsUrl || "").trim();
      const isPreview = (() => {
        try {
          return new URLSearchParams(window.location.search).has("codex_legacy_edit") || window.Shopify?.designMode === true;
        } catch (error) {
          return false;
        }
      })();
      const forcePreviewNotification = (() => {
        try {
          return new URLSearchParams(window.location.search).has("codex_show_order_popup");
        } catch (error) {
          return false;
        }
      })();
      const now = Date.now();
      const previewOrders = [
        { id: "preview-1", item: "HERCXLES Legacy Hoodie", country: "United Kingdom", orderedAt: new Date(now - 6 * 60000).toISOString(), url: "/products/awakening-oversized-t-shirt-1" },
        { id: "preview-2", item: "Oversized Training Tee", country: "Germany", orderedAt: new Date(now - 19 * 60000).toISOString(), url: "/products/awakening-oversized-t-shirt-1" },
        { id: "preview-3", item: "HERCXLES Shorts", country: "France", orderedAt: new Date(now - 42 * 60000).toISOString(), url: "/products/awakening-oversized-t-shirt-1" },
        { id: "preview-4", item: "Legacy Zip Hoodie", country: "Netherlands", orderedAt: new Date(now - 76 * 60000).toISOString(), url: "/products/awakening-oversized-t-shirt-1" },
      ];
      let orders = [];
      let queue = [];
      let currentIndex = -1;
      let showing = false;
      let nextTimer = null;
      let clearTimer = null;
      let pollTimer = null;
      let popupObserver = null;
      const capturedPopupFingerprints = [];

      const isToday = (date) => {
        const orderDate = new Date(date);
        const today = new Date();

        return (
          orderDate.getFullYear() === today.getFullYear() &&
          orderDate.getMonth() === today.getMonth() &&
          orderDate.getDate() === today.getDate()
        );
      };

      const formatTimeAgo = (date) => {
        const diff = Math.max(0, Date.now() - new Date(date).getTime());
        const minutes = Math.floor(diff / 60000);

        if (minutes < 1) return "just now";
        if (minutes < 60) return `${minutes} min ago`;

        const hours = Math.floor(minutes / 60);
        return `${hours} hr${hours === 1 ? "" : "s"} ago`;
      };

      const cleanText = (value, fallback = "") =>
        String(value || fallback)
          .replace(/\s+/g, " ")
          .trim();

      const normalizeProductUrl = (value) => {
        const urlText = cleanText(value);
        if (!urlText || urlText === "#") return "";

        try {
          const url = new URL(urlText, window.location.origin);
          if (url.origin !== window.location.origin || !url.pathname.includes("/products/")) return "";

          return `${url.pathname}${url.search}${url.hash}`;
        } catch (error) {
          return "";
        }
      };

      const productPathFromTitle = (value) => {
        const handle = cleanText(value)
          .toLowerCase()
          .replace(/&/g, " and ")
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/^-+|-+$/g, "");

        return handle ? `/products/${handle}` : "";
      };

      const getOrderUrl = (order) => {
        const firstItem = Array.isArray(order.items) ? order.items[0] : Array.isArray(order.line_items) ? order.line_items[0] : null;
        const handle = cleanText(order.handle || order.product_handle || firstItem?.handle || firstItem?.product_handle);
        const directUrl = normalizeProductUrl(
          order.url ||
          order.product_url ||
          order.productUrl ||
          order.product_href ||
          order.href ||
          firstItem?.url ||
          firstItem?.product_url ||
          firstItem?.productUrl ||
          firstItem?.href
        );

        return directUrl || (handle ? `/products/${handle}` : "");
      };

      const getPopupProductUrl = (popup) => {
        const link = popup?.closest?.("a[href]") || popup?.querySelector?.("a[href]");

        return normalizeProductUrl(link?.getAttribute("href"));
      };

      const normalizePopupText = (value) =>
        cleanText(value)
          .replace(/[\u2022\u00b7|]/g, " ")
          .replace(/\s*\bby\s+CareCart\b\.?/gi, " ")
          .replace(/\b(?:close|dismiss)\b/gi, " ")
          .replace(/\b(?:verified purchase|verified buyer|verified customer|verified order|order verified|verification)\b/gi, " ")
          .replace(/\s+/g, " ")
          .trim();

      const rememberCapturedPopup = (text) => {
        const fingerprint = normalizePopupText(text).toLowerCase().slice(0, 180);
        if (!fingerprint || capturedPopupFingerprints.includes(fingerprint)) return false;

        capturedPopupFingerprints.push(fingerprint);
        if (capturedPopupFingerprints.length > 18) capturedPopupFingerprints.shift();

        return true;
      };

      const getElementSignature = (element) => {
        const className = typeof element.className === "string" ? element.className : "";

        return `${element.id || ""} ${className} ${element.getAttribute("role") || ""} ${element.getAttribute("aria-live") || ""}`;
      };

      const isFloatingPopupElement = (element) => {
        try {
          const style = window.getComputedStyle(element);
          const zIndex = Number.parseInt(style.zIndex, 10);

          return ["fixed", "sticky", "absolute"].includes(style.position) && (style.position === "fixed" || zIndex > 10);
        } catch (error) {
          return false;
        }
      };

      const looksLikeExternalSalesPopup = (element) => {
        if (!(element instanceof HTMLElement) || program.contains(element)) return false;

        const text = normalizePopupText(element.textContent);
        if (text.length < 12 || text.length > 320) return false;
        if (!/\b(?:purchased|bought|ordered|order placed|placed an order|recently|just now|\d+\s*(?:sec|second|min|minute|hr|hour|day)s?\s*ago)\b/i.test(text)) {
          return false;
        }

        const hasPopupSignature = /\b(?:fordeer|sales?|popup|toast|notification|notify|social.?proof|recent|order|purchase)\b/i.test(getElementSignature(element));

        return hasPopupSignature || isFloatingPopupElement(element);
      };

      const parseExternalSalesPopup = (popup, text) => {
        const normalized = normalizePopupText(text);
        const timeMatch = normalized.match(/\b(?:just now|now|\d+\s*(?:sec(?:ond)?s?|s|min(?:ute)?s?|m|hr|hour|hours|h|day|days|d)\s*(?:ago)?)\b/i);
        const timeAgo = cleanText(timeMatch?.[0] || "now")
          .replace(/\bseconds?\b/i, "sec")
          .replace(/\bminutes?\b/i, "min")
          .replace(/\bhours?\b/i, "hr")
          .replace(/\bdays?\b/i, "day");
        let working = normalized;
        if (timeMatch) working = working.replace(timeMatch[0], " ");
        working = working
          .replace(/\b(?:someone|a customer|customer|shopper)\b/gi, " ")
          .replace(/\b(?:just|recently|verified)\b/gi, " ");

        const locationMatch =
          working.match(/\b(?:from|in)\s+([A-Z][A-Za-z'.-]*(?:\s+[A-Z][A-Za-z'.-]*){0,3})(?=\s+(?:purchased|bought|ordered|placed|an?\s+order)|$)/i) ||
          working.match(/\b(?:from|in)\s+([A-Z][A-Za-z'.-]*(?:\s+[A-Z][A-Za-z'.-]*){0,3})\b/i);
        const passiveItemMatch = working.match(/^(.+?)\s+(?:was\s+)?(?:purchased|bought|ordered)\b/i);
        const activeItemMatch = working.match(/\b(?:purchased|bought|ordered|placed an order for)\s+(.+)$/i);
        let item = cleanText(activeItemMatch?.[1] || passiveItemMatch?.[1] || working);

        item = item
          .replace(/\b(?:from|in)\s+[A-Z][A-Za-z'.-]*(?:\s+[A-Z][A-Za-z'.-]*){0,3}\b/gi, " ")
          .replace(/\b(?:purchased|bought|ordered|placed an order for|order placed|new order|verified)\b/gi, " ")
          .replace(/\s+/g, " ")
          .trim();

        return {
          country: cleanText(locationMatch?.[1] || "Online customer").slice(0, 40),
          item: (item && item.length >= 3 && item.length <= 120 ? item : "New HERCXLES order").slice(0, 80),
          timeAgo: timeAgo.slice(0, 30),
          url: getPopupProductUrl(popup),
        };
      };

      const hideExternalSalesPopup = (element) => {
        if (!(element instanceof HTMLElement)) return;

        element.setAttribute("aria-hidden", "true");
        element.style.setProperty("opacity", "0", "important");
        element.style.setProperty("pointer-events", "none", "important");
        element.style.setProperty("visibility", "hidden", "important");
        element.style.setProperty("transform", "translate3d(0, -140vh, 0)", "important");
      };

      const inspectExternalSalesPopup = (node) => {
        const root = node instanceof HTMLElement ? node : node?.parentElement;
        if (!root || root === document.documentElement || root === document.body) return;

        const candidates = [];
        let ancestor = root;
        for (let depth = 0; ancestor && depth < 6; depth += 1) {
          candidates.push(ancestor);
          ancestor = ancestor.parentElement;
        }
        root.querySelectorAll?.("[class],[id],[role],[aria-live]").forEach((element) => candidates.push(element));

        const popup = candidates.find(looksLikeExternalSalesPopup);
        if (!popup) return;

        const text = normalizePopupText(popup.textContent);
        hideExternalSalesPopup(popup);
        if (!rememberCapturedPopup(text)) return;

        showExternalNotification(parseExternalSalesPopup(popup, text));
      };

      const startSalesPopupBridge = () => {
        if (!document.body || !("MutationObserver" in window)) return;

        const scanExistingPopups = () => {
          document.querySelectorAll("[class],[id],[role],[aria-live]").forEach(inspectExternalSalesPopup);
        };

        popupObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === "characterData") {
              inspectExternalSalesPopup(mutation.target);
              return;
            }

            mutation.addedNodes.forEach(inspectExternalSalesPopup);
          });
        });
        popupObserver.observe(document.body, { childList: true, characterData: true, subtree: true });
        window.setTimeout(scanExistingPopups, 800);
        window.setTimeout(scanExistingPopups, 2500);
      };

      const formatCountry = (value) => {
        const country = cleanText(value);

        if (!/^[a-z]{2}$/i.test(country) || typeof Intl === "undefined" || !Intl.DisplayNames) return country;

        try {
          const displayNames = new Intl.DisplayNames([navigator.language || "en"], { type: "region" });
          return displayNames.of(country.toUpperCase()) || country.toUpperCase();
        } catch (error) {
          return country.toUpperCase();
        }
      };

      const getOrderItem = (order) => {
        const firstItem = Array.isArray(order.items) ? order.items[0] : Array.isArray(order.line_items) ? order.line_items[0] : null;

        return (
          order.item ||
          order.title ||
          order.product_title ||
          order.product ||
          order.line_item ||
          firstItem?.item ||
          firstItem?.title ||
          firstItem?.product_title ||
          firstItem?.name
        );
      };

      const normalizeOrder = (order, index = 0) => {
        const item = cleanText(getOrderItem(order));
        const country = formatCountry(order.country || order.shipping_country || order.billing_country || order.country_code);
        const orderedAt = order.orderedAt || order.ordered_at || order.created_at || order.timestamp || order.date;
        const date = orderedAt ? new Date(orderedAt) : null;

        if (!item || !country || !date || Number.isNaN(date.getTime()) || !isToday(date)) return null;

        const id = cleanText(order.id || order.order_id || `${item}:${country}:${date.toISOString()}:${index}`);
        return {
          id,
          item: item.slice(0, 80),
          country: country.slice(0, 40),
          orderedAt: date.toISOString(),
          url: getOrderUrl(order),
        };
      };

      const setOrders = (nextOrders) => {
        const normalized = nextOrders
          .map(normalizeOrder)
          .filter(Boolean)
          .sort((a, b) => new Date(b.orderedAt) - new Date(a.orderedAt))
          .slice(0, 12);

        if (!normalized.length) {
          orders = [];
          queue = [];
          currentIndex = -1;
          return false;
        }

        const existingIds = new Set(orders.map((order) => order.id));
        const fresh = normalized.filter((order) => !existingIds.has(order.id));
        orders = normalized;
        if (fresh.length) queue.push(...fresh);

        return true;
      };

      const readFeed = async () => {
        if (!feedUrl) return false;

        try {
          const response = await fetch(feedUrl, {
            cache: "no-store",
            credentials: "same-origin",
            headers: { Accept: "application/json" },
          });

          if (!response.ok) return false;

          const data = await response.json();
          const nextOrders = Array.isArray(data) ? data : Array.isArray(data.orders) ? data.orders : [];
          return setOrders(nextOrders);
        } catch (error) {
          return false;
        }
      };

      const getNextOrder = () => {
        if (queue.length) return queue.shift();
        if (!orders.length) return null;

        currentIndex = (currentIndex + 1) % orders.length;
        return orders[currentIndex];
      };

      const clearNotification = () => {
        program.hcxLegacyOrderNotification = null;
        program.dispatchEvent(new CustomEvent("hcx:legacy-order-notification", { detail: null }));
        if (liveRegion) liveRegion.textContent = "";
        if (notificationLink) {
          notificationLink.hidden = true;
          notificationLink.classList.remove("is-active");
          notificationLink.removeAttribute("href");
        }
        showing = false;
        if (orders.length) scheduleNext();
      };

      const publishNotification = (payload) => {
        const productUrl = normalizeProductUrl(payload.url) || productPathFromTitle(payload.item);

        showing = true;
        program.hcxLegacyOrderNotification = { ...payload, url: productUrl };
        program.dispatchEvent(new CustomEvent("hcx:legacy-order-notification", { detail: program.hcxLegacyOrderNotification }));
        if (liveRegion) liveRegion.textContent = `Someone bought ${payload.item}, ${payload.timeAgo}.`;
        if (notificationLink && productUrl) {
          notificationLink.href = productUrl;
          notificationLink.hidden = false;
          notificationLink.classList.add("is-active");
        }

        window.clearTimeout(clearTimer);
        clearTimer = window.setTimeout(clearNotification, forcePreviewNotification ? 16000 : 6800);
      };

      const showExternalNotification = (payload) => {
        if (!payload?.item || document.hidden) return;

        publishNotification({
          item: payload.item,
          country: payload.country || "Online customer",
          timeAgo: payload.timeAgo || "now",
          url: payload.url,
        });
      };

      const showOrder = (order) => {
        if (!order || showing || document.hidden) {
          if (orders.length) scheduleNext();
          return;
        }

        publishNotification({
          item: order.item,
          country: order.country,
          timeAgo: formatTimeAgo(order.orderedAt),
          url: order.url,
        });
      };

      const scheduleNext = () => {
        if (!orders.length) return;

        window.clearTimeout(nextTimer);
        const delay = 32000 + Math.round(Math.random() * 18000);
        nextTimer = window.setTimeout(() => showOrder(getNextOrder()), delay);
      };

      const start = async () => {
        const hasFeed = await readFeed();
        if (!hasFeed && (isPreview || forcePreviewNotification)) setOrders(previewOrders);
        if (!orders.length) return;

        const firstDelay = forcePreviewNotification ? 900 : isPreview ? 3500 : 8000 + Math.round(Math.random() * 5000);
        nextTimer = window.setTimeout(() => showOrder(getNextOrder()), firstDelay);
        pollTimer = window.setInterval(readFeed, 60000);
      };

      document.addEventListener("visibilitychange", () => {
        if (!document.hidden && !showing && orders.length) scheduleNext();
      });

      window.addEventListener("pagehide", () => {
        window.clearTimeout(nextTimer);
        window.clearTimeout(clearTimer);
        window.clearInterval(pollTimer);
        popupObserver?.disconnect?.();
      });

      startSalesPopupBridge();
      start();
    });
  };

  const initPolicyPageEnhancements = () => {
    const container = document.querySelector(".shopify-policy__container");
    if (!container || container.dataset.hcxPolicyEnhanced === "true") return;

    const body = container.querySelector(".shopify-policy__body");
    const title = container.querySelector(".shopify-policy__title");
    const titleText = title?.textContent?.trim() || "Information";
    const titleLower = titleText.toLowerCase();
    const isContactPolicy = titleLower.includes("contact") || window.location.pathname.includes("/policies/contact-information");
    const supportValue = "enquiries@hercxles.co.uk";
    const cleanPolicyText = (root) => {
      if (!root) return;

      const replacements = [
        [/This website is operated by HERCXLES\./g, "This website is operated by us."],
        [/Throughout the site,\s*the terms\s*(?:"|\u201c)we(?:"|\u201d),?\s*(?:"|\u201c)us(?:"|\u201d)\s*and\s*(?:"|\u201c)our(?:"|\u201d)\s*refer to HERCXLES\./gi, "Throughout the site, the terms \"we\", \"us\" and \"our\" refer to us."],
        [/HERCXLES offers this website/g, "We offer this website"],
        [/contact HERCXLES/g, "contact us"],
        [/Contact HERCXLES/g, "Contact us"],
        [/email HERCXLES/g, "email us"],
        [/Email HERCXLES/g, "Email us"],
        [/to HERCXLES/g, "to us"],
        [/HERCXLES may contact you/g, "we may contact you"],
        [/HERCXLES if/g, "us if"],
        [/HERCXLES before/g, "us before"]
      ];
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      const textNodes = [];

      while (walker.nextNode()) textNodes.push(walker.currentNode);

      textNodes.forEach((node) => {
        let value = node.nodeValue || "";
        replacements.forEach(([pattern, replacement]) => {
          value = value.replace(pattern, replacement);
        });
        node.nodeValue = value;
      });
    };

    container.dataset.hcxPolicyEnhanced = "true";
    container.classList.add("hcx-policy-page");

    if (isContactPolicy) {
      container.classList.add("hcx-contact-policy-page");
      if (body) {
        body.innerHTML = `
          <section class="hcx-contact-policy-card" aria-label="Contact us">
            <a class="hcx-contact-policy-card__email" href="mailto:${supportValue}">${supportValue}</a>
          </section>
        `;
      }
      return;
    }

    if (body && !body.querySelector(".hcx-policy-page__aside")) {
      const aside = document.createElement("aside");
      aside.className = "hcx-policy-page__aside";
      aside.innerHTML = `
        <nav class="hcx-policy-page__nav" aria-label="Customer information pages">
          <a href="/pages/hercxles-club">LEGACY</a>
          <a href="/pages/about-us-page">ABOUT US</a>
          <a href="/pages/returns">MAKE A RETURN</a>
          <a href="/pages/track-order">TRACK AN ORDER</a>
          <a href="/pages/reviews">REVIEWS</a>
        </nav>
        <div class="hcx-policy-page__support">
          <span>Need help?</span>
          <a href="mailto:enquiries@hercxles.co.uk">enquiries@hercxles.co.uk</a>
        </div>
      `;

      aside.querySelectorAll("a[href]").forEach((link) => {
        if (link.pathname === window.location.pathname) {
          link.setAttribute("aria-current", "page");
        }
      });

      body.prepend(aside);
    }

    cleanPolicyText(body?.querySelector(".rte") || body);
  };

  const initReturnExchangePortal = () => {
    const returnAddressLines = [
      "HERCXLES Returns",
      "19 Lapwing Way",
      "Whiteley, Winchester",
      "PO15 7RN",
      "United Kingdom"
    ];
    const supportEmail = "enquiries@hercxles.co.uk";
    const lookupNotFoundMessage = `We could not find an order matching both details. Check the order number and the email or phone used at checkout, or contact ${supportEmail} if you need help.`;
    const lookupUnavailableMessage = `If you need further assistance, email us at ${supportEmail}.`;
    const returnRequestVerificationMessage = "We could not verify that this order belongs to that email or phone. Search the order again before making a return.";
    const returnRequestVerificationErrors = new Set([
      "missing_request_details",
      "order_customer_mismatch",
      "shopify_admin_api_not_configured",
      "return_window_closed",
      "exchange_window_closed"
    ]);
    const returnWindowDays = 25;
    const exchangeWindowDays = 40;
    const dayInMs = 24 * 60 * 60 * 1000;
    const returnWindowTimeZone = "Europe/London";

    document.querySelectorAll("[data-hcx-return-portal]").forEach((portal) => {
      const form = portal.querySelector("[data-hcx-return-form]");
      if (!form || form.dataset.hcxReturnBound === "true") return;

      form.dataset.hcxReturnBound = "true";

      const startScreen = portal.querySelector("[data-hcx-return-start-screen]");
      const startButton = portal.querySelector("[data-hcx-return-start-button]");
      const manualTriggerWrapper = portal.querySelector("[data-hcx-return-manual-trigger-wrapper]");
      const manualTrigger = portal.querySelector("[data-hcx-return-manual-trigger]");
      const manualPanel = portal.querySelector("[data-hcx-return-manual]");
      const manualBackButton = portal.querySelector("[data-hcx-return-manual-back]");
      const manualSuccess = portal.querySelector("[data-hcx-return-manual-success]");
      const manualError = portal.querySelector("[data-hcx-return-manual-error]");
      const manualMessage = portal.querySelector(".hcx-return-portal__manual-header p");
      const manualDefaultMessage = manualMessage?.textContent?.trim() || "We will verify the order and reply with the next steps.";
      const setManualMessage = (message = manualDefaultMessage) => {
        if (!manualMessage) return;
        const nextMessage = String(message || manualDefaultMessage).trim();
        const emailIndex = nextMessage.indexOf(supportEmail);

        if (emailIndex === -1) {
          manualMessage.textContent = nextMessage;
          return;
        }

        const emailLink = document.createElement("a");
        emailLink.href = `mailto:${supportEmail}`;
        emailLink.textContent = supportEmail;
        manualMessage.replaceChildren(
          nextMessage.slice(0, emailIndex),
          emailLink,
          nextMessage.slice(emailIndex + supportEmail.length)
        );
      };
      const manualOrderField = portal.querySelector("[data-hcx-manual-order]");
      const manualEmailField = portal.querySelector("[data-hcx-manual-email]");
      const manualPhoneField = portal.querySelector("[data-hcx-manual-phone]");
      const manualTypeField = portal.querySelector("[data-hcx-manual-type]");
      const lookupOrderField = form.querySelector('[name="order_number"]');
      const lookupDetailField = form.querySelector('[name="customer_detail"]');
      const ordersScript = portal.querySelector("[data-hcx-return-orders]");
      const result = portal.querySelector("[data-hcx-return-result]");
      const summaryTarget = portal.querySelector("[data-hcx-return-order-summary]");
      const itemsTarget = portal.querySelector("[data-hcx-return-items]");
      const labelTarget = portal.querySelector("[data-hcx-return-label]");
      const workflow = portal.querySelector("[data-hcx-return-workflow]");

      const upgradeLegacyReturnPortalMarkup = () => {
        const legacyActionButtons = [...portal.querySelectorAll("[data-hcx-return-action]")];
        const actions = portal.querySelector(".hcx-return-portal__actions");

        if (!portal.querySelector("[data-hcx-return-confirm]") && actions && legacyActionButtons.length) {
          actions.setAttribute("aria-label", "Confirm return or exchange details");
          actions.innerHTML = `<button type="button" data-hcx-return-confirm>Confirm return</button>`;
          const note = portal.querySelector(".hcx-return-portal__note");
          if (note) {
            note.textContent = "Confirm unlocks after the order is in window, at least one item is selected, and the required reason details are filled in.";
          }
        }

        const reasonSelect = portal.querySelector("[data-hcx-return-reason]");
        if (reasonSelect) {
          reasonSelect.required = true;
        }

      };

      upgradeLegacyReturnPortalMarkup();

      const reasonField = portal.querySelector("[data-hcx-return-reason]");
      const detailsField = portal.querySelector("[data-hcx-return-details]");
      const exchangeTypeField = portal.querySelector("[data-hcx-exchange-type]");
      const exchangeSizeField = portal.querySelector("[data-hcx-exchange-size]");
      const exchangeItemField = portal.querySelector("[data-hcx-exchange-item]");
      const exchangeOptions = portal.querySelector("[data-hcx-exchange-options]");
      const exchangeProductSearch = portal.querySelector("[data-hcx-exchange-product-search]");
      const exchangeProductResults = portal.querySelector("[data-hcx-exchange-product-results]");
      const exchangeBalanceTarget = portal.querySelector("[data-hcx-exchange-balance]");
      const requestTypeFields = [...portal.querySelectorAll("[data-hcx-request-type]")];
      const error = portal.querySelector("[data-hcx-return-error]");
      const notice = portal.querySelector("[data-hcx-return-notice]");
      const matchLabel = portal.querySelector("[data-hcx-return-match-label]");
      const submitButton = form.querySelector('button[type="submit"]');
      const requiredFields = [...form.querySelectorAll("[required]")];
      const helpButtons = [...portal.querySelectorAll("[data-hcx-return-help]")];
      const actionButtons = [...portal.querySelectorAll("[data-hcx-return-action]")];
      const confirmButton = portal.querySelector("[data-hcx-return-confirm]");
      const actionsTarget = portal.querySelector(".hcx-return-portal__actions");
      const requestFields = [reasonField, detailsField, exchangeTypeField, exchangeSizeField, exchangeItemField].filter(Boolean);
      const lookupUrl = portal.dataset.hcxReturnLookupUrl || "";
      const requestUrl = lookupUrl ? lookupUrl.replace(/\/lookup(\?.*)?$/, "/request$1") : "";
      const hasLocalOrders = portal.dataset.hcxReturnHasLocalOrders === "true";
      const defaultButtonText = submitButton?.textContent || "Get started";
      let orders = [];
      let isSubmitting = false;
      let activeOrder = null;
      let productCatalogPromise = null;
      let balancePreviewToken = 0;
      let exchangeProductSearchTimer = null;
      let exchangeRenderedProductOptions = [];
      let selectedReplacementVariant = null;
      const sentRequestNotifications = new Set();

      form.setAttribute("novalidate", "novalidate");

      const normalizeOrder = (value = "") =>
        String(value)
          .toLowerCase()
          .replace(/^#/, "")
          .replace(/[^a-z0-9]/g, "");

      const normalizeText = (value = "") =>
        String(value)
          .toLowerCase()
          .trim();

      const normalizeCompact = (value = "") => normalizeText(value).replace(/[^a-z0-9@.]/g, "");

      const normalizePhone = (value = "") => String(value).replace(/\D/g, "");

      const asArray = (value) => {
        if (Array.isArray(value)) return value;
        if (Array.isArray(value?.edges)) return value.edges.map((edge) => edge?.node).filter(Boolean);
        if (Array.isArray(value?.nodes)) return value.nodes;
        return [];
      };

      const escapeHtml = (value = "") =>
        String(value).replace(/[&<>"']/g, (char) => ({
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          "\"": "&quot;",
          "'": "&#39;"
        }[char]));

      const escapeAttribute = (value = "") => escapeHtml(value).replace(/`/g, "&#96;");

      const firstValue = (...values) => values.find((value) => String(value || "").trim());

      const parseWindowDate = (value = "") => {
        const raw = String(value || "").trim();
        if (!raw) return null;

        const dated = raw.match(/^(\d{1,2})\s+([A-Za-z]{3,9})\s+(\d{4})$/);
        if (dated) {
          const month = "jan feb mar apr may jun jul aug sep oct nov dec".split(" ").indexOf(dated[2].slice(0, 3).toLowerCase());
          if (month >= 0) {
            const fallback = new Date(Date.UTC(Number(dated[3]), month, Number(dated[1]), 12));
            if (!Number.isNaN(fallback.getTime())) return fallback;
          }
        }

        const parsed = new Date(raw);
        return Number.isNaN(parsed.getTime()) ? null : parsed;
      };

      const calendarDayNumber = (value) => {
        const date = value instanceof Date ? value : parseWindowDate(value);
        if (!date || Number.isNaN(date.getTime())) return null;

        try {
          const parts = Object.fromEntries(
            new Intl.DateTimeFormat("en-GB", {
              timeZone: returnWindowTimeZone,
              year: "numeric",
              month: "2-digit",
              day: "2-digit"
            })
              .formatToParts(date)
              .filter((part) => part.type !== "literal")
              .map((part) => [part.type, part.value])
          );
          const year = Number(parts.year);
          const month = Number(parts.month);
          const day = Number(parts.day);
          if (![year, month, day].every(Number.isFinite)) return null;
          return Math.floor(Date.UTC(year, month - 1, day) / dayInMs);
        } catch (_) {
          return null;
        }
      };

      const getWindowDate = (order = {}) => {
        const value = order.createdAt;
        const date = parseWindowDate(value);
        return date
          ? { date, source: "order", value }
          : { date: null, source: "order", value: "" };
      };

      const getReturnWindow = (order = {}) => {
        const authoritativeWindow = order.returnWindow;
        if (
          authoritativeWindow &&
          typeof authoritativeWindow === "object" &&
          String(authoritativeWindow.source || "").toLowerCase() === "order" &&
          typeof authoritativeWindow.canReturn === "boolean" &&
          typeof authoritativeWindow.canExchange === "boolean"
        ) {
          const days = authoritativeWindow.days !== null && authoritativeWindow.days !== "" && Number.isFinite(Number(authoritativeWindow.days))
            ? Math.trunc(Number(authoritativeWindow.days))
            : null;
          const policyConfirmed = days !== null && days >= 0;
          const canReturn = policyConfirmed && Boolean(authoritativeWindow.canReturn);
          const canExchange = policyConfirmed && Boolean(authoritativeWindow.canExchange);
          const status = canReturn ? "open" : canExchange ? "exchange_only" : "closed";
          const reason = String(authoritativeWindow.reason || (days > exchangeWindowDays
            ? "exchange_window_closed"
            : days > returnWindowDays
              ? "return_window_closed"
              : "eligible"));
          const summary = status === "open"
            ? "Return or exchange available"
            : status === "exchange_only"
              ? "Exchange available"
              : "Outside the standard policy window";
          const title = status === "open"
            ? "Return or exchange available"
            : status === "exchange_only"
              ? "Exchange only"
              : "Contact us directly";
          const message = status === "open"
            ? "This order is eligible for a return or exchange request."
            : status === "exchange_only"
              ? "This order is no longer eligible for a return, but you can still request an exchange."
              : "This order is outside our standard returns and exchanges policy. Contact us directly if you need help.";

          return {
            ...authoritativeWindow,
            status,
            reason,
            policyConfirmed,
            canReturn,
            canExchange,
            days,
            source: "order",
            dateLabel: "",
            summary,
            title,
            message
          };
        }

        const windowDate = getWindowDate(order);

        if (!windowDate.date) {
          return {
            status: "closed",
            canReturn: false,
            canExchange: false,
            days: null,
            source: "order",
            dateLabel: "",
            reason: "order_date_unavailable",
            policyConfirmed: false,
            summary: "Eligibility could not be verified",
            title: "Contact us directly",
            message: "We could not verify this order's eligibility. Contact us directly for help."
          };
        }

        const todayDay = calendarDayNumber(new Date());
        const orderDay = calendarDayNumber(windowDate.date);
        const days = todayDay === null || orderDay === null || todayDay < orderDay
          ? null
          : todayDay - orderDay;

        if (days === null) {
          return {
            status: "closed",
            canReturn: false,
            canExchange: false,
            days: null,
            source: "order",
            dateLabel: "",
            reason: "order_date_invalid",
            policyConfirmed: false,
            summary: "Eligibility could not be verified",
            title: "Contact us directly",
            message: "We could not verify this order's eligibility. Contact us directly for help."
          };
        }

        if (days > exchangeWindowDays) {
          return {
            status: "closed",
            canReturn: false,
            canExchange: false,
            days,
            source: "order",
            dateLabel: "",
            reason: "exchange_window_closed",
            policyConfirmed: true,
            summary: "Outside the standard policy window",
            title: "Contact us directly",
            message: "This order is outside our standard returns and exchanges policy. Contact us directly if you need help."
          };
        }

        if (days > returnWindowDays) {
          return {
            status: "exchange_only",
            canReturn: false,
            canExchange: true,
            days,
            source: "order",
            dateLabel: "",
            reason: "return_window_closed",
            policyConfirmed: true,
            summary: "Exchange available",
            title: "Exchange only",
            message: "This order is no longer eligible for a return, but you can still request an exchange."
          };
        }

        return {
          status: "open",
          canReturn: true,
          canExchange: true,
          days,
          source: "order",
          dateLabel: "",
          reason: "eligible",
          policyConfirmed: true,
          summary: "Return or exchange available",
          title: "Return or exchange available",
          message: "This order is eligible for a return or exchange request."
        };
      };

      const normaliseLineItem = (item = {}, index = 0) => {
        const node = item.node || item;
        const variantTitle = firstValue(node.variantTitle, node.variant_title, node.variant?.title, node.variant?.displayName);

        return {
          id: String(firstValue(node.id, node.key, node.sku, index + 1)),
          title: String(firstValue(node.title, node.name, node.productTitle, node.product?.title, "Order item")),
          variantTitle: variantTitle === "Default Title" ? "" : String(variantTitle || ""),
          sku: String(firstValue(node.sku, node.variant?.sku, "") || ""),
          quantity: String(firstValue(node.quantity, node.currentQuantity, node.current_quantity, "") || ""),
          price: String(firstValue(node.price, node.finalLinePrice, node.final_line_price, node.total, "") || ""),
          image: String(firstValue(node.image, node.imageUrl, node.image_url, node.variant?.image?.url, node.product?.featuredImage?.url, "") || "")
        };
      };

      const normaliseOrderPayload = (payload = {}, fallbackOrderNumber = "", fallbackDetail = "") => {
        const source = payload?.order || payload?.data?.order || payload;
        const root = source || {};
        const shippingAddress = root.shippingAddress || root.shipping_address || root.shipping || {};
        const rawItems = firstValue(root.lineItems, root.line_items, root.items, payload.lineItems, payload.items) || [];
        const fulfillmentRecords = asArray(firstValue(root.fulfillments, root.fulfilments, root.shipments, root.deliveries, payload.fulfillments, payload.shipments) || []);
        const firstFulfillment = fulfillmentRecords[0] || {};
        const name = firstValue(root.name, root.orderName, root.order_name, root.orderNumber, root.order_number, root.number, fallbackOrderNumber);

        return {
          source: firstValue(root.source, payload.source, "lookup"),
          name: String(name || ""),
          number: String(firstValue(root.number, root.orderNumber, root.order_number, name, fallbackOrderNumber) || ""),
          email: String(firstValue(root.email, root.customerEmail, root.customer_email, root.customer?.email, fallbackDetail) || ""),
          phone: String(firstValue(root.phone, root.customerPhone, root.customer_phone, root.shippingPhone, shippingAddress.phone, "") || ""),
          billingPhone: String(firstValue(root.billingPhone, root.billing_phone, root.billingAddress?.phone, root.billing_address?.phone, "") || ""),
          createdAt: String(firstValue(root.createdAt, root.created_at, root.processedAt, root.processed_at, root.date, "") || ""),
          fulfilledAt: String(firstValue(root.fulfilledAt, root.fulfilled_at, root.fulfillmentDate, root.fulfilmentDate, root.fulfillment_date, root.fulfilment_date, firstFulfillment.fulfilledAt, firstFulfillment.fulfilled_at, firstFulfillment.createdAt, firstFulfillment.created_at, "") || ""),
          financialStatus: String(firstValue(root.financialStatus, root.financial_status, root.financialStatusLabel, "") || ""),
          fulfillmentStatus: String(firstValue(root.fulfillmentStatus, root.fulfilmentStatus, root.fulfillment_status, root.fulfilment_status, root.fulfillmentStatusLabel, root.fulfilmentStatusLabel, "") || ""),
          total: String(firstValue(root.total, root.totalPrice, root.total_price, root.currentTotalPrice, root.current_total_price, "") || ""),
          customerUrl: String(firstValue(root.customerUrl, root.customer_url, root.orderStatusUrl, root.order_status_url, "") || ""),
          returnWindow: root.returnWindow && typeof root.returnWindow === "object"
            ? root.returnWindow
            : payload.returnWindow && typeof payload.returnWindow === "object"
              ? payload.returnWindow
              : null,
          shippingAddress: {
            name: String(firstValue(shippingAddress.name, root.customer?.displayName, "") || ""),
            line1: String(firstValue(shippingAddress.line1, shippingAddress.address1, "") || ""),
            line2: String(firstValue(shippingAddress.line2, shippingAddress.address2, "") || ""),
            city: String(firstValue(shippingAddress.city, "") || ""),
            postcode: String(firstValue(shippingAddress.postcode, shippingAddress.zip, shippingAddress.postalCode, "") || ""),
            country: String(firstValue(shippingAddress.country, shippingAddress.countryCode, "") || "")
          },
          lineItems: asArray(rawItems).map(normaliseLineItem),
          needsManualReview: Boolean(root.needsManualReview || payload.needsManualReview)
        };
      };

      try {
        orders = JSON.parse(ordersScript?.textContent || "[]").map((order) => normaliseOrderPayload(order));
      } catch (_) {
        orders = [];
      }

      const validLookupDetail = (value = "") => {
        const detail = String(value || "").trim();
        if (!detail) return false;
        if (detail.includes("@")) return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(detail);
        return normalizePhone(detail).length >= 7;
      };

      const syncSubmitState = () => {
        if (!submitButton) return;
        const orderIsValid = normalizeOrder(lookupOrderField?.value || "").length >= 3;
        const detailIsValid = validLookupDetail(lookupDetailField?.value || "");
        submitButton.disabled = isSubmitting || !orderIsValid || !detailIsValid;
      };

      const syncManualRequestFields = (orderNumber = "", customerDetail = "", requestType = "") => {
        const cleanOrderNumber = String(orderNumber || lookupOrderField?.value || "").trim();
        const cleanCustomerDetail = String(customerDetail || lookupDetailField?.value || "").trim();
        if (manualOrderField && cleanOrderNumber) manualOrderField.value = cleanOrderNumber;
        if (cleanCustomerDetail.includes("@")) {
          if (manualEmailField) manualEmailField.value = cleanCustomerDetail;
        } else if (cleanCustomerDetail && manualPhoneField) {
          manualPhoneField.value = cleanCustomerDetail;
        }
        if (manualTypeField && requestType) {
          manualTypeField.value = requestType === "exchange" ? "Exchange" : "Return";
        }
      };

      const hideManualRequest = () => {
        if (manualPanel) manualPanel.hidden = true;
        manualTrigger?.setAttribute("aria-expanded", "false");
        setManualMessage();
        portal.classList.remove("is-manual-request-open");
      };

      const showLookupForm = ({ focus = true } = {}) => {
        if (startScreen) startScreen.hidden = true;
        if (startButton) startButton.setAttribute("aria-expanded", "true");
        form.hidden = false;
        if (manualTriggerWrapper) manualTriggerWrapper.hidden = false;
        hideManualRequest();
        hideNotice();
        if (error) error.hidden = true;
        portal.classList.add("is-lookup-open");
        if (focus) lookupOrderField?.focus?.({ preventScroll: true });
      };

      const showManualRequest = (orderNumber = "", customerDetail = "", message = "", requestType = "") => {
        if (lookupOrderField && orderNumber) lookupOrderField.value = orderNumber;
        if (lookupDetailField && customerDetail) lookupDetailField.value = customerDetail;
        showLookupForm({ focus: false });
        setError(message || lookupUnavailableMessage);
        syncSubmitState();
      };

      const clearLabel = () => {
        portal.classList.remove("is-return-complete");
        if (!labelTarget) return;
        labelTarget.hidden = true;
        labelTarget.replaceChildren();
      };

      const hideNotice = () => {
        if (!notice) return;
        notice.hidden = true;
        notice.textContent = "";
      };

      const setError = (message) => {
        activeOrder = null;
        clearLabel();
        hideNotice();
        if (error) {
          error.textContent = message;
          error.hidden = false;
        }
        if (result) result.hidden = true;
        error?.scrollIntoView({ behavior: "smooth", block: "center" });
      };

      const setRequestError = (message) => {
        clearLabel();
        hideNotice();
        if (error) {
          error.textContent = message;
          error.hidden = false;
        }
        result?.scrollIntoView({ behavior: "smooth", block: "start" });
      };

      const detailMatches = (input, order) => {
        const text = normalizeText(input);
        const compact = normalizeCompact(input);
        const phone = normalizePhone(input);
        const phoneCandidates = [order.phone, order.billingPhone]
          .map(normalizePhone)
          .filter(Boolean);
        const candidates = [
          normalizeText(order.email),
          normalizeCompact(order.email),
          normalizeCompact(order.phone),
          normalizeCompact(order.billingPhone),
          ...phoneCandidates
        ].filter(Boolean);

        return candidates.includes(text) ||
          candidates.includes(compact) ||
          (phone && phoneCandidates.some((candidate) =>
            candidate === phone ||
            candidate.endsWith(phone) ||
            phone.endsWith(candidate)
          ));
      };

      const orderMatches = (input, order) => {
        const requestedOrder = normalizeOrder(input);
        if (!requestedOrder) return false;

        return [order.name, order.number]
          .map(normalizeOrder)
          .filter(Boolean)
          .some((orderName) =>
            orderName === requestedOrder ||
            orderName.endsWith(requestedOrder) ||
            requestedOrder.endsWith(orderName)
          );
      };

      const renderOrderSummary = (order) => {
        if (!summaryTarget) return;

        const returnWindow = getReturnWindow(order);
        const meta = [
          ["Order", order.name || order.number],
          ["Eligibility", returnWindow.summary]
        ].filter(([, value]) => String(value || "").trim());

        summaryTarget.innerHTML = `
          <h3>${escapeHtml(order.name || order.number || "Order request")}</h3>
          <dl>
            ${meta.map(([label, value]) => `
              <div>
                <dt>${escapeHtml(label)}</dt>
                <dd>${escapeHtml(value)}</dd>
              </div>
            `).join("")}
          </dl>
          ${order.customerUrl ? `<a href="${escapeAttribute(order.customerUrl)}">View order details</a>` : ""}
        `;
      };

      const renderOrderItems = (order) => {
        if (!itemsTarget) return;

        if (order.needsManualReview || !order.lineItems.length) {
          const orderName = order.name || order.number || "your order";
          const subject = `Return/exchange item list help ${orderName}`;
          const body = [
            "Hi,",
            "",
            "I found my order, but the returns portal could not load the products from the order.",
            `Order: ${orderName}`,
            `Contact: ${order.email || order.phone || ""}`,
            "",
            "Please help me start a return or exchange for the products in this order."
          ].join("\n");
          const href = `mailto:${supportEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

          itemsTarget.innerHTML = `
            <h3>Products in this order</h3>
            <p class="hcx-return-portal__empty">We could not load the products bought in this order. Please contact ${escapeHtml(supportEmail)} with the order number.</p>
            <a class="hcx-return-portal__inline-link" href="${escapeAttribute(href)}">Email HERCXLES about this order</a>
          `;
          return;
        }

        itemsTarget.innerHTML = `
          <h3>${escapeHtml(order.name || order.number || "Order")} products</h3>
          <div class="hcx-return-portal__item-list">
            ${order.lineItems.map((item, index) => `
              <label class="hcx-return-portal__item">
                <input
                  type="checkbox"
                  data-hcx-return-item-checkbox
                  data-hcx-return-item-index="${index}"
                  checked
                >
                <span class="hcx-return-portal__item-media" aria-hidden="true">
                  ${item.image ? `<img src="${escapeAttribute(item.image)}" alt="">` : ""}
                </span>
                <span class="hcx-return-portal__item-copy">
                  <strong>${escapeHtml(item.title)}</strong>
                  ${item.variantTitle ? `<small>${escapeHtml(item.variantTitle)}</small>` : ""}
                  <em>${escapeHtml([item.sku ? `SKU ${item.sku}` : "", item.quantity ? `Qty ${item.quantity}` : "", item.price].filter(Boolean).join(" | "))}</em>
                </span>
              </label>
            `).join("")}
          </div>
        `;
      };

      const contactHrefForWindow = (order, returnWindow) => {
        const orderName = order.name || order.number || "Order";
        const subject = `Return/exchange window help ${orderName}`;
        const body = [
          "Hi,",
          "",
          "I need help with a return or exchange request that is outside the automatic portal window.",
          `Order: ${orderName}`,
          `Contact: ${order.email || order.phone || "Matched order contact"}`,
          `Window status: ${returnWindow.summary}`,
          "",
          "Message:"
        ].filter(Boolean).join("\n");

        return `mailto:${supportEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      };

      const getSelectedRequestType = () =>
        requestTypeFields.find((field) => field.checked)?.value === "exchange" ? "exchange" : "return";

      const isRequestTypeAllowed = (requestType, returnWindow) =>
        requestType === "exchange" ? Boolean(returnWindow?.canExchange) : Boolean(returnWindow?.canReturn);

      const setSelectedRequestType = (requestType) => {
        const normalizedType = requestType === "exchange" ? "exchange" : "return";
        requestTypeFields.forEach((field) => {
          field.checked = field.value === normalizedType;
        });
      };

      const updateRequestTypeUi = () => {
        const requestType = getSelectedRequestType();
        portal.classList.toggle("is-exchange-request", requestType === "exchange");
        portal.classList.toggle("is-return-request", requestType !== "exchange");
        if (exchangeOptions) exchangeOptions.hidden = requestType !== "exchange";
        if (confirmButton) {
          confirmButton.textContent = requestType === "exchange" ? "Confirm exchange" : "Confirm return";
        }
      };

      const syncRequestTypeForWindow = (returnWindow) => {
        if (!requestTypeFields.length) {
          updateRequestTypeUi();
          return;
        }

        requestTypeFields.forEach((field) => {
          const requestType = field.value === "exchange" ? "exchange" : "return";
          const isAllowed = isRequestTypeAllowed(requestType, returnWindow);
          const option = field.closest("[data-hcx-request-choice]");
          const windowLabel = option?.querySelector("small");

          if (windowLabel && !windowLabel.dataset.hcxDefaultWindowLabel) {
            windowLabel.dataset.hcxDefaultWindowLabel = windowLabel.textContent.trim();
          }

          field.disabled = !isAllowed;
          option?.classList.toggle("is-disabled", !isAllowed);
          option?.setAttribute("aria-disabled", isAllowed ? "false" : "true");

          if (windowLabel) {
            windowLabel.textContent = isAllowed
              ? windowLabel.dataset.hcxDefaultWindowLabel
              : "Unavailable for this order";
          }
        });

        if (!isRequestTypeAllowed(getSelectedRequestType(), returnWindow)) {
          if (returnWindow?.canReturn) setSelectedRequestType("return");
          else if (returnWindow?.canExchange) setSelectedRequestType("exchange");
          else requestTypeFields.forEach((field) => {
            field.checked = false;
          });
        }

        updateRequestTypeUi();
      };

      const renderReturnWindowControls = (order) => {
        const returnWindow = getReturnWindow(order);
        const requestTypeGroup = portal.querySelector("[data-hcx-request-type-group]");
        order.returnWindow = returnWindow;

        portal.classList.toggle("is-return-window-open", returnWindow.status === "open");
        portal.classList.toggle("is-return-window-exchange-only", returnWindow.status === "exchange_only");
        portal.classList.toggle("is-return-window-closed", returnWindow.status === "closed");

        actionButtons.forEach((button) => {
          const action = button.dataset.hcxReturnAction === "exchange" ? "exchange" : "return";
          const isAllowed = action === "exchange" ? returnWindow.canExchange : returnWindow.canReturn;
          button.hidden = !isAllowed;
          button.disabled = !isAllowed;
          button.setAttribute("aria-disabled", isAllowed ? "false" : "true");
        });

        syncRequestTypeForWindow(returnWindow);
        updateConfirmButtonState();

        requestFields.forEach((field) => {
          field.disabled = returnWindow.status === "closed";
        });

        let windowMessage = portal.querySelector("[data-hcx-return-window-message]");
        const shouldShowWindowMessage = returnWindow.status !== "open";
        if (!shouldShowWindowMessage) {
          windowMessage?.remove();
          return returnWindow;
        }

        if (!windowMessage) {
          windowMessage = document.createElement("div");
          windowMessage.setAttribute("data-hcx-return-window-message", "");
          requestTypeGroup?.after(windowMessage);
          if (!requestTypeGroup) actionsTarget?.after(windowMessage);
          if (!requestTypeGroup && !actionsTarget && workflow) workflow.append(windowMessage);
        }

        const contactHref = contactHrefForWindow(order, returnWindow);
        windowMessage.className = `hcx-return-portal__window hcx-return-portal__window--${returnWindow.status}`;
        windowMessage.innerHTML = `
          <h3>${escapeHtml(returnWindow.title)}</h3>
          <p>${escapeHtml(returnWindow.message)}</p>
          ${returnWindow.status === "closed" ? `<a href="${escapeAttribute(contactHref)}">Contact us directly</a>` : ""}
        `;

        return returnWindow;
      };

      const getSelectedItems = () => {
        if (!activeOrder?.lineItems?.length || activeOrder.needsManualReview) return [];

        return [...portal.querySelectorAll("[data-hcx-return-item-checkbox]")]
          .filter((checkbox) => checkbox.checked)
          .map((checkbox) => activeOrder.lineItems[Number(checkbox.dataset.hcxReturnItemIndex)])
          .filter(Boolean);
      };

      const updateConfirmButtonState = () => {
        if (!confirmButton || !activeOrder) return;

        const returnWindow = activeOrder.returnWindow || getReturnWindow(activeOrder);
        const requestType = getSelectedRequestType();
        const isAllowed = isRequestTypeAllowed(requestType, returnWindow);
        const hasSelectedItems = Boolean(getSelectedItems().length);
        const requestDetails = getRequestDetails(requestType);
        const hasRequiredReason = Boolean(requestDetails.reason);
        const hasRequiredExchangeDetails = requestType !== "exchange" || Boolean(
          requestDetails.exchange.size || requestDetails.exchange.item
        );
        const canConfirm = isAllowed && hasSelectedItems && hasRequiredReason && hasRequiredExchangeDetails;
        confirmButton.hidden = !(returnWindow.canReturn || returnWindow.canExchange);
        confirmButton.disabled = !canConfirm;
        confirmButton.setAttribute("aria-disabled", canConfirm ? "false" : "true");
      };

      const requestReference = (order, action) => {
        const orderId = normalizeOrder(order.name || order.number || "order").toUpperCase() || "ORDER";
        return `HRCX-${orderId}-${action === "exchange" ? "EXCHANGE" : "RETURN"}`;
      };

      const getFieldValue = (field) => String(field?.value || "").trim();

      const parseMoneyAmount = (value = "") => {
        const text = String(value || "").replace(/,/g, "");
        const match = text.match(/-?\d+(?:\.\d+)?/);
        if (!match) return null;

        const amount = Number(match[0]);
        return Number.isFinite(amount) ? amount : null;
      };

      const formatMoneyAmount = (amount = 0) => {
        try {
          return new Intl.NumberFormat("en-GB", {
            style: "currency",
            currency: "GBP"
          }).format(Math.max(0, Number(amount) || 0));
        } catch (_) {
          return `GBP ${Math.max(0, Number(amount) || 0).toFixed(2)}`;
        }
      };

      const selectedItemsTotal = (selectedItems = []) => {
        if (!selectedItems.length) {
          return {
            amount: 0,
            known: false,
            quantity: 0,
            label: "Select products"
          };
        }

        let amount = 0;
        let known = true;
        let quantity = 0;

        selectedItems.forEach((item) => {
          const itemAmount = parseMoneyAmount(item.price);
          const itemQuantity = Number.parseInt(String(item.quantity || "1"), 10);
          quantity += Number.isFinite(itemQuantity) && itemQuantity > 0 ? itemQuantity : 1;

          if (itemAmount === null) {
            known = false;
            return;
          }

          amount += itemAmount;
        });

        return {
          amount,
          known,
          quantity: Math.max(1, quantity || selectedItems.length || 1),
          label: known ? formatMoneyAmount(amount) : "To confirm"
        };
      };

      const normalizeLookupPhrase = (value = "") =>
        String(value || "")
          .toLowerCase()
          .replace(/&/g, " and ")
          .replace(/[^a-z0-9]+/g, " ")
          .trim();

      const lookupTokens = (value = "") =>
        normalizeLookupPhrase(value)
          .split(/\s+/)
          .filter((token) => token.length > 1);

      const getProductCatalog = async () => {
        if (!productCatalogPromise) {
          productCatalogPromise = fetch("/products.json?limit=250", {
            headers: { "Accept": "application/json" },
            cache: "no-store"
          })
            .then((response) => (response.ok ? response.json() : { products: [] }))
            .then((payload) => asArray(payload.products).flatMap((product) => {
              const productTitle = String(product.title || "").trim();
              const productHandle = String(product.handle || "").trim();
              const productImage = String(product.image?.src || asArray(product.images)[0]?.src || "");
              return asArray(product.variants).map((variant) => {
                const variantTitle = String(variant.title || "").trim();
                const price = Number(variant.price);
                return {
                  id: String(variant.id || `${productHandle}-${variantTitle || "default"}`),
                  title: productTitle,
                  handle: productHandle,
                  variantTitle: variantTitle === "Default Title" ? "" : variantTitle,
                  price: Number.isFinite(price) ? price : null,
                  available: variant.available !== false,
                  image: productImage,
                  text: normalizeLookupPhrase(`${productTitle} ${productHandle} ${variantTitle} ${variant.option1 || ""} ${variant.option2 || ""} ${variant.option3 || ""}`)
                };
              });
            }))
            .catch(() => []);
        }

        return productCatalogPromise;
      };

      const replacementLabel = (entry = {}) =>
        [entry.title, entry.variantTitle].filter(Boolean).join(" - ") || "Replacement item";

      const replacementPriceLabel = (entry = {}) =>
        entry.price === null || entry.price === undefined ? "Price to confirm" : formatMoneyAmount(entry.price);

      const scoreCatalogEntry = (entry, query = "") => {
        const normalizedQuery = normalizeLookupPhrase(query);
        if (!normalizedQuery) return 1;

        const tokens = lookupTokens(normalizedQuery);
        let score = 0;
        if (entry.text.includes(normalizedQuery)) score += 80;
        if (normalizeLookupPhrase(entry.title) === normalizedQuery) score += 80;
        if (String(entry.handle || "").includes(normalizedQuery.replace(/\s+/g, "-"))) score += 45;
        score += tokens.filter((token) => entry.text.includes(token)).length * 18;
        if (tokens.length && tokens.every((token) => entry.text.includes(token))) score += 32;
        return score;
      };

      const renderExchangeProductResults = async () => {
        if (!exchangeProductResults) return;

        exchangeProductResults.dataset.hcxExchangeResultsState = "loading";
        exchangeProductResults.innerHTML = `<p>Loading current store products...</p>`;

        const catalog = await getProductCatalog();
        const query = getFieldValue(exchangeProductSearch);

        if (!catalog.length) {
          exchangeRenderedProductOptions = [];
          exchangeProductResults.dataset.hcxExchangeResultsState = "empty";
          exchangeProductResults.innerHTML = `<p>Store product search is unavailable. Type the replacement item and size above and HERCXLES will confirm the price by email.</p>`;
          return;
        }

        exchangeRenderedProductOptions = catalog
          .map((entry) => ({ entry, score: scoreCatalogEntry(entry, query) }))
          .filter(({ entry, score }) => entry.available && score > 0)
          .sort((a, b) => b.score - a.score || replacementLabel(a.entry).localeCompare(replacementLabel(b.entry)))
          .map(({ entry }) => entry);

        if (!exchangeRenderedProductOptions.length) {
          exchangeProductResults.dataset.hcxExchangeResultsState = "empty";
          exchangeProductResults.innerHTML = `<p>No matching products found. Try a shorter search, or type the replacement details above.</p>`;
          return;
        }

        exchangeProductResults.dataset.hcxExchangeResultsState = "ready";
        exchangeProductResults.innerHTML = exchangeRenderedProductOptions
          .map((entry, index) => {
            const selected = selectedReplacementVariant?.id === entry.id;
            return `
              <button
                type="button"
                class="hcx-return-portal__exchange-product${selected ? " is-selected" : ""}"
                data-hcx-exchange-product-option
                data-hcx-exchange-product-index="${index}"
                aria-pressed="${selected ? "true" : "false"}"
              >
                <span>
                  <strong>${escapeHtml(entry.title || "Store item")}</strong>
                  <small>${escapeHtml(entry.variantTitle || "One size")}</small>
                </span>
                <em>${escapeHtml(replacementPriceLabel(entry))}</em>
              </button>
            `;
          })
          .join("");
      };

      const queueExchangeProductResults = () => {
        if (!exchangeProductResults) return;
        window.clearTimeout(exchangeProductSearchTimer);
        exchangeProductSearchTimer = window.setTimeout(() => {
          renderExchangeProductResults().catch(() => {
            exchangeRenderedProductOptions = [];
            exchangeProductResults.dataset.hcxExchangeResultsState = "empty";
            exchangeProductResults.innerHTML = `<p>Store product search is unavailable. Type the replacement item and size above and HERCXLES will confirm the price by email.</p>`;
          });
        }, 120);
      };

      const selectExchangeReplacement = (entry) => {
        selectedReplacementVariant = entry || null;
        if (!selectedReplacementVariant) return;

        if (exchangeTypeField && !getFieldValue(exchangeTypeField)) {
          exchangeTypeField.value = "Swap for another item";
        }
        if (exchangeItemField) exchangeItemField.value = selectedReplacementVariant.title || "";
        if (exchangeSizeField) exchangeSizeField.value = selectedReplacementVariant.variantTitle || "One size";

        clearLabel();
        if (error) error.hidden = true;
        updateConfirmButtonState();
        updateExchangeBalancePreview();
        renderExchangeProductResults().catch(() => {});
      };

      const findReplacementProduct = async (itemQuery = "", sizeQuery = "") => {
        const query = normalizeLookupPhrase(itemQuery);
        const queryTokenList = lookupTokens(itemQuery);
        const sizeTokenList = lookupTokens(sizeQuery);
        if (!query || query.length < 3 || !queryTokenList.length) return null;

        const catalog = await getProductCatalog();
        let bestMatch = null;

        catalog.forEach((entry) => {
          if (entry.price === null) return;

          const productText = normalizeLookupPhrase(`${entry.title} ${entry.handle}`);
          const variantText = normalizeLookupPhrase(entry.variantTitle);
          const haystack = entry.text;
          let score = 0;

          if (productText === query || entry.handle === query.replace(/\s+/g, "-")) score += 100;
          if (productText.includes(query) || haystack.includes(query)) score += 70;
          if (queryTokenList.every((token) => haystack.includes(token))) score += 48;
          score += queryTokenList.filter((token) => haystack.includes(token)).length * 10;

          if (sizeTokenList.length) {
            if (sizeTokenList.every((token) => variantText.includes(token))) score += 24;
            else if (sizeTokenList.some((token) => variantText.includes(token))) score += 12;
          }

          if (!bestMatch || score > bestMatch.score) {
            bestMatch = { ...entry, score };
          }
        });

        return bestMatch?.score >= 55 ? bestMatch : null;
      };

      const returnBalanceSummary = (selectedItems = []) => {
        const selectedTotal = selectedItemsTotal(selectedItems);
        if (!selectedTotal.known) {
          const needsSelection = !selectedItems.length;
          return {
            status: "unknown",
            heading: "Refund estimate",
            customerLabel: needsSelection ? "Select products to calculate refund" : "Refund estimate unavailable",
            detail: needsSelection
              ? "Tick the products being returned and the refund estimate will update from their current prices."
              : "The selected product price is not available online, so HERCXLES will email the refund amount.",
            merchantAction: "Confirm the returned item value, then refund the customer after inspection.",
            selectedValue: selectedTotal.label,
            replacementValue: "",
            matchedReplacement: ""
          };
        }

        return {
          status: "refund",
          heading: "Refund estimate",
          customerLabel: `${selectedTotal.label} refund expected`,
          detail: "Final refund is processed after the returned items are inspected.",
          merchantAction: `Refund ${selectedTotal.label} after the returned items are inspected.`,
          selectedValue: selectedTotal.label,
          replacementValue: "",
          matchedReplacement: ""
        };
      };

      const exchangeBalanceSummary = async (requestDetails, selectedItems = []) => {
        const selectedTotal = selectedItemsTotal(selectedItems);
        const exchangeType = normalizeLookupPhrase(requestDetails.exchange.type);
        const replacementText = requestDetails.exchange.item;
        const shouldMatchCatalog = Boolean(replacementText && (exchangeType.includes("swap") || replacementText.length >= 4));

        if (!selectedItems.length) {
          return {
            status: "unknown",
            heading: "Exchange balance",
            customerLabel: "Select products to calculate balance",
            detail: "Tick the products being exchanged and the price difference will update from their current prices.",
            merchantAction: "Confirm the selected returned items, then set up any payment link or refund difference.",
            selectedValue: selectedTotal.label,
            replacementValue: "Select replacement",
            matchedReplacement: ""
          };
        }

        if (!selectedTotal.known) {
          return {
            status: "unknown",
            heading: "Exchange balance",
            customerLabel: "Price difference to confirm",
            detail: "We will confirm the replacement price by email before setting up any payment or refund.",
            merchantAction: "Confirm the returned item value and replacement item price, then email the customer.",
            selectedValue: selectedTotal.label,
            replacementValue: "To confirm",
            matchedReplacement: ""
          };
        }

        let replacementMatch = selectedReplacementVariant?.price !== null && selectedReplacementVariant?.price !== undefined
          ? selectedReplacementVariant
          : null;
        if (!replacementMatch && shouldMatchCatalog) {
          replacementMatch = await findReplacementProduct(replacementText, requestDetails.exchange.size);
        }

        if (!replacementMatch && (exchangeType.includes("different size") || exchangeType.includes("different colour"))) {
          return {
            status: "same",
            heading: "Exchange balance",
            customerLabel: "No price difference expected",
            detail: `${selectedTotal.label} returned item value. Same product size/colour exchanges are expected to be the same price.`,
            merchantAction: "No payment or refund is expected unless stock or current pricing has changed.",
            selectedValue: selectedTotal.label,
            replacementValue: selectedTotal.label,
            matchedReplacement: "Same product exchange"
          };
        }

        if (!replacementMatch) {
          return {
            status: "unknown",
            heading: "Exchange balance",
            customerLabel: "Price difference to confirm",
            detail: `Returned item value is ${selectedTotal.label}. We will confirm the replacement item price by email.`,
            merchantAction: "Confirm the replacement item price, then send the customer a payment link or refund the difference.",
            selectedValue: selectedTotal.label,
            replacementValue: "To confirm",
            matchedReplacement: ""
          };
        }

        const replacementTotal = replacementMatch.price * selectedTotal.quantity;
        const difference = replacementTotal - selectedTotal.amount;
        const amountLabel = formatMoneyAmount(Math.abs(difference));
        const replacementLabel = formatMoneyAmount(replacementTotal);
        const matchedReplacement = [
          replacementMatch.title,
          replacementMatch.variantTitle
        ].filter(Boolean).join(" - ");

        if (difference > 0.009) {
          return {
            status: "pay",
            heading: "Exchange balance",
            customerLabel: `${amountLabel} to pay`,
            detail: `Returned item value ${selectedTotal.label}. Replacement ${replacementLabel}.`,
            merchantAction: `Send the customer a payment link for ${amountLabel} after confirming stock.`,
            selectedValue: selectedTotal.label,
            replacementValue: replacementLabel,
            matchedReplacement
          };
        }

        if (difference < -0.009) {
          return {
            status: "refund",
            heading: "Exchange balance",
            customerLabel: `${amountLabel} refund expected`,
            detail: `Returned item value ${selectedTotal.label}. Replacement ${replacementLabel}.`,
            merchantAction: `Refund ${amountLabel} after confirming stock and receiving the returned item.`,
            selectedValue: selectedTotal.label,
            replacementValue: replacementLabel,
            matchedReplacement
          };
        }

        return {
          status: "same",
          heading: "Exchange balance",
          customerLabel: "No price difference expected",
          detail: `Returned item value ${selectedTotal.label}. Replacement ${replacementLabel}.`,
          merchantAction: "No payment or refund is expected unless stock or current pricing has changed.",
          selectedValue: selectedTotal.label,
          replacementValue: replacementLabel,
          matchedReplacement
        };
      };

      const balanceSummaryMarkup = (summary) => `
        <span>${escapeHtml(summary.heading || "Balance")}</span>
        <strong>${escapeHtml(summary.customerLabel || "To confirm")}</strong>
        <p>${escapeHtml(summary.detail || "")}</p>
      `;

      const updateExchangeBalancePreview = async () => {
        if (!exchangeBalanceTarget || !activeOrder) return;
        if (getSelectedRequestType() !== "exchange") return;

        const token = ++balancePreviewToken;
        const requestDetails = getRequestDetails("exchange");
        const selectedItems = getSelectedItems();
        exchangeBalanceTarget.dataset.hcxBalanceStatus = "loading";
        exchangeBalanceTarget.innerHTML = `
          <span>Exchange balance</span>
          <strong>Checking price difference</strong>
          <p>Matching the replacement item against current product prices.</p>
        `;

        const summary = await exchangeBalanceSummary(requestDetails, selectedItems);
        if (token !== balancePreviewToken) return;

        exchangeBalanceTarget.dataset.hcxBalanceStatus = summary.status || "unknown";
        exchangeBalanceTarget.innerHTML = balanceSummaryMarkup(summary);
      };

      const getRequestDetails = (requestType) => {
        const exchangeDetails = {
          type: getFieldValue(exchangeTypeField),
          size: getFieldValue(exchangeSizeField),
          item: getFieldValue(exchangeItemField)
        };

        return {
          type: requestType,
          reason: getFieldValue(reasonField),
          details: getFieldValue(detailsField) || getFieldValue(reasonField),
          exchange: exchangeDetails,
          replacement: selectedReplacementVariant ? {
            title: selectedReplacementVariant.title || "",
            size: selectedReplacementVariant.variantTitle || "One size",
            price: replacementPriceLabel(selectedReplacementVariant)
          } : null,
          hasExchangeRequest: Boolean(exchangeDetails.type || exchangeDetails.size || exchangeDetails.item)
        };
      };

      const inferRequestTypeFromDetails = () => getSelectedRequestType();

      const setReturnRequestActionsEnabled = (statusTarget, enabled) => {
        const requestCard = statusTarget?.closest?.(".hcx-return-request-card");
        const sendLink = requestCard?.querySelector?.("[data-hcx-send-return-request]");
        const copyButton = requestCard?.querySelector?.("[data-hcx-copy-return-request]");

        if (sendLink) {
          const storedHref = sendLink.dataset.hcxRequestHref || sendLink.getAttribute("href") || "";
          if (storedHref) sendLink.dataset.hcxRequestHref = storedHref;

          if (enabled) {
            if (sendLink.dataset.hcxRequestHref) sendLink.setAttribute("href", sendLink.dataset.hcxRequestHref);
            sendLink.removeAttribute("aria-disabled");
            sendLink.removeAttribute("tabindex");
          } else {
            sendLink.removeAttribute("href");
            sendLink.setAttribute("aria-disabled", "true");
            sendLink.setAttribute("tabindex", "-1");
          }
        }

        if (copyButton) copyButton.disabled = !enabled;
      };

      const copyReturnRequest = async (text = "") => {
        if (navigator.clipboard?.writeText && window.isSecureContext) {
          await navigator.clipboard.writeText(text);
          return true;
        }

        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.setAttribute("readonly", "readonly");
        textarea.style.position = "fixed";
        textarea.style.inset = "-9999px auto auto -9999px";
        document.body.append(textarea);
        textarea.select();
        const copied = document.execCommand?.("copy") === true;
        textarea.remove();
        return copied;
      };

      const notifyMerchantRequest = async (payload, statusTarget) => {
        setReturnRequestActionsEnabled(statusTarget, true);

        if (!requestUrl) {
          if (statusTarget) statusTarget.textContent = "Open the email below to send this request to HERCXLES.";
          return;
        }

        const notificationKey = [
          payload.reference,
          payload.requestType,
          payload.reason,
          payload.details,
          payload.exchange?.type,
          payload.exchange?.size,
          payload.exchange?.item,
          payload.balance?.customerLabel,
          payload.items?.join("|")
        ].join("::");

        if (sentRequestNotifications.has(notificationKey)) {
          if (statusTarget) statusTarget.textContent = "This request has already been prepared. You can still open or copy the email below.";
          return;
        }

        try {
          if (statusTarget) statusTarget.textContent = "Request ready. Sending a copy to HERCXLES.";
          const { payload: notificationPayload, response } = await fetchHcxOrderLookup(requestUrl, payload);
          if (response.ok && (notificationPayload?.shopifyReturnCreated || notificationPayload?.notificationSent)) {
            sentRequestNotifications.add(notificationKey);
            if (statusTarget) statusTarget.textContent = "Request sent to HERCXLES. Keep your proof of postage after posting.";
            return;
          }

          if (response.ok && notificationPayload?.error === "email_notification_not_configured") {
            setReturnRequestActionsEnabled(statusTarget, true);
            if (statusTarget) statusTarget.textContent = "Order verified. Open the email below to send this request to HERCXLES.";
            return;
          }

          if (returnRequestVerificationErrors.has(notificationPayload?.error)) {
            if (statusTarget) statusTarget.textContent =
              notificationPayload.error === "order_customer_mismatch"
                ? returnRequestVerificationMessage
                : notificationPayload.error === "return_window_closed"
                  ? "This order is not eligible for a return. Contact us if you still need help."
                  : notificationPayload.error === "exchange_window_closed"
                    ? "This order is not eligible for an exchange. Contact us if you still need help."
                    : "Automatic send could not verify the request. Use the email button below or contact us with your order number.";
            return;
          }
        } catch (_) {
          if (statusTarget) statusTarget.textContent = "Automatic send is unavailable. Use the email button below and keep your proof of postage.";
          return;
        }

        if (statusTarget) {
          statusTarget.textContent = "Automatic send is unavailable. Use the email button below and keep your proof of postage.";
        }
      };

      const renderLabel = async (action) => {
        if (!activeOrder || !labelTarget) return;

        const selectedItems = getSelectedItems();
        if (!selectedItems.length) {
          setRequestError("Select at least one item before creating the return or exchange instructions.");
          return;
        }

        const requestType = action === "exchange" ? "exchange" : "return";
        const actionLabel = requestType === "exchange" ? "Exchange" : "Return";
        const returnWindow = activeOrder.returnWindow || getReturnWindow(activeOrder);

        if (requestType === "return" && !returnWindow.canReturn) {
          setRequestError(returnWindow.status === "exchange_only"
            ? "This order is no longer eligible for a return. You can still request an exchange."
            : "This order is outside the return and exchange window. Please contact us for help.");
          return;
        }

        if (requestType === "exchange" && !returnWindow.canExchange) {
          setRequestError("This order is outside the exchange window. Please contact us for help.");
          return;
        }

        const requestDetails = getRequestDetails(requestType);
        if (!requestDetails.reason) {
          setRequestError("Type the reason for the return or exchange before confirming.");
          return;
        }

        if (requestType === "exchange" && !requestDetails.exchange.size && !requestDetails.exchange.item) {
          setRequestError("Add the replacement size, colour or item you want before confirming the exchange.");
          exchangeSizeField?.focus?.({ preventScroll: true });
          return;
        }

        const balanceSummary = requestType === "exchange"
          ? await exchangeBalanceSummary(requestDetails, selectedItems)
          : returnBalanceSummary(selectedItems);

        if (error) error.hidden = true;
        const reference = requestReference(activeOrder, requestType);
        const orderName = activeOrder.name || activeOrder.number || "Order";
        const selectedItemLines = selectedItems.map((item) =>
          [
            item.title,
            item.variantTitle,
            item.quantity ? `Qty ${item.quantity}` : ""
        ].filter(Boolean).join(", ")
        );
        const reasonHeading = requestType === "exchange" ? "Exchange request / reason" : "Return reason";
        const exchangeEmailLines = requestType === "exchange"
          ? [
            "Exchange details:",
            `Exchange type: ${requestDetails.exchange.type || "Not provided"}`,
            `Requested size: ${requestDetails.exchange.size || "Not provided"}`,
            `Replacement item / colour: ${requestDetails.exchange.item || "Not provided"}`,
            `Exchange balance: ${balanceSummary.customerLabel || "To confirm"}`,
            `Returned item value: ${balanceSummary.selectedValue || "To confirm"}`,
            `Replacement value: ${balanceSummary.replacementValue || "To confirm"}`,
            balanceSummary.matchedReplacement ? `Matched replacement: ${balanceSummary.matchedReplacement}` : "",
            `Merchant action: ${balanceSummary.merchantAction || "Confirm by email"}`
          ]
            .filter(Boolean)
          : [];
        const supportSubject = `${actionLabel} request ${orderName}`;
        const supportBody = [
          `${actionLabel} request`,
          `Reference: ${reference}`,
          `Order: ${orderName}`,
          `Customer contact: ${activeOrder.email || activeOrder.phone || "Matched order contact"}`,
          `Window status: ${returnWindow.summary}`,
          "",
          `Items:`,
          ...selectedItemLines.map((line) => `- ${line}`),
          "",
          `${reasonHeading}: ${requestDetails.reason || "Not provided"}`,
          `Extra details: ${requestDetails.details || "Not provided"}`,
          ...(exchangeEmailLines.length ? ["", ...exchangeEmailLines] : []),
          requestType === "return" ? "" : "",
          requestType === "return" ? `Refund estimate: ${balanceSummary.customerLabel || "To confirm"}` : "",
          requestType === "return" ? `Merchant action: ${balanceSummary.merchantAction || "Confirm refund after inspection"}` : "",
          "",
          "Postage: Customer will pay for tracked delivery and keep the receipt/proof of postage.",
          "Tracking number: Customer to add after posting if available."
        ].filter((line, index, lines) => line !== "" || lines[index - 1] !== "").join("\n");
        const supportHref = `mailto:${supportEmail}?subject=${encodeURIComponent(supportSubject)}&body=${encodeURIComponent(supportBody)}`;
        const submissionId = window.crypto?.randomUUID?.()
          || `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
        const notificationPayload = {
          submissionId,
          reference,
          requestType,
          actionLabel,
          order_number: orderName,
          order: orderName,
          customer_detail: activeOrder.email || activeOrder.phone || "",
          customerContact: activeOrder.email || activeOrder.phone || "Matched order contact",
          windowStatus: returnWindow.summary,
          items: selectedItemLines,
          selectedItems: selectedItems.map((item) => ({
            lineItemId: item.id,
            quantity: Math.max(1, Number.parseInt(item.quantity, 10) || 1)
          })),
          reason: requestDetails.reason || "Not provided",
          details: requestDetails.details || "Not provided",
          exchange: requestDetails.exchange,
          balance: balanceSummary,
          subject: supportSubject,
          body: supportBody
        };
        const completeTitle = `${actionLabel} request and return address`;

        labelTarget.innerHTML = `
          <section class="hcx-return-complete-page hcx-return-complete-page--address-only" aria-label="${escapeAttribute(completeTitle)}">
            <div class="hcx-return-request-card">
              <span>Final step</span>
              <strong>Send ${escapeHtml(actionLabel.toLowerCase())} request</strong>
              <p>We will try to send this automatically. If that is unavailable, use the email button below and wait for approval before posting your item.</p>
              <div class="hcx-return-request-card__actions">
                <a href="${escapeAttribute(supportHref)}" data-hcx-send-return-request data-hcx-request-href="${escapeAttribute(supportHref)}">Open request email</a>
                <button type="button" data-hcx-copy-return-request>Copy request details</button>
              </div>
              <p class="hcx-return-request-card__status" data-hcx-return-request-status aria-live="polite"></p>
            </div>
            <div class="hcx-return-portal__label-actions">
              <button type="button" data-hcx-print-return-address-label>Print address label</button>
            </div>
            <section class="hcx-return-address-label" aria-label="Printable return address label">
              <div class="hcx-return-address-label__brand">
                <span>Return to</span>
                <strong>HERCXLES RETURNS</strong>
              </div>
              <address>${returnAddressLines.slice(1).map(escapeHtml).join("<br>")}</address>
              <div class="hcx-return-address-label__meta">
                <p>Order: ${escapeHtml(orderName)}</p>
                <p>${escapeHtml(reference)}</p>
              </div>
            </section>
          </section>
        `;
        portal.classList.add("is-return-complete");
        labelTarget.hidden = false;
        const requestStatus = labelTarget.querySelector("[data-hcx-return-request-status]");
        setReturnRequestActionsEnabled(requestStatus, true);
        if (window.history?.pushState) {
          window.history.pushState(
            { hcxReturnComplete: true, requestType },
            "",
            `${window.location.pathname}${window.location.search}#${requestType}-complete`
          );
        }
        labelTarget.querySelector("[data-hcx-print-return-address-label]")?.addEventListener("click", () => {
          document.body.classList.add("hcx-printing-return-label");
          const clearPrintMode = () => document.body.classList.remove("hcx-printing-return-label");
          window.addEventListener("afterprint", clearPrintMode, { once: true });
          window.print();
          window.setTimeout(clearPrintMode, 1500);
        });
        labelTarget.querySelector("[data-hcx-copy-return-request]")?.addEventListener("click", async () => {
          try {
            const copied = await copyReturnRequest(`To: ${supportEmail}\nSubject: ${supportSubject}\n\n${supportBody}`);
            if (requestStatus) {
              requestStatus.textContent = copied
                ? "Request details copied. Paste them into an email to HERCXLES before posting."
                : "Copy did not complete. Use the email button instead.";
            }
          } catch (_) {
            if (requestStatus) requestStatus.textContent = "Copy did not complete. Use the email button instead.";
          }
        });
        notifyMerchantRequest(notificationPayload, requestStatus);
        labelTarget.scrollIntoView({ behavior: "smooth", block: "start" });
      };

      const showOrderWorkspace = (payload, rawOrderNumber, requestedDetail, options = {}) => {
        hideManualRequest();
        if (startScreen) startScreen.hidden = true;
        form.hidden = false;
        if (manualTriggerWrapper) manualTriggerWrapper.hidden = false;
        portal.classList.add("is-lookup-open");
        activeOrder = normaliseOrderPayload(payload, rawOrderNumber, requestedDetail);
        activeOrder.needsManualReview = Boolean(activeOrder.needsManualReview || options.needsManualReview);
        selectedReplacementVariant = null;
        if (exchangeProductSearch) exchangeProductSearch.value = "";
        if (exchangeProductResults) {
          exchangeRenderedProductOptions = [];
          exchangeProductResults.dataset.hcxExchangeResultsState = "idle";
          exchangeProductResults.innerHTML = `<p>Search or scroll to choose the replacement item and size.</p>`;
        }
        portal.classList.toggle("is-manual-review", activeOrder.needsManualReview);
        const matchedPanel = portal.querySelector(".hcx-return-portal__matched");
        if (matchedPanel) matchedPanel.hidden = false;
        if (matchLabel) matchLabel.textContent = "Order details";
        clearLabel();
        renderOrderSummary(activeOrder);
        renderOrderItems(activeOrder);
        renderReturnWindowControls(activeOrder);
        updateExchangeBalancePreview();

        if (error) error.hidden = true;
        hideNotice();
        if (result) {
          result.hidden = false;
          result.focus?.({ preventScroll: true });
          result.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      };

      const showManualReviewWorkspace = (rawOrderNumber, requestedDetail, message = "") => {
        showManualRequest(rawOrderNumber, requestedDetail, message || lookupUnavailableMessage);
      };

      const lookupOrderRemotely = async (orderNumber, customerDetail) => {
        if (!lookupUrl) return null;

        const { payload, response } = await fetchHcxOrderLookup(lookupUrl, {
          order_number: orderNumber,
          customer_detail: customerDetail
        });

        if (!response.ok) {
          return {
            matched: false,
            unavailable: true,
            status: response.status,
            error: payload?.error || "",
            message: hcxOrderLookupErrorMessage(payload, response.status, lookupUnavailableMessage)
          };
        }

        return payload;
      };

      const handleReturnRequest = async (event) => {
        event?.preventDefault();
        event?.stopPropagation();

        syncSubmitState();
        if (submitButton?.disabled || isSubmitting) return false;

        const formData = new FormData(form);
        const rawOrderNumber = String(formData.get("order_number") || "").trim();
        const requestedDetail = String(formData.get("customer_detail") || "").trim();

        const matchedOrder = orders.find((order) => orderMatches(rawOrderNumber, order) && detailMatches(requestedDetail, order));

        if (lookupUrl) {
          try {
            isSubmitting = true;
            if (submitButton) submitButton.textContent = "Checking";
            syncSubmitState();

            const lookupResult = await lookupOrderRemotely(rawOrderNumber, requestedDetail);

            if (lookupResult?.matched || lookupResult?.ok || lookupResult?.order || lookupResult?.lineItems || lookupResult?.items) {
              showOrderWorkspace(lookupResult, rawOrderNumber, requestedDetail);
              return false;
            }

            if (lookupResult?.unavailable) {
              if (matchedOrder) {
                showOrderWorkspace(matchedOrder, rawOrderNumber, requestedDetail);
              } else {
                showManualReviewWorkspace(rawOrderNumber, requestedDetail, lookupResult.message || lookupUnavailableMessage);
              }
              return false;
            }

            if (matchedOrder) {
              showOrderWorkspace(matchedOrder, rawOrderNumber, requestedDetail);
              return false;
            }

            setError(lookupNotFoundMessage);
            return false;
          } catch (_) {
            if (matchedOrder) {
              showOrderWorkspace(matchedOrder, rawOrderNumber, requestedDetail);
            } else {
              showManualReviewWorkspace(rawOrderNumber, requestedDetail, lookupUnavailableMessage);
            }
            return false;
          } finally {
            isSubmitting = false;
            if (submitButton) submitButton.textContent = defaultButtonText;
            syncSubmitState();
          }
        }

        if (matchedOrder) {
          showOrderWorkspace(matchedOrder, rawOrderNumber, requestedDetail);
        } else if (hasLocalOrders) {
          setError(lookupNotFoundMessage);
        } else {
          showManualReviewWorkspace(rawOrderNumber, requestedDetail, lookupUnavailableMessage);
        }
        return false;
      };

      form.addEventListener("submit", handleReturnRequest);

      startButton?.addEventListener("click", () => showLookupForm());
      manualTrigger?.addEventListener("click", () => {
        showManualRequest(
          lookupOrderField?.value || "",
          lookupDetailField?.value || "",
          manualDefaultMessage,
          getSelectedRequestType()
        );
      });
      manualBackButton?.addEventListener("click", () => showLookupForm());

      actionButtons.forEach((button) => {
        button.addEventListener("click", () => {
          renderLabel(button.dataset.hcxReturnAction || "return").catch(() => {
            setRequestError("We could not prepare this request. Please try again or email us with your order number.");
          });
        });
      });

      confirmButton?.addEventListener("click", () => {
        renderLabel(inferRequestTypeFromDetails()).catch(() => {
          setRequestError("We could not prepare this request. Please try again or email us with your order number.");
        });
      });

      portal.addEventListener("change", (event) => {
        if (event.target?.matches?.("[data-hcx-return-item-checkbox]")) {
          clearLabel();
          updateConfirmButtonState();
          updateExchangeBalancePreview();
        }
      });

      requestTypeFields.forEach((field) => {
        field.addEventListener("change", () => {
          clearLabel();
          if (error) error.hidden = true;
          updateRequestTypeUi();
          updateConfirmButtonState();
          if (getSelectedRequestType() === "exchange") queueExchangeProductResults();
          updateExchangeBalancePreview();
        });
      });

      requestFields.forEach((field) => {
        const handleRequestFieldChange = () => {
          clearLabel();
          if (error) error.hidden = true;
          if ((field === exchangeSizeField || field === exchangeItemField) && selectedReplacementVariant) {
            const currentItem = getFieldValue(exchangeItemField);
            const currentSize = getFieldValue(exchangeSizeField);
            const selectedSize = selectedReplacementVariant.variantTitle || "One size";
            if (currentItem !== selectedReplacementVariant.title || currentSize !== selectedSize) {
              selectedReplacementVariant = null;
              renderExchangeProductResults().catch(() => {});
            }
          }
          updateConfirmButtonState();
          if (field === exchangeTypeField || field === exchangeSizeField || field === exchangeItemField) {
            updateExchangeBalancePreview();
          }
        };
        field.addEventListener("input", handleRequestFieldChange);
        field.addEventListener("change", handleRequestFieldChange);
      });

      exchangeProductSearch?.addEventListener("focus", () => {
        if (getSelectedRequestType() === "exchange") queueExchangeProductResults();
      });

      exchangeProductSearch?.addEventListener("input", () => {
        if (selectedReplacementVariant) {
          if (exchangeItemField) exchangeItemField.value = "";
          if (exchangeSizeField) exchangeSizeField.value = "";
        }
        selectedReplacementVariant = null;
        clearLabel();
        if (error) error.hidden = true;
        queueExchangeProductResults();
        updateConfirmButtonState();
        updateExchangeBalancePreview();
      });

      exchangeProductResults?.addEventListener("click", (event) => {
        const option = event.target?.closest?.("[data-hcx-exchange-product-option]");
        if (!option) return;
        const entry = exchangeRenderedProductOptions[Number(option.dataset.hcxExchangeProductIndex)];
        if (entry) selectExchangeReplacement(entry);
      });

      const closeHelpPopovers = () => {
        helpButtons.forEach((button) => {
          const field = button.closest(".hcx-return-portal__field");
          field?.classList.remove("is-help-open");
          button.setAttribute("aria-expanded", "false");
        });
      };

      helpButtons.forEach((button) => {
        const field = button.closest(".hcx-return-portal__field");
        if (!field) return;

        button.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();

          const shouldOpen = !field.classList.contains("is-help-open");
          closeHelpPopovers();
          field.classList.toggle("is-help-open", shouldOpen);
          button.setAttribute("aria-expanded", shouldOpen ? "true" : "false");
        });
      });

      portal.addEventListener("click", (event) => {
        const target = event.target;
        if (!target?.closest) return;
        if (target.closest("[data-hcx-return-help]") || target.closest("[data-hcx-return-help-popover]")) return;
        closeHelpPopovers();
      });

      portal.addEventListener("keydown", (event) => {
        if (event.key === "Escape") closeHelpPopovers();
      });

      document.addEventListener("click", (event) => {
        const target = event.target;
        if (!target?.closest || portal.contains(target)) return;
        closeHelpPopovers();
      });

      requiredFields.forEach((field) => {
        field.addEventListener("input", syncSubmitState);
        field.addEventListener("change", syncSubmitState);
        field.addEventListener("keyup", syncSubmitState);
      });

      const manualSubmissionVisible = Boolean(
        manualSuccess ||
        manualError ||
        new URLSearchParams(window.location.search).has("contact_posted") ||
        window.location.hash === "#HcxReturnManualForm"
      );

      if (manualSubmissionVisible) {
        showManualRequest();
      } else if (startScreen) {
        startScreen.hidden = false;
        startButton?.setAttribute("aria-expanded", "false");
        form.hidden = true;
        if (manualTriggerWrapper) manualTriggerWrapper.hidden = true;
        hideManualRequest();
        if (result) result.hidden = true;
        if (error) error.hidden = true;
        hideNotice();
        clearLabel();
        portal.classList.remove("is-lookup-open");
      } else {
        showLookupForm({ focus: false });
      }

      syncSubmitState();
    });
  };

  const initFaqPage = () => {
    document.querySelectorAll("[data-hcx-faq-page]").forEach((faq) => {
      if (faq.dataset.hcxFaqBound === "true") return;
      faq.dataset.hcxFaqBound = "true";

      const search = faq.querySelector("[data-hcx-faq-search]");
      const filters = [...faq.querySelectorAll("[data-hcx-faq-filter]")];
      const items = [...faq.querySelectorAll("[data-hcx-faq-item]")];
      const count = faq.querySelector("[data-hcx-faq-count]");
      const empty = faq.querySelector("[data-hcx-faq-empty]");
      let activeCategory = "all";

      const normalize = (value = "") =>
        String(value)
          .toLowerCase()
          .replace(/\s+/g, " ")
          .trim();

      const setCount = (visibleCount) => {
        if (!count) return;
        count.textContent = visibleCount === 1 ? "1 answer" : `${visibleCount} answers`;
      };

      const applyFilters = () => {
        const query = normalize(search?.value || "");
        let visibleCount = 0;

        items.forEach((item) => {
          const category = item.dataset.category || "";
          const haystack = normalize(`${item.textContent || ""} ${item.dataset.keywords || ""} ${category}`);
          const categoryMatch = activeCategory === "all" || category.split(/\s+/).includes(activeCategory);
          const queryMatch = !query || haystack.includes(query);
          const isVisible = categoryMatch && queryMatch;

          item.hidden = !isVisible;
          if (!isVisible) item.open = false;
          if (isVisible) visibleCount += 1;
        });

        setCount(visibleCount);
        if (empty) empty.hidden = visibleCount !== 0;
      };

      filters.forEach((button) => {
        button.addEventListener("click", () => {
          activeCategory = button.dataset.hcxFaqFilter || "all";
          filters.forEach((filterButton) => {
            const isActive = filterButton === button;
            filterButton.classList.toggle("is-active", isActive);
            filterButton.setAttribute("aria-pressed", isActive ? "true" : "false");
          });
          applyFilters();
        });
      });

      items.forEach((item) => {
        item.addEventListener("toggle", () => {
          if (!item.open) return;
          items.forEach((otherItem) => {
            if (otherItem !== item) otherItem.open = false;
          });
        });
      });

      search?.addEventListener("input", applyFilters);
      filters.forEach((button) => button.setAttribute("aria-pressed", button.classList.contains("is-active") ? "true" : "false"));
      applyFilters();
    });
  };

  const initOrderTrackingHubs = () => {
    document.querySelectorAll("[data-hcx-tracking-hub]").forEach((hub) => {
      if (hub.dataset.hcxTrackingBound === "true") return;
      hub.dataset.hcxTrackingBound = "true";

      const filters = [...hub.querySelectorAll("[data-hcx-tracking-filter]")];
      const search = hub.querySelector("[data-hcx-tracking-search]");
      const cards = [...hub.querySelectorAll("[data-hcx-tracking-card]")];
      const empty = hub.querySelector("[data-hcx-tracking-empty]");
      const lookup = hub.querySelector("[data-hcx-order-lookup]");
      const lookupForm = lookup?.querySelector("[data-hcx-order-lookup-form]");
      const lookupError = lookup?.querySelector("[data-hcx-order-lookup-error]");
      const lookupResult = lookup?.querySelector("[data-hcx-order-lookup-result]");
      const lookupButton = lookupForm?.querySelector('button[type="submit"]');
      const lookupFields = lookupForm ? [...lookupForm.querySelectorAll("[required]")] : [];
      const lookupUrl = lookup?.dataset.hcxOrderLookupUrl || "";
      const lookupDefaultButtonText = lookupButton?.textContent || "Track order";
      let activeFilter = "all";
      let selectedCard = cards.find((card) => card.classList.contains("is-selected")) || cards[0] || null;
      let isLookupSubmitting = false;

      const normalize = (value = "") =>
        String(value)
          .toLowerCase()
          .replace(/\s+/g, " ")
          .trim();

      const escapeHtml = (value = "") =>
        String(value).replace(/[&<>"']/g, (char) => ({
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          "\"": "&quot;",
          "'": "&#39;"
        }[char]));

      const escapeAttribute = (value = "") => escapeHtml(value).replace(/`/g, "&#96;");

      const firstValue = (...values) => values.find((value) => String(value || "").trim());

      const asArray = (value) => {
        if (Array.isArray(value)) return value;
        if (Array.isArray(value?.edges)) return value.edges.map((edge) => edge?.node).filter(Boolean);
        if (Array.isArray(value?.nodes)) return value.nodes;
        return [];
      };

      const clampProgress = (value) => {
        const number = Number(value);
        if (!Number.isFinite(number)) return 18;
        return Math.max(0, Math.min(100, number));
      };

      const isRoyalMail = (shipment = {}) =>
        normalize(`${shipment.company || shipment.carrier || ""} ${shipment.url || shipment.trackingUrl || ""}`).includes("royal mail") ||
        normalize(`${shipment.company || shipment.carrier || ""} ${shipment.url || shipment.trackingUrl || ""}`).includes("royalmail");

      const publicTrackingUrl = (shipment = {}) => {
        const url = String(firstValue(shipment.url, shipment.trackingUrl, "") || "").trim();
        if (url) return url;

        const number = String(firstValue(shipment.number, shipment.trackingNumber, "") || "").trim();
        if (number && isRoyalMail(shipment)) {
          return `https://www.royalmail.com/track-your-item#/tracking-results/${encodeURIComponent(number)}`;
        }

        return "";
      };

      const normaliseShipment = (shipment = {}, index = 0) => {
        const node = shipment.node || shipment;
        const company = String(firstValue(node.company, node.carrier, node.trackingCompany, "") || "");
        const number = String(firstValue(node.number, node.trackingNumber, node.tracking_number, "") || "");
        const url = publicTrackingUrl({ ...node, company, number });
        const events = asArray(node.events)
          .map((event) => event?.node || event)
          .filter(Boolean);
        const latestEvent = node.latestEvent || events[0] || null;

        return {
          id: String(firstValue(node.id, `${company || "shipment"}-${number || index}`)),
          company,
          carrier: company,
          number,
          trackingNumber: number,
          url,
          trackingUrl: url,
          status: String(firstValue(node.status, node.latestStatus, node.displayStatus, "") || ""),
          rawStatus: String(firstValue(node.rawStatus, node.raw_status, "") || ""),
          createdAt: String(firstValue(node.createdAt, node.created_at, "") || ""),
          createdAtIso: String(firstValue(node.createdAtIso, node.created_at_iso, "") || ""),
          updatedAt: String(firstValue(node.updatedAt, node.updated_at, "") || ""),
          updatedAtIso: String(firstValue(node.updatedAtIso, node.updated_at_iso, "") || ""),
          inTransitAt: String(firstValue(node.inTransitAt, node.in_transit_at, "") || ""),
          inTransitAtIso: String(firstValue(node.inTransitAtIso, node.in_transit_at_iso, "") || ""),
          deliveredAt: String(firstValue(node.deliveredAt, node.delivered_at, "") || ""),
          deliveredAtIso: String(firstValue(node.deliveredAtIso, node.delivered_at_iso, "") || ""),
          estimatedDeliveryAt: String(firstValue(node.estimatedDeliveryAt, node.estimated_delivery_at, "") || ""),
          estimatedDeliveryAtIso: String(firstValue(node.estimatedDeliveryAtIso, node.estimated_delivery_at_iso, "") || ""),
          lastUpdated: String(firstValue(node.lastUpdated, node.updatedAt, node.updated_at, latestEvent?.happenedAt, "") || ""),
          lastUpdatedIso: String(firstValue(node.lastUpdatedIso, node.updatedAtIso, node.updated_at_iso, latestEvent?.happenedAtIso, "") || ""),
          latestEvent,
          events
        };
      };

      const fallbackTrackingForOrder = (order) => {
        const shipments = order.shipments || [];
        const statusText = normalize([
          order.fulfillmentStatus,
          ...shipments.flatMap((shipment) => [shipment.status, shipment.rawStatus])
        ].join(" ")).replace(/[_-]+/g, " ");
        const financialText = normalize(order.financialStatus || "");
        const royalMailShipment = shipments.find(isRoyalMail);
        const primaryShipment = royalMailShipment || shipments.find((shipment) => shipment.number || shipment.url || shipment.company) || shipments[0] || {};
        const hasTracking = shipments.some((shipment) => shipment.number || shipment.url);

        if (statusText.includes("delivered")) {
          return {
            state: "complete",
            label: "Delivered",
            detail: "Your order has been delivered.",
            progress: 100,
            step: 6,
            totalSteps: 6,
            localStepLabel: royalMailShipment ? "Royal Mail" : "Local carrier",
            carrier: primaryShipment.company,
            trackingNumber: primaryShipment.number,
            trackingUrl: primaryShipment.url
          };
        }

        if (statusText.includes("out for delivery")) {
          return {
            state: "transit",
            label: "Out for delivery",
            detail: "Your order is out for delivery.",
            progress: 92,
            step: 5,
            totalSteps: 6,
            localStepLabel: royalMailShipment ? "Royal Mail" : "Local carrier",
            carrier: primaryShipment.company,
            trackingNumber: primaryShipment.number,
            trackingUrl: primaryShipment.url
          };
        }

        if (statusText.includes("in transit") || statusText.includes("on its way")) {
          return {
            state: "transit",
            label: "On its way",
            detail: "Your order is on its way.",
            progress: 72,
            step: 4,
            totalSteps: 6,
            localStepLabel: "Local carrier",
            carrier: primaryShipment.company,
            trackingNumber: primaryShipment.number,
            trackingUrl: primaryShipment.url
          };
        }

        if (statusText.includes("preparing")) {
          return {
            state: "active",
            label: "Preparing to ship",
            detail: "We are preparing to ship your order.",
            progress: 30,
            step: 2,
            totalSteps: 6,
            localStepLabel: "Local carrier",
            carrier: primaryShipment.company,
            trackingNumber: primaryShipment.number,
            trackingUrl: primaryShipment.url
          };
        }

        if (hasTracking || statusText.includes("fulfilled")) {
          return {
            state: "transit",
            label: "Dispatched",
            detail: "Your order has been dispatched.",
            progress: 48,
            step: 3,
            totalSteps: 6,
            localStepLabel: "Local carrier",
            carrier: primaryShipment.company,
            trackingNumber: primaryShipment.number,
            trackingUrl: primaryShipment.url
          };
        }

        if (financialText.includes("paid") || financialText.includes("authorized")) {
          return {
            state: "active",
            label: "Preparing to ship",
            detail: "We are preparing to ship your order.",
            progress: 30,
            step: 2,
            totalSteps: 6,
            localStepLabel: "Local carrier",
            carrier: primaryShipment.company,
            trackingNumber: primaryShipment.number,
            trackingUrl: primaryShipment.url
          };
        }

        return {
          state: "active",
          label: "Processing",
          detail: "Your order is being processed.",
          progress: 16,
          step: 1,
          totalSteps: 6,
          localStepLabel: "Local carrier",
          carrier: primaryShipment.company,
          trackingNumber: primaryShipment.number,
          trackingUrl: primaryShipment.url
        };
      };

      const normaliseLookupOrder = (payload = {}, fallbackOrderNumber = "") => {
        const root = payload.order || payload.data?.order || payload;
        const shipments = asArray(firstValue(root.shipments, root.tracking?.shipments, root.fulfillments, [])).map(normaliseShipment);
        const tracking = root.tracking || {};
        const fallback = fallbackTrackingForOrder({
          fulfillmentStatus: root.fulfillmentStatus || root.fulfilmentStatus || root.fulfillment_status || "",
          financialStatus: root.financialStatus || root.financial_status || root.financialStatusLabel || "",
          shipments
        });
        const mergedTracking = {
          ...fallback,
          ...tracking
        };

        const primaryShipment = shipments.find((shipment) => shipment.number || shipment.url || shipment.company) || shipments[0] || {};
        const etaShipment = shipments.find((shipment) => shipment.estimatedDeliveryAt || shipment.estimatedDeliveryAtIso) || primaryShipment;
        const updatedShipment = shipments.find((shipment) => shipment.lastUpdated || shipment.lastUpdatedIso) || primaryShipment;
        mergedTracking.progress = clampProgress(firstValue(mergedTracking.progress, fallback.progress));
        mergedTracking.step = Number(firstValue(mergedTracking.step, fallback.step)) || fallback.step;
        mergedTracking.totalSteps = Number(firstValue(mergedTracking.totalSteps, fallback.totalSteps)) || fallback.totalSteps;
        mergedTracking.carrier = String(firstValue(mergedTracking.carrier, mergedTracking.company, primaryShipment.company, fallback.carrier, "") || "");
        mergedTracking.trackingNumber = String(firstValue(mergedTracking.trackingNumber, primaryShipment.number, fallback.trackingNumber, "") || "");
        mergedTracking.trackingUrl = String(firstValue(mergedTracking.trackingUrl, primaryShipment.url, fallback.trackingUrl, root.trackingUrl, root.tracking_url, "") || "");
        mergedTracking.localStepLabel = String(firstValue(mergedTracking.localStepLabel, shipments.some(isRoyalMail) ? "Royal Mail" : "Local carrier") || "Local carrier");
        mergedTracking.estimatedDeliveryAt = String(firstValue(tracking.estimatedDeliveryAt, tracking.estimated_delivery_at, etaShipment.estimatedDeliveryAt, "") || "");
        mergedTracking.estimatedDeliveryAtIso = String(firstValue(tracking.estimatedDeliveryAtIso, tracking.estimated_delivery_at_iso, etaShipment.estimatedDeliveryAtIso, "") || "");
        mergedTracking.lastUpdated = String(firstValue(tracking.lastUpdated, tracking.last_updated, updatedShipment.lastUpdated, updatedShipment.updatedAt, updatedShipment.latestEvent?.happenedAt, "") || "");
        mergedTracking.lastUpdatedIso = String(firstValue(tracking.lastUpdatedIso, tracking.last_updated_iso, updatedShipment.lastUpdatedIso, updatedShipment.updatedAtIso, updatedShipment.latestEvent?.happenedAtIso, "") || "");

        return {
          name: String(firstValue(root.name, root.orderName, root.order_name, root.orderNumber, root.order_number, root.number, fallbackOrderNumber) || ""),
          number: String(firstValue(root.number, root.orderNumber, root.order_number, fallbackOrderNumber) || ""),
          createdAt: String(firstValue(root.createdAt, root.created_at, root.processedAt, root.processed_at, "") || ""),
          financialStatus: String(firstValue(root.financialStatus, root.financial_status, root.financialStatusLabel, "") || ""),
          fulfillmentStatus: String(firstValue(root.fulfillmentStatus, root.fulfilmentStatus, root.fulfillment_status, root.fulfilment_status, root.fulfillmentStatusLabel, "") || ""),
          total: String(firstValue(root.total, root.totalPrice, root.total_price, "") || ""),
          statusPageUrl: String(firstValue(root.statusPageUrl, root.status_page_url, root.customerUrl, root.customer_url, "") || ""),
          customerUrl: String(firstValue(root.customerUrl, root.customer_url, root.statusPageUrl, root.status_page_url, "") || ""),
          shipments,
          tracking: mergedTracking
        };
      };

      const trackingDateView = (displayValue = "", isoValue = "", options = {}) => {
        const display = String(displayValue || "").trim();
        const rawIso = String(isoValue || "").trim();
        const source = rawIso || display;
        if (!source) return { display: "", iso: "" };

        const parseableSource = rawIso || (/^\d{4}-\d{2}-\d{2}(?:T|$)/.test(display) ? display : "");
        if (!parseableSource) return { display, iso: "" };

        const parsed = new Date(parseableSource);
        if (!Number.isFinite(parsed.getTime())) return { display: display || source, iso: "" };

        let formatted = display;
        try {
          formatted = new Intl.DateTimeFormat(document.documentElement.lang || "en-GB", options).format(parsed);
        } catch (_) {
          formatted = display || source;
        }

        return {
          display: formatted || display || source,
          iso: rawIso || parsed.toISOString()
        };
      };

      const renderLookupTrackingCard = (payload, fallbackOrderNumber = "") => {
        const order = normaliseLookupOrder(payload, fallbackOrderNumber);
        const tracking = order.tracking || {};
        const shipmentRows = order.shipments
          .filter((shipment) => shipment.company || shipment.number || shipment.url || shipment.status)
          .slice(0, 4);
        const step = Number(tracking.step) || 0;
        const state = String(tracking.state || "active").toLowerCase().replace(/[^a-z0-9-]/g, "") || "active";
        const progress = clampProgress(tracking.progress);
        const carrier = String(firstValue(tracking.carrier, tracking.company, "") || "");
        const trackingNumber = String(tracking.trackingNumber || "");
        const trackingUrl = String(tracking.trackingUrl || "");
        const orderUrl = String(firstValue(order.statusPageUrl, order.customerUrl, "") || "");
        const eta = trackingDateView(tracking.estimatedDeliveryAt, tracking.estimatedDeliveryAtIso, {
          weekday: "long",
          day: "numeric",
          month: "long",
          year: "numeric"
        });
        const lastUpdated = trackingDateView(tracking.lastUpdated, tracking.lastUpdatedIso, {
          day: "numeric",
          month: "short",
          year: "numeric"
        });
        const actions = [
          trackingUrl ? `<a href="${escapeAttribute(trackingUrl)}" target="_blank" rel="noopener">Track shipment</a>` : "",
          orderUrl ? `<a href="${escapeAttribute(orderUrl)}" target="_blank" rel="noopener">Order status</a>` : ""
        ].filter(Boolean);
        const meta = [
          ["Payment", order.financialStatus],
          ["Order status", order.fulfillmentStatus || tracking.label],
          ["Carrier", carrier || (order.shipments.length ? "Carrier tracking" : "Waiting")],
          ["Tracking number", trackingNumber || (order.shipments.length ? "Attached" : "Waiting")],
          ["Last updated", lastUpdated.display]
        ].filter(([, value]) => String(value || "").trim());
        const steps = [
          "Order received",
          "Preparing",
          "Dispatched",
          "In transit",
          "Out for delivery",
          "Delivered"
        ];

        return `
          <article
            class="hcx-order-track hcx-order-track--${escapeAttribute(state)} hcx-order-track--lookup is-selected"
            data-hcx-tracking-card
            data-hcx-tracking-state="${escapeAttribute(state)}"
            data-hcx-tracking-search="${escapeAttribute([order.name, tracking.label, carrier, trackingNumber].join(" "))}"
            style="--hcx-order-progress: ${progress}%; --hcx-order-step-count: ${Number(tracking.totalSteps) || 6};"
          >
            <button class="hcx-order-track__top" type="button" data-hcx-order-select aria-expanded="true">
              <div>
                <span>${escapeHtml(order.createdAt || "Matched order")}</span>
                <h3>${escapeHtml(order.name || order.number || fallbackOrderNumber || "Order")}</h3>
              </div>
              <span>
                <strong>${escapeHtml(tracking.label || "Processing")}</strong>
                <em>Live progress</em>
              </span>
            </button>
            <div class="hcx-order-track__details" data-hcx-order-details>
              <div class="hcx-order-track__arrival">
                <span>Estimated delivery</span>
                ${eta.display
                  ? `<strong><time${eta.iso ? ` datetime="${escapeAttribute(eta.iso)}"` : ""}>${escapeHtml(eta.display)}</time></strong><small>Supplied by Shopify or the carrier.</small>`
                  : "<strong>Awaiting carrier estimate</strong><small>We’ll show it when the carrier adds one.</small>"}
              </div>
              <div
                class="hcx-order-track__meter"
                role="progressbar"
                aria-label="Shipment stage"
                aria-valuemin="0"
                aria-valuemax="100"
                aria-valuenow="${progress}"
                aria-valuetext="${escapeAttribute(`${tracking.label || "Order progress"}. ${progress} percent complete.`)}"
              >
                <span class="hcx-order-track__meter-fill" aria-hidden="true"></span>
                <span class="hcx-order-track__lorry" aria-hidden="true">&#128666;</span>
              </div>
              <ol class="hcx-order-track__steps" aria-label="Order progress">
                ${steps.map((label, index) => {
                  const position = index + 1;
                  const stateClass = step > position ? "is-complete" : step === position ? "is-current" : "";
                  return `<li class="${stateClass}"${step === position ? ' aria-current="step"' : ""}>${escapeHtml(label)}</li>`;
                }).join("")}
              </ol>
              <p>${escapeHtml(tracking.detail || "Your order is being processed.")}</p>
              <div class="hcx-order-track__meta">
                ${meta.map(([label, value]) => `
                  <span>
                    <small>${escapeHtml(label)}</small>
                    ${escapeHtml(value)}
                  </span>
                `).join("")}
              </div>
              ${shipmentRows.length ? `
                <div class="hcx-order-track__shipments">
                  <span>Carrier updates</span>
                  <ul role="list">
                    ${shipmentRows.map((shipment) => `
                      <li>
                        <strong>${escapeHtml(shipment.company || "Carrier tracking")}</strong>
                        <p>${escapeHtml([shipment.status, shipment.number ? `#${shipment.number}` : "", shipment.estimatedDeliveryAt ? `ETA ${shipment.estimatedDeliveryAt}` : ""].filter(Boolean).join(" | "))}</p>
                        ${shipment.url ? `<a href="${escapeAttribute(shipment.url)}" target="_blank" rel="noopener">Open tracking</a>` : ""}
                      </li>
                    `).join("")}
                  </ul>
                </div>
              ` : ""}
              ${actions.length ? `<div class="hcx-order-track__actions">${actions.join("")}</div>` : ""}
            </div>
          </article>
        `;
      };

      const syncLookupState = () => {
        if (!lookupButton) return;
        lookupButton.disabled = isLookupSubmitting || lookupFields.some((field) => !String(field.value || "").trim());
      };

      const showLookupError = (message) => {
        if (lookupResult) {
          lookupResult.hidden = true;
          lookupResult.replaceChildren();
        }
        if (lookupError) {
          lookupError.textContent = message;
          lookupError.hidden = false;
        }
      };

      const showLookupResult = (payload, orderNumber) => {
        if (lookupError) lookupError.hidden = true;
        if (!lookupResult) return;
        lookupResult.innerHTML = renderLookupTrackingCard(payload, orderNumber);
        lookupResult.hidden = false;
        if (!lookupResult.hasAttribute("tabindex")) lookupResult.tabIndex = -1;
        lookupResult.scrollIntoView({ behavior: "smooth", block: "start" });
        lookupResult.focus({ preventScroll: true });
      };

      const selectCard = (card) => {
        if (!card || card.hidden) return;
        selectedCard = card;

        cards.forEach((orderCard) => {
          const isSelected = orderCard === selectedCard;
          orderCard.classList.toggle("is-selected", isSelected);
          orderCard.querySelector("[data-hcx-order-select]")?.setAttribute("aria-expanded", isSelected ? "true" : "false");
          const details = orderCard.querySelector("[data-hcx-order-details]");
          if (details) details.hidden = !isSelected;
        });
      };

      const matchesFilter = (card) => {
        const state = card.dataset.hcxTrackingState || "active";
        if (activeFilter === "all") return true;
        if (activeFilter === "active") return state !== "complete" && state !== "cancelled";
        return state === activeFilter;
      };

      const applyTrackingFilters = () => {
        const query = normalize(search?.value || "");
        let visibleCount = 0;

        cards.forEach((card) => {
          const haystack = normalize(`${card.dataset.hcxTrackingSearch || ""} ${card.textContent || ""}`);
          const isVisible = matchesFilter(card) && (!query || haystack.includes(query));
          card.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });

        if (empty) empty.hidden = visibleCount !== 0;

        if (visibleCount === 0) {
          selectedCard = null;
          cards.forEach((card) => {
            card.classList.remove("is-selected");
            card.querySelector("[data-hcx-order-select]")?.setAttribute("aria-expanded", "false");
            const details = card.querySelector("[data-hcx-order-details]");
            if (details) details.hidden = true;
          });
          return;
        }

        if (!selectedCard || selectedCard.hidden) {
          selectCard(cards.find((card) => !card.hidden));
        } else {
          selectCard(selectedCard);
        }
      };

      cards.forEach((card) => {
        card.querySelector("[data-hcx-order-select]")?.addEventListener("click", () => selectCard(card));
      });

      filters.forEach((button) => {
        button.addEventListener("click", () => {
          activeFilter = button.dataset.hcxTrackingFilter || "all";
          filters.forEach((filterButton) => {
            const isActive = filterButton === button;
            filterButton.classList.toggle("is-active", isActive);
            filterButton.setAttribute("aria-pressed", isActive ? "true" : "false");
          });
          applyTrackingFilters();
        });
      });

      search?.addEventListener("input", applyTrackingFilters);

      if (lookupForm) {
        lookupForm.setAttribute("novalidate", "novalidate");
        lookupForm.addEventListener("input", syncLookupState);
        lookupForm.addEventListener("change", syncLookupState);
        lookupForm.addEventListener("submit", async (event) => {
          event.preventDefault();
          event.stopPropagation();

          syncLookupState();
          if (!lookupUrl || lookupButton?.disabled || isLookupSubmitting) return;

          const formData = new FormData(lookupForm);
          const orderNumber = String(formData.get("order_number") || "").trim();
          const customerDetail = String(formData.get("customer_detail") || "").trim();

          try {
            isLookupSubmitting = true;
            if (lookupButton) lookupButton.textContent = "Checking";
            syncLookupState();

            const { payload, response } = await fetchHcxOrderLookup(lookupUrl, {
              order_number: orderNumber,
              customer_detail: customerDetail
            });

            if (!response.ok) {
              showLookupError(
                hcxOrderLookupErrorMessage(
                  payload,
                  response.status,
                  "Live order tracking is unavailable right now. Please try again shortly."
                )
              );
              return;
            }

            if (payload?.matched || payload?.order || payload?.tracking || payload?.shipments) {
              showLookupResult(payload, orderNumber);
              return;
            }

            showLookupError("We could not find an order matching both details.");
          } catch (_) {
            showLookupError("Live order tracking is unavailable right now. Please try again shortly.");
          } finally {
            isLookupSubmitting = false;
            if (lookupButton) lookupButton.textContent = lookupDefaultButtonText;
            syncLookupState();
          }
        });
        syncLookupState();
      }

      applyTrackingFilters();
    });
  };

  const initHeaderAnnouncementSlider = () => {
    const section = document.querySelector(".announcement-bar-section");
    if (!section || section.dataset.hcxAnnouncementSlider === "true") return;
    const saleCountdown = section.querySelector("[data-hcx-sale-countdown]");
    if (saleCountdown && !saleCountdown.hidden) return;

    const originalMessages = Array.from(section.querySelectorAll(".announcement-bar__message span"))
      .map((message) => message.textContent.trim())
      .filter(Boolean);
    const uniqueMessages = [];
    const seenMessages = new Set();

    originalMessages.forEach((message) => {
      const key = message.replace(/\s+/g, " ").toUpperCase();
      if (seenMessages.has(key)) return;

      seenMessages.add(key);
      uniqueMessages.push(message);
    });

    const messages = uniqueMessages.length
      ? uniqueMessages
      : [
          "FREE WORLDWIDE SHIPPING ON ORDERS OVER \u00a370",
          "EASY RETURNS",
        ];
    const utilityBar = section.querySelector(".utility-bar") || section;
    const escapeHtml = (value) =>
      value.replace(/[&<>"']/g, (character) => {
        const entities = {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;",
        };
        return entities[character];
      });
    const renderAnnouncementMessage = (value) => {
      const text = value.trim();
      const upperText = text.toUpperCase();
      const joinPhrase = "JOIN LEGACY";
      const joinIndex = upperText.indexOf(joinPhrase);

      if (upperText === "EASY RETURNS") {
        return '<a class="hcx-announcement-slider__link hcx-announcement-slider__link--underlined" href="/pages/returns">EASY RETURNS</a>';
      }

      if (joinIndex !== -1) {
        const beforeJoin = text.slice(0, joinIndex);
        const joinText = text.slice(joinIndex, joinIndex + joinPhrase.length);
        const afterJoin = text.slice(joinIndex + joinPhrase.length);
        const beforeJoinSpacing = /\s$/.test(beforeJoin) ? "&nbsp;" : "";
        const afterJoinSpacing = /^\s/.test(afterJoin) ? "&nbsp;" : "";

        return `${escapeHtml(
          beforeJoin.trimEnd()
        )}${beforeJoinSpacing}<a class="hcx-announcement-slider__link" href="/pages/hercxles-club">${escapeHtml(
          joinText
        )}</a>${afterJoinSpacing}${escapeHtml(afterJoin.trimStart())}`;
      }

      return escapeHtml(text);
    };

    section.dataset.hcxAnnouncementSlider = "true";
    section.classList.remove("hcx-original-scrolling-content-section", "hcx-announcement-marquee-section");
    section.classList.add("hcx-announcement-slider-section");
    utilityBar.innerHTML = `
      <div class="hcx-announcement-slider" role="region" aria-label="Store announcements" data-hcx-announcement-slider>
        <div class="hcx-announcement-slider__viewport" aria-live="polite" aria-atomic="true">
          <p class="hcx-announcement-slider__message">
            <span class="hcx-announcement-slider__message-current">${renderAnnouncementMessage(messages[0])}</span>
            <span class="hcx-announcement-slider__message-next" aria-hidden="true"></span>
          </p>
        </div>
      </div>
    `;

    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const message = utilityBar.querySelector(".hcx-announcement-slider__message");
    const currentMessage = message?.querySelector(".hcx-announcement-slider__message-current");
    const nextMessageElement = message?.querySelector(".hcx-announcement-slider__message-next");
    let currentIndex = 0;
    let timer = null;
    let swapTimer = null;

    const finishMessageSwap = () => {
      if (!message || !currentMessage || !nextMessageElement || !message.classList.contains("is-spinning-up")) return;

      currentMessage.innerHTML = nextMessageElement.innerHTML || renderAnnouncementMessage(messages[currentIndex]);
      nextMessageElement.innerHTML = "";
      message.classList.remove("is-spinning-up");
      window.clearTimeout(swapTimer);
      swapTimer = null;
    };

    const showNextMessage = () => {
      if (!message || !currentMessage || !nextMessageElement || messages.length < 2) return;

      currentIndex = (currentIndex + 1) % messages.length;
      const nextMessage = messages[currentIndex];
      const nextMessageMarkup = renderAnnouncementMessage(nextMessage);

      if (prefersReducedMotion.matches) {
        window.clearTimeout(swapTimer);
        swapTimer = null;
        nextMessageElement.innerHTML = "";
        message.classList.remove("is-spinning-up");
        currentMessage.innerHTML = nextMessageMarkup;
        return;
      }

      window.clearTimeout(swapTimer);
      message.classList.remove("is-spinning-up");
      void message.offsetWidth;
      nextMessageElement.innerHTML = nextMessageMarkup;
      message.classList.add("is-spinning-up");
      swapTimer = window.setTimeout(finishMessageSwap, 760);
    };

    message?.addEventListener("animationend", (event) => {
      if (event.target !== nextMessageElement) return;

      finishMessageSwap();
    });

    if (messages.length > 1) {
      timer = window.setInterval(showNextMessage, 5000);
      prefersReducedMotion.addEventListener("change", () => {
        window.clearInterval(timer);
        finishMessageSwap();
        timer = window.setInterval(showNextMessage, 5000);
      });
    }
  };

  const hcxCasePreserveWords = new Set([
    "HERCXLES",
    "UK",
    "US",
    "EU",
    "GBP",
    "USD",
    "EUR",
    "FAQ",
    "SKU",
    "ID",
    "LCKD",
    "URL",
    "CM",
    "KG",
    "GSM",
    "FT",
    "IN",
    "XS",
    "S",
    "M",
    "L",
    "XL",
    "XXL",
    "XXXL",
    "3XL",
  ]);

  const hcxCaseWordOverrides = new Map([
    ["HERCXLES", "HERCXLES"],
    ["KLARNA", "Klarna"],
    ["LEGACY", "Legacy"],
    ["SHOPIFY", "Shopify"],
    ["PAYPAL", "PayPal"],
  ]);

  const hcxWordPattern = /[A-Za-z][A-Za-z'’]*(?:-[A-Za-z][A-Za-z'’]*)*/g;

  const isMostlyUppercaseText = (text) => {
    const letters = text.replace(/[^A-Za-z]/g, "");
    return letters.length >= 2 && letters === letters.toUpperCase();
  };

  const hasUppercaseWord = (text) => /\b[A-Z]{2,}\b/.test(text);

  const formatCaseSegment = (segment) => {
    const upper = segment.toUpperCase();
    if (hcxCaseWordOverrides.has(upper)) return hcxCaseWordOverrides.get(upper);
    if (hcxCasePreserveWords.has(upper)) return upper;

    return segment.charAt(0).toUpperCase() + segment.slice(1).toLowerCase();
  };

  const formatTitleCase = (text) =>
    text.replace(hcxWordPattern, (word) => word.split("-").map(formatCaseSegment).join("-"));

  const formatSentenceCase = (text) => {
    let shouldCapitaliseNext = true;
    let cursor = 0;

    return text.replace(hcxWordPattern, (word, offset) => {
      const betweenWords = text.slice(cursor, offset);
      if (/[.!?]\s*$/.test(betweenWords) || /(?:^|[\n\r])\s*$/.test(betweenWords)) {
        shouldCapitaliseNext = true;
      }
      cursor = offset + word.length;

      const upper = word.toUpperCase();
      if (hcxCaseWordOverrides.has(upper)) {
        shouldCapitaliseNext = false;
        return hcxCaseWordOverrides.get(upper);
      }
      if (hcxCasePreserveWords.has(upper)) return upper;

      const lower = word.toLowerCase();
      if (!shouldCapitaliseNext) return lower;

      shouldCapitaliseNext = false;
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    });
  };

  const getCaseModeForTextNode = (node) => {
    const parent = node.parentElement;
    if (!parent) return null;
    if (parent.closest("script, style, svg, noscript, textarea, input, select, option, [data-hcx-preserve-case], .hcx-product-rating")) return null;
    if (parent.closest(".hcx-product-option--size, .product-form__input--pill, .variant-radios")) return null;

    if (
      parent.closest(
        ".product__title, .card__heading, .predictive-search__item-heading, .cart-item__name, .hcx-cart-rec__title"
      )
    ) {
      return "title";
    }

    return "sentence";
  };

  const normaliseStoreTextCase = (root = document.body) => {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const textNodes = [];

    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }

    textNodes.forEach((node) => {
      const original = node.nodeValue;
      if (!original || !/[A-Za-z]/.test(original)) return;

      const trimmed = original.trim();
      if (hcxCasePreserveWords.has(trimmed.toUpperCase())) return;

      const mode = getCaseModeForTextNode(node);
      if (!mode) return;

      if (mode === "title") {
        const formattedTitle = formatTitleCase(original);
        if (formattedTitle !== original) node.nodeValue = formattedTitle;
        return;
      }

      if (!isMostlyUppercaseText(original) && !hasUppercaseWord(original)) return;

      const formatted = mode === "title" ? formatTitleCase(original) : formatSentenceCase(original);
      if (formatted !== original) node.nodeValue = formatted;
    });
  };

  const initStoreTextCase = () => {
    normaliseStoreTextCase();

    if (document.documentElement.dataset.hcxStoreCaseObserverBound === "true") return;
    document.documentElement.dataset.hcxStoreCaseObserverBound = "true";

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "characterData") {
          const parent = mutation.target.parentElement;
          if (parent) normaliseStoreTextCase(parent);
          return;
        }

        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            const parent = node.parentElement;
            if (parent) normaliseStoreTextCase(parent);
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            normaliseStoreTextCase(node);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, characterData: true, subtree: true });
  };

  const hcxButtonFlyAllowedSelector = [
    ".hcx-featured-drop__view-all-button",
    ".collection__view-all a",
    ".collection-list-view-all a",
    ".blog__view-all a",
  ].join(",");

  const hcxButtonFlySelector = [
    hcxButtonFlyAllowedSelector,
    ".hcx-button-fly",
  ].join(",");

  const hcxButtonFlyDesktopMedia = window.matchMedia?.("(min-width: 750px)");

  const hcxButtonFlyIgnoreSelector = [
    "[data-hcx-no-button-fly]",
    ".localization-form__select",
    ".disclosure__button.localization-form__select",
    ".localization-selector",
    ".product-form__submit.hcx-size-required",
    "[id*='shopify-pc'] button",
    "[class*='shopify-pc'] button",
    ".shopify-pc__banner__btns button",
    ".shopify-pc__prefs__dialog button",
    ".header__icon",
    ".hcx-header-saves-link",
    ".hcx-product-save-button",
    ".hcx-product-size-note__link",
    ".hcx-card-save-button",
    ".hcx-card-size-button",
    ".hcx-cart-rec__size-button",
    "[data-hcx-related-filter]",
    ".quantity__button",
    ".slider-button",
    ".country-selector__close-button",
    ".modal__close-button",
    ".search-modal__close-button",
    ".drawer__close",
    ".hcx-mobile-menu__action",
    ".hcx-mobile-menu__close",
    ".button--tertiary",
  ].join(",");

  const getButtonFlyLabel = (button) => {
    const clone = button.cloneNode(true);
    clone
      .querySelectorAll(
        "svg, img, picture, canvas, video, script, style, .svg-wrapper, .visually-hidden, .loading__spinner, .loading-overlay__spinner, .spinner"
      )
      .forEach((node) => node.remove());

    return clone.textContent.replace(/\s+/g, " ").trim();
  };

  const syncButtonTextFly = (root = document.body) => {
    if (!root) return;

    const candidates = [];
    if (root instanceof Element && root.matches(hcxButtonFlySelector)) candidates.push(root);
    if (root.querySelectorAll) candidates.push(...root.querySelectorAll(hcxButtonFlySelector));

    candidates.forEach((button) => {
      if (!(button instanceof HTMLElement)) return;
      if (button.matches(hcxButtonFlyIgnoreSelector) || button.closest("[data-hcx-no-button-fly]")) {
        button.classList.remove("hcx-button-fly");
        delete button.dataset.hcxButtonFlyLabel;
        return;
      }

      const label = getButtonFlyLabel(button);
      const isDesktopViewAllButton =
        (!hcxButtonFlyDesktopMedia || hcxButtonFlyDesktopMedia.matches) &&
        button.closest(".content-for-layout") &&
        button.matches(hcxButtonFlyAllowedSelector) &&
        /^view\s+all$/i.test(label);

      if (!isDesktopViewAllButton) {
        button.classList.remove("hcx-button-fly");
        delete button.dataset.hcxButtonFlyLabel;
        return;
      }

      if (!label || label.length > 48) {
        button.classList.remove("hcx-button-fly");
        delete button.dataset.hcxButtonFlyLabel;
        return;
      }

      button.dataset.hcxButtonFlyLabel = label;
      button.classList.add("hcx-button-fly");
    });
  };

  const initButtonTextFly = () => {
    syncButtonTextFly();

    if (document.documentElement.dataset.hcxButtonTextFlyObserverBound === "true") return;
    document.documentElement.dataset.hcxButtonTextFlyObserverBound = "true";

    if (hcxButtonFlyDesktopMedia?.addEventListener) {
      hcxButtonFlyDesktopMedia.addEventListener("change", () => syncButtonTextFly());
    } else if (hcxButtonFlyDesktopMedia?.addListener) {
      hcxButtonFlyDesktopMedia.addListener(() => syncButtonTextFly());
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "characterData") {
          const parent = mutation.target.parentElement;
          if (parent) syncButtonTextFly(parent.closest(hcxButtonFlySelector) || parent);
          return;
        }

        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            const parent = node.parentElement;
            if (parent) syncButtonTextFly(parent.closest(hcxButtonFlySelector) || parent);
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            syncButtonTextFly(node);
          }
        });
      });
    });

    observer.observe(document.querySelector(".content-for-layout") || document.body, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  };

  const initUnavailableXsDescriptionCleanup = () => {
    document.querySelectorAll(".hcx-product-description-copy.hcx-hide-unavailable-xs").forEach((container) => {
      container.querySelectorAll("table").forEach((table) => {
        const xsColumnIndexes = new Set();

        table.querySelectorAll("tr").forEach((row) => {
          [...row.children].forEach((cell, index) => {
            if (cell.textContent.trim().toLowerCase() === "xs") {
              xsColumnIndexes.add(index);
            }
          });
        });

        [...xsColumnIndexes]
          .sort((a, b) => b - a)
          .forEach((index) => {
            table.querySelectorAll("tr").forEach((row) => {
              const cell = row.children[index];
              if (cell) cell.remove();
            });
          });
      });

      container.querySelectorAll("p, li").forEach((node) => {
        if (node.textContent.trim().toLowerCase() === "xs") {
          node.remove();
        }
      });
    });
  };

  const initProductDescriptionFormatting = () => {
    const normaliseText = (text) => text.replace(/\s+/g, " ").trim();
    const isSizeFitText = (text) => /^(size\s*(?:&|and)\s*fit)\s*:/i.test(text);
    const isModelText = (text) => /^model(?:\s+\d+)?\s+is\b/i.test(text);
    const isWashText = (text) =>
      /^to help this item last longer\b/i.test(text) ||
      /\bwash inside out\b/i.test(text) ||
      /\bavoid tumble drying\b/i.test(text);
    const ensureSentenceEnd = (text) => (/[.!?]$/.test(text) ? text : `${text}.`);
    const formatModelSentence = (text) =>
      ensureSentenceEnd(
        normaliseText(text)
          .toLowerCase()
          .replace(/\bmodel\b/g, "Model")
          .replace(/\b(3xl|2xl|xxxl|xxl|xl|xs|s|m|l)\b/g, (size) => size.toUpperCase())
      );
    const formatModelCopy = (text) => {
      const source = normaliseText(text).replace(/^(size\s*(?:&|and)\s*fit)\s*:\s*/i, "");
      const modelMatches = source.match(
        /\bmodel(?:\s+\d+)?\s+is\b[\s\S]*?\bwearing\s+(?:a\s+)?size\s+[A-Z0-9]+/gi
      );

      if (!modelMatches?.length) return isModelText(source) ? formatModelSentence(source) : "";

      return modelMatches
        .map((match) => formatModelSentence(match))
        .join(" ");
    };

    const getDescriptionRows = (container) =>
      [...container.querySelectorAll("p, li")].filter((node) => {
        const nestedRows = node.querySelectorAll("p, li");
        return nestedRows.length === 0;
      });

    const unwrapElement = (element) => {
      const parent = element.parentNode;
      if (!parent) return;
      while (element.firstChild) parent.insertBefore(element.firstChild, element);
      element.remove();
    };

    const normaliseWashRow = (row) => {
      row.classList.remove("hcx-product-description-wash");
      row.querySelectorAll(":scope > .hcx-product-description-wash__text").forEach(unwrapElement);

      const directBoldChildren = [...row.children].filter((child) => /^(B|STRONG)$/i.test(child.tagName));
      if (
        directBoldChildren.length === 1 &&
        normaliseText(directBoldChildren[0].textContent || "") === normaliseText(row.textContent || "")
      ) {
        unwrapElement(directBoldChildren[0]);
      }
    };

    document.querySelectorAll(".hcx-product-description-copy").forEach((container) => {
      const modelRows = [];
      const hasModelVisual = container.dataset.hcxHasModelVisual !== "false";

      getDescriptionRows(container).forEach((row) => {
        const text = normaliseText(row.textContent || "");
        if (!text) return;

        if (isSizeFitText(text)) {
          const modelCopy = formatModelCopy(text);
          if (hasModelVisual && modelCopy) modelRows.push(modelCopy);
          row.remove();
          return;
        }

        if (isModelText(text)) {
          const modelCopy = formatModelCopy(text);
          if (hasModelVisual && modelCopy) modelRows.push(modelCopy);
          row.remove();
          return;
        }

        if (isWashText(text)) normaliseWashRow(row);
      });

      if (!modelRows.length) return;

      const modelParagraph = document.createElement("p");
      modelParagraph.className = "hcx-product-description-model-fit";
      modelParagraph.textContent = [...new Set(modelRows)].join(" ");
      container.insertBefore(modelParagraph, container.firstElementChild || null);
    });
  };

  const initProductInfoPanels = () => {
    document.querySelectorAll(".product__info-container").forEach((container) => {
      if (container.dataset.hcxProductInfoPanelsBound === "true") return;

      const drawer = container.querySelector("[data-hcx-product-panel-drawer]");
      const title = drawer?.querySelector("[data-hcx-product-panel-title]");
      const body = drawer?.querySelector("[data-hcx-product-panel-body]");
      const closeButtons = drawer ? [...drawer.querySelectorAll("[data-hcx-product-panel-close]")] : [];
      const triggers = [...container.querySelectorAll("[data-hcx-product-panel-trigger]")];
      if (!drawer || !title || !body || !triggers.length) return;

      let activeTrigger = null;

      const setTriggerState = (open, target = null) => {
        triggers.forEach((trigger) => {
          const isActive = open && trigger === target;
          trigger.setAttribute("aria-expanded", isActive ? "true" : "false");
        });
      };

      const closePanel = () => {
        drawer.classList.remove("is-open");
        drawer.setAttribute("aria-hidden", "true");
        document.documentElement.classList.remove("hcx-product-info-panel-open");
        setTriggerState(false);

        if (activeTrigger) {
          activeTrigger.focus({ preventScroll: true });
          activeTrigger = null;
        }
      };

      const openPanel = (trigger) => {
        const key = trigger.dataset.hcxProductPanelTrigger;
        const source = key ? container.querySelector(`[data-hcx-product-panel-content="${key}"]`) : null;
        if (!source) return;

        activeTrigger = trigger;
        title.textContent = trigger.dataset.hcxProductPanelTitle || trigger.textContent.trim();
        body.innerHTML = source.innerHTML;
        initProductDescriptionFormatting();
        drawer.classList.add("is-open");
        drawer.setAttribute("aria-hidden", "false");
        document.documentElement.classList.add("hcx-product-info-panel-open");
        setTriggerState(true, trigger);
        closeButtons[0]?.focus({ preventScroll: true });
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener("click", () => {
          if (drawer.classList.contains("is-open") && activeTrigger === trigger) {
            closePanel();
            return;
          }

          openPanel(trigger);
        });
      });

      closeButtons.forEach((button) => {
        button.addEventListener("click", closePanel);
      });

      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && drawer.classList.contains("is-open")) closePanel();
      });

      container.dataset.hcxProductInfoPanelsBound = "true";
    });
  };

  const getProductLowerRailTrack = (section) =>
    section?.querySelector("[data-hcx-product-rail-track], .product-grid") || null;

  const getProductLowerRailControls = (section) => ({
    previous: section?.querySelector("[data-hcx-product-rail-prev]") || null,
    next: section?.querySelector("[data-hcx-product-rail-next]") || null,
  });

  const getProductLowerRailStep = (track) => {
    if (!track) return 0;

    const firstVisibleItem = [...track.children].find(
      (child) => !child.hidden && window.getComputedStyle(child).display !== "none"
    );
    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;
    const itemWidth = firstVisibleItem?.getBoundingClientRect().width || 0;

    return Math.max(itemWidth + gap, track.clientWidth * 0.82);
  };

  const updateProductLowerRailControls = (section) => {
    const track = getProductLowerRailTrack(section);
    const { previous, next } = getProductLowerRailControls(section);
    const controls = previous?.closest(".hcx-product-rail-controls") || next?.closest(".hcx-product-rail-controls") || null;
    if (!track || !previous || !next || !controls) return;

    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    const canScroll = maxScroll > 2;
    const atStart = track.scrollLeft <= 2;
    const atEnd = track.scrollLeft >= maxScroll - 2;

    controls.hidden = !canScroll;
    previous.disabled = !canScroll || atStart;
    next.disabled = !canScroll || atEnd;
    previous.setAttribute("aria-disabled", previous.disabled ? "true" : "false");
    next.setAttribute("aria-disabled", next.disabled ? "true" : "false");
  };

  const initProductLowerRailControls = () => {
    document.querySelectorAll(".related-products--recommendations").forEach((section) => {
      const track = getProductLowerRailTrack(section);
      const { previous, next } = getProductLowerRailControls(section);
      const controls = previous?.closest(".hcx-product-rail-controls") || next?.closest(".hcx-product-rail-controls") || null;
      if (!track || !previous || !next || !controls || controls.dataset.hcxProductRailControlsBound === "true") return;

      controls.dataset.hcxProductRailControlsBound = "true";
      const scrollRail = (direction, event) => {
        event?.preventDefault();

        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        if (maxScroll <= 2) return;

        const target = Math.max(0, Math.min(maxScroll, track.scrollLeft + getProductLowerRailStep(track) * direction));
        track.scrollTo({ left: target, behavior: "smooth" });
        window.setTimeout(() => updateProductLowerRailControls(section), 360);
      };
      const requestUpdate = () => window.requestAnimationFrame(() => updateProductLowerRailControls(section));

      previous.addEventListener("click", (event) => scrollRail(-1, event));
      next.addEventListener("click", (event) => scrollRail(1, event));
      track.addEventListener("scroll", requestUpdate, { passive: true });
      window.addEventListener("resize", requestUpdate);
      requestUpdate();
    });
  };

  const relatedProductCategoryOrder = [
    "hoodies",
    "t-shirts",
    "long-sleeves",
    "sweatshirts",
    "tank-tops",
    "sweatpants",
    "shorts",
    "jackets",
  ];

  const relatedProductCategoryLabels = {
    hoodies: "Hoodies",
    "t-shirts": "T-shirts",
    "long-sleeves": "Long sleeves",
    sweatshirts: "Sweatshirts",
    "tank-tops": "Tank tops",
    sweatpants: "Sweatpants",
    shorts: "Shorts",
    jackets: "Jackets",
  };

  const getRelatedProductCategorySignal = (item) => {
    const productHref = item.querySelector('a[href*="/products/"]')?.getAttribute("href") || "";
    const productHandle = productHref.includes("/products/")
      ? productHref.split("/products/").pop().split(/[?#/]/)[0]
      : productHref;
    const title =
      item.querySelector(".card__heading a, .card__heading, a[href*='/products/']")?.textContent || "";
    const imageAlt = item.querySelector("img")?.getAttribute("alt") || "";

    return `${productHandle} ${title} ${imageAlt}`.toLowerCase();
  };

  const getRelatedProductCategoryFromSignal = (signal) => {
    if (!signal) return null;
    if (signal.includes("hoodie") || signal.includes("hooded")) return "hoodies";
    if (
      signal.includes("long sleeve") ||
      signal.includes("long-sleeve") ||
      signal.includes("longsleeve") ||
      signal.includes("waffle")
    )
      return "long-sleeves";
    if (signal.includes("sweatshirt") || signal.includes("crewneck") || signal.includes("polo") || signal.includes("sweater"))
      return "sweatshirts";
    if (
      signal.includes("t-shirt") ||
      signal.includes("t shirt") ||
      signal.includes("tshirt") ||
      signal.includes(" tee") ||
      signal.includes("raw edge") ||
      signal.includes("raw-cut")
    )
      return "t-shirts";
    if (signal.includes("tank") || signal.includes("vest")) return "tank-tops";
    if (signal.includes("sweatpant") || signal.includes("jogger") || /\bpants?\b/.test(signal)) return "sweatpants";
    if (signal.includes("shorts") || signal.includes("-shorts") || /\bshort\b/.test(signal)) return "shorts";
    if (signal.includes("jacket") || signal.includes("stand collar") || signal.includes("stand-collar")) return "jackets";
    return null;
  };

  const renderRelatedProductCategoryButtons = (section) => {
    const categories = new Set(
      [...section.querySelectorAll("[data-hcx-related-category]")]
        .map((item) => item.dataset.hcxRelatedCategory)
        .filter((category) => relatedProductCategoryLabels[category])
    );
    if (categories.size <= 1) return;

    let container = section.querySelector("[data-hcx-related-categories]");
    if (!container) {
      const track = getProductLowerRailTrack(section);
      if (!track) return;

      container = document.createElement("div");
      container.className = "hcx-related-categories";
      container.setAttribute("aria-label", "Filter products by category");
      container.dataset.hcxRelatedCategories = "";
      container.dataset.hcxNoButtonFly = "";
      track.before(container);
    }

    const activeFilter = container.querySelector(".is-active")?.dataset.hcxRelatedFilter || "all";
    const orderedCategories = relatedProductCategoryOrder.filter((category) => categories.has(category));
    const desiredFilters = ["all", ...orderedCategories];
    const currentFilters = [...container.querySelectorAll("[data-hcx-related-filter]")].map(
      (button) => button.dataset.hcxRelatedFilter
    );

    if (currentFilters.join("|") !== desiredFilters.join("|")) {
      container.replaceChildren(
        ...desiredFilters.map((category) => {
          const button = document.createElement("button");
          button.type = "button";
          button.className = "hcx-related-categories__button";
          button.dataset.hcxRelatedFilter = category;
          button.setAttribute("aria-pressed", "false");
          button.textContent = category === "all" ? "All" : relatedProductCategoryLabels[category];
          return button;
        })
      );
    }

    const normalizedActiveFilter = activeFilter !== "all" && !categories.has(activeFilter) ? "all" : activeFilter;
    container.querySelectorAll("[data-hcx-related-filter]").forEach((button) => {
      const isActive = button.dataset.hcxRelatedFilter === normalizedActiveFilter;
      button.classList.toggle("is-active", isActive);
      button.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  };

  const normalizeRelatedProductCategories = (section) => {
    if (!section || section.dataset.hcxRelatedCategoriesNormalizing === "true") return;

    section.dataset.hcxRelatedCategoriesNormalizing = "true";
    try {
      section.querySelectorAll("[data-hcx-related-category]").forEach((item) => {
        const category = getRelatedProductCategoryFromSignal(getRelatedProductCategorySignal(item));
        if (!category || !relatedProductCategoryLabels[category]) return;

        item.dataset.hcxRelatedCategory = category;
        item.dataset.hcxRelatedCategoryLabel = relatedProductCategoryLabels[category];
      });

      renderRelatedProductCategoryButtons(section);
      setRelatedProductVisibleCount(section);
    } finally {
      delete section.dataset.hcxRelatedCategoriesNormalizing;
    }
  };

  const setRelatedProductVisibleCount = (section) => {
    if (!section) return;

    const rail = getProductLowerRailTrack(section);
    const items = [...section.querySelectorAll("[data-hcx-related-category]")];
    const visibleCount =
      items.filter((item) => !item.hidden && window.getComputedStyle(item).display !== "none").length || items.length;
    const count = Math.max(1, Math.min(8, visibleCount || 1));

    section.style.setProperty("--hcx-related-visible-count", String(count));
    rail?.style.setProperty("--hcx-related-visible-count", String(count));
  };

  const applyRelatedProductCategory = (section, category) => {
    if (!section) return;

    normalizeRelatedProductCategories(section);

    const requestedFilter = category || "all";
    const filter =
      requestedFilter === "all" || section.querySelector(`[data-hcx-related-category="${requestedFilter}"]`)
        ? requestedFilter
        : "all";
    section.querySelectorAll("[data-hcx-related-filter]").forEach((button) => {
      const isActive = button.dataset.hcxRelatedFilter === filter;
      button.classList.toggle("is-active", isActive);
      button.setAttribute("aria-pressed", isActive ? "true" : "false");
    });

    const hasDefaultSet = section.querySelector("[data-hcx-related-default='true']");
    section.querySelectorAll("[data-hcx-related-category]").forEach((item) => {
      const shouldShow =
        filter === "all"
          ? !hasDefaultSet || item.dataset.hcxRelatedDefault === "true"
          : item.dataset.hcxRelatedCategory === filter;
      item.hidden = !shouldShow;
      item.classList.toggle("is-hidden-by-category", !shouldShow);
    });
    setRelatedProductVisibleCount(section);

    const rail = getProductLowerRailTrack(section);
    if (rail) {
      rail.scrollTo({ left: 0, behavior: "smooth" });
      window.requestAnimationFrame(() => updateProductLowerRailControls(section));
      window.requestAnimationFrame(() => initHomeFeaturedDropSliders());
    }
  };

  const getRelatedProductCategorySection = (source) => {
    const section = source?.closest?.(".related-products--recommendations");
    if (!section || !section.querySelector("[data-hcx-related-category]")) return null;
    return section;
  };

  const initRelatedProductCategories = () => {
    const normalizeAllRelatedProductSections = () => {
      document.querySelectorAll(".related-products--recommendations").forEach((section) => {
        if (!section.querySelector("[data-hcx-related-category]")) return;

        normalizeRelatedProductCategories(section);

        if (section.dataset.hcxRelatedCategoryObserverBound === "true" || !("MutationObserver" in window)) return;

        section.dataset.hcxRelatedCategoryObserverBound = "true";
        new MutationObserver((mutations) => {
          if (mutations.some((mutation) => mutation.addedNodes.length || mutation.removedNodes.length)) {
            normalizeRelatedProductCategories(section);
          }
        }).observe(section, { childList: true, subtree: true });
      });
    };

    window.HCXRelatedFilterClick = (event, button) => {
      const section = getRelatedProductCategorySection(button);
      if (!button || !section) return false;

      event?.preventDefault?.();
      applyRelatedProductCategory(section, button.dataset.hcxRelatedFilter || "all");
      return false;
    };

    normalizeAllRelatedProductSections();

    if (document.documentElement.dataset.hcxRelatedCategoryFiltersBound === "true") return;

    document.documentElement.dataset.hcxRelatedCategoryFiltersBound = "true";
    document.addEventListener("shopify:section:load", normalizeAllRelatedProductSections);
    document.addEventListener("product-info:loaded", normalizeAllRelatedProductSections);

    document.addEventListener("click", (event) => {
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      const button = target?.closest("[data-hcx-related-filter]");
      if (!button) return;

      window.HCXRelatedFilterClick(event, button);
    });
  };

  const initHoverRevealScrollbars = () => {
    const railSelector = [
      ".related-products--style-with .product-grid",
      ".related-products--recommendations .product-grid",
      ".hcx-featured-drop:not(.hcx-recently-viewed) .hcx-featured-drop__grid",
      ".hcx-rep-products",
      ".hcx-conversion-rail__track",
    ].join(", ");

    document.querySelectorAll(railSelector).forEach((rail) => {
      if (!(rail instanceof HTMLElement) || rail.dataset.hcxScrollbarRevealBound === "true") return;

      rail.dataset.hcxScrollbarRevealBound = "true";
      const stripSize = 44;
      const stripOuterSlack = 18;
      const stripInlineSlack = 12;
      const cardHoverSelector = ".product-card-wrapper .card__inner, .product-card-wrapper .card__media";
      let clearHoverTimeout;
      const canScrollHorizontally = () => rail.scrollWidth > rail.clientWidth + 2;
      const canScrollVertically = () => rail.scrollHeight > rail.clientHeight + 2;
      const revealStripHover = () => {
        if (!canScrollHorizontally() && !canScrollVertically()) return;

        window.clearTimeout(clearHoverTimeout);
        rail.classList.add("hcx-scrollbar-strip-hover");
      };
      const clearStripHover = () => {
        window.clearTimeout(clearHoverTimeout);
        rail.classList.remove("hcx-scrollbar-strip-hover");
      };
      const scheduleClearStripHover = () => {
        window.clearTimeout(clearHoverTimeout);
        clearHoverTimeout = window.setTimeout(clearStripHover, 140);
      };
      const clearActive = () => rail.classList.remove("hcx-scrollbar-strip-active");
      const isInScrollbarStrip = (event) => {
        const rect = rail.getBoundingClientRect();
        const withinX =
          event.clientX >= rect.left - stripInlineSlack && event.clientX <= rect.right + stripInlineSlack;
        const withinY =
          event.clientY >= rect.top - stripInlineSlack && event.clientY <= rect.bottom + stripInlineSlack;
        const overHorizontalStrip =
          canScrollHorizontally() &&
          withinX &&
          event.clientY >= rect.bottom - stripSize &&
          event.clientY <= rect.bottom + stripOuterSlack;
        const overVerticalStrip =
          canScrollVertically() &&
          withinY &&
          event.clientX >= rect.right - stripSize &&
          event.clientX <= rect.right + stripOuterSlack;

        return overHorizontalStrip || overVerticalStrip;
      };
      const isProductImageHover = (target) =>
        target instanceof Element && Boolean(target.closest(cardHoverSelector));

      rail.addEventListener("pointermove", (event) => {
        if (isInScrollbarStrip(event) || isProductImageHover(event.target)) {
          revealStripHover();
          return;
        }

        if (!rail.classList.contains("hcx-scrollbar-strip-active")) scheduleClearStripHover();
      });
      rail.addEventListener("pointerover", (event) => {
        if (isProductImageHover(event.target)) revealStripHover();
      });
      rail.addEventListener("pointerleave", () => {
        if (!rail.classList.contains("hcx-scrollbar-strip-active")) scheduleClearStripHover();
      });
      rail.addEventListener("pointerdown", (event) => {
        if (!isInScrollbarStrip(event)) return;
        rail.classList.add("hcx-scrollbar-strip-active");
      });
      rail.addEventListener("pointerup", clearActive);
      rail.addEventListener("pointercancel", clearActive);
      rail.addEventListener("lostpointercapture", clearActive);
      rail.addEventListener("scroll", () => {
        if (!canScrollHorizontally() && !canScrollVertically()) {
          clearStripHover();
          clearActive();
        }
      });
    });
  };

  const getHomeFeaturedDropSliderRail = (section) => {
    if (!(section instanceof HTMLElement)) return null;

    return section.querySelector(".hcx-featured-drop__grid, .product-grid, .hcx-recently-viewed__track");
  };

  const normalizeHomeFeaturedDropStaticGrid = (section) => {
    if (
      !isHome ||
      !(section instanceof HTMLElement) ||
      !section.classList.contains("hcx-featured-drop") ||
      section.classList.contains("hcx-recently-viewed")
    ) {
      return false;
    }

    const grid = section.querySelector(".hcx-featured-drop__grid");
    if (!(grid instanceof HTMLElement)) return true;

    section.querySelectorAll(".hcx-featured-drop__slider, [data-hcx-home-rail-slider]").forEach((slider) => {
      slider.remove();
    });

    section.classList.remove(
      "hcx-featured-drop--has-slider",
      "hcx-featured-drop--slider-active",
      "hcx-rail-slider--has-slider",
      "hcx-rail-slider--slider-active",
      "hcx-rail-slider--bar-hover"
    );

    grid.dataset.hcxHomepageStaticGrid = "true";
    grid.removeAttribute("data-hcx-rail-slider-track");
    grid.scrollLeft = 0;
    const isDesktopGrid = window.matchMedia && window.matchMedia("(min-width: 990px)").matches;
    grid.style.setProperty("display", "grid", "important");
    grid.style.setProperty("grid-template-columns", isDesktopGrid ? "repeat(5, minmax(0, 1fr))" : "repeat(2, minmax(0, 1fr))", "important");
    grid.style.setProperty("grid-auto-flow", "row", "important");
    grid.style.setProperty("grid-auto-columns", "unset", "important");
    grid.style.setProperty("column-gap", isDesktopGrid ? ".18rem" : ".55rem", "important");
    grid.style.setProperty("row-gap", isDesktopGrid ? ".18rem" : "1.25rem", "important");
    grid.style.setProperty("overflow-x", "visible", "important");
    grid.style.setProperty("overflow-y", "visible", "important");
    grid.style.setProperty("scroll-snap-type", "none", "important");
    grid.style.setProperty("scrollbar-width", "none", "important");

    [...grid.children].forEach((child) => {
      if (!(child instanceof HTMLElement) || !child.matches("li")) return;

      child.style.setProperty("width", "auto", "important");
      child.style.setProperty("max-width", "none", "important");
      child.style.setProperty("min-width", "0", "important");
      child.style.setProperty("scroll-snap-align", "unset", "important");
      child.style.setProperty("display", "", "");
    });

    grid.querySelectorAll(":scope > li[data-hcx-home-grid-clone='true']").forEach((clone) => clone.remove());

    const originalItems = [...grid.children].filter(
      (child) => child instanceof HTMLElement && child.matches("li")
    );
    if (!originalItems.length) return true;

    const parsedTargetCount = parseInt(section.dataset.hcxProductTarget || "", 10);
    const targetCount = parsedTargetCount > 0 ? parsedTargetCount : 12;
    let visibleItems = originalItems.slice(0, targetCount);
    originalItems.slice(targetCount).forEach((item) => {
      item.style.setProperty("display", "none", "important");
    });

    for (let index = 0; visibleItems.length < targetCount; index += 1) {
      const source = originalItems[index % originalItems.length];
      const clone = source.cloneNode(true);
      if (!(clone instanceof HTMLElement)) break;

      clone.dataset.hcxHomeGridClone = "true";
      clone.style.setProperty("width", "auto", "important");
      clone.style.setProperty("max-width", "none", "important");
      clone.style.setProperty("min-width", "0", "important");
      clone.style.setProperty("scroll-snap-align", "unset", "important");
      grid.appendChild(clone);
      visibleItems.push(clone);
    }

    return true;
  };

  const normalizeHomeFeaturedDropStaticGrids = () => {
    if (!isHome) return;

    document
      .querySelectorAll(".hcx-featured-drop:not(.hcx-recently-viewed)")
      .forEach((section) => normalizeHomeFeaturedDropStaticGrid(section));
  };

  const syncHomeFeaturedDropSlider = (section) => {
    if (normalizeHomeFeaturedDropStaticGrid(section)) return;

    const rail = getHomeFeaturedDropSliderRail(section);
    const slider = section?.querySelector("[data-hcx-home-rail-slider]");
    const thumb = section?.querySelector("[data-hcx-home-rail-slider-thumb]");
    if (!(rail instanceof HTMLElement) || !(slider instanceof HTMLElement) || !(thumb instanceof HTMLElement)) return;

    const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
    const trackWidth = slider.clientWidth || slider.getBoundingClientRect().width || rail.clientWidth || section.clientWidth || 0;
    const canScroll = maxScroll > 1 && trackWidth > 0;

    section.classList.toggle("hcx-featured-drop--has-slider", canScroll);
    section.classList.toggle("hcx-rail-slider--has-slider", canScroll);

    if (!canScroll) {
      thumb.style.setProperty("--hcx-home-slider-thumb-width", "100%");
      thumb.style.setProperty("--hcx-home-slider-thumb-x", "0px");
      thumb.style.setProperty("width", "100%", "important");
      thumb.style.setProperty("transform", "translate3d(0px, 0, 0)", "important");
      return;
    }

    const visibleRatio = Math.min(1, rail.clientWidth / rail.scrollWidth);
    const thumbWidth = Math.max(96, Math.min(trackWidth * visibleRatio, trackWidth * 0.36));
    const maxThumbX = Math.max(0, trackWidth - thumbWidth);
    const thumbX = (rail.scrollLeft / maxScroll) * maxThumbX;

    thumb.style.setProperty("--hcx-home-slider-thumb-width", `${thumbWidth}px`);
    thumb.style.setProperty("--hcx-home-slider-thumb-x", `${thumbX}px`);
    thumb.style.setProperty("width", `${thumbWidth}px`, "important");
    thumb.style.setProperty("transform", `translate3d(${thumbX}px, 0, 0)`, "important");
  };

  const initHomeFeaturedDropSliders = () => {
    normalizeHomeFeaturedDropStaticGrids();

    if (isHome) return;

    const sectionSelector = [
      ".hcx-featured-drop:not(.hcx-recently-viewed)",
      ".related-products--style-with",
      ".related-products--recommendations",
      "#recently-viewed",
    ].join(", ");

    document.querySelectorAll(sectionSelector).forEach((section) => {
      if (normalizeHomeFeaturedDropStaticGrid(section)) return;

      const rail = getHomeFeaturedDropSliderRail(section);
      const slider = section.querySelector("[data-hcx-home-rail-slider]");
      const thumb = section.querySelector("[data-hcx-home-rail-slider-thumb]");
      if (!(rail instanceof HTMLElement) || !(slider instanceof HTMLElement) || !(thumb instanceof HTMLElement)) return;

      rail.dataset.hcxRailSliderTrack = "true";

      const requestSync = () => {
        if (rail.dataset.hcxHomeRailSliderFrame === "true") return;
        rail.dataset.hcxHomeRailSliderFrame = "true";
        window.requestAnimationFrame(() => {
          rail.dataset.hcxHomeRailSliderFrame = "false";
          syncHomeFeaturedDropSlider(section);
        });
      };

      if (slider.dataset.hcxHomeRailSliderBound !== "true") {
        slider.dataset.hcxHomeRailSliderBound = "true";
        rail.addEventListener("scroll", requestSync, { passive: true });
        window.addEventListener("resize", requestSync, { passive: true });

        let sliderDragInProgress = false;
        const desktopSliderQuery = window.matchMedia("(hover: hover) and (pointer: fine) and (min-width: 990px)");
        const canUseSlider = () => desktopSliderQuery.matches;
        const showSliderHover = () => {
          if (canUseSlider()) section.classList.add("hcx-rail-slider--bar-hover");
        };
        const clearSliderHover = () => {
          if (!sliderDragInProgress) section.classList.remove("hcx-rail-slider--bar-hover");
        };
        const startSliderDrag = (event, { capturePointer = false, eventPrefix = "pointer", pointerId } = {}) => {
          if (sliderDragInProgress) return;
          if (!canUseSlider()) return;

          const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
          if (maxScroll <= 1) return;

          event.preventDefault();
          event.stopPropagation();
          sliderDragInProgress = true;
          const previousUserSelect = document.documentElement.style.userSelect;
          const previousScrollBehavior = rail.style.scrollBehavior;
          const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
          const getMetrics = () => {
            const rect = slider.getBoundingClientRect();
            const thumbWidth = Math.min(
              rect.width || 1,
              Number.parseFloat(getComputedStyle(thumb).getPropertyValue("--hcx-home-slider-thumb-width")) ||
                thumb.getBoundingClientRect().width ||
                1
            );

            return {
              maxScroll: Math.max(0, rail.scrollWidth - rail.clientWidth),
              rect,
              thumbWidth,
              travel: Math.max(1, rect.width - thumbWidth),
            };
          };
          const initialMetrics = getMetrics();
          const thumbRect = thumb.getBoundingClientRect();
          const pointerOffsetWithinThumb =
            event.clientX >= thumbRect.left && event.clientX <= thumbRect.right
              ? event.clientX - thumbRect.left
              : initialMetrics.thumbWidth / 2;
          let pendingClientX = event.clientX;
          let dragFrame = null;
          let dragging = true;

          document.documentElement.style.userSelect = "none";
          rail.style.scrollBehavior = "auto";
          section.classList.add("hcx-featured-drop--slider-active");
          section.classList.add("hcx-rail-slider--slider-active");
          section.classList.add("hcx-rail-slider--bar-hover");
          rail.classList.add("hcx-scrollbar-strip-active");
          if (capturePointer) {
            try {
              slider.setPointerCapture?.(pointerId);
            } catch (error) {
              // Pointer capture can fail if the browser cancels the pointer immediately.
            }
          }

          const applyPointerPosition = () => {
            dragFrame = null;

            const metrics = getMetrics();
            if (metrics.maxScroll <= 1) return;

            const targetX = clamp(
              pendingClientX - metrics.rect.left - pointerOffsetWithinThumb,
              0,
              metrics.travel
            );
            rail.scrollLeft = (targetX / metrics.travel) * metrics.maxScroll;
            syncHomeFeaturedDropSlider(section);
          };

          const moveToPointer = (pointerEvent) => {
            pointerEvent.preventDefault();
            pendingClientX = pointerEvent.clientX;

            if (dragFrame !== null) return;
            dragFrame = window.requestAnimationFrame(applyPointerPosition);
          };

          const stopDragging = () => {
            if (!dragging) return;

            dragging = false;
            if (dragFrame !== null) {
              window.cancelAnimationFrame(dragFrame);
              applyPointerPosition();
            }

            document.documentElement.style.userSelect = previousUserSelect;
            rail.style.scrollBehavior = previousScrollBehavior;
            section.classList.remove("hcx-featured-drop--slider-active");
            section.classList.remove("hcx-rail-slider--slider-active");
            if (!slider.matches(":hover")) section.classList.remove("hcx-rail-slider--bar-hover");
            rail.classList.remove("hcx-scrollbar-strip-active");
            sliderDragInProgress = false;
            if (capturePointer) {
              try {
                if (slider.hasPointerCapture?.(pointerId)) slider.releasePointerCapture(pointerId);
              } catch (error) {
                // The pointer may already be released after a cancel/lostcapture event.
              }
            }
            document.removeEventListener(`${eventPrefix}move`, moveToPointer);
            document.removeEventListener(`${eventPrefix}up`, stopDragging);
            if (eventPrefix === "pointer") {
              document.removeEventListener("pointercancel", stopDragging);
              slider.removeEventListener("lostpointercapture", stopDragging);
            }
          };

          document.addEventListener(`${eventPrefix}move`, moveToPointer);
          document.addEventListener(`${eventPrefix}up`, stopDragging);
          if (eventPrefix === "pointer") {
            document.addEventListener("pointercancel", stopDragging);
            slider.addEventListener("lostpointercapture", stopDragging);
          }
          moveToPointer(event);
        };

        slider.addEventListener("pointerdown", (event) => {
          startSliderDrag(event, { capturePointer: true, eventPrefix: "pointer", pointerId: event.pointerId });
        });
        slider.addEventListener("pointerenter", showSliderHover);
        slider.addEventListener("pointermove", showSliderHover);
        slider.addEventListener("pointerleave", clearSliderHover);

        slider.addEventListener("mousedown", (event) => {
          if (event.button !== 0) return;

          startSliderDrag(event, { eventPrefix: "mouse" });
        });
      }

      if (rail.dataset.hcxHomeRailSliderResizeBound !== "true" && "ResizeObserver" in window) {
        rail.dataset.hcxHomeRailSliderResizeBound = "true";
        const observer = new ResizeObserver(requestSync);
        observer.observe(rail);
        observer.observe(section);
      }

      rail.querySelectorAll("img").forEach((image) => {
        if (!(image instanceof HTMLImageElement) || image.dataset.hcxRailSliderImageBound === "true") return;

        image.dataset.hcxRailSliderImageBound = "true";
        if (!image.complete) image.addEventListener("load", requestSync, { once: true });
      });

      requestSync();
    });

    if (html.dataset.hcxRailSlidersObserverBound !== "true" && "MutationObserver" in window) {
      html.dataset.hcxRailSlidersObserverBound = "true";
      const requestGlobalSync = () => {
        if (html.dataset.hcxRailSlidersFrame === "true") return;
        html.dataset.hcxRailSlidersFrame = "true";
        window.requestAnimationFrame(() => {
          html.dataset.hcxRailSlidersFrame = "false";
          initHomeFeaturedDropSliders();
        });
      };

      new MutationObserver(requestGlobalSync).observe(document.getElementById("MainContent") || document.body, {
        childList: true,
        subtree: true,
      });
      document.addEventListener("shopify:section:load", requestGlobalSync);
      document.addEventListener("product-info:loaded", requestGlobalSync);
    }
  };

  const initRailScrollbarStripDrag = () => {
    const railSelector = [
      ".hcx-featured-drop:not(.hcx-recently-viewed) .hcx-featured-drop__grid",
      ".related-products--style-with .product-grid",
      ".related-products--recommendations .product-grid",
      "#recently-viewed .hcx-recently-viewed__track",
    ].join(", ");
    const desktopScrollbarQuery = window.matchMedia("(hover: hover) and (pointer: fine) and (min-width: 990px)");
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    document.querySelectorAll(railSelector).forEach((rail) => {
      if (!(rail instanceof HTMLElement) || rail.dataset.hcxRailScrollbarStripBound === "true") return;

      rail.dataset.hcxRailScrollbarStripBound = "true";
      let dragging = false;
      let dragFrame = null;
      let pendingClientX = 0;
      let pointerOffsetWithinThumb = 0;
      let previousUserSelect = "";
      let previousScrollBehavior = "";

      const getSection = () => rail.closest(".hcx-featured-drop, .related-products, #recently-viewed");
      const canUseScrollbarDrag = () =>
        desktopScrollbarQuery.matches && rail.scrollWidth > rail.clientWidth + 2;
      const getMetrics = () => {
        const rect = rail.getBoundingClientRect();
        const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
        const visibleRatio = rail.scrollWidth > 0 ? Math.min(1, rail.clientWidth / rail.scrollWidth) : 1;
        const thumbWidth = Math.max(96, Math.min(rect.width * visibleRatio, rect.width * 0.36));
        const travel = Math.max(1, rect.width - thumbWidth);
        const thumbX = maxScroll > 1 ? (rail.scrollLeft / maxScroll) * travel : 0;

        return { maxScroll, rect, thumbWidth, thumbX, travel };
      };
      const isInScrollbarStrip = (event) => {
        if (!canUseScrollbarDrag()) return false;

        const rect = rail.getBoundingClientRect();
        const stripHeight = 30;
        const outerSlack = 12;
        return (
          event.clientX >= rect.left - 8 &&
          event.clientX <= rect.right + 8 &&
          event.clientY >= rect.bottom - stripHeight &&
          event.clientY <= rect.bottom + outerSlack
        );
      };
      const setScrollbarHover = (isHovering) => {
        const section = getSection();
        rail.classList.toggle("hcx-native-rail-scrollbar-hover", isHovering);
        section?.classList.toggle("hcx-rail-slider--bar-hover", isHovering);
      };
      const clearScrollbarHover = () => {
        if (!dragging) setScrollbarHover(false);
      };
      const syncSectionSlider = () => {
        const section = getSection();
        if (section instanceof HTMLElement) syncHomeFeaturedDropSlider(section);
      };
      const applyPointerPosition = () => {
        dragFrame = null;

        const metrics = getMetrics();
        if (metrics.maxScroll <= 1) return;

        const targetX = clamp(
          pendingClientX - metrics.rect.left - pointerOffsetWithinThumb,
          0,
          metrics.travel
        );
        rail.scrollLeft = (targetX / metrics.travel) * metrics.maxScroll;
        syncSectionSlider();
      };
      const moveToPointer = (pointerEvent) => {
        if (!dragging) return;

        pointerEvent.preventDefault();
        pendingClientX = pointerEvent.clientX;
        if (dragFrame !== null) return;

        dragFrame = window.requestAnimationFrame(applyPointerPosition);
      };
      const stopDragging = (pointerEvent) => {
        if (!dragging) return;

        dragging = false;
        if (dragFrame !== null) {
          window.cancelAnimationFrame(dragFrame);
          applyPointerPosition();
        }

        document.documentElement.style.userSelect = previousUserSelect;
        rail.style.scrollBehavior = previousScrollBehavior;
        rail.classList.remove("hcx-native-rail-scrollbar-active");
        rail.classList.remove("hcx-scrollbar-strip-active");
        const section = getSection();
        section?.classList.remove("hcx-rail-slider--slider-active");
        if (!rail.matches(":hover")) section?.classList.remove("hcx-rail-slider--bar-hover");
        if (!rail.matches(":hover")) rail.classList.remove("hcx-native-rail-scrollbar-hover");
        try {
          if (pointerEvent?.pointerId != null && rail.hasPointerCapture?.(pointerEvent.pointerId)) {
            rail.releasePointerCapture(pointerEvent.pointerId);
          }
        } catch (error) {
          // Pointer capture may already be released if the browser cancels the drag.
        }
        document.removeEventListener("pointermove", moveToPointer);
        document.removeEventListener("pointerup", stopDragging);
        document.removeEventListener("pointercancel", stopDragging);
      };

      rail.addEventListener("pointermove", (event) => {
        if (dragging || isInScrollbarStrip(event)) {
          setScrollbarHover(true);
          return;
        }

        clearScrollbarHover();
      });
      rail.addEventListener("pointerleave", clearScrollbarHover);
      rail.addEventListener("pointerdown", (event) => {
        if (event.button !== 0 || !isInScrollbarStrip(event)) return;

        const metrics = getMetrics();
        if (metrics.maxScroll <= 1) return;

        event.preventDefault();
        event.stopPropagation();
        dragging = true;
        pendingClientX = event.clientX;
        previousUserSelect = document.documentElement.style.userSelect;
        previousScrollBehavior = rail.style.scrollBehavior;
        document.documentElement.style.userSelect = "none";
        rail.style.scrollBehavior = "auto";
        rail.classList.add("hcx-native-rail-scrollbar-active");
        rail.classList.add("hcx-scrollbar-strip-active");
        setScrollbarHover(true);
        const section = getSection();
        section?.classList.add("hcx-rail-slider--slider-active");

        const thumbLeft = metrics.rect.left + metrics.thumbX;
        const thumbRight = thumbLeft + metrics.thumbWidth;
        pointerOffsetWithinThumb =
          event.clientX >= thumbLeft && event.clientX <= thumbRight
            ? event.clientX - thumbLeft
            : metrics.thumbWidth / 2;

        try {
          rail.setPointerCapture?.(event.pointerId);
        } catch (error) {
          // Pointer capture can fail if the browser has already cancelled this pointer.
        }

        document.addEventListener("pointermove", moveToPointer);
        document.addEventListener("pointerup", stopDragging);
        document.addEventListener("pointercancel", stopDragging);
        applyPointerPosition();
      });
      rail.addEventListener("scroll", syncSectionSlider, { passive: true });
    });
  };

  const initProductLowerRailWheelScroll = () => {
    document
      .querySelectorAll(
        ".related-products--style-with .product-grid, .related-products--recommendations .product-grid"
      )
      .forEach((rail) => {
        if (rail.dataset.hcxProductRailWheelBound === "true") return;

        rail.dataset.hcxProductRailWheelBound = "true";
        const hasOverflow = () => rail.scrollWidth > rail.clientWidth + 2;
        const isDesktopPointer = () => window.matchMedia("(hover: hover) and (pointer: fine)").matches;

        rail.addEventListener(
          "wheel",
          (event) => {
            if (!isDesktopPointer() || !hasOverflow()) return;
            if (Math.abs(event.deltaX) <= Math.abs(event.deltaY) && !event.shiftKey) return;
            event.preventDefault();
          },
          { passive: false }
        );
      });
  };

  const initCollectionFilterAccordions = () => {
    if (html.dataset.hcxCollectionFilterAccordionsBound === "true") return;
    html.dataset.hcxCollectionFilterAccordionsBound = "true";

    const isCollectionFilterPage = () =>
      body?.classList.contains("template-collection") || body?.classList.contains("template-search");

    const closeFacetDetails = (details) => {
      if (!(details instanceof HTMLElement)) return;

      details.open = false;
      details.classList.remove("menu-opening");
      details.querySelector(".mobile-facets__summary")?.setAttribute("aria-expanded", "false");
    };

    document.addEventListener(
      "click",
      (event) => {
        if (!isCollectionFilterPage()) return;

        const summary = event.target?.closest?.("#FacetFiltersFormMobile .mobile-facets__details > .mobile-facets__summary");
        if (!(summary instanceof HTMLElement)) return;

        const details = summary.closest(".mobile-facets__details");
        if (!(details instanceof HTMLElement)) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const shouldOpen = !details.open;
        const main = details.closest(".mobile-facets__main");

        main?.querySelectorAll(".mobile-facets__details[open]").forEach((candidate) => {
          if (candidate !== details) closeFacetDetails(candidate);
        });

        details.open = shouldOpen;
        details.classList.remove("menu-opening");
        main?.classList.remove("submenu-open");
        summary.setAttribute("aria-expanded", shouldOpen ? "true" : "false");
        summary.focus({ preventScroll: true });
      },
      true
    );
  };

  const getHcxThemeAssetUrl = (filename) => {
    const script = document.querySelector('script[src*="hercxles-premium-wheel-guard.js"], script[src*="hercxles-premium.js"]');
    const scriptSrc = script?.getAttribute("src") || "";
    if (!scriptSrc) return "";

    const absoluteScriptSrc = new URL(scriptSrc, window.location.origin).href;
    return absoluteScriptSrc.replace(/hercxles-premium(?:-wheel-guard)?\.js(?:\?.*)?$/i, filename);
  };

  const forcedProductCardImages = [];

  const setForcedProductCardImageSource = (image, src, alt) => {
    if (!image || image.tagName !== "IMG" || !src) return;

    image.removeAttribute("srcset");
    image.removeAttribute("data-hcx-lazy-srcset");
    image.dataset.hcxLazySrc = src;
    image.dataset.hcxLazyLoaded = "true";
    image.src = src;
    image.alt = alt;
    image.width = 3000;
    image.height = 4000;
  };

  const syncForcedProductCardImages = () => {
    forcedProductCardImages.forEach((replacement) => {
      document.querySelectorAll(`.product-card-wrapper a[href*="/products/${replacement.handle}"]`).forEach((link) => {
        const card = link.closest(".product-card-wrapper");
        if (!card) return;

        const images = [...card.querySelectorAll(".card__media img[data-hcx-card-image], .card__media img")];
        if (!images.length) return;

        images.forEach((image, index) => {
          const useHover = index > 0 && replacement.hoverUrl;
          setForcedProductCardImageSource(
            image,
            useHover ? replacement.hoverUrl : replacement.primaryUrl,
            useHover ? replacement.hoverAlt : replacement.primaryAlt
          );
        });

        if (replacement.hoverUrl && images.length > 1) {
          card.classList.add("hcx-card-wrapper--has-hover-image");
          card.querySelector(".card__media .media")?.setAttribute("data-hcx-card-gallery", "");
        }
      });
    });
  };

  const syncRequestedModelHoverImages = () => {
    const replacements = [
      {
        handle: "sport-sweatpants-black",
        asset: "hcx-sport-sweatpants-model-no-black-nike-v3.jpg",
        alt: "Sport Sweatpants worn by model",
      },
      {
        handle: "angel-waffle-long-sleeve",
        asset: "hcx-angel-waffle-long-sleeve-grey.jpg",
        alt: "Angel Waffle Long Sleeve worn by model",
      },
    ];

    replacements.forEach((replacement) => {
      const assetUrl = getHcxThemeAssetUrl(replacement.asset);
      if (!assetUrl) return;

      document.querySelectorAll(`.product-card-wrapper a[href*="/products/${replacement.handle}"]`).forEach((link) => {
        const card = link.closest(".product-card-wrapper");
        const hoverImage = card?.querySelector(".hcx-card-hover-image");
        if (!hoverImage || hoverImage.tagName !== "IMG") return;
        if (hoverImage.currentSrc.includes(`/assets/${replacement.asset}`) || hoverImage.src.includes(`/assets/${replacement.asset}`)) return;

        const nextSrc = `${assetUrl}?hcx=20260603-model-hover`;
        hoverImage.removeAttribute("srcset");
        hoverImage.removeAttribute("data-hcx-lazy-srcset");
        if (hoverImage.dataset.hcxLazySrc || hoverImage.dataset.hcxLazyLoaded !== "true") {
          hoverImage.dataset.hcxLazySrc = nextSrc;
          hoverImage.dataset.hcxLazyHoverImage = "true";
          if (hoverImage.dataset.hcxLazyLoaded !== "true") hoverImage.src = hcxTransparentImage;
          bindHcxDeferredImages(hoverImage);
        } else {
          hoverImage.src = nextSrc;
        }
        hoverImage.alt = replacement.alt;
        hoverImage.width = 3000;
        hoverImage.height = 4000;
        loadHcxDeferredImage(hoverImage);
        initCardImageGalleries(card);
      });
    });
  };

  const syncRequestedPrimaryModelImages = () => {
    const replacements = [
      {
        handle: "lckd-in-full-zip-mesh-jacket",
        asset: "hcx-lckd-in-full-zip-mesh-jacket-flatlay-front.jpg",
        alt: "LCKD IN Mesh Jacket flat lay front",
      },
    ];

    replacements.forEach((replacement) => {
      const assetUrl = getHcxThemeAssetUrl(replacement.asset);
      if (!assetUrl) return;

      document.querySelectorAll(`.product-card-wrapper a[href*="/products/${replacement.handle}"]`).forEach((link) => {
        const card = link.closest(".product-card-wrapper");
        const primaryImage = card?.querySelector("img:not(.hcx-card-hover-image)");
        if (!primaryImage || primaryImage.tagName !== "IMG") return;
        if (primaryImage.currentSrc.includes(`/assets/${replacement.asset}`) || primaryImage.src.includes(`/assets/${replacement.asset}`)) return;

        const nextSrc = `${assetUrl}?hcx=20260623-flatlay-primary`;
        primaryImage.removeAttribute("srcset");
        primaryImage.removeAttribute("data-hcx-lazy-srcset");
        primaryImage.dataset.hcxLazySrc = nextSrc;
        primaryImage.src = hcxTransparentImage;
        bindHcxDeferredImages(primaryImage);
        primaryImage.alt = replacement.alt;
        primaryImage.width = 3000;
        primaryImage.height = 4000;
      });
    });
  };

  const initRequestedModelHoverImageSync = () => {
    syncRequestedPrimaryModelImages();
    syncRequestedModelHoverImages();
    syncForcedProductCardImages();

    if (isHome) return;

    if (html.dataset.hcxRequestedModelHoverSyncBound === "true" || !document.body || !("MutationObserver" in window)) return;
    html.dataset.hcxRequestedModelHoverSyncBound = "true";

    let cardMediaFrame = 0;
    const cardMediaSelector = ".product-card-wrapper, .card-wrapper, .hcx-search-product-card";
    new MutationObserver((mutations) => {
      if (cardMediaFrame || !mutations.some((mutation) =>
        [...mutation.addedNodes].some((node) => node instanceof Element &&
          (node.matches(cardMediaSelector) || node.querySelector(cardMediaSelector) || node.closest(cardMediaSelector)))
      )) return;
      cardMediaFrame = window.requestAnimationFrame(() => {
        cardMediaFrame = 0;
        syncRequestedPrimaryModelImages();
        syncRequestedModelHoverImages();
        syncForcedProductCardImages();
      });
    }).observe(document.body, { childList: true, subtree: true });
  };

  const initProductEnhancements = () => {
    initHeaderAccountPointsGuard();
    bindHcxDeferredImages();
    initHeaderAnnouncementSlider();
    initUnavailableXsDescriptionCleanup();
    initProductDescriptionFormatting();
    initProductInfoPanels();
    // These full-document text MutationObservers can fight with Shopify/app-injected
    // content on large pages and keep Chrome's renderer busy during load.
    // Keep them off the critical path until they can be narrowed to owned sections.
    // initStoreTextCase();
    initButtonTextFly();
    initCareCartAttributionCleaner();
    initPolicyPageEnhancements();
    initReturnExchangePortal();
    initFaqPage();
    initOrderTrackingHubs();
    initMobileMenuInteractionGuard();
    initMobileMenuClose();
    initMobileMenuSearch();
    initCartRecommendationScrollbars();
    initRecentCartRecommendations();
    initCardQuickAdds();
    initCardImageGalleries();
    initCardQuickAddRefresh();
    initSearchQuickAdds();
    initLinkedColourHoverLabels();
    initAllRequiredSizeSelections();
    initFitConfidenceSystem();
    initSavesControls();
    initProductTitleRhythm();
    initInStockSizeFiltering();
    initColourFilterGrouping();
    initDeliveryPromises();
    initHcxStoreReviews();
    initHcxStoreReviewForm();
    initProductReviewAnchorScroll();
    initProductReviewMetrics();
    initRelatedProductCategories();
    initHoverRevealScrollbars();
    initHomeFeaturedDropSliders();
    initRailScrollbarStripDrag();
    initClickableHeroes();
    trackRecentlyViewedProduct();
    renderRecentlyViewed();
    initProductLowerRailWheelScroll();
    initProductLowerRailControls();
    initCustomerVoiceCarousels();
    initCollectionFilterAccordions();
    initRequestedModelHoverImageSync();
    rerenderProductReviewApp();
    initLoyaltyProgram();
    initLegacyRegisterForm();
    initLoyaltyInterface();
    initLoyaltyPhoneScenes();
    initLegacyOrderNotifications();
    renderSaves();
    initCookieConsentFallback();
  };

  const isLaunchGateLocked = () =>
    Boolean(document.querySelector("[data-hcx-launch-gate]")) &&
    !html.classList.contains("hcx-launch-unlocked") &&
    !window.Shopify?.designMode;

  const initProductEnhancementsWhenAllowed = () => {
    if (isLaunchGateLocked()) return;
    initProductEnhancements();
  };

  const initAlwaysSafeEnhancements = () => {
    initHeaderAccountPointsGuard();
    initHcxProductCardPriceSync();
    initMobileMenuInteractionGuard();
    initMobileMenuSearch();
    initSearchQuickAdds();
    initFitConfidenceSystem();
    initCookieConsentFallback();
  };

  if (isLaunchGateLocked()) {
    window.addEventListener("hcx:launch-unlocked", initProductEnhancementsWhenAllowed, { once: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAlwaysSafeEnhancements);
    document.addEventListener("DOMContentLoaded", initProductEnhancementsWhenAllowed);
  } else {
    initAlwaysSafeEnhancements();
    initProductEnhancementsWhenAllowed();
  }

  document.addEventListener("product-info:loaded", initProductEnhancementsWhenAllowed);
  document.addEventListener("shopify:section:load", initProductEnhancementsWhenAllowed);
})();
